// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/main-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/welcome-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
Author       : Dreamstechnologies
Template Name: Cloud Connect - Bootstrap Admin Template
Version      : 1.0
*/

/*============================
 [Table of CSS]

1. General
2. Table
3. Helper Class
4. Bootstrap Classes
5. Select2
6. Nav Tabs
7. Components
8. Header
9. Sidebar
10. Content
11. Login
12. Modal
13. Welcome
14. Dashboard
15. Create
16. Patient Registration
17. Doctor Dashboard
18. Appointment
19. Join
20. Notification
21. Responsive

========================================*/

/*-----------------
	1. General
-----------------------*/

html {
	height: 100%;
}
body {
	background-color: #F2F2F2;
	color: #000;
	font-family: "Poppins", sans-serif;
	font-size: 15px;
	height: 100%;
	line-height: 1.5;
	overflow-x: hidden;
}
h1,
h2,
h3,
h4,
h5,
h6 {
	font-family: "Poppins", sans-serif;
	font-weight: 600;
	color: #000;
	margin-top: 0;
}
p {
	color: #000;
}
p:last-child {
	margin-bottom: 0;
}
a:hover,
a:active,
a:focus {
	outline: none;
	text-decoration: none;
}
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus {
	-webkit-box-shadow: 0 0 0px 1000px white inset !important;
	box-shadow: 0 0 0px 1000px white inset !important;
}
.form-control {
    background: #FFF;
	border: 0;
	border-bottom: 1px solid #00000038;
    box-shadow: none;
    border-radius: 0;
    color: #000;
    font-size: 14px;
    padding: 2px 0;
    height: auto;
	transition: all 0.5s;
}
.form-control:focus{
	border: 0;
	box-shadow: none;
	outline: 0 none;
	border-bottom: 1px solid #00000038;
}
.form-control.form-control-sm {
	height: calc(1.5em + .5rem + 2px);
}
.form-control-sm {
	background-color: #fff;
}
.form-control.form-control-lg {
	height: calc(1.5em + 1rem + 2px);
}
.form-control::placeholder {
	font-size: 14px;
	color: #898989;
}
a {
	color: #000;
	text-decoration: none;
}
a:hover {
	color: #3FA2DB;
	text-decoration: none;
}
input,
button,
a {
	transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-ms-transition: all 0.4s ease;
	-webkit-transition: all 0.4s ease;
}
input, input:focus,
button, button:focus {
	outline: none;
}
input[type="file"] {
    height: auto;
    min-height: calc(1.5em + .75rem + 2px);
}
input[type=text],
input[type=password] {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
}
textarea.form-control {
	resize: none;
	min-height: 100px;
}
.navbar-nav > li {
	float: left;
}
.form-group {
	margin-bottom: 24px;
}
.form-wrap {
	margin-bottom: 24px;
}
label {
	font-size: 15px;
    display: inline-block;
    margin-bottom: 5px;
    color: #000;
}
.input-group .form-control {
	height: 40px;
}
.input-group .input-height {
	height: auto;
}
.nav .open > a,
.nav .open > a:focus,
.nav .open > a:hover {
	background-color: rgba(0, 0, 0, 0.1);
	border-color: rgba(0, 0, 0, 0.1);
}
ul, ol {
	padding: 0;
	margin: 0;
	list-style: none;
}

/*-----------------
	2. Table
-----------------------*/

.table {
	color: #000;
	max-width: 100%;
	margin-bottom: 0;
	width: 100%;
	background: transparent;
}
.table>:not(:first-child) {
    border-top: transparent;
}
.table>:not(caption)>*>* {
	box-shadow: unset;
	padding: 0.75rem;
	background: transparent;
}
.table thead {
	border: 0;
	background: transparent;
	vertical-align: middle;
}
.table thead tr th {
	font-size: 16px;
	font-weight: 600;
	color: #000;
	padding: 15px;
	border: 0;
	white-space: nowrap;
	background: transparent;
}
.table thead tr {
	border-bottom: 1px solid #E6E6E6;
}
.table tbody tr {
	border-bottom: 1px solid #E6E6E6;
}
.table tbody tr.active {
	cursor: pointer;
	border-left: 8px solid #3FA2DB;
	box-shadow: 0px 0px 9.7px -1px #00000040;
}
.table tbody tr td {
	font-size: 14px;
	color: #000;
	padding: 15px;
	vertical-align: middle;
	background: transparent;
	border: 0;
	white-space: nowrap;
}
.table-striped > tbody > tr:nth-of-type(2n+1) {
	background-color: #f8f9fa;
}
.table.no-border > tbody > tr > td,
.table > tbody > tr > th,
.table.no-border > tfoot > tr > td,
.table.no-border > tfoot > tr > th,
.table.no-border > thead > tr > td,
.table.no-border > thead > tr > th {
	border-top: 0;
	padding: 10px 8px;
}
.table-nowrap td,
.table-nowrap th {
	white-space: nowrap
}
.table.dataTable {
	border-collapse: collapse !important;
	border: 1px solid rgba(0, 0, 0, 0.05);
}
table.table td h2 {
	display: inline-block;
	font-size: inherit;
	font-weight: 400;
	margin: 0;
	padding: 0;
	vertical-align: middle;
}
table.table td h2.table-avatar {
    align-items: center;
    display: inline-flex;
    font-size: inherit;
    font-weight: 400;
    margin: 0;
    padding: 0;
    vertical-align: middle;
	white-space: nowrap;
}
table.table td h2 a {
	color: #333;
}
table.table td h2 a:hover {
	color: #FFBC53;
}
table.table td h2 span {
	color: #888;
	display: block;
	font-size: 12px;
	margin-top: 3px;
}
.table tbody tr:last-child {
	border-bottom: 0;
}
.table.table-center td,
.table.table-center th {
	vertical-align: middle;
}
.table-hover tbody tr:hover {
	background-color: #f7f7f7;
}
.table-hover tbody tr:hover td {
	color: #474648;
}
.table-striped thead tr {
	border-color: transparent;
}
.table-striped tbody tr {
	border-color: transparent;
}
.table-striped tbody tr:nth-of-type(even) {
	background-color: rgba(255, 255, 255, 0.3);
}
.table-striped tbody tr:nth-of-type(odd) {
	background-color: rgba(235, 235, 235, 0.4);
}
.table-bordered {
	border: 1px solid rgba(0, 0, 0, 0.05) !important;
}
.table-bordered th,
.table-bordered td {
	border-color: rgba(0, 0, 0, 0.05);
}
.card-table .card-body .table > thead > tr > th {
    border-top: 0;
}
.card-table .card-body .table tr td:first-child,
.card-table .card-body .table tr th:first-child {
    padding-left: 1.5rem;
}
.card-table .card-body .table tr td:last-child,
.card-table .card-body .table tr th:last-child {
    padding-right: 1.5rem;
}
.card-table .table td, .card-table .table th {
    border-top: 1px solid #e2e5e8;
    padding: 1rem 0.75rem;
    white-space: nowrap;
}
.table .thead-light th {
    color: #495057;
    background-color: #f8f9fa;
    border-color: #eff2f7;
}
.table tbody tr .status-data p {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-bottom: 0;
}
.table tbody tr .status-data span {
	width: 10px;
	min-width: 10px;
	height: 10px;
	border-radius: 50px;
	margin-right: 10px;
	display: inline-block;
}
.table tbody tr .status-data .status-active {
	background: #3FA2DB;
}
.table tbody tr .status-data .status-inactive {
	background: #F7D333;
}
.table tbody tr .status-data .status-disabled {
	background: #E87373;
}
.table tbody tr .action-pending {
	color: #3FA2DB;
}
.table tbody tr .action-waiting {
	color: #898989;
}
.table tbody tr .action-delayed {
	color: #E87373;
}
.table tbody tr td .action-pending {
	color: #3FA2DB;
}
.table tbody tr td .action-waiting {
	color: #898989;
}
.table tbody tr td .action-delayed {
	color: #E87373;
}
.table tbody tr .data-btn .btn { 
	font-size: 14px;
	padding: 5px 24px;
}
.table tbody tr .vitals-data .nav {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    flex-wrap: nowrap;
	-webkit-flex-wrap: nowrap;
}
.table tbody tr .vitals-data .nav li {
	margin-right: 30px;
}
.table tbody tr .vitals-data .nav li:last-child {
	margin-right: 0;
}
.table tbody tr .days-data {
	color: #C7C7C7;
}
.table tbody tr .days-data .nav {
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
    flex-wrap: nowrap;
	-webkit-flex-wrap: nowrap;
}
.table tbody tr .days-data .nav li {
	margin-right: 12px;
}
.table tbody tr .days-data .nav li:last-child {
	margin-right: 0;
}
.table tbody tr .days-data .nav li span {
	color: #3FA2DB;
}
.table tbody tr td .data-slot span {
	margin-right: 14px;
}
.table tbody tr td .data-slot span:last-child {
	margin-right: 0;
}
.table tbody tr td .data-slot a {
	font-size: 18px;
	color: #3FA2DB;
	margin-right: 14px;
}
.table tbody tr td .data-slot a:hover {
	color: #00568E;
}
.table tbody tr td .data-slot a:last-child {
	margin-right: 0;
}
.table tbody tr td .data-slot .slot-delete {
	color: #E87373;
}
.tooltip > .tooltip-inner {
	padding: 6px 20px;
	color: black;
	border: 1px solid #E6E6E6;
	background-color: #FFF;
	border-radius: 30px;
}
.schedule-data .btn {
	font-size: 14px;
	padding: 5px 24px;
	box-shadow: 0px 0px 10px 0px #00000040;
}
.table .custom-radio {
	margin-left: 14px;
	position: relative;
}
.table .custom-checkbox-radius {
	margin-left: 14px;
}
.table .custom-checkbox-radius .check .box {
	border-radius: 50px;
}
.table .custom-checkbox-left {
	margin-left: 14px
}
.table-dropdown .dropdown-toggle {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    font-size: 18px;
    color: #3FA2DB;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: transparent;
    border: 1px solid #3FA2DB;
}
.table-dropdown .dropdown-toggle::after {
	display: none;
}
.table-dropdown .dropdown-menu {
    min-width: 170px;
    border-radius: 5px;
    border: 1px solid #EFEFEF;
    padding: 0;
}
.table-dropdown .dropdown-menu .dropdown-item {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	font-size: 15px;
	color: #000;
	padding: 10px 15px;
	border-bottom: 1px solid #EFEFEF;
	border-radius: 0;
	-webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}
.table-dropdown .dropdown-menu .dropdown-item:first-child {
    border-radius: 5px 5px 0 0;
}
.table-dropdown .dropdown-menu .dropdown-item:last-child {
    border-radius: 0 0 5px 5px;
    border-bottom: 0;
}
.table-dropdown .dropdown-menu .dropdown-item:hover {
    color: #3FA2DB;
    padding-left: 20px;
    -webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}
.table-dropdown .dropdown-menu .dropdown-item i {
	font-size: 18px;
	margin-right: 8px;
}
.table-dropdown .dropdown-menu .dropdown-item img {
	margin-right: 8px;
}
.dropdown-menu.front-desk-dropdown {
	min-width: 300px;
	max-width: 300px;
	padding: 30px;
	z-index: 1;
	border-radius: 12px;
	box-shadow: 0px 0px 10px -1px #00000040;
	margin-top: -15px !important;
    margin-right: 10px !important;
}
.front-desk-dropdown-right-info {
	position: relative;
	right: 300px;
}
.dropdown-menu.front-desk-dropdown-right {
	position: absolute;
}
.front-desk-dropdown-menu-right {
	position: relative;
	top: 20px;
	right: 300px;
}
.front-desk-dropdown p {
	white-space: pre-wrap;
	width: 100%;
	margin-bottom: 20px;
}
.front-desk-dropdown .edit-text {
	white-space: pre-wrap;
	width: 100%;
	margin-bottom: 20px;
}
.front-desk-dropdown-btn .btn {
	min-width: 80px;
	padding: 5px 24px;
	margin-right: 40px;
}
.front-desk-dropdown-btn .btn:last-child {
	margin-right: 0;
}
.table-btn {
	padding-top: 20px;
	padding-bottom: 20px;
	text-align: center;
}
.table-btn-info {
	padding: 0 30px 30px;
}
.table-btn .btn {
	padding: 10px 50px;
}
.table-pagination {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	margin-bottom: 24px;
}
.table-pagination .pagination-list {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
}
.table-pagination .pagination-list li {
	position: relative;
}
.table-pagination .pagination-list li+li::before {
    padding-right: 0;
    content: "/";
}
.pagination-arrow {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	margin-left: auto;
}
.pagination-arrow li {
	margin-right: 15px;
}
.pagination-arrow li:last-child {
	margin-right: 0;
}
.patient-table-card .card-body {
	padding: 20px;
}
.patient-table-list h6 {
	font-size: 16px;
    font-weight: 600;
    color: #000;
    text-align: center;
    margin-bottom: 30px;
}
.patient-table-list ul {
	padding: 0;
	margin: 0;
	text-align: center;
	list-style: none;
}
.patient-table-list ul li {
	display: block;
	margin-bottom: 20px;
}
.patient-table-list ul li:last-child {
	margin-bottom: 0;
}
.patient-table-list ul li a {
	padding: 7px 15px;
	border-radius: 30px;
}
.patient-table-list ul li a.active {
	box-shadow: 0px 0px 9.7px -1px #00000040;
}

/*-----------------
	3. Helper Class
-----------------------*/

.p-20 {
	padding: 20px !important;
}
.p-t-0 {
	padding-top: 0 !important;
}
.m-0 {
	margin: 0 !important;
}
.m-r-5 {
	margin-right: 5px !important;
}
.m-r-10 {
	margin-right: 10px !important;
}
.m-l-5 {
	margin-left: 5px !important;
}
.m-l-15 {
	margin-left: 15px !important;
}
.m-t-5 {
	margin-top: 5px !important;
}
.m-t-0 {
	margin-top: 0 !important;
}
.m-t-10 {
	margin-top: 10px !important;
}
.m-t-15 {
	margin-top: 15px !important;
}
.m-t-20 {
	margin-top: 20px !important;
}
.m-t-30 {
	margin-top: 30px !important;
}
.m-t-50 {
	margin-top: 50px !important;
}
.m-b-5 {
	margin-bottom: 5px !important;
}
.m-b-10 {
	margin-bottom: 10px !important;
}
.m-b-15 {
	margin-bottom: 15px !important;
}
.m-b-20 {
	margin-bottom: 20px !important;
}
.m-b-30 {
	margin-bottom: 30px !important;
}
.f-500 {
	font-weight: 500;
}
.f-600 {
	font-weight: 600;
}
.block {
	display: block !important;
}
.loader-main {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 999999;
	width: 100%;
	height: 100%;
	background: #FFF;
	display: flex;
	align-items: center;
	justify-content: center;
}
.page-loader {
	width: 60px;
	height: 60px;
	border: 3px dotted #3FA2DB;
	border-style: solid solid dotted dotted;
	border-radius: 50%;
	display: inline-block;
	position: relative;
	box-sizing: border-box;
	animation: rotation 2s linear infinite;
}
.page-loader::after {
	content: '';  
	box-sizing: border-box;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
	border: 3px dotted #CC0001;
	border-style: solid solid dotted;
	width: 30px;
	height: 30px;
	border-radius: 50%;
	animation: rotationBack 1s linear infinite;
	transform-origin: center center;
}  
@keyframes rotation {
	0% {
	  transform: rotate(0deg);
	}
		100% {
		  transform: rotate(360deg);
		}
	} 
	@keyframes rotationBack {
		0% {
		  transform: rotate(0deg);
		}
	100% {
	  transform: rotate(-360deg);
	}
}
.form-wrap-checkbox {
    position: relative;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    line-height: normal;
}
.custom-checkbox {
	line-height: 0;
}
.custom-checkbox-line {
    line-height: normal;
}
.custom-checkbox .check {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  cursor: pointer;
  color: #000;
  margin-bottom: 0;
}
.custom-checkbox .check input {
 	display: none;
}
.custom-checkbox .check input:checked + .box {
 	background: #3FA2DB;
 	border: 1px solid #3FA2DB;
}
.custom-checkbox .check input:checked + .box:after {
 	top: 0;
}
.custom-checkbox .check .box {
	width: 26px;
	min-width: 26px;
	height: 26px;
	display: block;
	transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
	background: #E6E6E6;
	position: relative;
	overflow: hidden;
	cursor: pointer;
	border: 1px solid #E6E6E6;
	border-radius: 0;
}
.custom-checkbox .check .box:after {
	width: 12px;
	height: 6px;
	content: "";
	position: absolute;
	border-left: 2px solid;
	border-bottom: 2px solid;
	border-color: white;
	transform: rotate(-45deg) translate3d(0, 0, 0);
	transform-origin: center center;
	transition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);
	left: 0;
	right: 0;
	top: 200%;
	bottom: 3px;
	margin: auto;
}
.custom_radio {
	color: #000;
	display: inline-flex;
    align-items: center;
	position: relative;
	margin-bottom: 0;
	cursor: pointer;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none
}
.radio_input .custom_radio + .custom_radio {
	margin-left: 15px;
}
.custom_radio input {
	position: absolute;
	opacity: 0
}
.custom_radio input:checked ~ .checkmark {
	border: 1px solid #3FA2DB;
}
.custom_radio input:checked ~ .checkmark:after {
	opacity: 1;
}
.custom_radio .checkmark {
	position: absolute;
	left: 0;
	height: 26px;
	width: 26px;
	background-color: #E6E6E6;
	border: 1px solid #E6E6E6;
	border-radius: 50%
}
.custom_radio .checkmark:after {
	display: block;
	content: "";
	position: absolute;
	opacity: 0;
	top: 0;
	left: 0;
	width: 26px;
	height: 26px;
	border-radius: 50%;
	background: #3FA2DB;
	border: 1px solid #3FA2DB;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out
}
.check-input {
	display: block;
	margin: 0;
	padding: 0;
	width: 0;
	height: 0;
	visibility: hidden;
	opacity: 0;
	pointer-events: none;
	position: absolute;
}
.checktoggle {
    background-color: #F0142F;
    border: 1px solid #F0142F;
    border-radius: 12px;
    cursor: pointer;
    display: block;
    font-size: 0;
    height: 24px;
    margin-bottom: 0;
    position: relative;
    width: 42px;
}
.checktoggle:after {
	content: ' ';
	display: block;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translate(5px, -50%);
	width: 14px;
	height: 14px;
	background-color: #fff;
	border-radius: 50%;
	transition: left 300ms ease, transform 300ms ease;
}
.check-input:checked + .checktoggle {
    background-color: #008F64;
    border: 1px solid #008F64;
}
.check-input:checked + .checktoggle:after {
	background-color: #fff;
	left: 100%;
	transform: translate(calc(-100% - 5px), -50%);
}
.onoffswitch {
	margin-left: auto;
    position: relative;
	width: 73px;
    -webkit-user-select:none;
	-moz-user-select:none;
	-ms-user-select: none;
}
.onoffswitch-checkbox {
    display: none;
}
.onoffswitch-label {
    display: block; 
	overflow: hidden; 
	cursor: pointer;
	border-radius: 20px;
	margin-bottom: 0;
}
.onoffswitch-inner {
	display: block;
    margin-left: -100%;
    transition: margin 0.3s ease-in 0s;
    width: 200%;
}
.onoffswitch-inner:before, .onoffswitch-inner:after {
    box-sizing: border-box;
    color: #fff;
    display: block;
    float: left;
    font-size: 16px;
    height: 30px;
    line-height: 32px;
    padding: 0;
    width: 50%;
}
.onoffswitch-inner:before {
	background-color: #55ce63;
    color: #fff;
    content: "ON";
    padding-left: 14px;
}
.onoffswitch-inner:after {
    content: "OFF";
    padding-right: 14px;
    background-color: #ccc;
    color: #fff;
    text-align: right;
}
.onoffswitch-switch {
    background: #fff;
    border-radius: 20px;
    bottom: 0;
    display: block;
	height: 20px;
    margin: 5px;
    position: absolute;
    right: 43px;
    top: 0;
    transition: all 0.3s ease-in 0s;
    width: 20px;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {
    margin-left: 0;
}
.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {
    right: 0px; 
}
.switch {
    cursor: pointer;
    position: relative;
}
.switch input {
    position: absolute;
    opacity: 0;
    filter: alpha(opacity=0);
}
.switch input:checked+span {
    background-color: #55ce63;
}
.switch input:checked+span:after {
    left: 31px;
}
.switch span {
    position: relative;
    width: 60px;
    height: 30px;
    border-radius: 30px;
    background-color: #fff;
    border: 1px solid #eee;
    border-color: rgba(0, 0, 0, 0.1);
    display: inline-block;
    -webkit-transition: background-color 0.2s;
    transition: background-color 0.2s;
}
.switch span:after {
    content: "";
    position: absolute;
    background-color: #fff;
    width: 26px;
    top: 1px;
    bottom: 1px;
    border-radius: 30px;
    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
    -webkit-transition: left 0.2s;
    transition: left 0.2s;
}
.inactive-text {
	color: #CBCBCB;
}
.scheduled-text {
	color: #3FA2DB;
}
.delayed-text {
	color: #FFA012;
}
.cancelled-text {
	color: #F50C0C;
}
.pending-text {
	color: #BE23CB;
}
.complete-text {
	color: #17D513;
}
.waiting-text {
	color: #fcc100;
}

/*-----------------
	4. Bootstrap Classes
-----------------------*/

.btn.focus, .btn:focus {
    box-shadow: unset;
}
.btn-block {
	width: 100%;
}
.btn-link {
	text-decoration: none;
}
.btn-link:hover {
	text-decoration: underline;
}
.note-btn {
	padding: 5px 8px;
}
.btn-white {
	background-color: #fff;
	border: 1px solid #ccc;
	color: #333;
}
.btn.btn-rounded {
	border-radius: 50px;
}
.bg-primary {
	background-color: #3FA2DB !important;
}
.bg-light {
    background-color: #ebebff !important;
}
a.bg-primary:focus, 
a.bg-primary:hover, 
button.bg-primary:focus, 
button.bg-primary:hover {
    background-color: #3FA2DB !important;
}
.bg-success,
.badge-success {
	background-color:rgba(40, 199, 111, 0.16);
    color: #28C76F;
}
.badge-success-light {
	background-color: rgba(40, 199, 111, 0.08);
    color: rgba(40, 199, 111, 0.48);
}
a.bg-success:focus, 
a.bg-success:hover, 
button.bg-success:focus, 
button.bg-success:hover {
    background-color: #699834 !important;
}
a.bg-info:focus, 
a.bg-info:hover, 
button.bg-info:focus, 
button.bg-info:hover {
    background-color: #028ee1 !important;
}
.bg-warning,
.badge-warning {
	background-color: rgba(255, 159, 67, 0.48) !important;
	color: #FF9F43;
}
a.bg-warning:focus, 
a.bg-warning:hover, 
button.bg-warning:focus, 
button.bg-warning:hover {
    background-color: #e9ab2e !important;
}
.bg-danger,
.badge-danger {
	background-color:rgba(255, 0, 0, 0.16) !important;
	color: #FF0000;
}
a.bg-danger:focus, 
a.bg-danger:hover, 
button.bg-danger:focus, 
button.bg-danger:hover {
    background-color: #e63333 !important;
}
.bg-white {
	background-color: #fff;
}
.bg-purple,
.badge-purple {
    background-color: #9368e9 !important;
}
.text-primary,
.dropdown-menu > li > a.text-primary {
	color: #3FA2DB !important;
}
.text-success,
.dropdown-menu > li > a.text-success {
	color: #699834 !important;
}
.text-danger,
.dropdown-menu > li > a.text-danger {
	color: #e84646 !important;
}
.text-light-danger,
.dropdown-menu > li > a.text-danger {
	color: #E87373 !important;
}
.text-info,
.dropdown-menu > li > a.text-info {
	color: #009efb !important;
}
.text-warning,
.dropdown-menu > li > a.text-warning {
	color: #ffbc34 !important;
}
.text-purple,
.dropdown-menu > li > a.text-purple {
	color: #7460ee !important;
}
.text-muted {
    color: #757575 !important;
}
.btn-primary {
	font-size: 16px;
	font-weight: 500;
	padding: 10px 20px;
	border-radius: 30px;
	color: #FFF;
	border: 1px solid #3FA2DB;
	background: #3FA2DB;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary.active,
.btn-primary:active,
.open > .dropdown-toggle.btn-primary {
	color: #3FA2DB;
	border: 1px solid #3FA2DB;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    background: transparent;
}
.btn-primary.active.focus,
.btn-primary.active:focus,
.btn-primary.active:hover,
.btn-primary.focus:active,
.btn-primary:active:focus,
.btn-primary:active:hover,
.open > .dropdown-toggle.btn-primary.focus,
.open > .dropdown-toggle.btn-primary:focus,
.open > .dropdown-toggle.btn-primary:hover {
	background-color: #3FA2DB;
	border: 1px solid #3FA2DB;
}
.btn-primary.active:not(:disabled):not(.disabled),
.btn-primary:active:not(:disabled):not(.disabled),
.show > .btn-primary.dropdown-toggle {
	background-color: #3FA2DB;
	border-color: #3FA2DB;
	color: #fff;
}
.btn-primary.active:focus:not(:disabled):not(.disabled), 
.btn-primary:active:focus:not(:disabled):not(.disabled), 
.show > .btn-primary.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-primary.disabled, .btn-primary:disabled {
    background-color: #FFBC53;
    border-color: #FFBC53;
    color: #fff;
}
.btn-secondary {
	font-size: 16px;
	font-weight: 500;
	padding: 10px 20px;
	border-radius: 30px;
	color: #000;
	border: 1px solid #F7D333;
	background: #F7D333;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-secondary:hover {
	color: #000;
	border: 1px solid #F7D333;
	background: transparent;
}
.btn-secondary.active:focus:not(:disabled):not(.disabled), 
.btn-secondary:active:focus:not(:disabled):not(.disabled), 
.show > .btn-secondary.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-primary-line {
	border: 2px solid #3FA2DB;
    width: calc(100% - 5px);
    display: block;
	color: #3FA2DB;
    padding: 4px 7px;
    border-radius: 5px;
	outline: none;
}
.btn-primary-line:hover {
	background: #3FA2DB;
    color: #fff;
}
.btn-success {
	background-color: #28C76F;
	border: 1px solid #28C76F
}
.btn-success:hover,
.btn-success:focus,
.btn-success.active,
.btn-success:active,
.open > .dropdown-toggle.btn-success {
	background-color: transparent;
	border: 1px solid #699834;
	color: #fff;
}
.btn-success.active.focus,
.btn-success.active:focus,
.btn-success.active:hover,
.btn-success.focus:active,
.btn-success:active:focus,
.btn-success:active:hover,
.open > .dropdown-toggle.btn-success.focus,
.open > .dropdown-toggle.btn-success:focus,
.open > .dropdown-toggle.btn-success:hover {
	background-color: #699834;
	border: 1px solid #699834
}
.btn-success.active:not(:disabled):not(.disabled),
.btn-success:active:not(:disabled):not(.disabled),
.show > .btn-success.dropdown-toggle {
	background-color: #699834;
	border-color: #699834;
	color: #fff;
}
.btn-success.active:focus:not(:disabled):not(.disabled), 
.btn-success:active:focus:not(:disabled):not(.disabled), 
.show > .btn-success.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-success.disabled, .btn-success:disabled {
    background-color: #7bb13c;
    border-color: #7bb13c;
    color: #fff;
}
.btn-info {
	background-color: #009efb;
	border: 1px solid #009efb
}
.btn-info:hover,
.btn-info:focus,
.btn-info.active,
.btn-info:active,
.open > .dropdown-toggle.btn-info {
	background-color: transparent;
	border: 1px solid #028ee1
}
.btn-info.active.focus,
.btn-info.active:focus,
.btn-info.active:hover,
.btn-info.focus:active,
.btn-info:active:focus,
.btn-info:active:hover,
.open > .dropdown-toggle.btn-info.focus,
.open > .dropdown-toggle.btn-info:focus,
.open > .dropdown-toggle.btn-info:hover {
	background-color: #028ee1;
	border: 1px solid #028ee1
}
.btn-info.active:not(:disabled):not(.disabled),
.btn-info:active:not(:disabled):not(.disabled),
.show > .btn-info.dropdown-toggle {
	background-color: #028ee1;
	border-color: #028ee1;
	color: #fff;
}
.btn-info.active:focus:not(:disabled):not(.disabled), 
.btn-info:active:focus:not(:disabled):not(.disabled), 
.show > .btn-info.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-info.disabled, .btn-info:disabled {
    background-color: #009efb;
    border-color: #009efb;
    color: #fff;
}
.btn-warning {
	background-color: #ffbc34;
	border: 1px solid #ffbc34
}
.btn-warning:hover,
.btn-warning:focus,
.btn-warning.active,
.btn-warning:active,
.open > .dropdown-toggle.btn-warning {
	background-color: transparent;
	border: 1px solid #e9ab2e
}
.btn-warning.active.focus,
.btn-warning.active:focus,
.btn-warning.active:hover,
.btn-warning.focus:active,
.btn-warning:active:focus,
.btn-warning:active:hover,
.open > .dropdown-toggle.btn-warning.focus,
.open > .dropdown-toggle.btn-warning:focus,
.open > .dropdown-toggle.btn-warning:hover {
	background-color: #e9ab2e;
	border: 1px solid #e9ab2e
}
.btn-warning.active:not(:disabled):not(.disabled),
.btn-warning:active:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle {
	background-color: #e9ab2e;
	border-color: #e9ab2e;
	color: #fff;
}
.btn-warning.active:focus:not(:disabled):not(.disabled), 
.btn-warning:active:focus:not(:disabled):not(.disabled), 
.show > .btn-warning.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-warning.disabled, .btn-warning:disabled {
    background-color: #ffbc34;
    border-color: #ffbc34;
    color: #fff;
}
.btn-danger {
	font-size: 16px;
	font-weight: 400;
	color: #FFF;
	padding: 8px 20px;
	background-color: #CC0001;
	border: 1px solid #CC0001;
	border-radius: 30px;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-danger:hover,
.btn-danger:focus,
.btn-danger.active,
.btn-danger:active,
.open > .dropdown-toggle.btn-danger {
	color: #CC0001;
	background-color: transparent;
	border: 1px solid #CC0001;
}
.btn-danger.active.focus,
.btn-danger.active:focus,
.btn-danger.active:hover,
.btn-danger.focus:active,
.btn-danger:active:focus,
.btn-danger:active:hover,
.open > .dropdown-toggle.btn-danger.focus,
.open > .dropdown-toggle.btn-danger:focus,
.open > .dropdown-toggle.btn-danger:hover {
	background-color: #CC0001;
	border: 1px solid #CC0001;
}
.btn-danger.active:not(:disabled):not(.disabled),
.btn-danger:active:not(:disabled):not(.disabled),
.show > .btn-danger.dropdown-toggle {
	background-color: #CC0001;
	border-color: #CC0001;
	color: #fff;
}
.btn-danger.active:focus:not(:disabled):not(.disabled), 
.btn-danger:active:focus:not(:disabled):not(.disabled), 
.show > .btn-danger.dropdown-toggle:focus {
	box-shadow: unset;
}
.btn-danger.disabled, .btn-danger:disabled {
    background-color: #f62d51;
    border-color: #f62d51;
    color: #fff;
}
.btn-light {
	font-size: 16px;
	font-weight: 500;
	padding: 10px 20px;
	border-radius: 30px;
	color: #898989;
	border: 1px solid #E6E6E6;
	background: #E6E6E6;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-light:hover {
	color: #000;
	border: 1px solid #d3d4d5;
	background: #d3d4d5;
}
.btn-light.active:focus:not(:disabled):not(.disabled), 
.btn-light:active:focus:not(:disabled):not(.disabled), 
.show > .btn-light.dropdown-toggle:focus {
    box-shadow: unset;
}
.btn-dark.active:focus:not(:disabled):not(.disabled), 
.btn-dark:active:focus:not(:disabled):not(.disabled), 
.show > .btn-dark.dropdown-toggle:focus {
    box-shadow: unset;
}
.btn-black {
	font-size: 16px;
	font-weight: 500;
	padding: 10px 20px;
	border-radius: 30px;
	color: #FFF;
	border: 1px solid #000;
	background: #000;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-black:hover {
	color: #000;
	border: 1px solid #000;
	background: transparent;
}
.btn-gray {
	font-size: 16px;
	font-weight: 500;
	padding: 10px 20px;
	border-radius: 30px;
	color: #000;
	border: 1px solid #898989;
	background: #898989;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-gray:hover {
	color: #FFF;
	border: 1px solid #000;
	background: transparent;
}
.btn-outline-primary {
	color: #FFBC53;
	border-color: #FFBC53;
}
.btn-outline-primary:hover {
	background-color: #FFBC53;
	border-color: #FFBC53;
}
.btn-outline-primary:focus, 
.btn-outline-primary.focus {
	box-shadow: none;
}
.btn-outline-primary.disabled, 
.btn-outline-primary:disabled {
	color: #FFBC53;
	background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, 
.btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
	background-color: #FFBC53;
	border-color: #FFBC53;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, 
.btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-success {
	color: #7bb13c;
	border-color: #7bb13c;
}
.btn-outline-success:hover {
	background-color: #7bb13c;
	border-color: #7bb13c;
}
.btn-outline-success:focus, .btn-outline-success.focus {
	box-shadow: none;
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
	color: #7bb13c;
	background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, 
.btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
	background-color: #7bb13c;
	border-color: #7bb13c;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, 
.btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
	box-shadow: none;
}
.box-shadow-none{
	box-shadow: none !important;
}
.btn-outline-info {
	color: #009efb;
	border-color: #009efb;
}
.btn-outline-info:hover {
	color: #fff;
	background-color: #009efb;
	border-color: #009efb;
}
.btn-outline-info:focus, .btn-outline-info.focus {
	box-shadow: none;
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
	background-color: transparent;
	color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled):active, 
.btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
	background-color: #009efb;
	border-color: #009efb;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, 
.btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-warning {
	color: #ffbc34;
	border-color: #ffbc34;
}
.btn-outline-warning:hover {
	color: #212529;
	background-color: #ffbc34;
	border-color: #ffbc34;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
	box-shadow: none;
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
	background-color: transparent;
	color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, 
.btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
	color: #212529;
	background-color: #ffbc34;
	border-color: #ffbc34;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, 
.btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-danger {
	color: #e84646;
	border-color: #e84646;
}
.btn-outline-danger:hover {
	color: #fff;
	background-color: #e84646;
	border-color: #e84646;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
	box-shadow: none;
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
	background-color: transparent;
	color: #e84646;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, 
.btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
	background-color: #e84646;
	border-color: #e84646;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, 
.btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
	box-shadow: none;
}
.btn-outline-light {
    color: #ababab;
    border-color: #e6e6e6;
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
    color: #ababab;
}
.btn-primary-light {
	font-size: 16px;
	font-weight: 400;
	color: #3FA2DB;
	padding: 8px 15px;
	background: transparent;
	border: 1px solid #3FA2DB;
	border-radius: 30px;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-primary-light:hover {
	color: #FFF;
	background: #3FA2DB;
	border: 1px solid #3FA2DB;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-secondary-light {
	font-size: 16px;
	font-weight: 400;
	color: #F7D333;
	padding: 8px 15px;
	background: transparent;
	border: 1px solid #F7D333;
	border-radius: 30px;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-secondary-light:hover {
	color: #FFF;
	background: #F7D333;
	border: 1px solid #F7D333;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-danger-light {
	font-size: 16px;
	font-weight: 400;
	color: #CC0001;
	padding: 8px 15px;
	background: transparent;
	border: 1px solid #CC0001;
	border-radius: 30px;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-danger-light:hover {
	color: #FFF;
	background: #CC0001;
	border: 1px solid #CC0001;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-dark-light {
	font-size: 16px;
	font-weight: 400;
	color: #000;
	padding: 8px 15px;
	background: transparent;
	border: 1px solid #000;
	border-radius: 30px;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.btn-dark-light:hover {
	color: #FFF;
	background: #000;
	border: 1px solid #000;
	moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.pagination > .active > a, 
.pagination > .active > a:focus,
.pagination > .active > a:hover,
.pagination > .active > span,
.pagination > .active > span:focus,
.pagination > .active > span:hover {
	background-color: #FFBC53;
	border-color: #FFBC53;
}
.pagination > li > a, 
.pagination > li > span {
	color: #FFBC53;
}
input:disabled,select:disabled{
	background: #F1F1F2 !important;
}
.page-link:hover {
	color: #FFBC53;
}
.page-link:focus {
	box-shadow: unset;
}
.page-item.active .page-link {
	background-color: #FFBC53;
	border-color: #FFBC53;
}
.dropdown-menu {
	border: 0;
	border-radius: 8px;
	transform-origin: left top 0;
	box-shadow: 0px 0px 10px -1px #00000040;
	background-color: #FFF;
}
.dropdown-menu::-webkit-scrollbar {
	width: 5px;
}
.dropdown-menu::-webkit-scrollbar-track {
	box-shadow: inset 0 0 10px #D9D9D9; 
	border-radius: 5px;
}
.dropdown-menu::-webkit-scrollbar-thumb {
	background: #AAA; 
	border-radius: 5px;
}
.dropdown-menu::-webkit-scrollbar-thumb:hover {
	background: #AAA; 
}
.dropdown-item.active, .dropdown-item:active {
    background-color: #FFF;
}
.navbar-nav .open .dropdown-menu {
	border: 0;
	box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	background-color: #fff;
}
.dropdown-menu {
	font-size: 14px;
}
.card {
	background: #FFF;
    border: 0;
    border-radius: 15px;
    box-shadow: 0px 0px 10px -1px #00000040;
    margin-bottom: 24px;
}
.card-body {
	padding: 24px;
}
.card-header {
	border-bottom: 1px solid #e6e6e6;
	padding: 1rem 1.5rem;
}
.card-footer {
	background-color: #fff;
	border-top: 1px solid #e6e6e6;
	padding: 1rem 1.5rem;
}
.card .card-header {
    background-color: #fff;
    border-bottom: 1px solid #eaeaea;
}
.card .card-header .card-title {
    margin-bottom: 0;
    font-size: 18px;
}
.modal-footer.text-left {
	text-align: left;
}
.modal-footer.text-center {
	text-align: center;
}
.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td.active:hover {
	background-color: #3FA2DB;
	text-shadow: unset;
}
.bootstrap-datetimepicker-widget table td.today:before{
	border-bottom-color:#FFBC53;
}
.bg-info-light{
	background-color:rgba(2, 182, 179,0.12) !important;
	color:#1db9aa !important;
}
.bg-primary-light{
	background-color:rgba(17, 148, 247,0.12) !important;
	color:#2196f3 !important;
}
.bg-danger-light{
	background-color:#FFBC53 !important;
	color:#fff !important;
}
.bg-warning-light{
	background-color:rgba(255, 152, 0,0.12) !important;
	color:#f39c12 !important;
}
.bg-success-light{
	background-color: #3FA2DB;
    color: #fff;
}
.bg-purple-light{
	background-color:rgba(197, 128, 255,0.12) !important;
	color:#c580ff !important;
}
.badge-highlight {
    background: rgba(0, 207, 232, 0.24) !important;
    color: rgba(0, 207, 232, 0.48);
}
.bg-default-light{
	background-color:rgba(40, 52, 71,0.12) !important;
	color:#283447 !important;
}
.bg-success-light:hover {
	color: #fff;
}
div.dataTables_wrapper div.dataTables_paginate ul.pagination {
	margin: 15px 0 0;
}
div.dataTables_wrapper div.dataTables_info {
    padding-top: 25px;
}
div.dataTables_wrapper div.dataTables_length select {
	appearance: auto;
}
.badge{
	padding: 5px 10px;
	border-radius: 4px;
	font-size: 13px;
    font-weight: 500;
    -webkit-background-clip: initial;
    -webkit-text-fill-color: initial;
}
.dropdown-toggle {
    font-size: 15px;
    color: #000;
    background: transparent;
    border: 0;
}
.dropdown-toggle::after {
	display: none;
}
.dropdown-menu {
    min-width: 160px;
    border-radius: 8px;
    border: 0;
    padding: 0;
    box-shadow: 0px 0px 10px -1px #00000040;
}
.dropdown-menu .dropdown-item {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	font-size: 14px;
	color: #000;
	padding: 10px 15px;
	border-bottom: 1px solid #EFEFEF;
	border-radius: 0;
	-webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}
.dropdown-menu .dropdown-item:first-child {
    border-radius: 8px 8px 0 0;
}
.dropdown-menu .dropdown-item:last-child {
    border-radius: 0 0 8px 8px;
    border-bottom: 0;
}
.dropdown-menu .dropdown-item:hover {
    color: #3FA2DB;
    padding-left: 20px;
    -webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}
.dropdown-menu .dropdown-item.active {
	color: #3FA2DB;
}
.dropdown-menu .dropdown-item.active:hover {
	background: #f8f9fa;
}
.dropdown-menu .dropdown-item i {
	font-size: 18px;
	margin-right: 8px;
}
.dropdown-menu .dropdown-item img {
	margin-right: 8px;
}

/*-----------------
	5. Select2
-----------------------*/
select {
	outline: none;
}
.select2-container {
	width: 100% !important;
}
.select2-search--dropdown {
	display: none;
}
.select2-dropdown {
	border: 1px solid #EFEFEF;
	border-radius: 0;
}
.select2-container .select2-selection--single {
	border: 0;
	border-bottom: 1px solid #00000038;
	border-radius: 0;
	height: 40px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 38px;
	right: 10px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow b {
	border-color: #000;
    border-style: solid;
    border-width: 0 2px 2px 0;
    padding: 3px;
    height: 0;
    margin-left: -6px;
    margin-top: -3px;
    width: 0;
    transform: rotate(45deg) translateY(-50%);
    -webkit-transform: rotate(45deg) translateY(-50%);
    -ms-transform: rotate(45deg) translateY(-50%);
}
.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
	border-color: #000;
    border-width: 2px 0 0 2px;
    margin-top: 3px;
    padding: 3px;
}
.select2-container .select2-selection--single .select2-selection__rendered {
	padding-top: 0;
	padding-bottom: 0;
	padding-left: 0;
	padding-right: 30px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
	font-size: 14px;
	color: #898989;
	font-weight: normal;
	line-height: 38px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered::placeholder {
	color: #898989;
}
.select2-container--default .select2-results__option--highlighted[aria-selected] {
	background-color: #EFEFEF;
	color: #333;
}
.select2-results .select2-highlighted {
    background: #3ea211;
}
.select2-container--default .select2-selection--multiple {
	border: 1px solid #00000038;
	min-height: 40px;
}
.select2-results__option {
	font-size: 14px;
	color: #898989;
	border-radius: 0;
	padding: 8px 15px;
}
.select2-container--default .select2-results__option[aria-selected=true] {
    background-color: #EFEFEF;
}
.select2-container--default .select2-search--dropdown .select2-search__field {
    border: 1px solid #3333;
}
.select2-search--dropdown .select2-search__field {
	font-size: 14px;
    padding: 4px 10px;
    width: 100%;
    box-sizing: border-box;
    border-radius: 5px;
}
.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar {
	width: 5px;
}
.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar-track {
	box-shadow: inset 0 0 10px #D9D9D9; 
	border-radius: 5px;
}
.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar-thumb {
	background: #AAA; 
	border-radius: 5px;
}
.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar-thumb:hover {
	background: #AAA; 
}

/*-----------------
	6. Nav Tabs
-----------------------*/

.nav-tabs {
	border-bottom: 1px solid #e6e6e6;
}
.card-header-tabs {
    border-bottom: 0;
}
.nav-tabs > li > a {
	margin-right: 0;
	color: #888;
	border-radius: 0;
}
.nav-tabs > li > a:hover,
.nav-tabs > li > a:focus {
	border-color: transparent;
	color: #333;
}
.nav-tabs.nav-tabs-solid > li > a {
	color: #333;
}
.nav-tabs.nav-tabs-solid > .active > a,
.nav-tabs.nav-tabs-solid > .active > a:hover,
.nav-tabs.nav-tabs-solid > .active > a:focus {
	background-color: #FFBC53;
	border-color: #FFBC53;
	color: #fff;
}
.tab-content {
	padding-top: 0;
}
.nav-tabs .nav-link {
	border-radius: 0;
}
.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {
    background-color: #eee;
    border-color: transparent;
	color: #333;
}
.nav-tabs.nav-justified > li > a {
	border-radius: 0;
	margin-bottom: 0;
}
.nav-tabs.nav-justified > li > a:hover,
.nav-tabs.nav-justified > li > a:focus {
	border-bottom-color: #ddd;
}
.nav-tabs.nav-justified.nav-tabs-solid > li > a {
	border-color: transparent;
}
.nav-tabs.nav-tabs-solid > li > a {
	color: #333;
}
.nav-tabs.nav-tabs-solid > li > a.active,
.nav-tabs.nav-tabs-solid > li > a.active:hover,
.nav-tabs.nav-tabs-solid > li > a.active:focus {
	background-color: #FFBC53;
	border-color: #FFBC53;
	color: #fff;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded {
	border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {
	border-radius: 50px;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,
.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {
	border-radius: 50px;
}
.nav-tabs-justified > li > a {
	border-radius: 0;
	margin-bottom: 0;
}
.nav-tabs-justified > li > a:hover,
.nav-tabs-justified > li > a:focus {
	border-bottom-color: #ddd;
}
.nav-tabs-justified.nav-tabs-solid > li > a {
	border-color: transparent;
}
.nav-tabs.nav-justified.nav-tabs-top {
	border-bottom: 1px solid #ddd;
}
.nav-tabs.nav-justified.nav-tabs-top > li > a,
.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,
.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li {
	margin-bottom: 0;
}
.nav-tabs.nav-tabs-top > li > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top > li.open > a,
.nav-tabs.nav-tabs-top > li > a:hover,
.nav-tabs.nav-tabs-top > li > a:focus {
	border-top-color: #ddd;
}
.nav-tabs.nav-tabs-top > li+li > a {
	margin-left: 1px;
}
.nav-tabs.nav-tabs-top > li > a.active,
.nav-tabs.nav-tabs-top > li > a.active:hover,
.nav-tabs.nav-tabs-top > li > a.active:focus {
	border-top-color: #FFBC53;
}
.nav-tabs.nav-tabs-bottom > li {
	margin-bottom: -1px;
}
.nav-tabs.nav-tabs-bottom > li > a.active, 
.nav-tabs.nav-tabs-bottom > li > a.active:hover, 
.nav-tabs.nav-tabs-bottom > li > a.active:focus {
	border-bottom-width: 2px;
	border-color: transparent;
	border-bottom-color: #FFBC53;
	background-color: transparent;
	transition: none 0s ease 0s; 
	-moz-transition: none 0s ease 0s; 
	-o-transition: none 0s ease 0s; 
	-ms-transition: none 0s ease 0s; 
	-webkit-transition: none 0s ease 0s;
}
.nav-tabs.nav-tabs-solid {
	background-color: #fafafa;
	border: 0;
}
.nav-tabs.nav-tabs-solid > li {
	margin-bottom: 0;
}
.nav-tabs.nav-tabs-solid > li > a {
	border-color: transparent;
}
.nav-tabs.nav-tabs-solid > li > a:hover,
.nav-tabs.nav-tabs-solid > li > a:focus {
	background-color: #f5f5f5;
}
.nav-tabs.nav-tabs-solid > .open:not(.active) > a {
	background-color: #f5f5f5;
	border-color: transparent;
}
.nav-tabs-justified.nav-tabs-top {
	border-bottom: 1px solid #ddd;
}
.nav-tabs-justified.nav-tabs-top > li > a,
.nav-tabs-justified.nav-tabs-top > li > a:hover,
.nav-tabs-justified.nav-tabs-top > li > a:focus {
	border-width: 2px 0 0 0;
}

/*-----------------
	7. Components
-----------------------*/

.section-header {
	margin-bottom: 1.875rem;
}
.section-header .section-title {
	color: #333;
}
.line {
	background-color: #3FA2DB;
	height: 2px;
	margin: 0;
	width: 60px;
}
.comp-buttons .btn {
	margin-bottom: 5px;
}
.pagination-box .pagination {
	margin-top: 0;
}
.comp-dropdowns .btn-group {
	margin-bottom: 5px;
}
.progress-example .progress {
	margin-bottom: 1.5rem;
}
.progress-xs {
	height: 4px;
}
.progress-sm {
	height: 15px;
}
.progress.progress-sm {
	height: 6px;
}
.progress.progress-md {
	height: 8px;
}
.progress.progress-lg {
	height: 18px;
}
.row.row-sm {
	margin-left: -3px;
	margin-right: -3px;
}
.row.row-sm > div {
	padding-left: 3px;
	padding-right: 3px;
}
.avatar {
	position: relative;
	display: inline-block;
	width: 40px;
	height: 40px;
}
.avatar > img {
	width: 100%;
	height: 100%;
	-o-object-fit: cover;
	object-fit: cover;
}
.avatar-title {
	width: 100%;
	height: 100%;
	background-color: #F7D333;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
}
.avatar-away:before,
.avatar-offline:before,
.avatar-online:before {
	position: absolute;
	right: 0;
	bottom: 0;
	width: 25%;
	height: 25%;
	border-radius: 50%;
	content: '';
	border: 2px solid #fff;
}
.avatar-online:before {
	background-color: #7bb13c;
}
.avatar-offline:before {
	background-color: #e84646;
}
.avatar-away:before {
	background-color: #ffbc34;
}
.avatar .border {
	border-width: 3px !important;
}
.avatar .rounded {
	border-radius: 6px !important;
}
.avatar .avatar-title {
	font-size: 16px;
}
.avatar-xs {
	width: 1.65rem;
	height: 1.65rem;
}
.avatar-xs .border {
	border-width: 2px !important;
}
.avatar-xs .rounded {
	border-radius: 4px !important;
}
.avatar-xs .avatar-title {
	font-size: 12px;
}
.avatar-xs.avatar-away:before,
.avatar-xs.avatar-offline:before,
.avatar-xs.avatar-online:before {
	border-width: 1px;
}
.avatar-sm {
	width: 2.5rem;
	height: 2.5rem;
}
.avatar-sm .border {
	border-width: 3px !important;
}
.avatar-sm .rounded {
	border-radius: 4px !important;
}
.avatar-sm .avatar-title {
	font-size: 15px;
}
.avatar-sm.avatar-away:before,
.avatar-sm.avatar-offline:before,
.avatar-sm.avatar-online:before {
	border-width: 2px;
}
.avatar-lg {
	width: 3.75rem;
	height: 3.75rem;
}
.avatar-lg .border {
	border-width: 3px !important;
}
.avatar-lg .rounded {
	border-radius: 8px !important;
}
.avatar-lg .avatar-title {
	font-size: 24px;
}
.avatar-lg.avatar-away:before,
.avatar-lg.avatar-offline:before,
.avatar-lg.avatar-online:before {
	border-width: 3px;
}
.avatar-xl {
	width: 5rem;
	height: 5rem;
}
.avatar-xl .border {
	border-width: 4px !important;
}
.avatar-xl .rounded {
	border-radius: 8px !important;
}
.avatar-xl .avatar-title {
	font-size: 28px;
}
.avatar-xl.avatar-away:before,
.avatar-xl.avatar-offline:before,
.avatar-xl.avatar-online:before {
	border-width: 4px;
}
.avatar-xxl {
	width: 5.125rem;
	height: 5.125rem;
}
.avatar-xxl .border {
	border-width: 6px !important;
}
.avatar-xxl .rounded {
	border-radius: 8px !important;
}
.avatar-xxl .avatar-title {
	font-size: 30px;
}
.avatar-xxl.avatar-away:before,
.avatar-xxl.avatar-offline:before,
.avatar-xxl.avatar-online:before {
	border-width: 4px;
}
.avatar-group {
	display: inline-flex;
}
.avatar-group .avatar + .avatar {
	margin-left: -.75rem;
}
.avatar-group .avatar-xs + .avatar-xs {
	margin-left: -.40625rem;
}
.avatar-group .avatar-sm+.avatar-sm {
	margin-left: -.625rem;
}
.avatar-group .avatar-lg + .avatar-lg {
	margin-left: -1rem;
}
.avatar-group .avatar-xl + .avatar-xl {
	margin-left: -1.28125rem;
}
.avatar-group .avatar:hover {
	z-index: 1;
}
.alert {
    position: relative;
    padding: 0.75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: 0.25rem;
}
.alert-dismissible .close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 0.75rem 1.25rem;
    color: inherit;
    border: none;
    background: transparent;
}

/*-----------------
	8. Header
-----------------------*/

.header {
	background: #000;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	z-index: 11;
	height:100px;
}
.header .header-left {
	float: left;
    height: 100px;
    position: relative;
    width: 170px;
    z-index: 1;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
	margin-left: 20px;
	margin-right: 60px;
}
.header .header-left .logo {
	display: inline-block;
}
.header .header-left .logo img {
	max-height: 60px;
	width: auto;
}
.header-left .logo.logo-small {
	display: none;
}
.header .dropdown-menu > li > a {
	position: relative;
}
.header .has-arrow .dropdown-toggle:after {
	border-top: 0;
	border-left: 0;
	border-bottom: 2px solid #FFF;
	border-right: 2px solid #FFF;
	content: '';
	height: 8px;
	display: inline-block;
	pointer-events: none;
	-webkit-transform-origin: 66% 66%;
	-transform-origin: 66% 66%;
	transform-origin: 66% 66%;
	-webkit-transform: rotate(45deg);
	-transform: rotate(45deg);
	transform: rotate(45deg);
	-webkit-transition: all 0.15s ease-in-out;
	transition: all 0.15s ease-in-out;
	width: 8px;
	vertical-align: 2px;
}
.header .has-arrow .dropdown-toggle[aria-expanded="true"]:after {
	-webkit-transform: rotate(-135deg);
	-transform: rotate(-135deg);
	transform: rotate(-135deg);
}
.header .has-arrow .dropdown-toggle:hover {
	color: #FFF;
}
.user-menu {
	float: right;
	margin: 0;
	position: relative;
	height: 100px;
	z-index: 99;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	padding-right: 20px;
}
.user-menu.nav > li > a:hover i,
.user-menu.nav > li > a:focus i {
	opacity: .8;
}
.user-img {
	display: inline-block;
	margin-right: 3px;
	position: relative;
}
.user-img img {
	width: 32px;
    border-radius: 50%;
}
.dropdown-item img {
	margin-right: 5px;
}
.user-menu.nav > li > a.mobile_btn {
	border: 0;
	position: relative;
	padding: 0;
	margin: 0;
	cursor: pointer
}
.user-menu .dropdown-menu {
	min-width: 200px;
	padding: 0;
}
.user-menu .dropdown-menu .dropdown-item {
	font-size: 14px;
	color: #000;
	display: flex;
	align-items: center;
	padding: 10px 15px;
}
.user-menu .dropdown-menu .dropdown-item:hover {
	padding-left: 20px;
	color: #3FA2DB;
	background-color: transparent;
}
.user-menu li {
	margin-right: 30px;
	position: relative;
}
.user-menu li a {
	font-size: 16px;
	color: #FFF;
}
.user-menu li a:hover {
	color: #3FA2DB;
}
.user-menu li a.active {
	border-radius: 30px;
	color: #FFF;
	background: #3FA2DB;
}
.user-menu li a.active:hover {
	color: #FFF;
}
.user-menu li .btn {
	padding: 5px 20px;
	color: #FFF;
}
.user-menu li .btn:hover {
	color: #CC0001;
}
.top-nav-search {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	max-width: 240px;
}
.top-nav-form {
	position: relative;
}
.top-nav-search .form-control {
	padding-left: 20px;
	color: #FFF;
	background: transparent;
	border-bottom: 1px solid #CCCCCC;
}
.top-nav-search .form-control::placeholder {
	color: #CCCCCC;
}
.top-nav-search i {
	position: absolute;
	top: 50%;
    transform: translateY(-50%);
	color: #898989;
}
.top-nav-search .btn {
	font-size: 20px;
	border: 1px solid #DDD;
	border-radius: 30px;
	background: #FFF;
	color: #000;
	width: 36px;
	height: 36px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    transition: .4s;
    -webkit-transition: .4s;
	-moz-transition: .4s;
}
.top-nav-search .btn:hover {
	background: #3FA2DB;
	color: #FFF;
	border: 1px solid #3FA2DB;
	transition: .4s;
    -webkit-transition: .4s;
	-moz-transition: .4s;
}
.user-menu li a.header-profile {
	color: #FFFFFF;
}
.user-menu li a.header-profile:hover {
	color: #3FA2DB;
}
.user-menu li a.header-bar {
	color: #FFFFFF;
}
.user-menu li a.header-bar:hover {
	color: #3FA2DB;
}
.user-menu li a.header-bar span {
    background: #FFF;
    display: block;
    height: 1.5px;
    margin-bottom: 7px;
    width: 34px;
}
.user-menu li a.header-bar span:nth-child(3) {
	margin-bottom: 0;
}
.header .dropdown-menu > li > a:focus,
.header .dropdown-menu > li > a:hover {
	background-color: #7638ff;
	color: #fff;
}
.header .dropdown-menu > li > a:focus i,
.header .dropdown-menu > li > a:hover i {
	color: #fff;
}
.header .dropdown-menu > li > a {
	padding: 10px 18px;
}
.header .dropdown-menu > li > a i {
	color: #7638ff;
	margin-right: 10px;
	text-align: center;
	width: 18px;
}
.header .user-menu .dropdown-menu > li > a i {
	color: #7638ff;
	font-size: 16px;
	margin-right: 10px;
	min-width: 18px;
	text-align: center;
}
.header .user-menu .dropdown-menu > li > a:focus i,
.header .user-menu .dropdown-menu > li > a:hover i {
	color: #fff;
}
.mobile_btn {
	display: none;
	float: left;
}
.bar-icon {
    display: inline-block;
    width: 24px;
}
.bar-icon span {
    background-color: #FFF;
    display: block;
    float: left;
    height: 2px;
    margin-bottom: 6px;
    width: 31px;
    transition: all 0.5s;
}
.bar-icon span:nth-child(2) {
	width: 16px;
}
.bar-icon span:nth-child(3) {
	margin-bottom: 0;
}
.menu-opened .slide-nav .bar-icon span:first-child {
    position: relative;
    top: 9px;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -ms-transform: rotate(45deg);
}
.menu-opened .slide-nav .bar-icon span:nth-child(2) {
    display: none;
}
.menu-opened .slide-nav .bar-icon span:last-child {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    -ms-transform: rotate(135deg);
}
.slide-nav .sidebar {
	margin-left: 0;
}
.menu-title {
	color: #a3a3a3;
	display: block;
	font-size: 14px;
	margin-bottom: 5px;
	padding: 0 25px;
}
.sidebar-overlay {
	background-color: rgba(0, 0, 0, 0.6);
	display: none;
	height: 100%;
	left: 0;
	position: fixed;
	top: 100px;
	width: 100%;
	z-index: 1;
}
.sidebar-overlay.opened {
	display: block;
}
.slimScrollBar {
	background: transparent !important;
}
html.menu-opened {
	overflow: hidden;
}
html.menu-opened body {
	overflow: hidden;
}
.mobile-menu {
	display: inline-block;
	position: relative;
	width: auto;
	padding: 0;
}
.toggler {
	display: none;
}
.mobile-search {
	display: none;
}
#menuToggle {
	position: absolute;
	top: 50%;
	right: -30px;
	transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
	display: block;
	z-index: 1;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}
#menuToggle input {
	display: block;
	width: 40px;
	height: 36px;
	position: absolute;
	top: -7px;
	left: -5px;
	cursor: pointer;
	opacity: 0;
	z-index: 2;
	-webkit-touch-callout: none;
}
#menuToggle span {
  display: block;
  width: 36px;
  height: 1.5px;
  margin-bottom: 6px;
  position: relative;
  background: #FFF;
  border-radius: 0;
  z-index: 1;
  transform-origin: 4px 0px;
  transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
  background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),
  opacity 0.55s ease;
}
#menuToggle span:first-child {
	transform-origin: 0% 0%;
}
#menuToggle span:nth-last-child(2) {
	transform-origin: 0% 100%;
}
#menuToggle input:checked ~ span {
	width: 26px;
	opacity: 1;
	transform: rotate(45deg) translate(-3px, -3px);
	background: #232323;
}
#menuToggle input:checked ~ span:nth-last-child(3) {
	width: 26px;
	opacity: 0;
	margin-bottom: 0;
	transform: rotate(0deg) scale(0.2, 0.2);
}
#menuToggle input:checked ~ span:nth-last-child(2) {
	width: 26px;
	opacity: 1;
	transform: rotate(-45deg) translate(-1px, 1px);
}
#menu {
    position: absolute;
    width: 250px;
    margin: -46px 0 0;
    padding: 60px 60px 0 50px;
    right: -10px;
    background: #FFF;
    box-shadow: 0px 4px 10px -1px #00000040;
    border-radius: 10px;
    text-align: center;
    list-style-type: none;
    -webkit-font-smoothing: antialiased;
    transform-origin: 0% 0%;
    transform: translate(110%, 0);
    transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);
}
#menu li {
	padding: 15px 0;
	margin-right: 0;
}
#menu .version-nav-item {
	font-size: 12px;
	font-weight: 500;
	color: #AAAAAA;
	padding: 30px 0 20px;
}
.user-menu li #menu a {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	color: #000;
}
.user-menu li #menu a:hover {
	color: #00568E;
}
.user-menu li #menu a.active {
	color: #00568E;
}
.user-menu li #menu a i {
	font-size: 18px;
	margin-right: 10px;
}
#menuToggle input:checked ~ ul {
	transform: none;
	opacity: 1;
}
.clinic-nav-item a {
	font-size: 14px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}
.clinic-nav-item a p {
	font-size: 13px;
	font-weight: 300;
	color: #FFF;
	margin-bottom: 0;
}
.clinic-nav-item a p:hover {
	color: #3FA2DB;
}
.clinic-nav-item a span {
	font-size: 16px;
	font-weight: 500;
	display: block;
}
.clinic-nav-item a img {
	width: 60px;
	min-width: 60px;
	height: 60px;
	border-radius: 50px;
	margin-left: 20px;
	object-fit: cover;
}
.clinic-nav-item a .doctor-menu-img {
	background: #eaeaea;
	border-radius: 6px;
	margin-left: 0;
	margin-right: 15px;
}
.user-menu li .notification-link {
	font-size: 16px;
	color: #000;
	width: 34px;
	height: 34px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	background: #F2F2F2;
	border-radius: 50%;
}
.user-menu li .notification-link .badge {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	font-size: 10px;
	font-weight: 400;
	width: 15px;
	min-width: 15px;
	height: 15px;
	padding: 0;
	border-radius: 50px;
	top: -3px;
	right: 0;
	position: absolute;
	animation: pulse-animation 2s infinite;
}
.user-menu li .notification-link .badge-primary {
	background: #3FA2DB;
	color: #FFF;
}
@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(63, 162, 219, 0.6);
  }
  100% {
    box-shadow: 0 0 0 12px rgba(0, 0, 0, 0);
  }
}

/*-----------------
	9. Sidebar
-----------------------*/

.sidebar {
	float: left;
    bottom: 0;
    left: 0;
    margin-top: 0;
    position: relative;
    top: 0;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
    width: auto;
    z-index: 1001;
    overflow-y: hidden;
}
.sidebar.opened {
	transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
}
.slimScrollDiv {
	height: auto !important;
}
.sidebar-inner {
	height: auto !important;
	transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
} 
.sidebar-menu ul {
	font-size: 15px;
	list-style-type: none;
	margin: 0;
	padding: 15px 0 0;
	position: relative;
}
.sidebar-menu li {
	display: inline-block;
	margin-right: 20px;
}
.sidebar-menu li:last-child {
	margin-right: 0;
}
.sidebar-menu li a {
	color: #FFF;
    display: block;
    font-size: 16px;
    font-weight: 400;
    height: auto;
    padding: 0;
}
.sidebar-menu li.active > a {
	font-weight: 600;
	color: #FFF;
}
.sidebar-menu li a:hover {
	color: #3FA2DB;
}
.sidebar-menu li a.active {
	color: #3FA2DB;
}
.menu-title {
	color: #9e9e9e;
	display: flex;
	font-size: 14px;
	opacity: 1;
	padding: 5px 15px;
	white-space: nowrap;
}
.menu-title > i {
	float: right;
	line-height: 40px;
}
.sidebar-menu li.menu-title a {
	color: #ff9b44;
	display: inline-block;
	margin-left: auto;
	padding: 0;
}
.sidebar-menu li.menu-title a.btn {
	color: #fff;
	display: block;
	float: none;
	font-size: 15px;
	margin-bottom: 15px;
	padding: 10px 15px;
}
.sidebar-menu ul ul a.active {
    color: #000000;
}
.sidebar .sidebar-menu > ul > li > a span {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    position: relative;
    border-radius: 10px;
	background: rgba(46, 49, 146, 0.10);
	width: 40px;
	height: 40px;
	transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
}
.sidebar .sidebar-menu > ul > li > a.active span {
	background: transparent;
}
.sidebar .sidebar-menu > ul > li > a.active span:after {
	content: '';
	position: absolute;
	right: -35px;
	border-radius: 30px 0 0 30px;
	background: rgba(46, 49, 146, 0.10);
	width: 80px;
	height: 40px;
}
.right-sidebar .sidebar-menu > ul > li > a.active span:after {
	right: 0;
	border-radius: 0px 30px 30px 0px;
}
.sidebar .sidebar-menu > ul > li > a.active span img {
	position: relative;
	left: 3px;
}
.right-sidebar .sidebar-menu > ul > li > a.active span img {
	position: relative;
	left: 0;
}
.sidebar .sidebar-menu > ul > li > a span.chat-user {
	margin-left: 0;
	overflow: hidden;
	text-overflow: ellipsis;
}
.sidebar .sidebar-menu > ul > li > a span.badge {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	font-size: 12px;
	font-weight: 400;
	width: 15px;
	min-width: 15px;
	height: 15px;
	padding: 0;
	border-radius: 50px;
	top: 3px;
	right: 22px;
	position: absolute;
	animation: pulse-animation 2s infinite;
}
.sidebar .sidebar-menu > ul > li > a.active span.badge:after {
	display: none;
}
.sidebar .sidebar-menu > ul > li > a span.badge-primary {
	background: #3FA2DB;
	color: #FFF;
}
@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.6);
  }
  100% {
    box-shadow: 0 0 0 12px rgba(0, 0, 0, 0);
  }
}
.sidebar-menu ul ul a {
	display: block;
	font-size: 15px;
	padding: 7px 10px 7px 45px;
	position: relative;
}
.sidebar-menu ul ul a span {
	float: right;
	color: #FF9800;
}
.sidebar-menu ul ul {
	display: none;
}
.sidebar-menu ul ul ul a {
	padding-left: 65px;
}
.sidebar-menu ul ul ul ul a {
	padding-left: 85px;
}
.sidebar-menu > ul > li {
	margin-top: 40px;
	position: relative;
}
.sidebar-menu > ul > li:last-child {
	margin-bottom: 25px;
}
.sidebar-menu .menu-arrow {
	-webkit-transition: -webkit-transform 0.15s;
	-o-transition: -o-transform 0.15s;
	transition: transform .15s;
	position: absolute;
	right: 15px;
	display: inline-block;
    font-family: "Font Awesome 5 Free";
    font-weight: 900;
	text-rendering: auto;
	line-height: 40px;
	font-size: 16px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	-webkit-transform: translate(0, 0);
	-transform: translate(0, 0);
	-o-transform: translate(0, 0);
	transform: translate(0, 0);
	line-height: 18px;
	top: 11px;
}
.sidebar-menu .menu-arrow:before {
	content: "\\f105";
}
.sidebar-menu li a.subdrop .menu-arrow {
	-transform: rotate(90deg);
	-webkit-transform: rotate(90deg);
	-o-transform: rotate(90deg);
	transform: rotate(90deg);
}
.sidebar-menu ul ul a .menu-arrow {
	top: 10px;
}
.sidebar-menu > ul > li > a {
	transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
}
.sidebar-menu > ul > li > a svg {
    width: 18px;
}
.sidebar-menu ul li.menu-title a i {
	font-size: 16px !important;
	margin-right: 0;
	text-align: right;
	width: auto;
}
.sidebar-menu li a > .badge {
	color: #fff;
}
.sidebar.hide-sidebar,
#toggle_btn.hide-togglebtn {
	margin-left: -131px;
}
.page-wrapper.hide-pagewrapper {
	margin-left: 0;
}
.toggle-right {
	display: none;
	cursor: pointer;
	margin-right: 40px;
}
.toggle-right .bar-icon span {
	background-color: #000;
}
.toggle-right .bar-icon {
	margin-top: 11px;
}
.header-left.auto-width-logo {
	width: auto;
}
.bottom-menu li a span {
	margin: 10px auto 0;
	border-radius: 50%;
}
.bottom-menu li a span img {
	width: 40px;
	min-width: 40px;
	height: 40px;
	border-radius: 50%;
}
.sidebar .sidebar-menu ul li a span.bottom-menu-users {
	color: #FFF;
	background: #000;
	border-radius: 50%;
}
.right-sidebar {
	top: 100px;
    right: 0;
    left: inherit;
    z-index: inherit;
	box-shadow: 1px 2px 5px rgba(66, 133, 244, 0.30);
}
.right-sidebar .sidebar-menu ul {
	padding: 0 0 30px;
}
.menu-profile {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	text-align: center;
	position: absolute;
	top: 0;
	right: 0;
	width: 80px;
	height: 100px;
	background: #FFF;
	box-shadow: 1px 2px 5px rgba(66, 133, 244, 0.30);
}
.menu-profile img {
	width: 55px;
	min-width: 55px;
	height: 55px;
	border-radius: 50px;
}
.menu-profile .dropdown-toggle {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    font-size: 18px;
    color: #000;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: transparent;
    border: 1px solid #000;
}
.menu-profile .dropdown-toggle::after {
	display: none;
}
.menu-profile .badge {
    background: #00D805;
    display: inline-block;
    width: 14px;
    height: 14px;
    position: absolute;
    padding: 0;
    top: 26px;
    right: 12px;
}
.menu-profile .dropdown-menu {
    min-width: 170px;
    border-radius: 5px;
    border: 1px solid #EFEFEF;
    padding: 0;
    margin-top: 30px !important;
}
.menu-profile .dropdown-menu .dropdown-item {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	font-size: 15px;
	color: #000;
	padding: 10px 15px;
	border-bottom: 1px solid #EFEFEF;
	border-radius: 0;
	-webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}
.menu-profile .dropdown-menu .dropdown-item:first-child {
    border-radius: 5px 5px 0 0;
}
.menu-profile .dropdown-menu .dropdown-item:last-child {
    border-radius: 0 0 5px 5px;
    border-bottom: 0;
}
.menu-profile .dropdown-menu .dropdown-item:hover {
    color: #3FA2DB;
    padding-left: 20px;
    -webkit-transition: all 0.4s;
    -ms-transition: all 0.4s;
    transition: all 0.4s;
}
.menu-profile .dropdown-menu .dropdown-item i {
	font-size: 18px;
	margin-right: 10px;
}
.menu-profile .dropdown-menu .accordion-toggle:hover {
	padding: 10px 15px;
}
.accordion-toggle .status-item-active {
	width: 14px;
	min-width: 14px;
	height: 14px;
	margin-right: 10px;
	border-radius: 50px;
	background: #00D805;
	display: inline-block;
}
.menu-profile .dropdown-menu .accordion-toggle i {
	font-size: 16px;
	margin-right: 0;
	margin-left: auto;
}
.menu-profile .dropdown-menu .status-collapse .dropdown-item {
	border-bottom: 1px solid #EFEFEF;
}
.menu-profile .dropdown-menu .status-collapse .dropdown-item:hover {
	padding: 10px 15px;
}
.status-collapse span {
	width: 14px;
	min-width: 14px;
	height: 14px;
	margin-right: 10px;
	border-radius: 50px;
	display: inline-block;
}
.status-collapse .status-item-active {
	background: #00D805;
}
.status-collapse .status-item-inactive {
	background: #AAA;
}
.status-collapse .status-item-danger {
	background: #CC0001;
}
.right-sidebar li .menu-profile a {
	padding: 0;
	position: relative;
}
.right-sidebar .menu-profile .badge {
    background: #00D805;
    display: inline-block;
    width: 14px;
    height: 14px;
    position: absolute;
    padding: 0;
    right: 0;
}
.right-sidebar .sidebar-menu .bottom-menu {
	padding: 0 0 20px;
}
.right-sidebar .bottom-menu li {
	margin: 0;
}
.bottom-menu-info {
	position: relative;
}
.bottom-menu-info li a span img {
	width: auto;
	min-width: inherit;
	height: auto;
	border-radius: 0;
}
.right-sidebar .sidebar-menu > .bottom-menu-info > li:first-child {
	margin: 0;
}
.hideright-sidebar .right-sidebar {
	right: -200px;
	z-index: 1001;
}
.hideright-sidebar .page-wrapper {
	margin-right: 0;
}
.sidebar-menu > ul > li > .sidebar-right-toggle {
	position: fixed;
	font-size: 18px;
	color: #000;
	background: #3FA2DB1A;
	border-radius: 0 100px 100px 0;
	width: 25px;
	height: 50px;
	bottom: 200px;
	right: 55px;
	padding: 0;
	transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
}
.sidebar-menu > ul > li > .sidebar-right-toggle:after {
	content: "\\f054";
	position: absolute;
	left: 5px;
  	font-family: "FontAwesome";
}
.hideright-sidebar #sidebar-right-toggle {
    right: 0;
    border-radius: 100px 0 0 100px;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
}
.hideright-sidebar #sidebar-right-toggle:after {
	content: "\\f053";
	position: absolute;
	right: 5px;
  	font-family: "FontAwesome";
}

/*-----------------
	10. Content
-----------------------*/

.main-wrapper {
	width: 100%;
	height: 100vh;
	min-height: 100vh;
}
.page-wrapper {
	margin-left: 0;
	margin-right: 0;
    padding-top: 110px;
    position: relative;
    transition: all 0.4s ease;
    -webkit-transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
}
.account-wrapper {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
}
.page-wrapper-info {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
}
.page-wrapper > .content {
	padding: 20px;
}
.page-header {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
    margin-bottom: 20px;
}
.page-header .breadcrumb {
	background-color: transparent;
	color: #6c757d;
	font-size: 1rem;
	font-weight: 500;
	margin-bottom: 0;
	padding: 0;
}
.page-header .breadcrumb a {
	color: #333;
}
.page-sub-title {
	font-size: 16px;
	font-weight: 700;
	color: #3FA2DB;
	margin-bottom: 8px;
}
.page-title {
	font-size: 22px;
	font-weight: 700;
	color: #000000;
	margin-bottom: 10px;
}
.page-btn {
	background: #ffffff;
    border-radius: 10px;
    font-weight: 900;
    font-size: 30px;
    line-height: 30px;
}
.page-btn::after {
	display: none;
}
.page-list .nav {
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: flex-end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: flex-end;
}
.page-list .nav li {
	margin-right: 30px;
	margin-bottom: 10px;
}
.page-list .nav li:last-child {
	margin-right: 0;
}
.page-dropdown {
	position: relative;
}
.page-dropdown .dropdown-toggle:hover {
	color: #000;
}
.page-dropdown .dropdown-toggle:after {
	border-top: 0;
    border-left: 0;
    border-bottom: 2px solid #000;
    border-right: 2px solid #000;
    content: '';
    height: 8px;
    display: inline-block;
    pointer-events: none;
    -webkit-transform-origin: 66% 66%;
    -transform-origin: 66% 66%;
    transform-origin: 66% 66%;
    -webkit-transform: rotate(45deg);
    -transform: rotate(45deg);
    transform: rotate(45deg);
    -webkit-transition: all 0.15s ease-in-out;
    transition: all 0.15s ease-in-out;
    width: 8px;
    vertical-align: 2px;
}
.page-dropdown .dropdown-toggle[aria-expanded="true"]:after {
    -webkit-transform: rotate(-135deg);
    -transform: rotate(-135deg);
    transform: rotate(-135deg);
}
.page-dropdown .dropdown-menu .dropdown-item {
	padding: 5px 10px;
	border: 0;
}
.page-dropdown .dropdown-menu .dropdown-item:hover {
	padding-left: 15px;
}
.page-search {
	position: relative;
}
.page-search .form-control {
	padding-left: 26px;
    color: #000;
    background: transparent;
    border: 0;
    border-bottom: 1px solid #CCCCCC;
}
.page-search i {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #898989;
}
.page-header-btn .btn {
	padding: 9px 20px;
	min-width: 150px;
}

/*-----------------
	11. Login
-----------------------*/

.login-wrapper {
	width: 100%;
    height: 100vh;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    background: #FFF;
}
.login-left {
	position: relative;
	padding: 60px 0 0 60px;
	background: #FFF;
}
.login-logo {
	padding-bottom: 20px;
}
.login-content h1 {
	font-size: 120px;
	font-weight: 700;
	color: #3FA2DB;
	margin-bottom: 0;
}
.login-content h5 {
	font-size: 30px;
	font-weight: 400;
	color: #898989;
	margin-bottom: 30px;
}
.login-content-bottom {
	position: absolute;
	bottom: 60px;
}
.login-content-bottom a {
	color: #898989;
	position: relative;
	display: inline-block;
	margin-bottom: 6px;
}
.login-content-bottom a:hover {
	color: #3FA2DB;
}
.login-content-bottom a:after {
    content: "";
    height: 2px;
    width: 100%;
    background: #3FA2DB;
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    -webkit-transition: all 0.3s ease;
    -ms-transition: all 0.3s ease;
    transition: all 0.3s ease;
    position: absolute;
    bottom: -3px;
    left: 0;
}
.login-content-bottom a:hover:after {
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
}
.login-content-bottom p {
	color: #898989;
	margin-bottom: 0;
}
.login-box {   
    width: 630px;
    height: 100vh;
    background: #3FA2DB;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
}
.login-box .login-right {
	position: relative;
	z-index: 1;
	background: #FFF;
	border-radius: 15px;
    box-shadow: 0px 0px 10px -1px #00000040;
    padding: 40px;
    max-width: 380px;
    margin-left: -180px;
    margin-bottom: 40px;
    top: 50%;
    transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
}
.login-box .login-right .login-right-wrap {
    max-width: 100%;
    flex: 0 0 100%;
}
.login-shape-img {
	position: absolute;
	bottom: 60px;
	margin-left: -175px;
}
.login-header {
	text-align: center;
	padding-bottom: 60px;
}
.login-box .login-right h2 {
    font-size: 24px;
    font-weight: 700;
    color: #000;
    text-transform: uppercase;
    margin-bottom: 0;
}
.login-form .form-wrap-input {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}
.login-form .form-wrap-input img {
	margin-right: 15px;
}
.form-wrap-flex {
	display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
}
.login-btn {
	margin-top: 40px;
	margin-bottom: 15px;
	text-align: center;
}
.login-btn .btn {
	padding: 10px 50px;
}
.login-otp {
	text-align: center;
	margin-bottom: 10px;
}
.login-otp.return-to-home {
	margin-top: 10px;
}
.login-otp a {
	font-weight: 500;
	color: #000;
	display: inline-block;
	padding-bottom: 5px;
	border-bottom: 0.5px solid #C3C3C3;
}
.login-otp a:hover {
	color: #3FA2DB;
}
.login-forgot {
	text-align: center;
}
.forgot-link {
	font-size: 14px;
	position: relative;
	color: #B71717;
    display: inline-block;
}
.forgot-link:hover {
	color: #3FA2DB;
}
.forgot-link:after {
    content: "";
    height: 1.5px;
    width: 100%;
    background: #3FA2DB;
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: -3px;
    left: 0;
}
.forgot-link:hover:after {
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
}
.register-body {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-attachment: fixed;
}
.register-logo {
    position: absolute;
    width: 100%;
    left: 60px;
    top: 60px;
    padding: 0;
    z-index: 1;
}
.register-logo-bg {
	position: relative;
	height: auto;
	padding: 30px 0;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	background-attachment: fixed;
}
.register-box {
	position: relative;
	width: 100%;
	height: auto;
	top: 0;
	background: transparent;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
}
.register-box .login-right {
	max-width: 600px;
	margin: 0 auto 0;
	top: 0;
    transform: translateY(0);
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
}
.password-body {
	background: #3FA2DB;
}
.white-logo img {
	width: 150px;
	filter: invert(1) brightness(100);
}
.password-header {
	text-align: center;
	padding-bottom: 20px;
}
.login-box .login-right .password-header h2 {
	font-size: 20px;
	text-transform: capitalize;
	margin-bottom: 30px;
}
.password-header img {
	margin-bottom: 30px;
}
.password-header h5 {
	font-size: 18px;
	font-weight: 500;
	color: #333;
	margin-bottom: 5px;
}
.password-header p {
	color: #919191;
	max-width: 350px;
	margin: 0 auto 0;
}
.otp-box {
	text-align: center;
}
.otp-box input {
    width: 35px;
    height: 35px;
    background: #E6E6E6;
    border: 1px solid #E6E6E6;
    border-radius: 0;
    text-align: center;
    margin-right: 20px;
    font-weight: 600;
    font-size: 16px;
    color: #000;
    outline: none;
}
.otp-box input:last-child {
	margin-right: 0;
}
.password-btn {
	text-align: center;
	margin-top: 30px;
}
.password-btn .btn {
	padding: 10px 35px;
}

/*------------------
  12. Modal
--------------------*/

.custom-modal .modal-content {
	background: #FFF;
	border: 1px solid #EFEFEF;
}
.custom-modal .modal-header {
	padding: 15px;
	border-bottom: 1px solid #EFEFEF;
	justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
}
.custom-modal .modal-header .modal-title {
	font-size: 18px;
	font-weight: 500;
	color: #3FA2DB;
	margin-bottom: 0;
}
.custom-modal .close {
	color: #CC0001;
	background-color: #FFF;
	border: 2px solid #CC0001;
	border-radius: 50%;
	font-size: 22px;
	height: 24px;
	width: 24px;
	margin: 0;
	opacity: 1;
	padding: 0;
	right: 10px;
	z-index: 99;
	display: flex;
	display: -webkit-flex;
	align-items: center;
	-webkit-align-items: center;
	justify-content: center;
	-webkit-justify-content: center;
	transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-ms-transition: all 0.4s ease;
	-webkit-transition: all 0.4s ease;
}
.custom-modal .close:hover {
	color: #FFF;
	background-color: #CC0001;
	border: 2px solid #CC0001;
	transition: all 0.4s ease;
	-moz-transition: all 0.4s ease;
	-o-transition: all 0.4s ease;
	-ms-transition: all 0.4s ease;
	-webkit-transition: all 0.4s ease;
	-webkit-transform: rotateZ(360deg);
	-moz-transform: rotateZ(360deg);
	transform: rotateZ(360deg);
}
.custom-modal .close span {
 	line-height: 0;
}
.custom-modal .modal-body {
  	padding: 15px;
}
.modal-form .form-group {
  	margin-bottom: 15px;
}
.modal-form .form-group label {
	font-size: 14px;
  	margin-bottom: 6px;
}
.modal-form .form-group .form-control {
	font-size: 14px;
	color: #000;
	background: #FFFFFF;
	border: 1px solid #EFEFEF;
	padding: 10px 10px;
	height: 30px;
}
.modal-form .form-group .form-control::placeholder {
	font-size: 14px;
	color: #AAA;
}
.modal-form .form-group textarea.form-control {
	height: 120px;
	resize: none;
}
.modal-form-btn .btn {
	font-size: 15px;
	padding: 7px 26px;
	margin-right: 15px;
}
.modal-form-btn .btn:last-child {
  	margin-right: 0;
}
.modal-text {
	text-align: center;
}
.modal-text span {
	font-size: 26px;
	background: #FFEEEC;
	color: #CC0001;
	width: 60px;
	height: 60px;
	border-radius: 50%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
	margin: 0 auto 15px;
	position: relative;
}
.modal-text h5 {
	font-size: 18px;
	font-weight: 500;
	color: #00568E;
	margin-bottom: 10px;
}
.modal-text p {
	font-size: 15px;
	max-width: 260px;
    margin: 0 auto 0;
}
.re-associate-content {
	padding: 20px;
	text-align: center;
}
.re-associate-text img {
    margin: 0 auto 20px;
    display: block;
}
.re-associate-text p {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 30px;
}
.re-associate-content .btn {
	font-size: 16px;
	padding: 10px 20px;
	min-width: 140px;
}
.modal.right .modal-dialog {
	position: fixed;
	margin: auto;
	width: 320px;
	height: 100%;
	-webkit-transform: translate3d(0%, 0, 0);
	-ms-transform: translate3d(0%, 0, 0);
	-o-transform: translate3d(0%, 0, 0);
	transform: translate3d(0%, 0, 0);
}
.modal.right.fade .modal-dialog {
	right: -320px;
	-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
	-moz-transition: opacity 0.3s linear, right 0.3s ease-out;
	-o-transition: opacity 0.3s linear, right 0.3s ease-out;
	transition: opacity 0.3s linear, right 0.3s ease-out;
}
.modal.right.fade.show .modal-dialog {
	right: 0;
}
.schedule-modal-header {
	padding: 40px 0 0;
	text-align: center;
}
.schedule-modal-header h4 {
	font-size: 20px;
	font-weight: 700;
	margin-bottom: 0;
}
.schedule-modal-form {
	padding: 15px;
}
.schedule-modal-form .form-wrap {
	margin-bottom: 10px;
}
.schedule-modal-form .form-control {
	padding: 10px 15px;
	background: #F6F6F6;
	border: 1px solid #F6F6F6;
}
.schedule-modal-form .form-control::placeholder {
	color: #898989;
}
.schedule-modal-form textarea.form-control {
	min-height: 150px;
}
.schedule-modal-form .select2-container .select2-selection--single .select2-selection__rendered {
	color: #898989;
	padding-left: 15px;
}
.schedule-modal-form .select2-container .select2-selection--single {
	border: 1px solid #F6F6F6;
	border-bottom: 1px solid #F6F6F6;
	background: #F6F6F6;
}
.schedule-modal-form .textarea-text {
	font-size: 14px;
	color: #898989;
	text-align: right;
	margin-top: 10px;
	margin-bottom: 0;
}
.schedule-modal-form .modal-form-btn {
	text-align: center;
	padding-top: 10px;
	padding-bottom: 10px;
}
.schedule-success {
	padding: 40px;
	text-align: center;
}
.schedule-success i {
	font-size: 60px;
	color: #3FA2DB;
	margin: 0 auto 30px;
	display: block;
}
.schedule-success h4 {
	font-size: 30px;
	max-width: 500px;
	margin: 0 auto 0;
}
.schedule-modal-form .custom-radio {
	padding: 20px 0 15px;
}
.schedule-modal-form .custom_radio {
	font-weight: 500;
	padding-left: 36px;
	margin-right: 24px;
	margin-bottom: 15px;
}
.schedule-modal-form .custom_radio .checkmark {
	background: #898989;
	border: 1px solid #898989;
}
.medical-modal-header {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    padding: 30px;
}
.medical-modal-header h4 {
	font-size: 24px;
	color: #00568E;
	margin-bottom: 0;
}
.prescription-modal-header {
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
}
.prescription-modal-header h5 {
	font-size: 18px;
	font-weight: 500;
	color: #00568E;
	margin-bottom: 0;
	text-align: center;
}
.medical-modal-header .close {
	position: absolute;
    top: -15px;
    right: -15px;
    width: 34px;
    height: 34px;
    color: #636363;
    background: #FFF;
    border: 1px solid #636363;
}
.medical-modal-header .close:hover {
	color: #FFF;
    background: #00568E;
    border: 1px solid #00568E;
}
.custom-modal .medical-modal-body {
	padding: 0 30px 10px;
}
.medical-history-card {
	border: 1px solid #00568E;
	box-shadow: none;
}
.medical-history-card .card-body {
	padding: 0;
	padding-bottom: 15px;
}
.medical-history-card.diagram-card .card-body {
	padding-bottom: 15px;
}
.past-medical-info {
	padding: 20px 30px 0;
	margin-bottom: 15px;
	border-bottom: 1px solid #E6E6E6;
}
.medical-history-card .past-surgeries .nav li {
	margin-bottom: 15px;
}
.medical-history-card .past-surgeries-left {
	padding-left: 40px;
}
.past-surgeries .form-control {
	width: 100%;
	max-width: 250px;
}
.past-surgeries .form-control::placeholder {
	color: #5B5B5B;
}
.patient-radio-btn .custom_radio {
    padding-left: 30px;
    margin-right: 24px;
    line-height: normal;
}
.patient-radio-btn .custom_radio input:checked ~ .checkmark:after {
	opacity: 1
}
.patient-radio-btn .custom_radio b {
	font-weight: 400;
	color: #898989;
}
.patient-radio-btn .custom_radio input:checked ~ b {
	color: #000;
}
.patient-radio-btn .custom_radio .checkmark {
	position: absolute;
	top: 0;
	left: 0;
	height: 20px;
	width: 20px;
	background-color: #fff;
	border: 1px solid #3FA2DB;
	border-radius: 50%;
}
.patient-radio-btn .custom_radio .checkmark:after {
	display: block;
	content: "";
	position: absolute;
	opacity: 0;
	top: 4px;
	left: 4px;
	width: 10px;
	height: 10px;
	border-radius: 50%;
	background: #3FA2DB;
	border: 1px solid #3FA2DB;
	-moz-transition: all 0.3s ease-in-out;
	-o-transition: all 0.3s ease-in-out;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
}
.past-medical-btn {
	padding: 20px 0 10px;
	text-align: center;
}
.past-medical-btn .btn {
	padding: 7px 30px;
}
.custom-modal .drug-modal-body {
	padding: 30px;
}
.drug-form-wrap {
	position: relative;
}
.drug-form-wrap .drug-select {
	margin-left: auto;
	width: 90px;
}
.drug-form-wrap .select2-container .select2-selection--single {
	border: 0;
}
.drug-btn {
	margin-top: 16px;
	text-align: center;
}
.drug-btn .btn {
	min-width: 150px;
}
.custom-modal .prescription-modal-body {
	padding: 0;
}
.prescription-grid {
	padding: 30px;
	border-bottom: 1px solid #00000038;
}
.prescription-btn {
	padding: 20px 20px 0;
	text-align: center;
}
.prescription-btn .btn {
	padding: 10px 40px;
}
.create-modal-header {
	justify-content: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
}
.create-modal-header h4 {
	color: #000;
}
.custom-modal .modal-create-form {
	max-width: inherit;
}
.custom-modal .profile-modal-content {
	max-width: 480px;
	margin: auto;
}
.custom-modal .profile-modal-body {
	padding: 30px;
}
.profile-modal-title {
	text-align: center;
	margin-bottom: 24px;
}
.profile-modal-title h4 {
	font-size: 20px;
	margin-bottom: 0;
}
.profile-modal-img {
	text-align: center;
    width: 175px;
    border-radius: 15px;
    margin: 0 auto 24px;
}
.profile-modal-img img {
	width: 100%;
	height: 180px;
    border-radius: 15px;
}
.profile-modal-img .file-upload {
	font-size: 14px;
    color: #3FA2DB;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    margin-top: 10px;
    margin-bottom: 0;
}
.profile-modal-img .file-upload:hover {
	color: #00568E;
}
.profile-modal-img .file-upload:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #3FA2DB;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 3px;
    left: 0;
}
.profile-modal-img .file-upload:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.profile-modal-img .file-upload input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity = 0);
    opacity: 0;
    outline: none;
    background: #fff;
    cursor: inherit;
    display: block;
}
.profile-modal-form {
	padding: 0 30px;
}
.profile-modal-form label {
	color: #707070;
}
.profile-modal-input {
	margin-bottom: 5px;
}
.profile-modal-btn {
	padding-top: 24px;
	text-align: center;
}
.profile-modal-btn .btn {
	padding: 5px 24px;
}
.custom-modal .doctor-slot-modal-content {
	max-width: 980px;
	margin: auto;
}
.custom-modal .doctor-slot-body {
	padding: 40px;
}
.doctor-slot-header {
	padding-bottom: 40px;
}
.doctor-slot-header h4 {
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 0;
}
.doctor-slot-input {
	padding-left: 30px;
}
.doctor-slot-input .form-wrap {
	margin-bottom: 30px;
}
.doctor-slot-input label {
	font-size: 16px;
	font-weight: 500;
	color: #393939;
	margin-bottom: 8px;
}
.doctor-slot-date {
	position: relative;
}
.form-wrap-date {
  	position: relative;
}
.form-wrap-date .scheduled-slot-datepicker input {
  	font-size: 14px;
}
.doctor-slot-date .form-control {
	font-size: 14px;
	padding: 10px 15px;
	height: 36px;
	border-radius: 7px;
	border: 1px solid #3FA2DB;
}
.doctor-slot-date .form-control::placeholder {
	color: #C0C0C0;
}
.doctor-slot-date .doctor-slot-icon {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
	right: 0;
	width: 36px;
	height: 36px;
	border-radius: 7px;
	background: #3FA2DB;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
}
.doctor-slot-date b {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
	right: 0;
	width: 36px;
	height: 36px;
	border-radius: 7px;
	background: #3FA2DB;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
}
.select-days h6 {
	font-size: 16px;
	font-weight: 500;
	color: #393939;
	margin-bottom: 10px;
}
.select-days .nav {
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
}
.select-days .nav li {
	margin-right: 20px;
}
.select-days .nav li:last-child {
	margin-right: 0;
}
.select-days label {
	font-weight: 300;
}
.custom_check {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	color: #000;
	position: relative;
	padding-left: 30px;
	margin-bottom: 10px;
	cursor: pointer;
}
.custom_check input {
	position: absolute;
	opacity: 0;
	cursor: pointer;
}
.custom_check input:checked ~ .checkmark {
	background-color: #D9D9D9;
}
.custom_check input:checked ~ .checkmark:after {
	display: block;
}
.custom_check .checkmark {
	height: 22px;
	width: 22px;
	border: 1px solid #D9D9D9;
	background-color: #D9D9D9;
	border-radius: 30px;
	-webkit-transition: all 0.3s ease-in-out;
	-ms-transition: all 0.3s ease-in-out;
	transition: all 0.3s ease-in-out;
	position: absolute;
	top: 0;
	left: 0;
}
.custom_check .checkmark::after {
	content: "\\f00c";
	font-family: "Font Awesome 5 Free";
	font-weight: 900;
	display: none;
	color: #0de0fe;
	font-size: 12px;
	position: absolute;
	top: 0;
	left: 4px;
}
.custom_check .checkmark::after {
	content: "";
	background: #3FA2DB;
	width: 12px;
	height: 12px;
	top: 4px;
	left: 4px;
	border-radius: 30px;
}
.form-flex-wrap {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
}
.form-flex-wrap .doctor-slot-date {
	margin-bottom: 8px;
}
.form-flex-wrap label {
	margin-right: 10px;
}
.form-flex-wrap .doctor-slot-date .form-control {
	width: 100px;
}
.form-flex-wrap .doctor-slot-date .form-control::placeholder {
	color: #3FA2DB;
}
.form-flex-wrap .doctor-slot-date .p-calendar {
  width: 100px;
}
.form-flex-wrap .doctor-slot-date .p-calendar input {
  font-size: 14px;
  color: #3fa2db;
  height: 36px;
}
.form-flex-wrap .doctor-slot-date .p-calendar input::placeholder {
  color: #3fa2db;
}
.doctor-slot-date small {
  display: block;
}
.doctor-slot-btn .btn {
	padding: 10px 40px;
	margin-right: 15px;
}
.doctor-slot-btn .btn:last-child {
	margin-right: 0;
}
.prescription-head {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    align-items: flex-start;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-bottom: 20px;
	border-bottom: 1px solid #00000038;
}
.prescription-head-list {
	margin-bottom: 6px;
}
.prescription-head-list p {
	font-size: 14px;
	margin-bottom: 4px;
}
.prescription-logo {
	margin-bottom: 10px;
}
.prescription-logo img {
	max-height: 80px;
    width: auto;
}
.prescription-title {
	margin-bottom: 15px;
}
.prescription-title h4 {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 0;
	display: inline-block;
	border-bottom: 1px solid #000;
}
.prescription-details-info {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    align-items: flex-start;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
}
.prescription-info {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: flex-start;
    -ms-flex-align: flex-start;
    align-items: flex-start;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
}
.prescription-details-info .prescription-info {
	display: block;
}
.prescription-info ul {
	padding: 0;
	margin-left: 20px;
	margin-bottom: 20px;
	list-style: none;
}
.prescription-info ul li {
	font-size: 14px;
	color: #000;
	margin-bottom: 4px;
}
.prescription-info ul li:last-child {
	margin-bottom: 0;
}
.prescription-info ul li span {
	font-weight: 500;
}
.prescription-info .sub-prescription-list li {
	margin-bottom: 10px;
}
.sub-prescription-list li p {
	margin-left: 20px;
	margin-bottom: 0;
}
.prescription-date {
	margin-bottom: 20px;
}
.prescription-date p {
	font-size: 14px;
	color: #000;
	margin-bottom: 0;
}
.prescription-md {
	padding-bottom: 20px;
	margin-bottom: 20px;
	border-bottom: 1px solid #00000038;
}
.prescription-md h6 {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 0;
}
.prescription-md p {
	font-size: 14px;
	margin-bottom: 0;
}
.prescription-bottom-content {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-bottom: 10px;
}
.prescription-bottom-text {
	margin-bottom: 10px;
}
.prescription-bottom-text p {
	font-size: 15px;
	font-weight: 500;
	margin-bottom: 0;
	display: inline-block;
	/* border-bottom: 1px solid #000; */
}

/*-----------------
	13. Welcome
-----------------------*/

.welcome-body {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    background-attachment: fixed;
    overflow: hidden;
}
.welcome-wrapper {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	padding-top: 0;
	padding-bottom: 50px;
}
.welcome-wrapper .content {
	padding-left: 80px;
}
.welcome-content {
	padding: 40px 0 0 80px;
}
.welcome-logo {
	width: 100%;
}
.welcome-text {
	width: 100%;
}
.welcome-text h6 {
	font-size: 70px;
	font-weight: 300;
	color: #FFF;
	margin-bottom: 0;
}
.welcome-text h1 {
	font-size: 70px;
	font-weight: 600;
	color: #FFF;
	margin-bottom: 0;
}
.welcome-btn {
	padding-top: 20px;
}
.welcome-btn .btn {
	font-size: 18px;
	min-width: 180px;
	margin-right: 15px;
}
.welcome-btn .btn:last-child {
	margin-right: 0;
}
.welcome-btn .btn:hover {
	background: #FFF;
}

/*-----------------
	14. Dashboard
-----------------------*/

.dash-header {
	margin-bottom: 24px;
}
.dash-header h4 {
    font-size: 24px;
    font-weight: 600;
    color: #3FA2DB;
    margin-bottom: 0;
}
.dash-progress {
	margin-bottom: 24px;
}
.progress-info {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	line-height: 0;
}
.progress-info span {
	color: #B9B9B9;
	margin-left: 10px;
}
.progress {
	width: 100%;
	height: 5px;
}
.progress .progress-bar {
    animation-name: animateBar;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 1.5s;
}
@keyframes animateBar {
    0% {transform: translateX(-100%);}
    100% {transform: translateX(0);}
}
.dash-progress p {
	margin-bottom: 0;
}
.dash-progress h6 {
	font-size: 40px;
	font-weight: 600;
	margin-bottom: 0;
}
.red-flag-list h6 {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 15px;
}
.red-flag-list .nav li {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	width: 100%;
	margin-bottom: 10px;
}
.red-flag-list .nav li p {
	text-decoration: underline;
	margin-bottom: 0;
}
.red-flag-list .nav li:last-child {
	margin-bottom: 0;
}
.red-flag-list .nav li span {
	display: inline-block;
	width: 7px;
	min-width: 7px;
	height: 7px;
	margin-right: 15px;
	background: #00568E;
	border-radius: 50px;
}
.dashboard-link {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	-ms-flex-direction: column;
	flex-direction: column;
	text-align: center;
	padding: 24px;
}
.dashboard-link a {
	font-size: 18px;
	font-weight: 500;
	color: #000;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
	-ms-flex-direction: column;
	flex-direction: column;
	text-align: center;
	width: 230px;
	min-width: 230px;
	padding: 24px;
	border-radius: 20px;
	background: #EAF5FB80;
}
.dashboard-link a img {
	margin-bottom: 14px;
	height: 120px;
}
.dashboard-link a:hover {
	color: #3FA2DB;
}

/*-----------------
	15. Create
-----------------------*/

.create-card {
	padding: 30px;
}
.create-header {
	text-align: center;
}
.create-header h4 {
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 30px;
}
.create-header img {
	height: 300px;
}
.create-form {
	max-width: 400px;
}
.form-wrap-status {
	margin-bottom: 30px;
}
.professional-wrap-status {
	margin-top: 40px;
}
.form-wrap-status.professional-wrap-status h4 {
	margin-bottom: 10px;
}
.form-wrap-status h4 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 20px;
}
.status-create-radio .custom_radio {
    margin-right: 24px;
    padding-left: 24px;
}
.status-create-radio .custom_radio .checkmark {
	width: 14px;
	height: 14px;
}
.status-create-radio .custom_radio .checkmark:after {
	width: 14px;
	height: 14px;
}
.form-wrap-btn .btn {
	min-width: 150px;
	margin-right: 20px;
}
.form-wrap-btn .btn:last-child {
	margin-right: 0;
}
.edit-inner-body {
	padding: 40px;
}
.edit-icon-info {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: flex-end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: flex-end;
}
.edit-icon-slot {
	margin-right: 24px;
}
.edit-icon {
	text-align: right;
}
.edit-icon a {
	font-size: 26px;
	color: #3FA2DB;
}
.edit-icon a:hover {
	color: #F7D333;
}
.edit-inner-box {
	position: relative;
	border-right: 1px solid #E6E6E6;
}
.edit-header {
	padding-bottom: 100px;
}
.edit-header h4 {
	font-size: 30px;
	font-weight: 700;
	margin-bottom: 10px;
}
.edit-header .nav {
	margin-top: 5px;
}
.edit-header .nav li {
	font-weight: 300;
	color: #898989;
	position: relative;
	margin-right: 25px;
}
.edit-header .nav li:last-child {
	margin-right: 0;
}
.edit-header .nav li::after {
    content: "|";
    position: relative;
    left: 15px;
}
.edit-header .nav li:last-child::after {
	display: none;
}
.edit-header .nav li p {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-bottom: 0;
}
.edit-header .nav li p span {
    width: 10px;
    min-width: 10px;
    height: 10px;
    border-radius: 50px;
    margin-right: 8px;
    display: inline-block;
    background: #3FA2DB;
}
.re-associate-nav {
	margin-top: 15px;
}
.re-associate-nav li a {
	color: #3FA2DB;
}
.re-associate-nav li a:hover {
	text-decoration: underline;
}
.associate-btn {
	padding-top: 20px;
}
.associate-btn .btn {
	padding: 6px 30px;
}
.edit-list {
	margin-bottom: 20px;
}
.edit-list-info {
	width: 100%;
	max-width: 400px;
}
.edit-list ul li {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	margin-bottom: 30px;
}
.edit-list ul li:last-child {
	margin-bottom: 0;
}
.edit-list ul li img {
	width: 36px;
	height: 36px;
	margin-right: 20px;
}
.edit-list ul li p {
	word-break: break-word;
	margin-bottom: 0;
}
.edit-list ul li .edit-form-control {
	width: 100%;
}
.edit-list ul li .form-control {
	border-bottom: 1px solid #E6E6E6;
}
.edit-details {
	padding-left: 50px;
}
.edit-details-disable {
	cursor: not-allowed;
}
.edit-details-disable .edit-grid h5 {
	color: #B4B4B4;
}
.edit-grid {
	margin-bottom: 20px;
}
.edit-grid h5 {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 10px;
}
.edit-box {
	padding: 0 10px;
	margin-bottom: 14px;
	border-radius: 12px;
	height: 170px;
	overflow: auto;
	box-shadow: 0px 0px 10px -1px #00000040;
}
.edit-box::-webkit-scrollbar {
	width: 5px;
}
.edit-box::-webkit-scrollbar-track {
	box-shadow: inset 0 0 10px #D9D9D9; 
	border-radius: 5px;
}
.edit-box::-webkit-scrollbar-thumb {
	background: #AAA; 
	border-radius: 5px;
}
.edit-box::-webkit-scrollbar-thumb:hover {
	background: #AAA; 
}
.edit-details-disable .edit-box .table tbody tr td {
	color: #B4B4B4;
}
.edit-associate-btn {
	text-align: right;
}
.edit-associate-btn .btn {
	color: #000000;
	padding: 5px 20px;
}
.edit-details-disable .edit-associate-btn .btn {
	color: #B4B4B4;
	background: #E6E6E6;
	border: 1px solid #E6E6E6;
	cursor: not-allowed;
}
.edit-info .form-wrap label {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	margin-bottom: 30px;
}
.edit-info .form-wrap label:last-child {
	margin-bottom: 0;
}
.edit-info .form-wrap label img {
	margin-right: 20px;
}
.edit-toggle {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	justify-content: flex-end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: flex-end;
}
.edit-toggle .status-toggle {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
}
.edit-toggle .status-toggle p {
	margin-right: 10px;
	margin-bottom: 0;
}
.edit-toggle .status-toggle .front-desk-dropdown p {
	margin-bottom: 20px;
}
.edit-toggle .status-toggle .checktoggle {
	width: 85px;
	height: 25px;
	border-radius: 50px;
	background-color: #E6E6E6;
	border: 1px solid #E6E6E6;
}
.edit-toggle .status-toggle .check-input:checked + .checktoggle {
    background-color: #3FA2DB;
    border: 1px solid #3FA2DB;
}
.edit-toggle .status-toggle .checktoggle:after {
	width: 25px;
	height: 25px;
	background-color: #000;
	transform: translate(0, -50%);
}
.edit-toggle .status-toggle .check-input:checked + .checktoggle:after {
	transform: translate(calc(-100% - 0px), -50%);
}
.edit-toggle-btn .btn {
	min-width: 140px;
	margin-left: 24px;
}
.success-card .card-body {
	padding: 40px;
}
.success-info {
	text-align: center;
}
.success-info i {
	font-size: 72px;
	color: #3FA2DB;
	margin: 0 auto 20px;
	display: block;
}
.success-info img {
	margin: 0 auto 30px;
}
.success-info p {
	font-size: 18px;
	font-weight: 500;
	margin-bottom: 0;
}
.success-info span {
	font-weight: 500;
	color: #717171;
	margin-top: 4px;
	display: block;
}
.success-info a {
	position: relative;
	color: #00568E;
    display: inline-block;
}
.success-info a:hover {
	color: #00568E;
}
.success-info a:after {
    content: "";
    height: 1.5px;
    width: 100%;
    background: #00568E;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 0px;
    left: 0;
}
.success-info a:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.patient-nav-list .nav {
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
	margin-bottom: 20px;
}
.patient-nav-list .nav li {
	border-right: 1px solid #898989;
	padding-right: 20px;
	margin-right: 20px;
	margin-bottom: 10px;
}
.patient-nav-list .nav li:last-child {
	border: 0;
	padding-right: 0;
	margin-right: 0;
}
.patient-nav-list .nav li a {
	color: #898989;
}
.patient-nav-list .nav li a:hover {
	color: #3FA2DB;
}
.patient-nav-list .nav li a.active {
	font-weight: 600;
	color: #3FA2DB;
}

/*-----------------
	16. Patient Registration
-----------------------*/

.patient-register-header {
	text-align: center;
	padding: 20px 0 60px;
}
.patient-register-header h4 {
	font-size: 24px;
	font-weight: 700;
	margin-bottom: 0;
}
.patient-register-card .card-body {
	padding: 30px;
}
.patient-register-img {
	width: 100px;
	min-width: 100px;
	height: auto;
	margin-bottom: 24px;
	border-radius: 50%;
}
.patient-register-img img {
	width: 100%;
	height: 100%;
	border-radius: 50%;
}
.patient-register-input .form-control::placeholder {
	color: #898989;
}
.patient-register-input .select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #898989;
	line-height: 24px;
}
.patient-register-input .select2-container .select2-selection--single {
	height: 26px;
}
.patient-register-input .select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 26px;
	right: 0;
}
.patient-register-input .iti__selected-flag {
	padding: 0 6px 0 0px;
}
.patient-register-input .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag {
	background: transparent;
}
.patient-register-input .iti--allow-dropdown input, 
.patient-register-input .iti--allow-dropdown input[type=text], 
.patient-register-input .iti--allow-dropdown input[type=tel], 
.patient-register-input .iti--separate-dial-code input, 
.patient-register-input .iti--separate-dial-code input[type=text], 
.patient-register-input .iti--separate-dial-code input[type=tel] {
	height: 30px;
	padding-left: 44px;
}
.pass-group {
	position: relative;
}
.toggle-password {
	font-size: 14px;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    color: #898989;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.toggle-password-icon-right {
	top: -2px;
	right: 25px;
	transform: translateY(0);
}
.patient-register-proceed {
	padding: 40px 0;
	text-align: center;
}
.patient-register-proceed .custom_radio {
	padding-left: 36px;
}
.patient-register-proceed .text-danger {
	margin-top: 10px;
}
.patient-register-btn {
	text-align: center;
	padding-bottom: 20px;
}
.patient-register-btn .btn {
	min-width: 150px;
	margin-right: 20px;
}
.patient-register-btn .btn:last-child {
	margin-right: 0;
}
.form-wrap-calendar-input input {
	padding: 2px 0;
	border: 0;
	border-radius: 0;
	border-bottom: 1px solid #00000038;
}

/*-----------------
	17. Doctor Dashboard
-----------------------*/

.doctor-dash-header h4 {
	color: #00568E;
}
.doctor-dashboard-img {
	width: 160px;
	height: 160px;
	margin-bottom: 24px;
	border-radius: 15px;
}
.doctor-dashboard-img img {
	width: 100%;
	height: 100%;
	border-radius: 15px;
}
.doctor-online {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	align-items: center;
	-webkit-box-align: center;
	-ms-flex-align: center;
}
.doctor-online h6 {
	font-size: 24px;
	font-weight: 600;
	max-width: 200px;
	margin-bottom: 0;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
}
.doctor-switch {
	margin-left: auto;
}
.doctor-switch .onoffswitch {
	width: 90px;
}
.doctor-switch .onoffswitch-inner:before {
	content: "Online";
}
.doctor-switch .onoffswitch-inner:after {
	content: "Offline";
}
.doctor-switch .onoffswitch-inner:before, 
.doctor-switch .onoffswitch-inner:after {
	font-size: 12px;
	color: #000;
	background: #E6E6E6;
	height: 28px;
    line-height: 30px;
}
.doctor-switch .onoffswitch-switch {
	width: 26px;
	height: 26px;
	margin: 0;
	right: 64px;
	background: #E87373;
}
.doctor-switch .onoffswitch-switch-online {
	width: 26px;
	height: 26px;
	margin: 0;
	right: 64px;
	background: #37dd07;
}
.dash-card {
	padding: 24px;
}
.dash-card-content p {
	font-size: 20px;
	color: #FFF;
	margin-bottom: 10px;
}
.dash-card-content h4 {
	font-size: 40px;
	color: #FFF;
	margin-bottom: 0;
}
.bg-pink {
	background: #E87373;
}
.bg-dark-blue {
	background: #00568E;
}
.bg-gray {
	background: #AAA;
}
.doctor-header {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
    flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	padding-top: 16px;
	padding-bottom: 14px;
}
.doctor-header h4 {
	font-size: 24px;
	font-weight: 600;
	color: #00568E;
	margin-bottom: 10px;
}
.doctor-header .nav li {
	margin-bottom: 10px;
	margin-right: 15px;
}
.doctor-header .nav li:last-child {
	margin-right: 0;
}
.doctor-header .nav li .btn {
	padding: 5px 24px;
}
.doctor-header .nav li .past-search {
	font-size: 24px;
	color: #3FA2DB;
}
.doctor-header .nav li .past-search:hover {
	color: #00568E;
}
.patient-header-list {
	padding-top: 30px;
}
.patient-header-info {
	padding-bottom: 100px;
}
.patient-header-list h6 {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 18px;
}
.patient-header-list h6 span {
	color: #3FA2DB;
}	
.patient-header-list ul li p {
	font-weight: 500;
	color: #898989;
	margin-bottom: 0;
}
.patient-header-btn {
	width: 100%;
	position: absolute;
	bottom: 30px;
	right: 50%;
	transform: translateX(50%);
    -webkit-transform: translateX(50%);
    -ms-transform: translateX(50%);
	padding-top: 60px;
	text-align: center;
}
.patient-card-header {
	margin-bottom: 30px;
}
.patient-card-header h4 {
	font-size: 18px;
	margin-bottom: 0;
}

/*-----------------
	18. Appointment 
-----------------------*/

.appointment-details-list ul {
	padding: 0;
	margin: 0;
	list-style: none;
}
.appointment-details-list ul li {
	display: block;
	margin-bottom: 24px;
}
.appointment-details-list ul li p {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	font-weight: 300;
	margin-bottom: 0;
}
.appointment-details-list ul li p span {
	font-weight: 500;
	margin-right: 50px;
}
.appointment-tabs {
	overflow-x: scroll;
	overflow-y: hidden;
	padding-bottom: 4px;
	margin-top: 10px;
	margin-bottom: 14px;
}
.appointment-tabs::-webkit-scrollbar {
  width: 7px;
}
.appointment-tabs::-webkit-scrollbar:horizontal {
  height: 7px;
}
.appointment-tabs::-webkit-scrollbar-track {
  background-color: rgba(204, 204, 204, 0.3);
}
.appointment-tabs::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #3FA2DB;
}
.appointment-details-tabs {
	padding-bottom: 10px;
	margin-top: 20px;
	margin-bottom: 0;
	overflow: hidden;
}
.appointment-tabs .nav-tabs {
	width: 100%;
    padding: 0;
    border: 0;
    display: block;
    white-space: nowrap;
}
.appointment-details-tabs .nav-tabs {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
}
.appointment-tabs .nav-tabs .nav-item {
	display: inline-block;
	margin-right: 20px;
}
.appointment-tabs .nav-tabs .nav-item:last-child {
	margin-right: 0;
}
.appointment-tabs .nav-tabs .nav-item .nav-link {
	font-size: 15px;
	color: #898989;
	background: transparent;
	padding: 0;
	border: 0;
	border-radius: 0;
}
.appointment-tabs .nav-tabs .nav-item .nav-link:hover {
	color: #00568E;
}
.appointment-tabs .nav-tabs .nav-item .nav-link.active {
	font-weight: 500;
	color: #00568E;
}
.symptoms-card {
	padding: 24px;
	margin-bottom: 24px;
	border-radius: 12px;
	background: #FFFFFF0A;
	border: 1px solid #E6E6E6;
}
.symptoms-card h4 {
	font-size: 18px;
	font-weight: 500;
	color: #00568E;
	margin-bottom: 24px;
}
.symptoms-card p {
	color: #000;
	background: #E6E6E6;
	display: inline-block;
	padding: 5px 24px;
	border-radius: 30px;
	margin-right: 5px;
	margin-bottom: 0;
}
.symptoms-card p:last-child {
  	margin-right: 0;
}
.symptoms-search {
	margin-bottom: 24px;
}
.symptoms-input {
	position: relative;
}
.symptoms-input .form-control {
	padding: 10px 20px;
	height: 46px;
	border-radius: 30px;
	border: 1px solid #00568E;
}
.symptoms-input .form-control::placeholder {
	color: #898989;
}
.symptoms-input textarea.form-control {
	border-radius: 18px;
	height: 125px;
	min-height: 125px;
}
.symptoms-input i {
	position: absolute;
    font-size: 20px;
    color: #3FA2DB;
    top: 50%;
    right: 20px;
	transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
}
.symptoms-tags .nav {
	margin-top: 14px;
}
.symptoms-tags .nav li {
	margin-right: 15px;
	margin-bottom: 5px;
}
.symptoms-tags .nav li:last-child {
	margin-right: 0;
}
.symptoms-tags .nav li h6 {
	font-size: 14px;
	font-weight: 400;
	color: #FFF;
	background: #3FA2DB;
	padding: 4px 15px;
	border-radius: 30px;
	margin-bottom: 0;
	line-height: normal;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}
.symptoms-tags .nav li h6 a {
	color: #FFF;
	margin-left: 10px;
}
.symptoms-tags .nav li h6 a:hover {
	opacity: 0.6;
}
.symptoms-tags .nav li h5 {
	font-size: 14px;
	font-weight: 400;
	color: #000;
	background: #E6E6E6;
	padding: 4px 15px;
	border-radius: 30px;
	margin-bottom: 0;
	line-height: normal;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
}
.symptoms-tags .nav li h5 a {
	margin-left: 10px;
}
.add-note-link {
	font-size: 16px;
	font-weight: 500;
	position: relative;
	color: #00568E;
    display: inline-block;
}
.add-note-link:hover {
	color: #3FA2DB;
}
.add-note-link:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #00568E;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 3px;
    left: 0;
}
.add-note-link:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.add-symptoms-input {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-top: 10px;
}
.add-self-input {
	text-align: right;
	display: block;
}
.add-self-input a {
	margin-left: 0;
}
.add-symptoms-input a {
	margin-top: 10px;
	margin-left: 10px;
}
.add-symptoms-input .form-control::placeholder {
	color: #898989;
}
.add-symptoms-input textarea.form-control {
	padding: 10px 15px;
	border: 1px solid #00568E;
	border-radius: 20px;
}
.symptoms-save {
	text-align: right;
}
.symptoms-save a {
	font-size: 16px;
	font-weight: 500;
	position: relative;
	color: #00568E;
    display: inline-block;
}
.symptoms-save a:hover {
	color: #3FA2DB;
}
.symptoms-save a:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #00568E;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 3px;
    left: 0;
}
.symptoms-save a:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.investigation-input .form-control::placeholder {
	color: #898989;
}
.add-investigation a {
	font-size: 16px;
	font-weight: 500;
	position: relative;
	color: #00568E;
    display: inline-block;
}
.add-investigation a:hover {
	color: #3FA2DB;
}
.add-investigation a:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #00568E;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 3px;
    left: 0;
}
.add-investigation a:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.symptoms-card .reports-no-data {
	font-size: 16px;
	font-weight: 500;
	color: #898989;
	padding-left: 40px;
	display: block;
}
.vitals-head {
	padding-right: 15px;
	padding-left: 40px;
    padding-bottom: 10px;
	border-bottom: 1px solid #E6E6E6;
}
.vitals-head h5 {
	font-size: 16px;
    font-weight: 600;
    color: #000;
    margin-bottom: 0;
}
.device-info {
	padding-top: 5px;
	padding-right: 15px;
	padding-left: 25px;
}
.device-list {
	padding: 10px 15px 5px;	
}
.device-list h6 {
	font-size: 14px;
    font-weight: 400;
    color: #000;
    margin-bottom: 10px;
}
.device-list p {
	font-size: 14px;
    font-weight: 400;
    color: #5E5E5E;
    background: transparent;
    display: block;
    padding: 0;
    margin-bottom: 10px;
}
.vitals-table .table thead tr th {
	padding: 0 15px 4px;
}
.vitals-table .table thead tr th:first-child {
	padding-left: 40px;
}
.vitals-table .table tbody tr {
	border: 0;
}
.vitals-table .table tbody tr td:first-child {
	padding-left: 40px;
}
.vitals-table .table tbody tr .value-text {
	color: #5E5E5E;
}
.vitals-table .border-table tbody tr:first-child {
	border-top: 1px solid #E6E6E6;
}
.vitals-table .border-table tbody tr {
	border-bottom: 1px solid #E6E6E6;
}
.vitals-table .border-table tbody tr:last-child {
	border-bottom: 0;
}
.value-link a {
	font-size: 14px;
	position: relative;
	color: #3FA2DB;
    display: inline-block;
}
.value-link a:hover {
	color: #3FA2DB;
}
.value-link a:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #3FA2DB;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 1px;
    left: 0;
}
.value-link a:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.vitals-card {
	padding: 0;
	padding-bottom: 9px;
}
.vitals-card h4 {
	padding: 24px;
	margin-bottom: 0;
}
.past-card .card-body {
	padding: 0;
	padding-bottom: 9px;
}
.past-header {
	padding: 24px;
	margin-bottom: 20px;
	border-bottom: 1px solid #E6E6E6;
}
.diagram-header {
	padding: 0 0 24px;
}
.past-header-border {
	margin-bottom: 18px;
	border-bottom: 1px solid #E6E6E6;
}
.past-header h4 {
	font-size: 18px;
	font-weight: 500;
	color: #00568E;
	margin-bottom: 0;
}
.past-header .past-title {
	color: #000;
}
.vitals-table .border-table .table-surgeries tbody tr {
	border: 0;
}
.vitals-table .border-table .table-surgeries tbody tr td {
	padding: 2px;
}
.past-surgeries {
	padding-left: 60px;
}
.past-surgeries-head {
	margin-bottom: 0;
}
.past-surgeries .nav li {
	width: 50%;
	margin-bottom: 10px;
}
.past-surgeries-left .nav li:first-child {
	padding-left: 40px;
}
.past-surgeries .nav li h6 {
	font-size: 15px;
	font-weight: 600;
	color: #000;
	margin-bottom: 0;
}
.past-surgeries .nav li p {
	color: #000;
	margin-bottom: 0;
}
.diagram-card .card-body {
	padding: 24px 24px 4px;
}
.body-diagram-img {
	margin-bottom: 10px;
}
.body-diagram-img img {
	width: 100%;
}
.diagram-list .nav {
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.diagram-list .nav li {
	width: 50%;
	margin-bottom: 20px;
}
.diagram-checkbox {
	line-height: normal;
}
.diagram-checkbox .check {
	margin-bottom: 0;
}
.diagram-checkbox .check p {
	margin-left: 15px;
	margin-bottom: 0;
} 
.diagram-checkbox .check .box {
    width: 20px;
    min-width: 20px;
    height: 20px;
    background: #FFF;
    border: 1px solid #3FA2DB;
}
.diagram-checkbox .check .box:after {
	display: none;
}
.attachment-upload-info {
	text-align: center;
	margin-bottom: 20px;
}
.attachment-upload-info .file-upload {
	font-size: 16px;
	font-weight: 600;
	color: #3FA2DB;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    margin-bottom: 0;
}
.attachment-upload-info .file-upload input[type=file] {
    position: absolute;
    top: 0;
    right: 0;
    min-width: 100%;
    min-height: 100%;
    font-size: 100px;
    text-align: right;
    filter: alpha(opacity = 0);
    opacity: 0;
    outline: none;
    background: #fff;
    cursor: inherit;
    display: block;
}
.attachment-upload-info .file-upload span {
	display: block;
	margin: 20px 0 6px;
}
.attachment-upload-info p {
	color: #898989;
	margin-bottom: 0;
}
.attachment-table {
	border-left: 0;
	padding-left: 0;
	padding-bottom: 10px;
    margin-bottom: 20px;
}
.attachment-table .table tbody td h6 {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    margin-bottom: 8px;
}
.attachment-table .table tbody td  {
	font-weight: 300;
	color: #898989;
}
.attachment-table .table tbody td p {
	font-weight: 300;
	color: #898989;
	margin-bottom: 0;
	max-width: 200px;
	white-space: break-spaces;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
}
.circle-bar > div {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: flex-end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: flex-end;
    text-align: center;
    position: relative;
}
.circle-bar > div canvas {
	width: 80px !important;
	height: 80px !important;
}
.circle-bar > div span {
	position: absolute;
    font-size: 16px;
    font-weight: 300;
    color: #898989;
    top: 50%;
    left: 50%;
	transform: translate(-50%, -50%);
	-webkit-transform: translate(-50%, -50%);
	-moz-transform: translate(-50%, -50%);
	-ms-transform: translate(-50%, -50%); 
	-o-transform: translate(-50%, -50%);
}
.examination-card {
	margin-bottom: 24px;
    border-radius: 12px;
    background: #FFF;
    border: 1px solid #E6E6E6;
}
.examination-card h4 {
	font-size: 18px;
    font-weight: 500;
    color: #00568E;
    margin-bottom: 24px;
    padding: 24px;
    border-bottom: 1px solid #E6E6E6;
}
.examination-details {
	padding: 0 24px 24px;
}
.examination-details p {
	font-weight: 300;
	margin-bottom: 0;
}
.investigation-details {
	padding: 0 24px 24px;
}
.investigation-details ul {
	padding: 0;
	margin: 0;
	list-style: none;
}
.investigation-details ul li {
	display: block;
	margin-bottom: 15px;
}
.investigation-details ul li:last-child {
	margin-bottom: 0;
}
.investigation-details p {
	color: #000;
    background: #E6E6E6;
    display: inline-block;
    padding: 5px 24px;
    border-radius: 30px;
    margin-bottom: 0;
}
.screenshot-details {
	margin-bottom: 24px;
    padding: 0 24px 20px;
}
.screenshot-details .nav {
	justify-content: space-between;
	-webkit-justify-content: space-between;
	-ms-flex-pack: space-between;
}
.screenshot-details .nav li {
	margin-right: 10px;
}
.screenshot-details .nav li:last-child {
	margin-right: 0;
}
.screenshot-details a {
	font-size: 14px;
	position: relative;
	color: #3FA2DB;
    display: inline-block;
}
.screenshot-details a:hover {
	color: #3FA2DB;
}
.screenshot-details a:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #3FA2DB;
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 1px;
    left: 0;
}
.screenshot-details a:hover:after {
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
}
/*-----------------
	19. Join
-----------------------*/

.join-bg {
	width: 106px;
	height: 158px;
	border-radius: 20px;
	background: #000;
	display: inline-block;
}
.patient-details {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.patient-details-img {
	width: 110px;
	min-width: 110px;
	height: 110px;
	border-radius: 10px;
	margin-bottom: 24px;
	margin-right: 20px;
}
.patient-details-img img {
	width: 110px;
	min-width: 110px;
	height: 110px;
	border-radius: 10px;
}
.patient-details-content {
	margin-bottom: 24px;
}
.patient-details-content h6 {
	font-size: 16px;
	font-weight: 600;
	color: #000;
	margin-bottom: 10px;
}
.patient-details-content p {
	color: #898989;
	margin-bottom: 0;
}
.patient-details-content .patient-details-text {
	margin-top: 14px;
}
.patient-details-btn .nav {
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 14px;
}
.patient-details-btn .nav li {
	margin-right: 10px;
	margin-bottom: 10px;
}
.patient-details-btn .nav li:last-child {
	margin-right: 0;
}
.patient-details-btn .nav li .btn {
	padding: 5px 18px;
}
.join-details-list .nav {
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-bottom: 4px;
}
.join-details-list .nav li {
	display: inline-block;
	margin-right: 40px;
	margin-bottom: 20px;
}
.join-details-list .nav li p span {
	margin-right: 24px;
}
.certificate-list .nav {
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-top: 50px;
	margin-bottom: 14px;
}
.certificate-list .nav li {
	margin-right: 30px;
	margin-bottom: 10px;
}
.certificate-list .nav li:last-child {
	margin-right: 0;
}
.certificate-list .nav li a {
	font-size: 16px;
	font-weight: 500;
	color: #3FA2DB;
	position: relative;
	display: inline-block;
}
.certificate-list .nav li a:hover {
	color: #3FA2DB;
}
.certificate-list .nav li a:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #3FA2DB;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 2px;
    left: 0;
}
.certificate-list .nav li a:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.symptoms-select .select2-container--default .select2-selection--single .select2-selection__rendered {
	color: #898989;
	line-height: 34px;
	padding-left: 15px;
}
.symptoms-select .select2-container--default .select2-selection--single {
	background: #E6E6E6;
	border: 1px solid #E6E6E6;
	border-radius: 30px;
	height: 34px;
}
.symptoms-select .select2-container--default .select2-selection--single .select2-selection__arrow {
	height: 34px;
}
.symptoms-select .select2-results__option {
	color: #898989;
}
.live-stethoscope {
	margin-bottom: 24px;
}
.live-stethoscope .btn {
	padding: 5px 20px;
}
.prescription-list {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-bottom: 14px;
}
.prescription-list a {
	font-size: 16px;
	font-weight: 500;
	color: #00568E;
	position: relative;
	display: inline-block;
	margin-right: 20px;
	margin-bottom: 10px;
}
.prescription-list a:last-child {
	margin-right: 0;
}
.prescription-list a:hover {
	color: #3FA2DB;
}
.prescription-list a:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #00568E;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 1px;
    left: 0;
}
.prescription-list a:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.prescription-table {
	margin-bottom: 30px;
}
.prescription-table .table thead tr {
	border: 0;
}
.prescription-table .table thead tr th {
	color: #737373;
	text-align: center;
	padding: 10px;
	background: #EFEFEF;
	border-radius: 0;
}
.prescription-table .table thead tr th:first-child {
	border-radius: 10px 0 0 10px;
}
.prescription-table .table thead tr th:last-child {
	border-radius: 0 10px 10px 0;
}
.prescription-table .table tbody tr {
	border-bottom: 1px solid #E6E6E6;
}
.prescription-table .table tbody tr td {
	color: #3FA2DB;
	text-align: center;
}
.prescription-table .table tbody tr .data-link a {
	font-size: 18px;
	color: #3FA2DB;
}
.prescription-table .table tbody tr .data-link a:hover {
	color: #00568E;
}
.self-care-add {
	margin-bottom: 20px;
}
.self-care-add .self-care-link {
	font-size: 16px;
	font-weight: 500;
	color: #00568E;
	position: relative;
	display: inline-block;
	margin-right: 24px;
	margin-bottom: 10px;
}
.self-care-add .self-care-link:last-child {
	margin-right: 0;
}
.self-care-add .self-care-link:hover {
	color: #3FA2DB;
}
.self-care-add .self-care-link:after {
    content: "";
    height: 1px;
    width: 100%;
    background: #00568E;
    transform: scale(1);
    -webkit-transform: scale(1);
    -ms-transform: scale(1);
    -webkit-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    transition: all 0.4s ease;
    position: absolute;
    bottom: 1px;
    left: 0;
}
.self-care-add .self-care-link:hover:after {
    transform: scale(0);
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
}
.refer-specialist {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: start;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-bottom: 14px;
}
.refer-specialist p {
	color: #464646;
	margin-right: 24px;
	margin-bottom: 10px;
}
.refer-specialist .custom-radio {
	margin-bottom: 10px;
}
.self-care-calender {
	position: relative;
	max-width: 270px;
	width: 100%;
	margin-bottom: 24px;
}
.self-care-calender .form-control::placeholder {
	color: #898989;
}
.self-care-calender i {
	font-size: 18px;
	color: #3FA2DB;
	position: absolute;
	top: 50%;
	right: 0;
	transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
}
#refer_select_yes {
	display: none;
}
.refer-select-info .symptoms-select {
	margin-bottom: 10px;
}
.refer-select-info .symptoms-select .select2-container--default .select2-selection--single .select2-selection__rendered {
	background: #FFF;
	border: 1px solid #E8E8E8;
	border-radius: 5px;
	padding-left: 10px;
}
.refer-select-info .symptoms-select .select2-container--default .select2-selection--single {
	background: #FFF;
	border: 1px solid #E8E8E8;
	border-radius: 5px;
}
.refer-select-info .symptoms-select .select2-container--default .select2-selection--single .select2-selection__arrow {
	width: 15px;
}
.past-surgeries-nav {
	border-bottom: 1px solid #E6E6E6;
	margin: 0 40px 15px;
}
.past-surgerie-left .past-surgeries-nav li:first-child {
	width: 30%;
}
.past-surgerie-left .past-surgeries-nav li {
	width: 70%;
}
.medical-history-card .past-surgeries .past-surgeries-nav li {
	margin-bottom: 10px;
}
.surgerie-flex {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.surgerie-flex .since-input {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.surgerie-flex .since-input span {
	margin-right: 15px;
}
.surgerie-flex .since-input .form-control {
	max-width: 100px;
	margin-right: 10px;
	padding: 0;
}
.surgerie-flex .per-since-input .form-control {
	max-width: 60px;
}
.past-surgerie-left .surgerie-flex .bootstrap-datetimepicker-widget ul {
	padding-top: 10px;
	border-bottom: 0;
	margin: 0;
}
.past-surgerie-left .surgerie-flex .bootstrap-datetimepicker-widget ul li {
	width: auto;
	text-align: center;
}
.appendectomy-details {
	padding: 0 40px 20px 60px;
}
.appendectomy-info {
	margin-bottom: 20px;
	border-bottom: 1px solid #E6E6E6;
}
.appendectomy-input {
	margin-bottom: 15px;
}
.appendectomy-input .form-control {
	max-width: 140px;
}
.appendectomy-input .form-control::placeholder {
	color: #000;
}
.appendectomy-nav {
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.past-surgeries .appendectomy-nav li {
	width: 25%;
}
.appendectomy-nav .form-control {
	width: 90px;
}
.past-surgeries .appendectomy-nav .bootstrap-datetimepicker-widget ul {
	padding-top: 10px;
	border-bottom: 0;
	margin: 0;
}
.past-surgeries .appendectomy-nav .bootstrap-datetimepicker-widget ul li {
	padding-left: 0;
	width: auto;
	text-align: center;
}
.add-type-surgery .form-control {
	max-width: 160px;
}
.add-type-surgery .form-control::placeholder {
	font-style: italic;
}
.hospitalization-info {
	padding: 0 40px 20px 60px;
}	
.hospitalization-nav {
	margin-bottom: 15px;
	border-bottom: 1px solid #E6E6E6;
}
.past-surgeries-left .hospitalization-nav li:first-child {
	padding-left: 0;
}
.hospitalization-grid {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.hospitalization-grid span {
	color: #000;
	margin-right: 15px;
}
.hospitalization-date .form-control {
	max-width: 110px;
}
.social-history-nav {
	margin-bottom: 15px;
	border-bottom: 1px solid #E6E6E6;
}
.past-surgeries-left .social-history-nav li:first-child {
	padding-left: 0;
	width: 30%;
}
.past-surgeries-left .social-history-nav li {
	width: 70%;
}
.medical-history-card .past-surgeries .social-history-nav .sub-history {
	width: 100%;
	margin: 0;
}
.past-surgeries-left .sub-history .nav {
	border: 0;
	margin: 0;
}
.past-surgeries-left .sub-history .nav li span {
	font-weight: 300;
}	
.past-surgeries-left .sub-history .nav li:first-child {
	padding-left: 30px;
}
.past-surgeries .sub-history .form-control {
	max-width: 500px;
}
.patient-sub-radio-btn {
	padding: 12px 0 0 30px;
}
.family-history-info {
	padding: 0 40px 0 40px;
}
.family-history-nav-top {
	padding-bottom: 10px;
	margin-bottom: 15px;
	border-bottom: 1px solid #E6E6E6;
}
.family-history-nav-top:last-child {
	padding-bottom: 0;
	margin-bottom: 0;
	border-bottom: 0;
}
.past-surgeries-left .family-history-nav-top li:first-child {
	width: 20%;
	padding-left: 0;
}
.medical-history-card .past-surgeries .family-history-info .family-history-nav-top li {
	margin-bottom: 30px;
}
.past-surgeries .family-history-info .sub-history .form-control {
	max-width: 100px;
}
.family-history-nav-top h5 {
	font-size: 15px;
	font-weight: 400;
	margin-bottom: 0;
}
.past-surgeries-left .family-history-nav li:first-child {
	padding-left: 0;
	width: 30%;
}
.past-surgeries-left .family-history-nav li {
	width: 70%;
}
.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history {
	width: 100%;
	margin: 0;
}
.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li:first-child {
	padding-left: 30px;
	width: 23%;
}
.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li {
	width: 75%;
	margin-bottom: 10px;
}
.past-surgeries .family-history-nav li p {
	font-size: 14px;
	font-weight: 300;
	margin-bottom: 0;
}
.vitals-list .nav {
	padding-bottom: 5px;
	margin-bottom: 15px;
	border-bottom: 1px solid #E6E6E6;
}
.vitals-list .nav:last-child {
	padding-bottom: 0;
	margin-bottom: 5px;
	border-bottom: 0;
}
.vitals-list .nav li:first-child {
	padding-left: 60px;
}
.vitals-list .nav li {
	width: 50%;
	color: #000;
	margin-bottom: 10px;
}
.vitals-since p {
	margin-bottom: 0;
}
.vitals-text {
	font-style: italic;
}
.vitals-since p span {
	font-style: normal;
	margin-right: 10px;
}
.appendectomy-list .nav li {
	color: #5B5B5B;
}
.appendectomy-list .vitals-since p {
	color: #373737;
}
.appendectomy-list .nav .appendectomy-sub-list {
	width: 100%;
}
.appendectomy-list .nav .appendectomy-sub-list .nav {
	padding: 0;
	margin: 0;
	border: 0;
}
.appendectomy-list .nav .appendectomy-sub-list li:first-child {
	padding-left: 90px;
}
.appendectomy-list .nav .appendectomy-sub-list li {
	margin-bottom: 5px;
}
.appendectomy-list h6 {
	font-size: 15px;
	font-weight: 500;
	color: #000;
	margin-bottom: 0;
}
.hospitalization-date p span {
	margin-left: 15px;
	color: #5B5B5B;
}

/*-----------------
	20. Notification
-----------------------*/

.notification-header {
	border-bottom: 1px solid #E6E6E6;
	margin-bottom: 20px;
}
.notification-header h4 {
	font-size: 24px;
	margin-bottom: 30px;
}
.notification-header .nav {
	-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin-bottom: 20px;
}
.notification-header .nav li {
	margin-right: 50px;
}
.notification-header .nav li:last-child {
	margin-right: 0;
}
.notification-header .nav li a {
	font-size: 16px;
	font-weight: 500;
	color: #898989;
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}
.notification-header .nav li a:hover {
	color: #00568E;
}
.notification-header .nav li a.active {
	color: #00568E;
}
.notification-header .nav li a span {
	background: #00568E1A;
	color: #00568E;
	width: 25px;
	height: 25px;
	padding: 5px;
	border-radius: 5px;
	margin-left: 10px;
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
}
.notification-read {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
	flex-wrap: wrap;
	-webkit-flex-wrap: wrap;
	margin-bottom: 10px;
}
.notification-select-all {
	margin-right: 10px;
	margin-bottom: 10px;
}
.notification-select-all .custom-checkbox {
	line-height: normal;
}
.notification-select-all .custom-checkbox .check {
	font-size: 14px;
	font-weight: 500;
	margin-bottom: 0;
}
.notification-select-all .custom-checkbox .check .box {
	margin-right: 10px;
}
.notification-read .nav {
	justify-content: flex-end;
    -webkit-justify-content: flex-end;
    -ms-flex-pack: flex-end;
	margin-bottom: 10px;
}
.notification-read .nav li {
	margin-right: 50px;
}
.notification-read .nav li:last-child {
	margin-right: 0;
}
.notification-read .nav li a {
	display: -webkit-inline-box;
	display: -ms-inline-flexbox;
	display: inline-flex;
	-webkit-box-align: center;
	-ms-flex-align: center;
	align-items: center;
	font-weight: 500;
	color: #3FA2DB;
}
.notification-read .nav li a img {
	margin-right: 10px;
}
.notification-read .nav li .clear-all-link {
	color: #FF3B30;
}
.notification-read .nav li a i {
	font-size: 17px;
	margin-right: 6px;
}
.notification-grid {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
	border: 1px solid #E6E6E6;
	border-radius: 10px;
	margin-bottom: 30px;
}
.notification-grid-unread {
	border: 1px solid #000;
}
.notification-left {
	padding: 20px;
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
	flex-grow: 1;
    cursor: pointer;
}
.notification-img {
	display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
	padding-right: 15px;
	margin-right: 15px;
	border-right: 1px solid #E6E6E6;
}
.notification-img span {
	width: 14px;
	min-width: 14px;
	height: 14px;
	border-radius: 50%;
	margin-right: 10px;
	display: inline-block;
}
.notification-active {
	background: #3FA2DB;
}
.notification-pending {
	background: #F7D333;
}
.notification-inactive {
	background: #E87373;
}
.notification-details-checkbox {
	padding: 20px 0px 20px 20px;
	margin-right: 0;
}
.notification-details-checkbox .check .box {
	width: 24px;
    min-width: 24px;
    height: 24px;
}
.notification-img img {
	width: 50px;
	min-width: 50px;
	height: 50px;
	border-radius: 50%;
}
.notification-content h6 {
	font-size: 16px;
	margin-bottom: 5px;
}
.notification-content p {
	color: #898989;
	margin-right: 15px;
	margin-bottom: 0;
}
.notification-right {
	margin-left: auto;
}
.notification-right p {
	color: #898989;
	margin-bottom: 0;
}

/*-----------------
	21. Responsive
-----------------------*/

@media (min-width:768px) {
	.avatar-xxl {
		width: 8rem;
		height: 8rem;
	}
	.avatar-xxl .border {
		border-width: 4px !important;
	}
	.avatar-xxl .rounded {
		border-radius: 12px !important;
	}
	.avatar-xxl .avatar-title {
		font-size: 42px;
	}
	.avatar-xxl.avatar-away:before,
	.avatar-xxl.avatar-offline:before,
	.avatar-xxl.avatar-online:before {
		border-width: 4px;
	}
}

@media (min-width: 992px) {
	#toggle_btn {
		color: #232020;
	    float: left;
	    font-size: 30px;
	    width: 80px;
	    height: 100px;
	    margin-left: 0px;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    box-shadow: 1px 2px 5px rgba(66, 133, 244, 0.30);
	}
	.mini-sidebar .header-left .logo img {
		height: auto;
		width: auto;
	}
	.mini-sidebar .header .header-left .logo {
		display: none;
	}
	.mini-sidebar .header-left .logo.logo-small {
		display: block;
	}
	.mini-sidebar .header .header-left {
		padding: 24px 20px;
    	width: 100px;
	}
	.mini-sidebar .sidebar {
		width: 78px;
	}
	.mini-sidebar.expand-menu .sidebar {
		width: 240px;
	}
	.mini-sidebar .menu-title {
		visibility: hidden;
		white-space: nowrap;
	}
	.mini-sidebar.expand-menu .menu-title {
		visibility: visible;
	}
	.mini-sidebar .menu-title a {
		visibility: hidden;
	}
	.mini-sidebar.expand-menu .menu-title a {
		visibility: visible;
	}
	.modal-open.mini-sidebar .sidebar {
		z-index: 1051;
	}
	.mini-sidebar .sidebar .sidebar-menu ul > li > a span {
		display: none;
		transition: all 0.4s ease;
    	-webkit-transition: all 0.4s ease;
		-moz-transition: all 0.4s ease;
		opacity: 0;
	}
	.mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a span {
		display: inline;
		opacity: 1;
	} 
	.mini-sidebar .page-wrapper {
		margin-left: 78px;
	}
	.user-menu .dropdown-menu {
		top: 100px;
		right: 0;
		left: auto;
		min-width: 200px;
		visibility: hidden;
		opacity: 0;
		border: 0;
		display: block;
		margin: 0;
		padding: 0;
		-webkit-transition: all 0.4s ease;
		-ms-transition: all 0.4s ease;
		transition: all 0.4s ease;
		transform: translateY(20px);
		-webkit-transform: translateY(20px);
		-ms-transform: translateY(20px);
	}
	.user-menu .dropdown-menu.show {
		visibility: visible;
		opacity: 1;
		transform: translateY(0);
		-webkit-transform: translateY(0);
		-ms-transform: translateY(0);
		-webkit-transition: all 0.4s ease;
		-ms-transition: all 0.4s ease;
		transition: all 0.4s ease;
	}
}

@media (max-width: 1699.98px) {
	.account-wrapper-info {
		display: block;
		padding: 0 0 30px;
	}
	.register-main-logo {
		position: relative;
		top: 0;
		left: 0;
		padding: 30px;
	}
	.account-wrapper-info .register-box .login-right {
		margin: 0 auto 30px;
	}
}

@media (max-width: 1599.98px) {
	body {
		font-size: 14px;
	}
	label {
		font-size: 14px;
	}
	.btn {
		font-size: 14px;
	}
	.btn-primary {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-secondary {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-danger {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-black {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-primary-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-secondary-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-danger-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-dark-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.page-header-btn .btn {
	    padding: 8px 20px;
	    min-width: 130px;
	}
	.login-logo img {
		width: 150px;
 	}
	.login-content h1 {
		font-size: 86px;
	}
	.login-content h5 {
		font-size: 26px;
	}
	.login-left {
		padding: 40px 0 0 40px;
	}
	.login-box .login-right {
		padding: 30px;
		max-width: 340px;
		margin-left: -160px;
		margin-bottom: 40px;
	}
	.login-box .login-right h2 {
		font-size: 20px;
	}
	.login-box .login-right .password-header h2 {
		margin-bottom: 20px;
	}
	.login-form .form-wrap-input img {
		width: 24px;
	}
	.login-btn .btn {
	    padding: 8px 40px;
	}
	.login-content img {
		width: 280px;
	}
	.login-content-bottom {
		bottom: 40px;
	}
	.login-box {
		width: 500px;
	}
	.login-box.register-box {
    	width: 100%;
	}
	.register-box .login-right {
		margin: 0 auto 0;
		max-width: 500px;
	}
	.login-shape-img {
		bottom: 50px;
    	margin-left: -140px;
	}
	.shape-img img {
		width: 280px;
	}
	.welcome-wrapper .content {
		padding-left: 60px;
	}
	.welcome-content {
		padding: 40px 0 0 60px;
	}
	.welcome-logo img {
		width: 150px;
	}
	.welcome-text h6 {
		font-size: 60px;
	}
	.welcome-text h1 {
		font-size: 60px;
	}
	.welcome-btn .btn {
		font-size: 16px;
		min-width: 140px;
		padding: 9px 20px;
	}
	.register-logo {
		top: 30px;
		left: 30px;
	}
	.register-main-logo {
		top: 0;
		left: 0;
	}
	.white-logo img {
		width: 130px;
	}
	.password-btn .btn {
		padding: 8px 32px;
	}
	.password-header img {
		width: 50px;
	}
	.user-menu li a {
		font-size: 15px;
	}
	.dash-header h4 {
		font-size: 22px;
	}
	.dash-progress h6 {
		font-size: 36px;
	}
	.dashboard-link {
		padding: 30px;
	}
	.dashboard-link a {
		font-size: 16px;
		width: 200px;
		min-width: 200px;
	}
	.dashboard-link a img {
		width: 100px;
	}
	.table-btn .btn {
		padding: 8px 36px;
	}
	.table thead tr th {
		font-size: 15px;
	}
	.dropdown-menu.front-desk-dropdown {
		padding: 24px;
	}
	.front-desk-dropdown-btn .btn {
		margin-right: 30px;
	}
	.create-header h4 {
		font-size: 22px;
	}
	.form-wrap-btn .btn {
		min-width: 120px;
		margin-right: 15px;
	}
	.edit-header h4 {
		font-size: 26px;
	}
	.edit-icon a {
		font-size: 22px;
	}
	.edit-toggle-btn .btn {
		min-width: 120px;
		margin-left: 20px;
	}
	.success-info i {
		font-size: 68px;
	}
	.success-info p {
		font-size: 16px;
	}
	.sidebar-menu li a {
		font-size: 15px;
	}
	.clinic-nav-item a span {
		font-size: 15px;
	}
	.re-associate-content .btn {
		font-size: 14px;
		padding: 8px 20px;
		min-width: 120px;
	}
	.doctor-online h6 {
		font-size: 22px;
	}
	.dash-card-content p {
		font-size: 18px;
	}
	.dash-card-content h4 {
		font-size: 34px;
	}
	.doctor-header h4 {
		font-size: 22px;
	}
	.doctor-header .nav li .past-search {
		font-size: 22px;
	}
	.symptoms-card h4 {
		font-size: 16px;
	}
	.examination-card h4 {
		font-size: 16px;
	}
	.past-header h4 {
		font-size: 16px;
	}
	.attachment-upload-info .file-upload img {
		width: 60px;
	}
	.certificate-list .nav li a {
		font-size: 15px;
	}
	.symptoms-input .form-control {
		padding: 10px 16px;
		height: 40px;
	}
	.symptoms-input i {
	    font-size: 18px;
	    right: 15px;
	}
	.add-note-link {
		font-size: 14px;
	}
	.add-investigation a {
		font-size: 14px;
	}
	.symptoms-input textarea.form-control {
		height: 100px;
		min-height: 100px;
	}
	.symptoms-save a {
		font-size: 14px;
	}
	.medical-modal-header h4 {
		font-size: 22px;
	}
	.symptoms-card .reports-no-data {
		font-size: 14px;
	}
	.prescription-list a {
		font-size: 15px;
		margin-right: 20px;
	}
	.self-care-add .self-care-link {
		font-size: 15px;
	}
	.drug-btn .btn {
		min-width: 120px;
	}
	.prescription-btn .btn {
		padding: 8px 30px;
	}
	.modal-form-btn .btn {
		font-size: 14px;
	}
	.custom-modal .doctor-slot-body {
		padding: 30px;
	}
	.doctor-slot-header {
		padding-bottom: 30px;
	}
	.doctor-slot-input {
		padding-left: 30px;
	}
	.doctor-slot-input label {
		font-size: 14px;
	}
	.select-days h6 {
		font-size: 14px;
	}
	.doctor-slot-btn .btn {
		padding: 8px 40px;
	}
	.patient-table-list h6 {
		font-size: 15px;
	}
	.notification-header h4 {
		font-size: 22px;
	}
	.notification-header .nav li {
		margin-right: 30px;
	}
	.notification-read .nav li {
		margin-right: 30px;
	}
}

@media (max-width: 1499.98px) {
	.login-left {
		padding: 30px 0 0 30px;
	}
	.login-logo img {
		width: 130px;
	}
	.login-shape-img {
		bottom: 30px;
	}
}

@media (max-width: 1399.98px) {
	.login-content h1 {
		font-size: 74px;
	}
	.login-content h5 {
		font-size: 22px;
	}
	.login-content-bottom {
		bottom: 20px;
	}
	.login-content img {
		width: 250px;
	}
	.login-box {
		width: 400px;
	}
	.login-shape-img {
		bottom: 20px;
        margin-left: -125px;
    }
	.shape-img img {
		width: 250px;
	}
	.dash-progress h6 {
		font-size: 36px;
	}
	.dashboard-link a img {
		width: 120px;
		height: 120px;
	}
	.doctor-dash-header h4 {
		font-size: 20px;
	}
	.doctor-online h6 {
		font-size: 20px;
	}
	.appointment-details-tabs {
		margin-top: 20px;
	}
	.create-header img {
		height: 200px;
	}
	.notification-header h4 {
		font-size: 20px;
	}
}

@media (max-width: 1199.98px) {
	.header .header-left {
		width: 100px;
		margin-right: 20px;
	}
	.sidebar-menu li {
		margin-right: 15px;
	}
	.sidebar-menu li a {
		font-size: 15px;
	}
	.user-menu li {
		margin-right: 26px;
	}
	.clinic-nav-item a img {
		margin-left: 15px;
	}
	.clinic-nav-item a .doctor-menu-img {
		margin-left: 0;
		margin-right: 15px;
	}
	.user-menu li a {
		font-size: 15px;
	}
	.user-menu li a span {
		font-size: 15px;
	}
	.top-nav-search {
		display: none;
	}
	.register-logo {
		position: relative;
		top: 0;
		left: 0;
		padding: 30px 0 0;
		text-align: center;
	}
	.register-box {
		margin-bottom: 30px;
	}
	.login-wrapper {
		min-height: auto;
		height: auto;
		background: #FFF;
		text-align: center;
		padding: 0px 0 30px;
	}
	.login-left {
		width: 100%;
		padding: 20px;
	}
	.login-content h5 {
		margin-bottom: 20px;
	}
	.login-content img {
		display: none;
	}
	.shape-img img {
		display: none;
	}
	.login-content-bottom {
		position: relative;
		bottom: 0;
	}
	.login-box {
		width: 100%;
		background: transparent;
		position: relative;
		height: auto;
		padding: 30px 20px 0;
		top: 0;
	    transform: translateY(0);
	    -webkit-transform: translateY(0);
	    -ms-transform: translateY(0);
	}
	.login-box .login-right {
		max-width: 400px;
		width: 100%;
		margin: 0 auto 0;
		top: 0;
	    transform: translateY(0);
	    -webkit-transform: translateY(0);
	    -ms-transform: translateY(0);
	}
	.account-wrapper {
		display: block;
	}
	.edit-inner-body {
		padding: 0;
	}
	.edit-inner-box {
		border: 0;
	}
	.edit-header {
		padding-bottom: 20px;
	}
	.edit-details {
		padding-left: 0;
	}
	.patient-header-btn {
		position: relative;
		bottom: 0;
		padding-top: 20px;
	}
	.attachment-table {
		border: 0;
		padding: 0;
	}
	.page-list .nav li {
		margin-right: 15px;
	}
	.past-surgeries .appendectomy-nav li {
		width: 27%;
	}
	.medical-history-card .past-surgeries {
		padding: 20px 20px 0 20px;
	}
	.medical-history-card .past-surgeries.past-surgerie-left {
		padding: 0;
	}
	.medical-history-card .past-surgeries.past-surgeries-left {
		padding: 0;
	}
	.past-surgeries-nav {
		margin: 0 0 15px;
	}
	.past-surgerie-left .past-surgeries-nav li:first-child {
		padding-left: 20px;
		width: 20%;
	}
	.appendectomy-details {
		padding: 0 20px;
	}
	.hospitalization-info {
		padding: 0 20px;
	}
	.family-history-info {
		padding: 0 20px;
	}
	.surgerie-flex {
		display: block;
	}
	.surgerie-flex .since-input {
		margin-top: 10px;
	}
	.past-surgeries-left .social-history-nav li {
		margin-bottom: 5px;
	}
	.social-history-nav .patient-radio-btn .custom_radio {
		margin-bottom: 5px;
	}
	.patient-header-info {
		padding-bottom: 0;
	}
}

@media (max-width: 991.98px) {
	.sidebar-overlay {
		top: 80px;
	}
	.header {
		height: 80px;
	}
	.header .header-left {
		position: absolute;
	    width: 100%;
	    height: 80px;
	    margin-right: 0;
	    justify-content: center;
	}
	.header .logout-left {
		width: auto;
	    margin-left: 20px;
	    justify-content: start;
	}
	.mobile-menu {
		top: 80px; 
	}
	.user-menu {
		height: 80px;
	}
	.add-item {
		margin-top: 10px;
	}
	.mobile_btn {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		justify-content: center;
		-webkit-justify-content: center;
		-ms-flex-pack: center;
	    cursor: pointer;
	    font-size: 24px;
	    left: 0;
	    line-height: 80px;
	    padding: 0 15px 0 0;
	    position: absolute;
	    text-align: center;
	    width: 80px;
	    height: 80px;
	    top: 0;
	    z-index: 10;
	}
	.mobile_btn:hover {
		color: #f6f6f7;
	}
	#toggle_btn {
		display: none;
	}
	.top-nav-search {
		display: none;
	}
	.sidebar {
		position: fixed;
		margin-left: -260px;
	    width: 260px;
	    top: 80px;
	    background: #FFF;
	    -webkit-transition: all 0.4s ease;
	    -moz-transition: all 0.4s ease;
	    transition: all 0.4s ease;
	    z-index: 1041;
	}
	.right-sidebar {
		margin-left: 0;
	}
	.sidebar-menu > ul > li > .sidebar-right-toggle {
		font-size: 16px;
		width: 40px;
		height: 40px;
		top: 18px;
		right: 25px;
		bottom: inherit;
		border-radius: 50px;
	}
	.sidebar-menu > ul > li > .sidebar-right-toggle:after {
		left: inherit;
	}
	.hideright-sidebar #sidebar-right-toggle {
		width: 25px;
		height: 50px;
	}
	.sidebar-menu > ul {
		padding: 0px 20px 30px;
	}
	.sidebar-menu > ul > li {
		margin-top: 20px;
		display: block;
	}
	.sidebar-menu li a {
		color: #000;
		text-align: left;
	}
	#menu {
		margin: -40px 0 0;
	}
	.clinic-nav-item {
		display: none;
	}
	.page-wrapper {
		margin-left: 0;
		padding-top: 90px;
		padding-left: 0;
		padding-right: 0;
		-webkit-transition: all 0.4s ease;
		-moz-transition: all 0.4s ease;
		transition: all 0.4s ease;
	}
	.login-logo img {
		width: 130px;
	}
	.register-logo img {
		width: 130px;
	}
	.login-content h1 {
		font-size: 60px;
	}
	.login-content h5 {
		font-size: 22px;
		margin-bottom: 20px;
	}
	.welcome-info {
		height: auto;
	}
	.welcome-logo {
		padding-bottom: 30px;
	}
	.welcome-wrapper {
		padding-top: 0;
	}
	.welcome-wrapper .content {
		padding-left: 40px;
	}
	.welcome-content {
		padding: 40px 0 0 40px;
	}
	.welcome-text h6 {
		font-size: 50px;
	}
	.welcome-text h1 {
		font-size: 50px;
	}
	.dashboard-link {
		padding: 20px;
	}
	.dashboard-link a img {
		width: 100px;
		height: 100px;
	}
	.professional-wrap-status {
		margin-top: 0;
	}
	.certificate-list .nav {
		margin-top: 0;
	}
	.symptoms-select {
		margin-top: 10px;
	}
	.refer-select-info .symptoms-select {
		margin-top: 0;
	}
	.custom-modal .medical-modal-body {
		padding: 0 20px 10px;
	}
	.medical-modal-header {
		padding: 20px;
	}
	.medical-history-card .past-surgeries.past-surgeries-left {
        padding: 0 20px;
    }
	.medical-history-card .past-surgeries {
		padding: 20px 20px 0px;
		margin-bottom: 15px;
	}
	.medical-history-card .past-surgeries .nav li {
		width: 100%;
		padding-left: 0;
		margin-bottom: 10px;
	}
	.medical-history-card .past-surgeries-left .nav li:first-child {
		padding-left: 0;
	}
	.hospitalization-info {
		padding: 0;
	}
	.past-surgeries-nav {
		padding: 0 20px;
	}
	.appendectomy-details {
        padding: 0;
    }
    .family-history-info {
    	padding: 0;
    }
    .hospitalization-nav {
    	display: block;
    }
	.past-surgeries-left .sub-history .family-history-nav {
		display: block;
	}
	.medical-history-card .past-surgeries .family-history-info .family-history-nav-top li {
		margin-bottom: 10px;
	}
	.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li:first-child {
		padding-left: 0;
		width: 100%;
	}
	.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li {
		width: 100%;
	}
	.medical-history-card.diagram-card .card-body {
		padding: 5px 20px 5px;
	}
	.custom-modal .doctor-slot-body {
		padding: 20px;
	}
	.doctor-slot-header h4 {
		font-size: 22px;
	}
	.doctor-slot-input {
		padding: 0;
	}
	.doctor-slot-input .form-wrap {
		margin-bottom: 20px;
	}
	.create-header {
		padding-bottom: 20px;
	}
	.create-header img {
		height: 150px;
	}
	.create-form {
		max-width: inherit;
	}
}

@media (max-width: 767.98px) {
	body {
		font-size: 14px;
	}
	h1, .h1 {
		font-size: 2rem;
	}
	h2, .h2 {
		font-size: 1.75rem;
	}
	h3, .h3 {
		font-size: 1.5rem;
	}
	h4, .h4 {
		font-size: 1.125rem;
	}
	h5, .h5 {
		font-size: 1rem;
	}
	h6, .h6 {
		font-size: 0.875rem;
	}
	label {
		font-size: 14px;
	}
	.form-group {
		margin-bottom: 20px;
	}
	.form-wrap {
		margin-bottom: 20px;
	}
	.form-control {
		font-size: 14px;
	}
	.sidebar-overlay {
	    top: 80px;
	}
	.header .has-arrow .dropdown-toggle:after {
		display: none;
	}
	.user-menu.nav > li > a > span:not(.user-img) {
		display: none;
	}
	.navbar-nav .open .dropdown-menu {
		float: left;
		position: absolute;
	}
	.navbar-nav.user-menu .open .dropdown-menu {
		left: auto;
		right: 0;
	}
	.header .header-left {
		padding: 0;
		margin-left: 0;
		height: 80px;
		text-align: center;
		width: 100%;
	}
	.header .logout-left {
		width: auto;
	    margin-left: 20px;
	    justify-content: start;
	}
	.header .header-left .logo {
		display: none;
	}
	.header-left .logo.logo-small {
		display: inline-block;
	}
	.sidebar-menu > ul > li > .sidebar-right-toggle {
		top: 7px;
	}
	.hideright-sidebar #sidebar-right-toggle {
		top: 0;
        width: 30px;
        height: 60px;
    }
	.sidebar-menu > ul > li {
		margin-top: 20px;
	}
	.sidebar-menu > ul > li:last-child {
		margin-bottom: 0;
	}
	.mobile_btn {
		width: 65px;
	    height: 80px;
	    padding: 0;
	}
	.mobile-menu {
		top: 60px; 
	}
    .user-menu li {
	    margin-right: 24px;
	}
	.user-menu li a.header-profile {
		display: none;
	}
	.user-menu li.has-arrow {
		display: none;
	}
	.user-menu li a .fa-search {
		display: none;
	}
	#menu {
		text-align: left;
		width: 180px;
		padding: 40px 0px 0 20px;
	}
	#menu li {
		padding: 15px 0 0;
	}
	.page-wrapper {
		padding-top: 80px;
	}
	.page-wrapper-info {
		display: block;
	}
	.page-title {
		font-size: 20px;
	}
	.breadcrumb .breadcrumb-item {
		font-size: 20px;
	}
	.breadcrumb-item+.breadcrumb-item {
		font-size: 20px;
	}
	.card {
		margin-bottom: 20px;
	}
	.card-body {
		padding: 20px;
	}
	.card-header {
		padding: .75rem 1.25rem;
	}
	.card-footer {
		padding: .75rem 1.25rem;
	}
	.table thead tr th {
		font-size: 15px;
	}
	.dropdown-menu.front-desk-dropdown {
		min-width: 220px;
    	max-width: 220px;
		padding: 20px;
	}
	.front-desk-dropdown-btn .btn {
		margin-right: 10px;
	}
	.page-header {
		margin-bottom: 20px;
	}
	.notifications .noti-content {
		width: 310px;
		height: 355px;
	}
	.breadcrumb .breadcrumb-item {
		font-size: 18px;
	}
	.breadcrumb-item+.breadcrumb-item {
		font-size: 18px;
	}
	.btn-primary {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-secondary {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-danger {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-black {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-primary-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-secondary-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-danger-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.btn-dark-light {
		font-size: 14px;
		padding: 8px 20px;
	}
	.account-wrapper-info {
		padding: 0 0 20px;
	}
	.login-wrapper {
		padding: 0 0 30px;
	}
	.login-wrapper .login-right {
		float: none;
		width: 100%;
	}
	.login-logo img {
		width: 100px;
	}
	.login-content h1 {
		font-size: 34px;
	}
	.login-content h5 {
		font-size: 16px;
	}
	.login-box {
		padding: 20px 20px 0;
	}
	.login-box .login-right {
		padding: 20px;
	}
	.login-header {
		padding-bottom: 40px;
	}
	.login-box .login-right h2 {
		font-size: 20px;
	}
	.login-form .form-wrap-input img {
		width: 20px;
	}
	.login-box.register-box {
		padding: 20px 0 0;
	}
	.welcome-body {
		background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	}
	.welcome-wrapper {
		padding-top: 0;
	}
	.welcome-wrapper .content {
		padding-left: 20px;
	}
	.welcome-content {
		padding: 20px 0 0 20px;
	}
	.welcome-logo img {
		width: 100px;
	}
	.welcome-text h6 {
		font-size: 30px;
	}
	.welcome-text h1 {
		font-size: 30px;
	}
	.welcome-btn .btn {
	    font-size: 14px;
	    min-width: auto;
	    margin-right: 10px;
	    padding: 7px 20px;
	}
	.register-section {
		padding: 20px 0;
	}
	.register-logo {
		padding: 20px 0;
		text-align: center;
	}
	.register-logo img {
		width: 100px;
	}
	.password-btn {
		margin-top: 20px;
	}
	.otp-box input {
		width: 32px;
		height: 32px;
		margin-right: 2px;
	}
	.dash-header {
		margin-bottom: 20px;
	}
	.dash-header h4 {
		font-size: 20px;
	}
	.dash-progress {
		margin-bottom: 20px;
	}
	.dashboard-link {
		padding: 5px;
	}
	.dashboard-link a {
		width: 150px;
		min-width: 150px;
		font-size: 15px;
	}
	.dashboard-link a img {
		width: 70px;
		height: 70px;
	}
	.page-list .nav {
		justify-content: start;
	    -webkit-justify-content: start;
	    -ms-flex-pack: start;
	}
	.page-list .nav li {
		margin-right: 10px;
	}
	.page-header-btn .btn {
		padding: 8px 20px;
		width: 100%;
	}
	.table-btn {
		padding: 20px 0;
	}
	.table-btn .btn {
		padding: 8px 40px;
	}
	.table-pagination {
		margin-bottom: 20px;
	}
	.create-card {
		padding: 0;
	}
	.edit-inner-body {
		padding: 0;
		padding-top: 20px;
	}
	.create-header h4 {
		font-size: 22px;
	}
	.create-form {
		max-width: inherit;
	}
	.create-header h4 {
		margin-bottom: 20px;
	}
	.create-header img {
		height: 100px;
	}
	.form-wrap-status {
		margin-bottom: 20px;
	}
	.form-wrap-btn .btn {
		width: 100%;
		min-width: 100%;
		margin-right: 0;
	}
	.form-wrap-btn .btn-secondary {
		margin-bottom: 10px;
	}
	.edit-icon a {
		font-size: 20px;
	}
	.edit-header h4 {
		font-size: 22px;
	}
	.edit-toggle {
		display: block;
	}
	.edit-toggle .status-toggle {
		margin-bottom: 15px;
	}
	.edit-toggle-btn .btn {
		margin-left: 0;
		min-width: 120px;
	}
	.success-card .card-body {
		padding: 20px;
	}
	.success-info i {
		font-size: 40px;
	}
	.success-info img {
	    margin: 0 auto 20px;
	    width: 60px;
	}
	.success-info p {
		font-size: 14px;
	}
	.re-associate-content {
		padding: 0;
	}
	.re-associate-text img {
		width: 60px;
	}
	.re-associate-text p {
		font-size: 14px;
		margin-bottom: 20px;
	}
	.re-associate-content .btn {
		font-size: 14px;
		padding: 7px 20px;
		min-width: 110px;
	}
	.schedule-modal-header {
		padding: 10px 0 10px;
	}
	.schedule-modal-header h4 {
		font-size: 18px;
	}
	.schedule-modal-form {
		padding: 0;
	}
	.schedule-success {
		padding: 15px;
	}
	.schedule-success i {
		font-size: 40px;
		margin: 0 auto 20px;
	}
	.schedule-success h4 {
		font-size: 18px;
	}
	.schedule-modal-form .custom-radio {
		padding: 10px 0 0;
	}
	.patient-nav-list .nav {
		margin-bottom: 10px;
	}
	.patient-nav-list .nav li {
		padding-right: 5px;
    	margin-right: 4px;
	}
	.patient-register-header {
		padding: 0 0 20px;
	}
	.patient-register-header h4 {
		font-size: 20px;
	}
	.patient-register-form {
		width: 100%;
	}
	.patient-register-img {
		margin: 0 auto 20px;
	}
	.patient-register-proceed {
	    padding: 20px 0 20px;
	}
	.patient-register-btn {
		padding-bottom: 0;
	}
	.patient-register-btn .btn {
		min-width: 120px;
		margin-right: 10px;
	}
	.doctor-dashboard-img {
		width: 100%;
		height: auto;
		margin-bottom: 20px;
	}
	.dash-card {
		padding: 20px;
	}
	.dash-card-content p {
		font-size: 16px;
	}
	.dash-card-content h4 {
		font-size: 30px;
	}
	.doctor-header {
		padding-top: 0;
	}
	.doctor-header h4 {
		font-size: 20px;
	}
	.doctor-header .nav li {
		margin-right: 10px;
	}
	.table tbody tr .vitals-data .nav li {
		margin-right: 10px;
	}
	.patient-card-header {
		margin-bottom: 20px;
	}
	.appointment-tabs {
		margin-top: 0;
	}
	.appointment-details-tabs {
		overflow-x: scroll;
    	overflow-y: hidden;
    	padding-bottom: 4px;
    	margin-top: 10px;
    	margin-bottom: 14px;
	}
	.appointment-details-tabs .nav-tabs {
		display: block;
	}
	.appointment-tabs .nav-tabs .nav-item .nav-link {
		font-size: 14px;
	}
	.symptoms-card {
		padding: 20px;
		margin-bottom: 20px;
	}
	.symptoms-card h4 {
		margin-bottom: 20px;
	}
	.appointment-details-list ul li {
		margin-bottom: 20px;
	}
	.vitals-card {
		padding: 0;
		padding-bottom: 5px;
	}
	.past-card .card-body {
		padding-bottom: 5px;
	}
	.vitals-card h4 {
		padding: 20px;
		margin-bottom: 0;
	}
	.vitals-table .table thead tr th:first-child {
		padding-left: 20px;
	}
	.vitals-table .table tbody tr td:first-child {
		padding-left: 20px;
	}
	.past-header {
		padding: 20px;
	}
	.diagram-card .card-body {
		padding: 20px 20px 0;
	}
	.diagram-header {
		padding: 0 0 20px;
	}
	.diagram-list .nav li {
		width: 100%;
	}
	.attachment-upload-info {
		margin-bottom: 15px;
	}
	.attachment-upload-info .file-upload {
		font-size: 14px;
	}
	.attachment-upload-info .file-upload img {
		width: 50px;
	}
	.attachment-table {
		margin-bottom: 5px;
	}
	.attachment-table .table tbody td h6 {
		font-size: 14px;
	}
	.patient-details {
		display: block;
	}
	.patient-details {
		margin-right: 0;
		margin-bottom: 20px;
	}
	.patient-details-content {
		margin-bottom: 20px;
	}
	.patient-details-btn .nav {
		margin-bottom: 10px;
	}
	.join-details-list .nav {
		display: block;
		margin-bottom: 0;
	}
	.join-details-list .nav li {
		display: block;
		margin-right: 0;
	}
	.certificate-list .nav {
		margin-bottom: 10px;
	}
	.certificate-list .nav li a {
		font-size: 14px;
	}
	.symptoms-search {
		margin-bottom: 20px;
	}
	.medical-modal-header {
    	padding: 20px 20px 10px;
    }
	.create-modal-header {
		justify-content: space-between;
		-webkit-justify-content: space-between;
		-ms-flex-pack: space-between;
	}
	.medical-modal-header h4 {
		font-size: 20px;
	}
	.medical-modal-header .close {
		width: 30px;
		height: 30px;
		top: 15px;
		right: 15px;
	}
	.form-wrap-status h4 {
		font-size: 16px;
	}
	.past-medical-btn {
		padding: 20px 0 0;
	}
	.symptoms-card .reports-no-data {
		padding-left: 0;
	}
	.prescription-list a {
		font-size: 14px;
		margin-right: 15px;
	}
	.self-care-add .self-care-link {
		font-size: 14px;
	}
	.self-care-add {
		margin-bottom: 10px;
	}
	.refer-specialist {
		margin-bottom: 10px;
	}
	.self-care-calender {
		margin-bottom: 20px;
	}
	.custom-modal .drug-modal-body {
		padding: 20px;
	}
	.drug-btn {
		margin-top: 0;
	}
	.prescription-modal-header {
		justify-content: flex-start;
		-webkit-justify-content: flex-start;
		-ms-flex-pack: flex-start;
	}
	.prescription-modal-header h5 {
		font-size: 16px;
	}
	.prescription-grid {
		padding: 20px;
	}
	.prescription-btn {
		padding: 20px;
	}
	.custom-modal .profile-modal-body {
		padding: 20px;
	}
	.profile-modal-title h4 {
		font-size: 18px;
	}
	.profile-modal-img {
		margin: 0 auto 20px;
	}
	.profile-modal-form {
		padding: 0;
	}
	.profile-modal-btn {
		padding: 0;
	}
	.doctor-slot-header {
		padding-bottom: 20px;
	}
	.form-flex-wrap {
		display: block;
	}
	.form-flex-wrap .doctor-slot-date .form-control {
	    width: 100%;
	}
	.medical-history-card .past-surgeries {
		padding: 20px 20px 5px;
	}
	.hospitalization-grid {
		display: block;
	}
	.doctor-slot-btn .btn {
		padding: 8px 30px;
		margin-right: 10px;
	}
	.notification-header h4 {
		font-size: 18px;
	}
	.notification-grid {
		margin-bottom: 20px;
		display: block;
	}
	.notification-left {
		display: block;
	}
	.notification-img {
		border: 0;
		padding-right: 0;
		margin-right: 0;
		padding-bottom: 15px;
		display: block;
	}
	.examination-card {
		margin-bottom: 20px;
	}
	.examination-card h4 {
		padding: 20px;
		margin-bottom: 20px;
	}
	.examination-details {
		padding: 0 20px 20px;
	}
	.investigation-details {
		padding: 0 20px 20px;
	}
	.screenshot-details {
		padding: 0 20px 20px;
	}
	.vitals-list {
		padding: 0 20px;
	}
	.vitals-list .nav {
		display: block;
	}
	.vitals-list .nav li {
		width: 100%;
	}
	.vitals-list .nav li:first-child {
		padding-left: 0;
	}
	.appendectomy-list .nav .appendectomy-sub-list li:first-child {
		padding-left: 0;
	}
}

@media (max-width: 575.98px) {
	.appointment-details-list ul li p {
		display: block;
	}
	.appointment-details-list ul li p span {
		margin-right: 0;
		margin-bottom: 4px;
		display: block;
	}
	.past-surgeries {
		padding: 0 20px 13px;
	}
	.past-surgeries-head {
		margin-bottom: 0;
	}
	.past-surgeries .nav {
		display: block;
	}
	.past-surgeries .nav li {
		width: 100%;
		margin-bottom: 2px;
	}
	.past-surgeries-left .nav li:first-child {
		padding-left: 0;
	}
	.past-surgeries .nav li h6 {
		font-size: 14px;
	}
	.patient-details-btn .nav {
		margin-bottom: 14px;
		display: block;
	}
	.patient-details-btn .nav li {
		margin-right: 0;
	}
	.patient-details-btn .nav li .btn {
		width: 100%;
	}
	.join-details-list .nav li p span {
		margin-right: 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;yCAyByC;;AAEzC;;wBAEwB;;AAIxB;CACC,YAAY;AACb;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,kCAAkC;CAClC,eAAe;CACf,YAAY;CACZ,gBAAgB;CAChB,kBAAkB;AACnB;AACA;;;;;;CAMC,kCAAkC;CAClC,gBAAgB;CAChB,WAAW;CACX,aAAa;AACd;AACA;CACC,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,aAAa;CACb,qBAAqB;AACtB;AACA;;;CAGC,yDAAyD;CACzD,iDAAiD;AAClD;AACA;IACI,gBAAgB;CACnB,SAAS;CACT,kCAAkC;IAC/B,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,cAAc;IACd,YAAY;CACf,oBAAoB;AACrB;AACA;CACC,SAAS;CACT,gBAAgB;CAChB,eAAe;CACf,kCAAkC;AACnC;AACA;CACC,iCAAiC;AAClC;AACA;CACC,sBAAsB;AACvB;AACA;CACC,gCAAgC;AACjC;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,WAAW;CACX,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;;;CAGC,yBAAyB;CACzB,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;AAClC;AACA;;CAEC,aAAa;AACd;AACA;IACI,YAAY;IACZ,sCAAsC;AAC1C;AACA;;CAEC,wBAAwB;CACxB,qBAAqB;CACrB,gBAAgB;AACjB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;IACZ,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;AACf;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;;;CAGC,oCAAoC;CACpC,gCAAgC;AACjC;AACA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,uBAAuB;AACxB;AACA;IACI,uBAAuB;AAC3B;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,SAAS;CACT,uBAAuB;CACvB,sBAAsB;AACvB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,aAAa;CACb,SAAS;CACT,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,gCAAgC;AACjC;AACA;CACC,gCAAgC;AACjC;AACA;CACC,eAAe;CACf,8BAA8B;CAC9B,wCAAwC;AACzC;AACA;CACC,eAAe;CACf,WAAW;CACX,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,SAAS;CACT,mBAAmB;AACpB;AACA;CACC,yBAAyB;AAC1B;AACA;;;;;;CAMC,aAAa;CACb,iBAAiB;AAClB;AACA;;CAEC;AACD;AACA;CACC,oCAAoC;CACpC,qCAAqC;AACtC;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,sBAAsB;AACvB;AACA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,sBAAsB;CACzB,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;CACX,cAAc;CACd,eAAe;CACf,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;;CAEC,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,0CAA0C;AAC3C;AACA;CACC,0CAA0C;AAC3C;AACA;CACC,gDAAgD;AACjD;AACA;;CAEC,iCAAiC;AAClC;AACA;IACI,aAAa;AACjB;AACA;;IAEI,oBAAoB;AACxB;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,6BAA6B;IAC7B,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,iBAAiB;CACpB,yBAAyB;AAC1B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;IAChB,iBAAiB;CACpB,yBAAyB;AAC1B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;CACjB,YAAY;CACZ,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,sCAAsC;AACvC;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC;AACD;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;AAC7B;AACA;CACC,aAAa;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;AACd;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,4BAA4B;IACzB,wBAAwB;IACxB,oBAAoB;AACxB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;AACxB;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,aAAa;CACb,UAAU;CACV,mBAAmB;CACnB,uCAAuC;CACvC,4BAA4B;IACzB,6BAA6B;AACjC;AACA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,SAAS;CACT,YAAY;AACb;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,qBAAqB;CACrB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,oBAAoB;CACpB,kBAAkB;AACnB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;IACI,gBAAgB;IAChB,YAAY;AAChB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;IACZ,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;AACA;CACC,UAAU;CACV,SAAS;CACT,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,wCAAwC;AACzC;;AAEA;;wBAEwB;;AAExB;CACC,wBAAwB;AACzB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,oBAAoB;AACrB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,wBAAwB;AACzB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,eAAe;CACf,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,YAAY;CACZ,0BAA0B;CAC1B,uCAAuC;CACvC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,sBAAsB;CACtB,sCAAsC;AACvC;AACA;CACC,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,MAAM;CACN,SAAS;CACT,YAAY;CACZ,0BAA0B;CAC1B,gCAAgC;CAChC,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,0CAA0C;CAC1C,+BAA+B;AAChC;AACA;CACC;GACE,uBAAuB;CACzB;EACC;IACE,yBAAyB;EAC3B;CACD;CACA;EACC;IACE,uBAAuB;EACzB;CACD;GACE,0BAA0B;CAC5B;AACD;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,mBAAmB;AACvB;AACA;CACC,cAAc;AACf;AACA;IACI,mBAAmB;AACvB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,MAAM;AACR;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,cAAc;CACd,mDAAmD;CACnD,mBAAmB;CACnB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,WAAW;CACX,WAAW;CACX,kBAAkB;CAClB,sBAAsB;CACtB,wBAAwB;CACxB,mBAAmB;CACnB,8CAA8C;CAC9C,+BAA+B;CAC/B,mDAAmD;CACnD,OAAO;CACP,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;AACb;AACA;CACC,WAAW;CACX,oBAAoB;IACjB,mBAAmB;CACtB,kBAAkB;CAClB,gBAAgB;CAChB,eAAe;CACf,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB;AACD;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;CAClB;AACD;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,UAAU;AACX;AACA;CACC,kBAAkB;CAClB,OAAO;CACP,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,yBAAyB;CACzB;AACD;AACA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,qCAAqC;CACrC,mCAAmC;CACnC,wCAAwC;CACxC,oCAAoC;CACpC;AACD;AACA;CACC,cAAc;CACd,SAAS;CACT,UAAU;CACV,QAAQ;CACR,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,oBAAoB;CACpB,kBAAkB;AACnB;AACA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;AACA;CACC,YAAY;CACZ,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,+BAA+B;CAC/B,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,kBAAkB;CAClB,iDAAiD;AAClD;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;CACC,sBAAsB;CACtB,UAAU;CACV,6CAA6C;AAC9C;AACA;CACC,iBAAiB;IACd,kBAAkB;CACrB,WAAW;IACR,wBAAwB;CAC3B,qBAAqB;CACrB,qBAAqB;AACtB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;CACjB,gBAAgB;CAChB,eAAe;CACf,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,cAAc;IACX,kBAAkB;IAClB,kCAAkC;IAClC,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,WAAW;IACX,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,UAAU;IACV,UAAU;AACd;AACA;CACC,yBAAyB;IACtB,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;IACT,cAAc;CACjB,YAAY;IACT,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,MAAM;IACN,+BAA+B;IAC/B,WAAW;AACf;AACA;IACI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,wBAAwB;AAC5B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,gCAAgC;IAChC,qBAAqB;IACrB,yCAAyC;IACzC,iCAAiC;AACrC;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,mDAAmD;IACnD,2CAA2C;IAC3C,6BAA6B;IAC7B,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;;AAEA;;wBAEwB;;AAExB;IACI,iBAAiB;AACrB;AACA;CACC,WAAW;AACZ;AACA;CACC,qBAAqB;AACtB;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,gBAAgB;AACjB;AACA;CACC,sBAAsB;CACtB,sBAAsB;CACtB,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oCAAoC;AACrC;AACA;IACI,oCAAoC;AACxC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,yCAAyC;IACtC,cAAc;AAClB;AACA;CACC,0CAA0C;IACvC,+BAA+B;AACnC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,qDAAqD;CACrD,cAAc;AACf;AACA;;;;IAII,oCAAoC;AACxC;AACA;;CAEC,iDAAiD;CACjD,cAAc;AACf;AACA;;;;IAII,oCAAoC;AACxC;AACA;CACC,sBAAsB;AACvB;AACA;;IAEI,oCAAoC;AACxC;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;IACI,yBAAyB;AAC7B;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;;;;;CAKC,cAAc;CACd,yBAAyB;CACzB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;IAC/B,uBAAuB;AAC3B;AACA;;;;;;;;;CASC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,uBAAuB;AACxB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,yBAAyB;IACtB,uBAAuB;IACvB,cAAc;CACjB,cAAc;IACX,gBAAgB;IAChB,kBAAkB;CACrB,aAAa;AACd;AACA;CACC,mBAAmB;IAChB,WAAW;AACf;AACA;CACC,yBAAyB;CACzB;AACD;AACA;;;;;CAKC,6BAA6B;CAC7B,yBAAyB;CACzB,WAAW;AACZ;AACA;;;;;;;;;CASC,yBAAyB;CACzB;AACD;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,yBAAyB;CACzB;AACD;AACA;;;;;CAKC,6BAA6B;CAC7B;AACD;AACA;;;;;;;;;CASC,yBAAyB;CACzB;AACD;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,yBAAyB;CACzB;AACD;AACA;;;;;CAKC,6BAA6B;CAC7B;AACD;AACA;;;;;;;;;CASC,yBAAyB;CACzB;AACD;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,iBAAiB;CACjB,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;CACnB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;;;;;CAKC,cAAc;CACd,6BAA6B;CAC7B,yBAAyB;AAC1B;AACA;;;;;;;;;CASC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;;;CAGC,iBAAiB;AAClB;AACA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;AACf;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,cAAc;CACd,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,mBAAmB;AACpB;AACA;;;IAGI,iBAAiB;AACrB;AACA;;;IAGI,iBAAiB;AACrB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,sBAAsB;CACtB,gBAAgB;CAChB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,WAAW;CACX,yBAAyB;CACzB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,6BAA6B;AAC9B;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,cAAc;CACd,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,qBAAqB;AACtB;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,6BAA6B;CAC7B,cAAc;AACf;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;;CAGC,gBAAgB;AACjB;AACA;IACI,cAAc;IACd,qBAAqB;AACzB;AACA;IACI,cAAc;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,yBAAyB;CACzB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,yBAAyB;CACzB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,uBAAuB;CACvB,yBAAyB;CACzB,mBAAmB;CACnB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,yBAAyB;CACzB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,iBAAiB;CACjB,uBAAuB;CACvB,sBAAsB;CACtB,mBAAmB;CACnB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,sBAAsB;CACtB,mCAAmC;IAChC,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;AACnC;AACA;;;;;;CAMC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;;CAEC,cAAc;AACf;AACA;CACC,8BAA8B;AAC/B;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,yBAAyB;CACzB,qBAAqB;AACtB;AACA;CACC,SAAS;CACT,kBAAkB;CAClB,4BAA4B;CAC5B,uCAAuC;CACvC,sBAAsB;AACvB;AACA;CACC,UAAU;AACX;AACA;CACC,kCAAkC;CAClC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;IACI,sBAAsB;AAC1B;AACA;CACC,SAAS;CACT,uCAAuC;CACvC,sBAAsB;AACvB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;IACb,SAAS;IACT,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;AACvB;AACA;CACC,aAAa;AACd;AACA;CACC,gCAAgC;CAChC,oBAAoB;AACrB;AACA;CACC,sBAAsB;CACtB,6BAA6B;CAC7B,oBAAoB;AACrB;AACA;IACI,sBAAsB;IACtB,gCAAgC;AACpC;AACA;IACI,gBAAgB;IAChB,eAAe;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,kDAAkD;CAClD,wBAAwB;AACzB;AACA;CACC,mDAAmD;CACnD,wBAAwB;AACzB;AACA;CACC,mCAAmC;CACnC,qBAAqB;AACtB;AACA;CACC,kDAAkD;CAClD,wBAAwB;AACzB;AACA;CACC,yBAAyB;IACtB,WAAW;AACf;AACA;CACC,oDAAoD;CACpD,wBAAwB;AACzB;AACA;IACI,8CAA8C;IAC9C,8BAA8B;AAClC;AACA;CACC,iDAAiD;CACjD,wBAAwB;AACzB;AACA;CACC,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;IACI,iBAAiB;AACrB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,eAAe;IACZ,gBAAgB;IAChB,gCAAgC;IAChC,gCAAgC;AACpC;AACA;IACI,eAAe;IACf,WAAW;IACX,uBAAuB;IACvB,SAAS;AACb;AACA;CACC,aAAa;AACd;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,uCAAuC;AAC3C;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,4BAA4B;IACzB,wBAAwB;IACxB,oBAAoB;AACxB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;AACxB;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;;AAEA;;wBAEwB;AACxB;CACC,aAAa;AACd;AACA;CACC,sBAAsB;AACvB;AACA;CACC,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,SAAS;CACT,kCAAkC;CAClC,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,YAAY;CACZ,WAAW;AACZ;AACA;CACC,kBAAkB;IACf,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;IACR,yCAAyC;IACzC,iDAAiD;IACjD,6CAA6C;AACjD;AACA;CACC,kBAAkB;IACf,yBAAyB;IACzB,eAAe;IACf,YAAY;AAChB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,yBAAyB;CACzB,WAAW;AACZ;AACA;IACI,mBAAmB;AACvB;AACA;CACC,2BAA2B;CAC3B,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,iBAAiB;AAClB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,uBAAuB;AAC3B;AACA;CACC,eAAe;IACZ,iBAAiB;IACjB,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;AACA;CACC,UAAU;AACX;AACA;CACC,kCAAkC;CAClC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,gCAAgC;AACjC;AACA;IACI,gBAAgB;AACpB;AACA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;CACzB,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;IACI,sBAAsB;IACtB,yBAAyB;CAC5B,WAAW;AACZ;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;AACZ;AACA;;;CAGC,yBAAyB;CACzB,qBAAqB;CACrB,WAAW;AACZ;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;;;CAGC,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,6BAA6B;AAC9B;AACA;;;CAGC,uBAAuB;AACxB;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,uBAAuB;AACxB;AACA;;;CAGC,sBAAsB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;;;CAGC,yBAAyB;AAC1B;AACA;CACC,mBAAmB;AACpB;AACA;;;CAGC,wBAAwB;CACxB,yBAAyB;CACzB,4BAA4B;CAC5B,6BAA6B;CAC7B,2BAA2B;CAC3B,gCAAgC;CAChC,8BAA8B;CAC9B,+BAA+B;CAC/B,mCAAmC;AACpC;AACA;CACC,yBAAyB;CACzB,SAAS;AACV;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;AAC1B;AACA;;CAEC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;CACC,6BAA6B;AAC9B;AACA;;;CAGC,uBAAuB;AACxB;;AAEA;;wBAEwB;;AAExB;CACC,uBAAuB;AACxB;AACA;CACC,WAAW;AACZ;AACA;CACC,yBAAyB;CACzB,WAAW;CACX,SAAS;CACT,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;CACX,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AACA;;;CAGC,kBAAkB;CAClB,QAAQ;CACR,SAAS;CACT,UAAU;CACV,WAAW;CACX,kBAAkB;CAClB,WAAW;CACX,sBAAsB;AACvB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,aAAa;CACb,cAAc;AACf;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,eAAe;AAChB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,eAAe;AAChB;AACA;;;CAGC,iBAAiB;AAClB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,wBAAwB;AACzB;AACA;CACC,UAAU;AACX;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,mBAAmB;IACnB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UAAU;IACV,wBAAwB;IACxB,cAAc;IACd,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;;wBAEwB;;AAExB;CACC,gBAAgB;CAChB,OAAO;CACP,eAAe;CACf,QAAQ;CACR,MAAM;CACN,WAAW;CACX,YAAY;AACb;AACA;CACC,WAAW;IACR,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,iCAAiC;CACpC,8BAA8B;CAC9B,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,8BAA8B;IAC3B,sCAAsC;IACtC,4BAA4B;CAC/B,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;CACb,cAAc;CACd,6BAA6B;CAC7B,4BAA4B;CAC5B,WAAW;CACX,WAAW;CACX,qBAAqB;CACrB,oBAAoB;CACpB,iCAAiC;CACjC,0BAA0B;CAC1B,yBAAyB;CACzB,gCAAgC;CAChC,yBAAyB;CACzB,wBAAwB;CACxB,yCAAyC;CACzC,iCAAiC;CACjC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,kCAAkC;CAClC,2BAA2B;CAC3B,0BAA0B;AAC3B;AACA;CACC,WAAW;AACZ;AACA;CACC,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,aAAa;CACb,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;;CAEC,WAAW;AACZ;AACA;CACC,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,WAAW;IACR,kBAAkB;AACtB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,SAAS;CACT,kBAAkB;CAClB,UAAU;CACV,SAAS;CACT;AACD;AACA;CACC,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,eAAe;CACf,WAAW;CACX,aAAa;CACb,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,cAAc;CACd,6BAA6B;AAC9B;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,uBAAuB;CACvB,gCAAgC;AACjC;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,QAAQ;IACL,2BAA2B;CAC9B,cAAc;AACf;AACA;CACC,eAAe;CACf,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,WAAW;CACX,WAAW;CACX,YAAY;CACZ,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,uBAAuB;CAC1B,oBAAoB;AACrB;AACA;CACC,mBAAmB;CACnB,WAAW;CACX,yBAAyB;CACzB,eAAe;IACZ,uBAAuB;CAC1B,oBAAoB;AACrB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;AACA;CACC,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;CACzB,WAAW;AACZ;AACA;;CAEC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,kBAAkB;CAClB,WAAW;AACZ;AACA;CACC,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,kBAAkB;AACnB;AACA;;CAEC,WAAW;AACZ;AACA;CACC,aAAa;CACb,WAAW;AACZ;AACA;IACI,qBAAqB;IACrB,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,cAAc;IACd,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,oBAAoB;AACxB;AACA;CACC,WAAW;AACZ;AACA;CACC,gBAAgB;AACjB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;AACA;IACI,aAAa;AACjB;AACA;IACI,yBAAyB;IACzB,iCAAiC;IACjC,6BAA6B;AACjC;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,eAAe;AAChB;AACA;CACC,oCAAoC;CACpC,aAAa;CACb,YAAY;CACZ,OAAO;CACP,eAAe;CACf,UAAU;CACV,WAAW;CACX,UAAU;AACX;AACA;CACC,cAAc;AACf;AACA;CACC,kCAAkC;AACnC;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,WAAW;CACX,UAAU;AACX;AACA;CACC,aAAa;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,YAAY;CACZ,2BAA2B;IACxB,mCAAmC;IACnC,+BAA+B;CAClC,cAAc;CACd,UAAU;CACV,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,eAAe;CACf,UAAU;CACV,UAAU;CACV,2BAA2B;AAC5B;AACA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,yBAAyB;EACzB;;oBAEkB;AACpB;AACA;CACC,uBAAuB;AACxB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,WAAW;CACX,UAAU;CACV,8CAA8C;CAC9C,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,UAAU;CACV,gBAAgB;CAChB,uCAAuC;AACxC;AACA;CACC,WAAW;CACX,UAAU;CACV,8CAA8C;AAC/C;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;IAChB,uCAAuC;IACvC,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,mCAAmC;IACnC,uBAAuB;IACvB,6BAA6B;IAC7B,0DAA0D;AAC9D;AACA;CACC,eAAe;CACf,eAAe;AAChB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,UAAU;AACX;AACA;CACC,eAAe;CACf,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,iBAAiB;CACjB,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,WAAW;CACX,WAAW;CACX,YAAY;CACZ,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,YAAY;CACZ,UAAU;CACV,mBAAmB;CACnB,SAAS;CACT,QAAQ;CACR,kBAAkB;CAClB,sCAAsC;AACvC;AACA;CACC,mBAAmB;CACnB,WAAW;AACZ;AACA;EACE;IACE,6CAA6C;EAC/C;EACA;IACE,uCAAuC;EACzC;AACF;;AAEA;;wBAEwB;;AAExB;CACC,WAAW;IACR,SAAS;IACT,OAAO;IACP,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,yBAAyB;IACzB,iCAAiC;CACpC,8BAA8B;IAC3B,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;AACA;CACC,yBAAyB;IACtB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,uBAAuB;CACvB,yBAAyB;IACtB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;CACC,eAAe;CACf,qBAAqB;CACrB,SAAS;CACT,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,WAAW;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;AACA;CACC,gBAAgB;CAChB,WAAW;AACZ;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,aAAa;CACb,eAAe;CACf,UAAU;CACV,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,qBAAqB;CACrB,iBAAiB;CACjB,UAAU;AACX;AACA;CACC,WAAW;CACX,cAAc;CACd,WAAW;CACX,eAAe;CACf,mBAAmB;CACnB,kBAAkB;AACnB;AACA;IACI,cAAc;AAClB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;IAClB,mBAAmB;CACtB,mCAAmC;CACnC,WAAW;CACX,YAAY;CACZ,yBAAyB;IACtB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;CACC,uBAAuB;AACxB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,4BAA4B;CAC5B,mCAAmC;CACnC,WAAW;CACX,YAAY;AACb;AACA;CACC,QAAQ;CACR,gCAAgC;AACjC;AACA;CACC,kBAAkB;CAClB,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,OAAO;AACR;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,eAAe;CACf,YAAY;CACZ,UAAU;CACV,mBAAmB;CACnB,QAAQ;CACR,WAAW;CACX,kBAAkB;CAClB,sCAAsC;AACvC;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;CACnB,WAAW;AACZ;AACA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,uCAAuC;EACzC;AACF;AACA;CACC,cAAc;CACd,eAAe;CACf,0BAA0B;CAC1B,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,cAAc;AACf;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,2CAA2C;CAC3C,iCAAiC;CACjC,0BAA0B;CAC1B,kBAAkB;CAClB,WAAW;CACX,qBAAqB;IAClB,kCAAkC;IAClC,gBAAgB;CACnB,oBAAoB;CACpB,iBAAiB;CACjB,eAAe;CACf,mCAAmC;CACnC,kCAAkC;CAClC,kCAAkC;CAClC,2BAA2B;CAC3B,6BAA6B;CAC7B,0BAA0B;CAC1B,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,2BAA2B;CAC3B,wBAAwB;AACzB;AACA;CACC,SAAS;AACV;AACA;CACC,yBAAyB;IACtB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;IACI,WAAW;AACf;AACA;CACC,0BAA0B;CAC1B,eAAe;CACf,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;;CAEC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,aAAa;CACb,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,UAAU;IACP,QAAQ;IACR,aAAa;IACb,gBAAgB;CACnB,gDAAgD;AACjD;AACA;CACC,iBAAiB;AAClB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,kBAAkB;CAClB,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,gDAAgD;AACjD;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,sBAAsB;AAC1B;AACA;CACC,aAAa;AACd;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,2BAA2B;AAC/B;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,eAAe;CACf,WAAW;CACX,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,4BAA4B;IACzB,wBAAwB;IACxB,oBAAoB;AACxB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,kBAAkB;IAClB,4BAA4B;IAC5B,wBAAwB;IACxB,oBAAoB;AACxB;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,gCAAgC;AACjC;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,UAAU;CACV,kBAAkB;AACnB;AACA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;AACA;CACC,iBAAiB;AAClB;AACA;CACC,SAAS;AACV;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;AACjB;AACA;CACC,SAAS;AACV;AACA;CACC,aAAa;CACb,aAAa;AACd;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,eAAe;CACf,WAAW;CACX,qBAAqB;CACrB,8BAA8B;CAC9B,WAAW;CACX,YAAY;CACZ,aAAa;CACb,WAAW;CACX,UAAU;CACV,yBAAyB;IACtB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,SAAS;GACP,0BAA0B;AAC7B;AACA;IACI,QAAQ;IACR,8BAA8B;IAC9B,yBAAyB;IACzB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;GACR,0BAA0B;AAC7B;;AAEA;;wBAEwB;;AAExB;CACC,WAAW;CACX,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,eAAe;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,iCAAiC;CACpC,8BAA8B;AAC/B;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;AACzB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,aAAa;AACd;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;CAClB,uBAAuB;IACpB,mBAAmB;AACvB;AACA;CACC,6BAA6B;CAC7B,cAAc;CACd,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,UAAU;AACX;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,mBAAmB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,yBAAyB;IACtB,iCAAiC;IACjC,uBAAuB;AAC3B;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,aAAa;IACV,cAAc;IACd,6BAA6B;IAC7B,4BAA4B;IAC5B,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,iCAAiC;IACjC,0BAA0B;IAC1B,yBAAyB;IACzB,gCAAgC;IAChC,yBAAyB;IACzB,wBAAwB;IACxB,yCAAyC;IACzC,iCAAiC;IACjC,UAAU;IACV,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,0BAA0B;AAC9B;AACA;CACC,iBAAiB;CACjB,SAAS;AACV;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;IACf,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,gCAAgC;AACpC;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,cAAc;AAClB;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,WAAW;IACR,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;AACjB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;AACnC;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,gBAAgB;CAChB,mBAAmB;IAChB,uCAAuC;IACvC,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;IAC3B,mCAAmC;IACnC,+BAA+B;AACnC;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,aAAa;IACV,qBAAqB;IACrB,mBAAmB;IACnB,2BAA2B;IAC3B,8BAA8B;IAC9B,sCAAsC;AAC1C;AACA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,WAAW;CACX,qBAAqB;CACrB,mBAAmB;CACnB,kCAAkC;AACnC;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,mDAAmC;CACnC,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,4BAA4B;AAC7B;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,SAAS;IACT,UAAU;IACV,UAAU;AACd;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,mDAAmC;CACnC,4BAA4B;CAC5B,2BAA2B;CAC3B,sBAAsB;CACtB,4BAA4B;AAC7B;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;CACZ,MAAM;CACN,uBAAuB;IACpB,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;AACA;CACC,gBAAgB;CAChB,gBAAgB;CAChB,MAAM;IACH,wBAAwB;IACxB,gCAAgC;IAChC,4BAA4B;AAChC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,YAAY;CACZ,iCAAiC;AAClC;AACA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,eAAe;CACf,0BAA0B;CAC1B,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,aAAa;AACjB;AACA;CACC,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;;AAEA;;qBAEqB;;AAErB;CACC,gBAAgB;CAChB,yBAAyB;AAC1B;AACA;CACC,aAAa;CACb,gCAAgC;CAChC,8BAA8B;IAC3B,sCAAsC;IACtC,4BAA4B;AAChC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,SAAS;CACT,UAAU;CACV,UAAU;CACV,WAAW;CACX,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,mBAAmB;CACnB,2BAA2B;CAC3B,uBAAuB;CACvB,+BAA+B;CAC/B,yBAAyB;CACzB,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;AAClC;AACA;CACC,WAAW;CACX,yBAAyB;CACzB,yBAAyB;CACzB,yBAAyB;CACzB,8BAA8B;CAC9B,4BAA4B;CAC5B,6BAA6B;CAC7B,iCAAiC;CACjC,kCAAkC;CAClC,+BAA+B;CAC/B,0BAA0B;AAC3B;AACA;EACE,cAAc;AAChB;AACA;GACG,aAAa;AAChB;AACA;GACG,mBAAmB;AACtB;AACA;CACC,eAAe;GACb,kBAAkB;AACrB;AACA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;AACb;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,aAAa;CACb,YAAY;AACb;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,kBAAkB;AACnB;AACA;GACG,eAAe;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,mBAAmB;CACnB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;IACb,gBAAgB;AACpB;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;AACA;IACI,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,wCAAwC;CACxC,oCAAoC;CACpC,mCAAmC;CACnC,gCAAgC;AACjC;AACA;CACC,aAAa;CACb,4DAA4D;CAC5D,yDAAyD;CACzD,uDAAuD;CACvD,oDAAoD;AACrD;AACA;CACC,QAAQ;AACT;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,yBAAyB;CACzB,gCAAgC;CAChC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,aAAa;CACb,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,8BAA8B;IAC3B,sCAAsC;IACtC,4BAA4B;IAC5B,aAAa;AACjB;AACA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;AACzB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,kBAAkB;IACf,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;CACC,WAAW;IACR,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;CACC,oBAAoB;AACrB;AACA;CACC,yBAAyB;CACzB,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,oBAAoB;AACrB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;CACC;AACD;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,SAAS;CACT,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,yBAAyB;CACzB,qCAAqC;CACrC,mCAAmC;CACnC,wCAAwC;CACxC,oCAAoC;CACpC,gCAAgC;AACjC;AACA;CACC,oBAAoB;CACpB,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,WAAW;AACZ;AACA;CACC,SAAS;AACV;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,UAAU;AACX;AACA;CACC,aAAa;CACb,kCAAkC;AACnC;AACA;CACC,oBAAoB;CACpB,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,uBAAuB;CACvB,+BAA+B;CAC/B,qBAAqB;AACtB;AACA;CACC,WAAW;AACZ;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,kBAAkB;IACf,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;AACvB;AACA;CACC,WAAW;CACX,aAAa;IACV,mBAAmB;AACvB;AACA;CACC,eAAe;IACZ,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,gBAAgB;CAChB,YAAY;AACb;AACA;CACC,aAAa;AACd;AACA;CACC,oBAAoB;AACrB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;GACG,kBAAkB;AACrB;AACA;GACG,eAAe;AAClB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,YAAY;CACZ,kBAAkB;CAClB,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;IACxB,mCAAmC;IACnC,+BAA+B;CAClC,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;AACzB;AACA;CACC,kBAAkB;CAClB,QAAQ;CACR,2BAA2B;IACxB,mCAAmC;IACnC,+BAA+B;CAClC,QAAQ;CACR,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,mBAAmB;CACnB,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;AACzB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,eAAe;CACf,uBAAuB;AACxB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;AAChB;AACA;CACC,kBAAkB;CAClB,UAAU;CACV,eAAe;AAChB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,WAAW;CACX,yBAAyB;CACzB,yBAAyB;CACzB,mBAAmB;CACnB,wCAAwC;CACxC,oCAAoC;CACpC,gCAAgC;CAChC,kBAAkB;CAClB,MAAM;CACN,OAAO;AACR;AACA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,gBAAgB;CAChB,aAAa;CACb,cAAc;CACd,eAAe;CACf,kBAAkB;CAClB,MAAM;CACN,SAAS;AACV;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,QAAQ;CACR,SAAS;CACT,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,YAAY;AACb;AACA;CACC,cAAc;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;EACd,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;IACvB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,kCAAkC;AACnC;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;IACb,WAAW;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,6BAA6B;AAC9B;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;IACvB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;CAClB,uBAAuB;AACxB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,6BAA6B;IAC7B,0BAA0B;IAC1B,uBAAuB;IACvB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;CAClB,uBAAuB;AACxB;AACA;CACC,cAAc;AACf;AACA;CACC,UAAU;CACV,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,kCAAkC;AACnC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;CAClB,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,mCAAmC;AACpC;;AAEA;;wBAEwB;;AAExB;IACI,mDAAsC;IACtC,4BAA4B;IAC5B,2BAA2B;IAC3B,sBAAsB;IACtB,4BAA4B;IAC5B,gBAAgB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,WAAW;AACZ;AACA;CACC,WAAW;AACZ;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,mBAAmB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,WAAW;AACZ;AACA;IACI,0BAA0B;IAC1B,4BAA4B;IAC5B,kCAAkC;IAClC,wBAAwB;AAC5B;AACA;IACI,IAAI,4BAA4B,CAAC;IACjC,MAAM,wBAAwB,CAAC;AACnC;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,0BAA0B;CAC1B,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,qBAAqB;CACrB,UAAU;CACV,cAAc;CACd,WAAW;CACX,kBAAkB;CAClB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,0BAA0B;CAC1B,sBAAsB;CACtB,kBAAkB;CAClB,aAAa;AACd;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;CACxB,0BAA0B;CAC1B,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,qBAAqB;AACtB;AACA;CACC,mBAAmB;CACnB,aAAa;AACd;AACA;CACC,cAAc;AACf;;AAEA;;wBAEwB;;AAExB;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,WAAW;CACX,YAAY;AACb;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,aAAa;AACd;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,yBAAyB;IACtB,iCAAiC;IACjC,uBAAuB;AAC3B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,+BAA+B;AAChC;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;AACA;CACC,aAAa;AACd;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,0BAA0B;AAC3B;AACA;CACC,iBAAiB;AAClB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,sBAAsB;CACtB,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,gCAAgC;AACjC;AACA;CACC,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,mBAAmB;CACnB,mBAAmB;CACnB,aAAa;CACb,cAAc;CACd,uCAAuC;AACxC;AACA;CACC,UAAU;AACX;AACA;CACC,kCAAkC;CAClC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,yBAAyB;IACtB,iCAAiC;IACjC,uBAAuB;AAC3B;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,yBAAyB;AAC1B;AACA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;AACA;CACC,WAAW;CACX,YAAY;CACZ,sBAAsB;CACtB,6BAA6B;AAC9B;AACA;CACC,6CAA6C;AAC9C;AACA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,cAAc;CACd,mBAAmB;CACnB,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,eAAe;CACf,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,+BAA+B;CAC/B,mBAAmB;CACnB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,SAAS;CACT,gBAAgB;CAChB,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;;AAEA;;wBAEwB;;AAExB;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,aAAa;AACd;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,YAAY;CACZ,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;CACd,iBAAiB;AAClB;AACA;CACC,YAAY;AACb;AACA;CACC,YAAY;CACZ,QAAQ;AACT;AACA;CACC,oBAAoB;AACrB;AACA;CACC,uBAAuB;AACxB;AACA;;;;;;CAMC,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;IACZ,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,cAAc;IACd,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;CACC,SAAS;CACT,WAAW;CACX,wBAAwB;AACzB;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;CACd,SAAS;CACT,gBAAgB;CAChB,kCAAkC;AACnC;;AAEA;;wBAEwB;;AAExB;CACC,cAAc;AACf;AACA;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;CACZ,mBAAmB;AACpB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,mBAAmB;CACnB,yBAAyB;CACzB,sBAAsB;AACvB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;AAClB;AACA;CACC,kBAAkB;AACnB;AACA;;CAEC,eAAe;CACf,WAAW;CACX,mBAAmB;CACnB,YAAY;IACT,iBAAiB;AACrB;AACA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,aAAa;AACd;AACA;CACC,eAAe;CACf,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;IAC5B,eAAe;CAClB,uBAAuB;CACvB,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,iBAAiB;AAClB;AACA;CACC,qBAAqB;AACtB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,kBAAkB;CAClB,YAAY;CACZ,UAAU;CACV,0BAA0B;IACvB,kCAAkC;IAClC,8BAA8B;CACjC,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;CACC,oBAAoB;CACpB,gBAAgB;CAChB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,WAAW;IACR,UAAU;IACV,SAAS;IACT,cAAc;IACd,mBAAmB;AACvB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,4BAA4B;AAChC;AACA;CACC,qBAAqB;CACrB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,cAAc;CACd,uBAAuB;CACvB,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,qBAAqB;CACrB,yBAAyB;AAC1B;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,mBAAmB;CACnB,qBAAqB;CACrB,iBAAiB;CACjB,mBAAmB;CACnB,iBAAiB;CACjB,gBAAgB;AACjB;AACA;GACG,eAAe;AAClB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;AAC1B;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,aAAa;CACb,iBAAiB;AAClB;AACA;CACC,kBAAkB;IACf,eAAe;IACf,cAAc;IACd,QAAQ;IACR,WAAW;CACd,2BAA2B;IACxB,mCAAmC;IACnC,+BAA+B;AACnC;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,WAAW;CACX,iBAAiB;AAClB;AACA;CACC,YAAY;AACb;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,mBAAmB;CACnB,iBAAiB;CACjB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;CACnB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;CACC,iBAAiB;CACjB,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,cAAc;AACf;AACA;CACC,mBAAmB;CACnB,kBAAkB;IACf,oBAAoB;CACvB,gCAAgC;AACjC;AACA;CACC,eAAe;IACZ,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;AACA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,eAAe;IACZ,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;AACA;CACC,eAAe;IACZ,gBAAgB;IAChB,cAAc;IACd,uBAAuB;IACvB,cAAc;IACd,UAAU;IACV,mBAAmB;AACvB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,SAAS;AACV;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,6BAA6B;AAC9B;AACA;CACC,gCAAgC;AACjC;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,iBAAiB;AAClB;AACA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,SAAS;AACV;AACA;CACC,YAAY;AACb;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,WAAW;AACZ;AACA;CACC,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,gBAAgB;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;CACC,aAAa;AACd;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;IACX,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;IAC1B,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,eAAe;CACf,oBAAoB;IACjB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;AACA;CACC,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,yBAAyB;CACzB,qBAAqB;CACrB,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,oBAAoB;AACrB;AACA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,iCAAiC;IACjC,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;AACtB;AACA;CACC,sBAAsB;CACtB,uBAAuB;AACxB;AACA;CACC,kBAAkB;IACf,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,QAAQ;IACR,SAAS;CACZ,gCAAgC;CAChC,wCAAwC;CACxC,qCAAqC;CACrC,oCAAoC;CACpC,mCAAmC;AACpC;AACA;CACC,mBAAmB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;AAC7B;AACA;CACC,eAAe;IACZ,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,aAAa;IACb,gCAAgC;AACpC;AACA;CACC,oBAAoB;AACrB;AACA;CACC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,oBAAoB;AACrB;AACA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;AACjB;AACA;CACC,cAAc;CACd,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;IACR,mBAAmB;IACnB,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;CACC,mBAAmB;IAChB,oBAAoB;AACxB;AACA;CACC,8BAA8B;CAC9B,sCAAsC;CACtC,4BAA4B;AAC7B;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,kBAAkB;CAClB,cAAc;IACX,qBAAqB;AACzB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;;wBAEwB;;AAExB;CACC,YAAY;CACZ,aAAa;CACb,mBAAmB;CACnB,gBAAgB;CAChB,qBAAqB;AACtB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;AACnB;AACA;CACC,YAAY;CACZ,gBAAgB;CAChB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,eAAe;CACf,uBAAuB;CACvB,kBAAkB;AACnB;AACA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,uBAAuB;CACvB,gBAAgB;CAChB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,kBAAkB;AACnB;AACA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,YAAY;AACb;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;CACtB,eAAe;CACf,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,mBAAmB;AACpB;AACA;CACC,SAAS;AACV;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,gBAAgB;AACjB;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,4BAA4B;AAC7B;AACA;CACC,gCAAgC;AACjC;AACA;CACC,cAAc;CACd,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,eAAe;AAChB;AACA;CACC,cAAc;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,OAAO;AACX;AACA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;AAC3B;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,wBAAwB;IACxB,qBAAqB;IACrB,kBAAkB;CACrB,eAAe;CACf,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,QAAQ;CACR,QAAQ;CACR,2BAA2B;IACxB,mCAAmC;IACnC,+BAA+B;AACnC;AACA;CACC,aAAa;AACd;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,yBAAyB;CACzB,kBAAkB;AACnB;AACA;CACC,WAAW;AACZ;AACA;CACC,gCAAgC;CAChC,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,mBAAmB;AACpB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,eAAe;AAChB;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,WAAW;AACZ;AACA;CACC,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,UAAU;AACX;AACA;CACC,WAAW;AACZ;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,SAAS;AACV;AACA;CACC,eAAe;CACf,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;AAC1B;AACA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,eAAe;AAChB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;CAChB,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,WAAW;CACX,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,eAAe;CACf,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,WAAW;CACX,SAAS;AACV;AACA;CACC,SAAS;CACT,SAAS;AACV;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,eAAe;AAChB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,eAAe;CACf,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,WAAW;CACX,SAAS;AACV;AACA;CACC,kBAAkB;CAClB,UAAU;AACX;AACA;CACC,UAAU;CACV,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,mBAAmB;CACnB,mBAAmB;CACnB,gCAAgC;AACjC;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,UAAU;CACV,WAAW;CACX,mBAAmB;AACpB;AACA;CACC,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,WAAW;AACZ;AACA;CACC,UAAU;CACV,SAAS;CACT,SAAS;AACV;AACA;CACC,kBAAkB;AACnB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,gBAAgB;AACjB;AACA;CACC,iBAAiB;CACjB,cAAc;AACf;;AAEA;;wBAEwB;;AAExB;CACC,gCAAgC;CAChC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,mBAAmB;AACpB;AACA;CACC,yBAAyB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;CACC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,qBAAqB;CACrB,cAAc;CACd,WAAW;CACX,YAAY;CACZ,YAAY;CACZ,kBAAkB;CAClB,iBAAiB;CACjB,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,uBAAuB;IACpB,+BAA+B;IAC/B,qBAAqB;AACzB;AACA;CACC,oBAAoB;CACpB,oBAAoB;CACpB,aAAa;CACb,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,8BAA8B;IAC3B,sCAAsC;IACtC,4BAA4B;CAC/B,eAAe;CACf,uBAAuB;CACvB,mBAAmB;AACpB;AACA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,yBAAyB;IACtB,iCAAiC;IACjC,uBAAuB;CAC1B,mBAAmB;AACpB;AACA;CACC,kBAAkB;AACnB;AACA;CACC,eAAe;AAChB;AACA;CACC,2BAA2B;CAC3B,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,sBAAsB;CACtB,mBAAmB;CACnB,gBAAgB;CAChB,cAAc;AACf;AACA;CACC,kBAAkB;AACnB;AACA;CACC,cAAc;AACf;AACA;CACC,eAAe;CACf,iBAAiB;AAClB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;CACtB,yBAAyB;CACzB,mBAAmB;CACnB,mBAAmB;AACpB;AACA;CACC,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;CACtB,YAAY;IACT,eAAe;AACnB;AACA;CACC,oBAAoB;IACjB,oBAAoB;IACpB,aAAa;IACb,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;CACtB,mBAAmB;CACnB,kBAAkB;CAClB,+BAA+B;AAChC;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,qBAAqB;AACtB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,mBAAmB;AACpB;AACA;CACC,2BAA2B;CAC3B,eAAe;AAChB;AACA;CACC,WAAW;IACR,eAAe;IACf,YAAY;AAChB;AACA;CACC,WAAW;CACX,eAAe;CACf,YAAY;CACZ,kBAAkB;AACnB;AACA;CACC,eAAe;CACf,kBAAkB;AACnB;AACA;CACC,cAAc;CACd,kBAAkB;CAClB,gBAAgB;AACjB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;;wBAEwB;;AAExB;CACC;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,4BAA4B;CAC7B;CACA;EACC,8BAA8B;CAC/B;CACA;EACC,eAAe;CAChB;CACA;;;EAGC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,cAAc;KACX,WAAW;KACX,eAAe;KACf,WAAW;KACX,aAAa;KACb,gBAAgB;KAChB,aAAa;KACb,uBAAuB;KACvB,mBAAmB;KACnB,gDAAgD;CACpD;CACA;EACC,YAAY;EACZ,WAAW;CACZ;CACA;EACC,aAAa;CACd;CACA;EACC,cAAc;CACf;CACA;EACC,kBAAkB;KACf,YAAY;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,YAAY;CACb;CACA;EACC,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;EACb,yBAAyB;KACtB,iCAAiC;EACpC,8BAA8B;EAC9B,UAAU;CACX;CACA;EACC,eAAe;EACf,UAAU;CACX;CACA;EACC,iBAAiB;CAClB;CACA;EACC,UAAU;EACV,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,cAAc;EACd,SAAS;EACT,UAAU;EACV,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;CAChC;CACA;EACC,mBAAmB;EACnB,UAAU;EACV,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,iCAAiC;EACjC,6BAA6B;EAC7B,yBAAyB;CAC1B;AACD;;AAEA;CACC;EACC,cAAc;EACd,iBAAiB;CAClB;CACA;EACC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;KACI,iBAAiB;KACjB,gBAAgB;CACpB;CACA;EACC,YAAY;EACZ;CACD;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,WAAW;CACZ;CACA;KACI,iBAAiB;CACrB;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;KACI,WAAW;CACf;CACA;EACC,gBAAgB;EAChB,gBAAgB;CACjB;CACA;EACC,YAAY;KACT,mBAAmB;CACvB;CACA;EACC,YAAY;CACb;CACA;EACC,kBAAkB;CACnB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,YAAY;CACb;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,SAAS;EACT,UAAU;CACX;CACA;EACC,MAAM;EACN,OAAO;CACR;CACA;EACC,YAAY;CACb;CACA;EACC,iBAAiB;CAClB;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;EACf,YAAY;EACZ,gBAAgB;CACjB;CACA;EACC,YAAY;CACb;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;EAChB,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;EAChB,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,YAAY;CACb;CACA;KACI,eAAe;KACf,WAAW;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;EACb,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,oBAAoB;CACrB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,sBAAsB;CACvB;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;AACD;;AAEA;CACC;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;QACN,mBAAmB;IACvB;CACH;EACC,YAAY;CACb;CACA;EACC,eAAe;CAChB;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,YAAY;EACZ,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,cAAc;EACd,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;CACpB;CACA;EACC,WAAW;EACX,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;EAClB,SAAS;CACV;CACA;EACC,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,oBAAoB;EACpB,MAAM;KACH,wBAAwB;KACxB,gCAAgC;KAChC,4BAA4B;CAChC;CACA;EACC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,MAAM;KACH,wBAAwB;KACxB,gCAAgC;KAChC,4BAA4B;CAChC;CACA;EACC,cAAc;CACf;CACA;EACC,UAAU;CACX;CACA;EACC,SAAS;CACV;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;EAClB,SAAS;EACT,iBAAiB;CAClB;CACA;EACC,SAAS;EACT,UAAU;CACX;CACA;EACC,kBAAkB;CACnB;CACA;EACC,UAAU;CACX;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,gBAAgB;CACjB;CACA;EACC,kBAAkB;EAClB,UAAU;CACX;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,gBAAgB;CACjB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,iBAAiB;CAClB;AACD;;AAEA;CACC;EACC,SAAS;CACV;CACA;EACC,YAAY;CACb;CACA;EACC,kBAAkB;KACf,WAAW;KACX,YAAY;KACZ,eAAe;KACf,uBAAuB;CAC3B;CACA;EACC,WAAW;KACR,iBAAiB;KACjB,sBAAsB;CAC1B;CACA;EACC,SAAS;CACV;CACA;EACC,YAAY;CACb;CACA;EACC,gBAAgB;CACjB;CACA;EACC,oBAAoB;EACpB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;KAClB,eAAe;KACf,eAAe;KACf,OAAO;KACP,iBAAiB;KACjB,mBAAmB;KACnB,kBAAkB;KAClB,kBAAkB;KAClB,WAAW;KACX,YAAY;KACZ,MAAM;KACN,WAAW;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;EACf,mBAAmB;KAChB,YAAY;KACZ,SAAS;KACT,gBAAgB;KAChB,iCAAiC;KACjC,8BAA8B;KAC9B,yBAAyB;KACzB,aAAa;CACjB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;EACf,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;EACX,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,sBAAsB;CACvB;CACA;EACC,gBAAgB;EAChB,cAAc;CACf;CACA;EACC,WAAW;EACX,gBAAgB;CACjB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,aAAa;CACd;CACA;EACC,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;CAC1B;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;CACb;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,YAAY;CACb;CACA;EACC,oBAAoB;CACrB;CACA;EACC,cAAc;CACf;CACA;EACC,kBAAkB;CACnB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;CACA;EACC,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;CACA;QACO,eAAe;IACnB;CACH;EACC,sBAAsB;EACtB,mBAAmB;CACpB;CACA;EACC,WAAW;EACX,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,UAAU;CACX;CACA;EACC,eAAe;CAChB;CACA;QACO,UAAU;IACd;IACA;KACC,UAAU;IACX;IACA;KACC,cAAc;IACf;CACH;EACC,cAAc;CACf;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;EACf,WAAW;CACZ;CACA;EACC,WAAW;CACZ;CACA;EACC,qBAAqB;CACtB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,UAAU;CACX;CACA;EACC,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;CACnB;AACD;;AAEA;CACC;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;KACI,SAAS;CACb;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,WAAW;EACX,kBAAkB;CACnB;CACA;EACC,UAAU;EACV,QAAQ;CACT;CACA;EACC,UAAU;EACV,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;CACZ;CACA;EACC,WAAW;KACR,iBAAiB;KACjB,sBAAsB;CAC1B;CACA;EACC,aAAa;CACd;CACA;EACC,qBAAqB;CACtB;CACA;EACC,QAAQ;CACT;CACA;EACC,MAAM;QACA,WAAW;QACX,YAAY;IAChB;CACH;EACC,gBAAgB;CACjB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,WAAW;KACR,YAAY;KACZ,UAAU;CACd;CACA;EACC,SAAS;CACV;IACG;KACC,kBAAkB;CACtB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,gBAAgB;EAChB,YAAY;EACZ,wBAAwB;CACzB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,uBAAuB;CACxB;CACA;EACC,uBAAuB;CACxB;CACA;EACC,eAAe;CAChB;CACA;EACC,gBAAgB;KACb,gBAAgB;EACnB,aAAa;CACd;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,YAAY;EACZ,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,eAAe;EACf,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,WAAW;EACX,WAAW;CACZ;CACA;EACC,YAAY;CACb;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,aAAa;CACd;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mDAAmC;CACpC;CACA;EACC,cAAc;CACf;CACA;EACC,kBAAkB;CACnB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,YAAY;CACb;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;KACI,eAAe;KACf,eAAe;KACf,kBAAkB;KAClB,iBAAiB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,kBAAkB;CACnB;CACA;EACC,YAAY;CACb;CACA;EACC,gBAAgB;CACjB;CACA;EACC,WAAW;EACX,YAAY;EACZ,iBAAiB;CAClB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,YAAY;CACb;CACA;EACC,YAAY;EACZ,gBAAgB;EAChB,eAAe;CAChB;CACA;EACC,WAAW;EACX,YAAY;CACb;CACA;EACC,sBAAsB;KACnB,8BAA8B;KAC9B,oBAAoB;CACxB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,iBAAiB;EACjB,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;EACV,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,mBAAmB;CACpB;CACA;EACC,WAAW;EACX,eAAe;EACf,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,mBAAmB;CACpB;CACA;EACC,cAAc;EACd,gBAAgB;CACjB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;KACI,mBAAmB;KACnB,WAAW;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,UAAU;CACX;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;CACjB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,UAAU;CACX;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,kBAAkB;KACf,iBAAiB;CACrB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,mBAAmB;CACpB;CACA;KACI,oBAAoB;CACxB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,gBAAgB;EAChB,kBAAkB;CACnB;CACA;EACC,WAAW;EACX,YAAY;EACZ,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,kBAAkB;KACf,kBAAkB;KAClB,mBAAmB;KACnB,gBAAgB;KAChB,mBAAmB;CACvB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;EACb,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,UAAU;EACV,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;EACb,gBAAgB;CACjB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,kBAAkB;CACnB;CACA;EACC,aAAa;CACd;CACA;EACC,oBAAoB;CACrB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,WAAW;CACZ;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,cAAc;EACd,gBAAgB;CACjB;CACA;EACC,cAAc;EACd,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;KACI,uBAAuB;IACxB;CACH;EACC,8BAA8B;EAC9B,sCAAsC;EACtC,4BAA4B;CAC7B;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;EACX,YAAY;EACZ,SAAS;EACT,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,iBAAiB;CAClB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;EACf,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,2BAA2B;EAC3B,mCAAmC;EACnC,yBAAyB;CAC1B;CACA;EACC,eAAe;CAChB;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;CACpB;CACA;EACC,UAAU;CACX;CACA;EACC,UAAU;CACX;CACA;EACC,oBAAoB;CACrB;CACA;EACC,cAAc;CACf;CACA;KACI,WAAW;CACf;CACA;EACC,sBAAsB;CACvB;CACA;EACC,cAAc;CACf;CACA;EACC,iBAAiB;EACjB,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;EACnB,cAAc;CACf;CACA;EACC,cAAc;CACf;CACA;EACC,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;CACf;CACA;EACC,mBAAmB;CACpB;CACA;EACC,aAAa;EACb,mBAAmB;CACpB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,oBAAoB;CACrB;CACA;EACC,eAAe;CAChB;CACA;EACC,cAAc;CACf;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;AACD;;AAEA;CACC;EACC,cAAc;CACf;CACA;EACC,eAAe;EACf,kBAAkB;EAClB,cAAc;CACf;CACA;EACC,oBAAoB;CACrB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,cAAc;CACf;CACA;EACC,WAAW;EACX,kBAAkB;CACnB;CACA;EACC,eAAe;CAChB;CACA;EACC,eAAe;CAChB;CACA;EACC,mBAAmB;EACnB,cAAc;CACf;CACA;EACC,eAAe;CAChB;CACA;EACC,WAAW;CACZ;CACA;EACC,eAAe;CAChB;AACD","sourcesContent":["/*\r\nAuthor       : Dreamstechnologies\r\nTemplate Name: Cloud Connect - Bootstrap Admin Template\r\nVersion      : 1.0\r\n*/\r\n\r\n/*============================\r\n [Table of CSS]\r\n\r\n1. General\r\n2. Table\r\n3. Helper Class\r\n4. Bootstrap Classes\r\n5. Select2\r\n6. Nav Tabs\r\n7. Components\r\n8. Header\r\n9. Sidebar\r\n10. Content\r\n11. Login\r\n12. Modal\r\n13. Welcome\r\n14. Dashboard\r\n15. Create\r\n16. Patient Registration\r\n17. Doctor Dashboard\r\n18. Appointment\r\n19. Join\r\n20. Notification\r\n21. Responsive\r\n\r\n========================================*/\r\n\r\n/*-----------------\r\n\t1. General\r\n-----------------------*/\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');\r\n\r\nhtml {\r\n\theight: 100%;\r\n}\r\nbody {\r\n\tbackground-color: #F2F2F2;\r\n\tcolor: #000;\r\n\tfont-family: \"Poppins\", sans-serif;\r\n\tfont-size: 15px;\r\n\theight: 100%;\r\n\tline-height: 1.5;\r\n\toverflow-x: hidden;\r\n}\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n\tfont-family: \"Poppins\", sans-serif;\r\n\tfont-weight: 600;\r\n\tcolor: #000;\r\n\tmargin-top: 0;\r\n}\r\np {\r\n\tcolor: #000;\r\n}\r\np:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\na:hover,\r\na:active,\r\na:focus {\r\n\toutline: none;\r\n\ttext-decoration: none;\r\n}\r\ninput:-webkit-autofill,\r\ninput:-webkit-autofill:hover,\r\ninput:-webkit-autofill:focus {\r\n\t-webkit-box-shadow: 0 0 0px 1000px white inset !important;\r\n\tbox-shadow: 0 0 0px 1000px white inset !important;\r\n}\r\n.form-control {\r\n    background: #FFF;\r\n\tborder: 0;\r\n\tborder-bottom: 1px solid #00000038;\r\n    box-shadow: none;\r\n    border-radius: 0;\r\n    color: #000;\r\n    font-size: 14px;\r\n    padding: 2px 0;\r\n    height: auto;\r\n\ttransition: all 0.5s;\r\n}\r\n.form-control:focus{\r\n\tborder: 0;\r\n\tbox-shadow: none;\r\n\toutline: 0 none;\r\n\tborder-bottom: 1px solid #00000038;\r\n}\r\n.form-control.form-control-sm {\r\n\theight: calc(1.5em + .5rem + 2px);\r\n}\r\n.form-control-sm {\r\n\tbackground-color: #fff;\r\n}\r\n.form-control.form-control-lg {\r\n\theight: calc(1.5em + 1rem + 2px);\r\n}\r\n.form-control::placeholder {\r\n\tfont-size: 14px;\r\n\tcolor: #898989;\r\n}\r\na {\r\n\tcolor: #000;\r\n\ttext-decoration: none;\r\n}\r\na:hover {\r\n\tcolor: #3FA2DB;\r\n\ttext-decoration: none;\r\n}\r\ninput,\r\nbutton,\r\na {\r\n\ttransition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n\t-o-transition: all 0.4s ease;\r\n\t-ms-transition: all 0.4s ease;\r\n\t-webkit-transition: all 0.4s ease;\r\n}\r\ninput, input:focus,\r\nbutton, button:focus {\r\n\toutline: none;\r\n}\r\ninput[type=\"file\"] {\r\n    height: auto;\r\n    min-height: calc(1.5em + .75rem + 2px);\r\n}\r\ninput[type=text],\r\ninput[type=password] {\r\n\t-webkit-appearance: none;\r\n\t-moz-appearance: none;\r\n\tappearance: none;\r\n}\r\ntextarea.form-control {\r\n\tresize: none;\r\n\tmin-height: 100px;\r\n}\r\n.navbar-nav > li {\r\n\tfloat: left;\r\n}\r\n.form-group {\r\n\tmargin-bottom: 24px;\r\n}\r\n.form-wrap {\r\n\tmargin-bottom: 24px;\r\n}\r\nlabel {\r\n\tfont-size: 15px;\r\n    display: inline-block;\r\n    margin-bottom: 5px;\r\n    color: #000;\r\n}\r\n.input-group .form-control {\r\n\theight: 40px;\r\n}\r\n.input-group .input-height {\r\n\theight: auto;\r\n}\r\n.nav .open > a,\r\n.nav .open > a:focus,\r\n.nav .open > a:hover {\r\n\tbackground-color: rgba(0, 0, 0, 0.1);\r\n\tborder-color: rgba(0, 0, 0, 0.1);\r\n}\r\nul, ol {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n}\r\n\r\n/*-----------------\r\n\t2. Table\r\n-----------------------*/\r\n\r\n.table {\r\n\tcolor: #000;\r\n\tmax-width: 100%;\r\n\tmargin-bottom: 0;\r\n\twidth: 100%;\r\n\tbackground: transparent;\r\n}\r\n.table>:not(:first-child) {\r\n    border-top: transparent;\r\n}\r\n.table>:not(caption)>*>* {\r\n\tbox-shadow: unset;\r\n\tpadding: 0.75rem;\r\n\tbackground: transparent;\r\n}\r\n.table thead {\r\n\tborder: 0;\r\n\tbackground: transparent;\r\n\tvertical-align: middle;\r\n}\r\n.table thead tr th {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tcolor: #000;\r\n\tpadding: 15px;\r\n\tborder: 0;\r\n\twhite-space: nowrap;\r\n\tbackground: transparent;\r\n}\r\n.table thead tr {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.table tbody tr {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.table tbody tr.active {\r\n\tcursor: pointer;\r\n\tborder-left: 8px solid #3FA2DB;\r\n\tbox-shadow: 0px 0px 9.7px -1px #00000040;\r\n}\r\n.table tbody tr td {\r\n\tfont-size: 14px;\r\n\tcolor: #000;\r\n\tpadding: 15px;\r\n\tvertical-align: middle;\r\n\tbackground: transparent;\r\n\tborder: 0;\r\n\twhite-space: nowrap;\r\n}\r\n.table-striped > tbody > tr:nth-of-type(2n+1) {\r\n\tbackground-color: #f8f9fa;\r\n}\r\n.table.no-border > tbody > tr > td,\r\n.table > tbody > tr > th,\r\n.table.no-border > tfoot > tr > td,\r\n.table.no-border > tfoot > tr > th,\r\n.table.no-border > thead > tr > td,\r\n.table.no-border > thead > tr > th {\r\n\tborder-top: 0;\r\n\tpadding: 10px 8px;\r\n}\r\n.table-nowrap td,\r\n.table-nowrap th {\r\n\twhite-space: nowrap\r\n}\r\n.table.dataTable {\r\n\tborder-collapse: collapse !important;\r\n\tborder: 1px solid rgba(0, 0, 0, 0.05);\r\n}\r\ntable.table td h2 {\r\n\tdisplay: inline-block;\r\n\tfont-size: inherit;\r\n\tfont-weight: 400;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tvertical-align: middle;\r\n}\r\ntable.table td h2.table-avatar {\r\n    align-items: center;\r\n    display: inline-flex;\r\n    font-size: inherit;\r\n    font-weight: 400;\r\n    margin: 0;\r\n    padding: 0;\r\n    vertical-align: middle;\r\n\twhite-space: nowrap;\r\n}\r\ntable.table td h2 a {\r\n\tcolor: #333;\r\n}\r\ntable.table td h2 a:hover {\r\n\tcolor: #FFBC53;\r\n}\r\ntable.table td h2 span {\r\n\tcolor: #888;\r\n\tdisplay: block;\r\n\tfont-size: 12px;\r\n\tmargin-top: 3px;\r\n}\r\n.table tbody tr:last-child {\r\n\tborder-bottom: 0;\r\n}\r\n.table.table-center td,\r\n.table.table-center th {\r\n\tvertical-align: middle;\r\n}\r\n.table-hover tbody tr:hover {\r\n\tbackground-color: #f7f7f7;\r\n}\r\n.table-hover tbody tr:hover td {\r\n\tcolor: #474648;\r\n}\r\n.table-striped thead tr {\r\n\tborder-color: transparent;\r\n}\r\n.table-striped tbody tr {\r\n\tborder-color: transparent;\r\n}\r\n.table-striped tbody tr:nth-of-type(even) {\r\n\tbackground-color: rgba(255, 255, 255, 0.3);\r\n}\r\n.table-striped tbody tr:nth-of-type(odd) {\r\n\tbackground-color: rgba(235, 235, 235, 0.4);\r\n}\r\n.table-bordered {\r\n\tborder: 1px solid rgba(0, 0, 0, 0.05) !important;\r\n}\r\n.table-bordered th,\r\n.table-bordered td {\r\n\tborder-color: rgba(0, 0, 0, 0.05);\r\n}\r\n.card-table .card-body .table > thead > tr > th {\r\n    border-top: 0;\r\n}\r\n.card-table .card-body .table tr td:first-child,\r\n.card-table .card-body .table tr th:first-child {\r\n    padding-left: 1.5rem;\r\n}\r\n.card-table .card-body .table tr td:last-child,\r\n.card-table .card-body .table tr th:last-child {\r\n    padding-right: 1.5rem;\r\n}\r\n.card-table .table td, .card-table .table th {\r\n    border-top: 1px solid #e2e5e8;\r\n    padding: 1rem 0.75rem;\r\n    white-space: nowrap;\r\n}\r\n.table .thead-light th {\r\n    color: #495057;\r\n    background-color: #f8f9fa;\r\n    border-color: #eff2f7;\r\n}\r\n.table tbody tr .status-data p {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmargin-bottom: 0;\r\n}\r\n.table tbody tr .status-data span {\r\n\twidth: 10px;\r\n\tmin-width: 10px;\r\n\theight: 10px;\r\n\tborder-radius: 50px;\r\n\tmargin-right: 10px;\r\n\tdisplay: inline-block;\r\n}\r\n.table tbody tr .status-data .status-active {\r\n\tbackground: #3FA2DB;\r\n}\r\n.table tbody tr .status-data .status-inactive {\r\n\tbackground: #F7D333;\r\n}\r\n.table tbody tr .status-data .status-disabled {\r\n\tbackground: #E87373;\r\n}\r\n.table tbody tr .action-pending {\r\n\tcolor: #3FA2DB;\r\n}\r\n.table tbody tr .action-waiting {\r\n\tcolor: #898989;\r\n}\r\n.table tbody tr .action-delayed {\r\n\tcolor: #E87373;\r\n}\r\n.table tbody tr td .action-pending {\r\n\tcolor: #3FA2DB;\r\n}\r\n.table tbody tr td .action-waiting {\r\n\tcolor: #898989;\r\n}\r\n.table tbody tr td .action-delayed {\r\n\tcolor: #E87373;\r\n}\r\n.table tbody tr .data-btn .btn { \r\n\tfont-size: 14px;\r\n\tpadding: 5px 24px;\r\n}\r\n.table tbody tr .vitals-data .nav {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    flex-wrap: nowrap;\r\n\t-webkit-flex-wrap: nowrap;\r\n}\r\n.table tbody tr .vitals-data .nav li {\r\n\tmargin-right: 30px;\r\n}\r\n.table tbody tr .vitals-data .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.table tbody tr .days-data {\r\n\tcolor: #C7C7C7;\r\n}\r\n.table tbody tr .days-data .nav {\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n    flex-wrap: nowrap;\r\n\t-webkit-flex-wrap: nowrap;\r\n}\r\n.table tbody tr .days-data .nav li {\r\n\tmargin-right: 12px;\r\n}\r\n.table tbody tr .days-data .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.table tbody tr .days-data .nav li span {\r\n\tcolor: #3FA2DB;\r\n}\r\n.table tbody tr td .data-slot span {\r\n\tmargin-right: 14px;\r\n}\r\n.table tbody tr td .data-slot span:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.table tbody tr td .data-slot a {\r\n\tfont-size: 18px;\r\n\tcolor: #3FA2DB;\r\n\tmargin-right: 14px;\r\n}\r\n.table tbody tr td .data-slot a:hover {\r\n\tcolor: #00568E;\r\n}\r\n.table tbody tr td .data-slot a:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.table tbody tr td .data-slot .slot-delete {\r\n\tcolor: #E87373;\r\n}\r\n.tooltip > .tooltip-inner {\r\n\tpadding: 6px 20px;\r\n\tcolor: black;\r\n\tborder: 1px solid #E6E6E6;\r\n\tbackground-color: #FFF;\r\n\tborder-radius: 30px;\r\n}\r\n.schedule-data .btn {\r\n\tfont-size: 14px;\r\n\tpadding: 5px 24px;\r\n\tbox-shadow: 0px 0px 10px 0px #00000040;\r\n}\r\n.table .custom-radio {\r\n\tmargin-left: 14px;\r\n\tposition: relative;\r\n}\r\n.table .custom-checkbox-radius {\r\n\tmargin-left: 14px;\r\n}\r\n.table .custom-checkbox-radius .check .box {\r\n\tborder-radius: 50px;\r\n}\r\n.table .custom-checkbox-left {\r\n\tmargin-left: 14px\r\n}\r\n.table-dropdown .dropdown-toggle {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    font-size: 18px;\r\n    color: #3FA2DB;\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    background: transparent;\r\n    border: 1px solid #3FA2DB;\r\n}\r\n.table-dropdown .dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n.table-dropdown .dropdown-menu {\r\n    min-width: 170px;\r\n    border-radius: 5px;\r\n    border: 1px solid #EFEFEF;\r\n    padding: 0;\r\n}\r\n.table-dropdown .dropdown-menu .dropdown-item {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tfont-size: 15px;\r\n\tcolor: #000;\r\n\tpadding: 10px 15px;\r\n\tborder-bottom: 1px solid #EFEFEF;\r\n\tborder-radius: 0;\r\n\t-webkit-transition: all 0.4s;\r\n    -ms-transition: all 0.4s;\r\n    transition: all 0.4s;\r\n}\r\n.table-dropdown .dropdown-menu .dropdown-item:first-child {\r\n    border-radius: 5px 5px 0 0;\r\n}\r\n.table-dropdown .dropdown-menu .dropdown-item:last-child {\r\n    border-radius: 0 0 5px 5px;\r\n    border-bottom: 0;\r\n}\r\n.table-dropdown .dropdown-menu .dropdown-item:hover {\r\n    color: #3FA2DB;\r\n    padding-left: 20px;\r\n    -webkit-transition: all 0.4s;\r\n    -ms-transition: all 0.4s;\r\n    transition: all 0.4s;\r\n}\r\n.table-dropdown .dropdown-menu .dropdown-item i {\r\n\tfont-size: 18px;\r\n\tmargin-right: 8px;\r\n}\r\n.table-dropdown .dropdown-menu .dropdown-item img {\r\n\tmargin-right: 8px;\r\n}\r\n.dropdown-menu.front-desk-dropdown {\r\n\tmin-width: 300px;\r\n\tmax-width: 300px;\r\n\tpadding: 30px;\r\n\tz-index: 1;\r\n\tborder-radius: 12px;\r\n\tbox-shadow: 0px 0px 10px -1px #00000040;\r\n\tmargin-top: -15px !important;\r\n    margin-right: 10px !important;\r\n}\r\n.front-desk-dropdown-right-info {\r\n\tposition: relative;\r\n\tright: 300px;\r\n}\r\n.dropdown-menu.front-desk-dropdown-right {\r\n\tposition: absolute;\r\n}\r\n.front-desk-dropdown-menu-right {\r\n\tposition: relative;\r\n\ttop: 20px;\r\n\tright: 300px;\r\n}\r\n.front-desk-dropdown p {\r\n\twhite-space: pre-wrap;\r\n\twidth: 100%;\r\n\tmargin-bottom: 20px;\r\n}\r\n.front-desk-dropdown .edit-text {\r\n\twhite-space: pre-wrap;\r\n\twidth: 100%;\r\n\tmargin-bottom: 20px;\r\n}\r\n.front-desk-dropdown-btn .btn {\r\n\tmin-width: 80px;\r\n\tpadding: 5px 24px;\r\n\tmargin-right: 40px;\r\n}\r\n.front-desk-dropdown-btn .btn:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.table-btn {\r\n\tpadding-top: 20px;\r\n\tpadding-bottom: 20px;\r\n\ttext-align: center;\r\n}\r\n.table-btn-info {\r\n\tpadding: 0 30px 30px;\r\n}\r\n.table-btn .btn {\r\n\tpadding: 10px 50px;\r\n}\r\n.table-pagination {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tmargin-bottom: 24px;\r\n}\r\n.table-pagination .pagination-list {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n}\r\n.table-pagination .pagination-list li {\r\n\tposition: relative;\r\n}\r\n.table-pagination .pagination-list li+li::before {\r\n    padding-right: 0;\r\n    content: \"/\";\r\n}\r\n.pagination-arrow {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tmargin-left: auto;\r\n}\r\n.pagination-arrow li {\r\n\tmargin-right: 15px;\r\n}\r\n.pagination-arrow li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.patient-table-card .card-body {\r\n\tpadding: 20px;\r\n}\r\n.patient-table-list h6 {\r\n\tfont-size: 16px;\r\n    font-weight: 600;\r\n    color: #000;\r\n    text-align: center;\r\n    margin-bottom: 30px;\r\n}\r\n.patient-table-list ul {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\ttext-align: center;\r\n\tlist-style: none;\r\n}\r\n.patient-table-list ul li {\r\n\tdisplay: block;\r\n\tmargin-bottom: 20px;\r\n}\r\n.patient-table-list ul li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.patient-table-list ul li a {\r\n\tpadding: 7px 15px;\r\n\tborder-radius: 30px;\r\n}\r\n.patient-table-list ul li a.active {\r\n\tbox-shadow: 0px 0px 9.7px -1px #00000040;\r\n}\r\n\r\n/*-----------------\r\n\t3. Helper Class\r\n-----------------------*/\r\n\r\n.p-20 {\r\n\tpadding: 20px !important;\r\n}\r\n.p-t-0 {\r\n\tpadding-top: 0 !important;\r\n}\r\n.m-0 {\r\n\tmargin: 0 !important;\r\n}\r\n.m-r-5 {\r\n\tmargin-right: 5px !important;\r\n}\r\n.m-r-10 {\r\n\tmargin-right: 10px !important;\r\n}\r\n.m-l-5 {\r\n\tmargin-left: 5px !important;\r\n}\r\n.m-l-15 {\r\n\tmargin-left: 15px !important;\r\n}\r\n.m-t-5 {\r\n\tmargin-top: 5px !important;\r\n}\r\n.m-t-0 {\r\n\tmargin-top: 0 !important;\r\n}\r\n.m-t-10 {\r\n\tmargin-top: 10px !important;\r\n}\r\n.m-t-15 {\r\n\tmargin-top: 15px !important;\r\n}\r\n.m-t-20 {\r\n\tmargin-top: 20px !important;\r\n}\r\n.m-t-30 {\r\n\tmargin-top: 30px !important;\r\n}\r\n.m-t-50 {\r\n\tmargin-top: 50px !important;\r\n}\r\n.m-b-5 {\r\n\tmargin-bottom: 5px !important;\r\n}\r\n.m-b-10 {\r\n\tmargin-bottom: 10px !important;\r\n}\r\n.m-b-15 {\r\n\tmargin-bottom: 15px !important;\r\n}\r\n.m-b-20 {\r\n\tmargin-bottom: 20px !important;\r\n}\r\n.m-b-30 {\r\n\tmargin-bottom: 30px !important;\r\n}\r\n.f-500 {\r\n\tfont-weight: 500;\r\n}\r\n.f-600 {\r\n\tfont-weight: 600;\r\n}\r\n.block {\r\n\tdisplay: block !important;\r\n}\r\n.loader-main {\r\n\tposition: fixed;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tz-index: 999999;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground: #FFF;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n.page-loader {\r\n\twidth: 60px;\r\n\theight: 60px;\r\n\tborder: 3px dotted #3FA2DB;\r\n\tborder-style: solid solid dotted dotted;\r\n\tborder-radius: 50%;\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\tbox-sizing: border-box;\r\n\tanimation: rotation 2s linear infinite;\r\n}\r\n.page-loader::after {\r\n\tcontent: '';  \r\n\tbox-sizing: border-box;\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tbottom: 0;\r\n\tmargin: auto;\r\n\tborder: 3px dotted #CC0001;\r\n\tborder-style: solid solid dotted;\r\n\twidth: 30px;\r\n\theight: 30px;\r\n\tborder-radius: 50%;\r\n\tanimation: rotationBack 1s linear infinite;\r\n\ttransform-origin: center center;\r\n}  \r\n@keyframes rotation {\r\n\t0% {\r\n\t  transform: rotate(0deg);\r\n\t}\r\n\t\t100% {\r\n\t\t  transform: rotate(360deg);\r\n\t\t}\r\n\t} \r\n\t@keyframes rotationBack {\r\n\t\t0% {\r\n\t\t  transform: rotate(0deg);\r\n\t\t}\r\n\t100% {\r\n\t  transform: rotate(-360deg);\r\n\t}\r\n}\r\n.form-wrap-checkbox {\r\n    position: relative;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    line-height: normal;\r\n}\r\n.custom-checkbox {\r\n\tline-height: 0;\r\n}\r\n.custom-checkbox-line {\r\n    line-height: normal;\r\n}\r\n.custom-checkbox .check {\r\n  display: -webkit-inline-box;\r\n  display: -ms-inline-flexbox;\r\n  display: inline-flex;\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  color: #000;\r\n  margin-bottom: 0;\r\n}\r\n.custom-checkbox .check input {\r\n \tdisplay: none;\r\n}\r\n.custom-checkbox .check input:checked + .box {\r\n \tbackground: #3FA2DB;\r\n \tborder: 1px solid #3FA2DB;\r\n}\r\n.custom-checkbox .check input:checked + .box:after {\r\n \ttop: 0;\r\n}\r\n.custom-checkbox .check .box {\r\n\twidth: 26px;\r\n\tmin-width: 26px;\r\n\theight: 26px;\r\n\tdisplay: block;\r\n\ttransition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);\r\n\tbackground: #E6E6E6;\r\n\tposition: relative;\r\n\toverflow: hidden;\r\n\tcursor: pointer;\r\n\tborder: 1px solid #E6E6E6;\r\n\tborder-radius: 0;\r\n}\r\n.custom-checkbox .check .box:after {\r\n\twidth: 12px;\r\n\theight: 6px;\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\tborder-left: 2px solid;\r\n\tborder-bottom: 2px solid;\r\n\tborder-color: white;\r\n\ttransform: rotate(-45deg) translate3d(0, 0, 0);\r\n\ttransform-origin: center center;\r\n\ttransition: all 1.1s cubic-bezier(0.19, 1, 0.22, 1);\r\n\tleft: 0;\r\n\tright: 0;\r\n\ttop: 200%;\r\n\tbottom: 3px;\r\n\tmargin: auto;\r\n}\r\n.custom_radio {\r\n\tcolor: #000;\r\n\tdisplay: inline-flex;\r\n    align-items: center;\r\n\tposition: relative;\r\n\tmargin-bottom: 0;\r\n\tcursor: pointer;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none\r\n}\r\n.radio_input .custom_radio + .custom_radio {\r\n\tmargin-left: 15px;\r\n}\r\n.custom_radio input {\r\n\tposition: absolute;\r\n\topacity: 0\r\n}\r\n.custom_radio input:checked ~ .checkmark {\r\n\tborder: 1px solid #3FA2DB;\r\n}\r\n.custom_radio input:checked ~ .checkmark:after {\r\n\topacity: 1;\r\n}\r\n.custom_radio .checkmark {\r\n\tposition: absolute;\r\n\tleft: 0;\r\n\theight: 26px;\r\n\twidth: 26px;\r\n\tbackground-color: #E6E6E6;\r\n\tborder: 1px solid #E6E6E6;\r\n\tborder-radius: 50%\r\n}\r\n.custom_radio .checkmark:after {\r\n\tdisplay: block;\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tborder-radius: 50%;\r\n\tbackground: #3FA2DB;\r\n\tborder: 1px solid #3FA2DB;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-ms-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out\r\n}\r\n.check-input {\r\n\tdisplay: block;\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\twidth: 0;\r\n\theight: 0;\r\n\tvisibility: hidden;\r\n\topacity: 0;\r\n\tpointer-events: none;\r\n\tposition: absolute;\r\n}\r\n.checktoggle {\r\n    background-color: #F0142F;\r\n    border: 1px solid #F0142F;\r\n    border-radius: 12px;\r\n    cursor: pointer;\r\n    display: block;\r\n    font-size: 0;\r\n    height: 24px;\r\n    margin-bottom: 0;\r\n    position: relative;\r\n    width: 42px;\r\n}\r\n.checktoggle:after {\r\n\tcontent: ' ';\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tleft: 0;\r\n\ttransform: translate(5px, -50%);\r\n\twidth: 14px;\r\n\theight: 14px;\r\n\tbackground-color: #fff;\r\n\tborder-radius: 50%;\r\n\ttransition: left 300ms ease, transform 300ms ease;\r\n}\r\n.check-input:checked + .checktoggle {\r\n    background-color: #008F64;\r\n    border: 1px solid #008F64;\r\n}\r\n.check-input:checked + .checktoggle:after {\r\n\tbackground-color: #fff;\r\n\tleft: 100%;\r\n\ttransform: translate(calc(-100% - 5px), -50%);\r\n}\r\n.onoffswitch {\r\n\tmargin-left: auto;\r\n    position: relative;\r\n\twidth: 73px;\r\n    -webkit-user-select:none;\r\n\t-moz-user-select:none;\r\n\t-ms-user-select: none;\r\n}\r\n.onoffswitch-checkbox {\r\n    display: none;\r\n}\r\n.onoffswitch-label {\r\n    display: block; \r\n\toverflow: hidden; \r\n\tcursor: pointer;\r\n\tborder-radius: 20px;\r\n\tmargin-bottom: 0;\r\n}\r\n.onoffswitch-inner {\r\n\tdisplay: block;\r\n    margin-left: -100%;\r\n    transition: margin 0.3s ease-in 0s;\r\n    width: 200%;\r\n}\r\n.onoffswitch-inner:before, .onoffswitch-inner:after {\r\n    box-sizing: border-box;\r\n    color: #fff;\r\n    display: block;\r\n    float: left;\r\n    font-size: 16px;\r\n    height: 30px;\r\n    line-height: 32px;\r\n    padding: 0;\r\n    width: 50%;\r\n}\r\n.onoffswitch-inner:before {\r\n\tbackground-color: #55ce63;\r\n    color: #fff;\r\n    content: \"ON\";\r\n    padding-left: 14px;\r\n}\r\n.onoffswitch-inner:after {\r\n    content: \"OFF\";\r\n    padding-right: 14px;\r\n    background-color: #ccc;\r\n    color: #fff;\r\n    text-align: right;\r\n}\r\n.onoffswitch-switch {\r\n    background: #fff;\r\n    border-radius: 20px;\r\n    bottom: 0;\r\n    display: block;\r\n\theight: 20px;\r\n    margin: 5px;\r\n    position: absolute;\r\n    right: 43px;\r\n    top: 0;\r\n    transition: all 0.3s ease-in 0s;\r\n    width: 20px;\r\n}\r\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-inner {\r\n    margin-left: 0;\r\n}\r\n.onoffswitch-checkbox:checked + .onoffswitch-label .onoffswitch-switch {\r\n    right: 0px; \r\n}\r\n.switch {\r\n    cursor: pointer;\r\n    position: relative;\r\n}\r\n.switch input {\r\n    position: absolute;\r\n    opacity: 0;\r\n    filter: alpha(opacity=0);\r\n}\r\n.switch input:checked+span {\r\n    background-color: #55ce63;\r\n}\r\n.switch input:checked+span:after {\r\n    left: 31px;\r\n}\r\n.switch span {\r\n    position: relative;\r\n    width: 60px;\r\n    height: 30px;\r\n    border-radius: 30px;\r\n    background-color: #fff;\r\n    border: 1px solid #eee;\r\n    border-color: rgba(0, 0, 0, 0.1);\r\n    display: inline-block;\r\n    -webkit-transition: background-color 0.2s;\r\n    transition: background-color 0.2s;\r\n}\r\n.switch span:after {\r\n    content: \"\";\r\n    position: absolute;\r\n    background-color: #fff;\r\n    width: 26px;\r\n    top: 1px;\r\n    bottom: 1px;\r\n    border-radius: 30px;\r\n    -webkit-box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);\r\n    box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);\r\n    -webkit-transition: left 0.2s;\r\n    transition: left 0.2s;\r\n}\r\n.inactive-text {\r\n\tcolor: #CBCBCB;\r\n}\r\n.scheduled-text {\r\n\tcolor: #3FA2DB;\r\n}\r\n.delayed-text {\r\n\tcolor: #FFA012;\r\n}\r\n.cancelled-text {\r\n\tcolor: #F50C0C;\r\n}\r\n.pending-text {\r\n\tcolor: #BE23CB;\r\n}\r\n.complete-text {\r\n\tcolor: #17D513;\r\n}\r\n.waiting-text {\r\n\tcolor: #fcc100;\r\n}\r\n\r\n/*-----------------\r\n\t4. Bootstrap Classes\r\n-----------------------*/\r\n\r\n.btn.focus, .btn:focus {\r\n    box-shadow: unset;\r\n}\r\n.btn-block {\r\n\twidth: 100%;\r\n}\r\n.btn-link {\r\n\ttext-decoration: none;\r\n}\r\n.btn-link:hover {\r\n\ttext-decoration: underline;\r\n}\r\n.note-btn {\r\n\tpadding: 5px 8px;\r\n}\r\n.btn-white {\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #ccc;\r\n\tcolor: #333;\r\n}\r\n.btn.btn-rounded {\r\n\tborder-radius: 50px;\r\n}\r\n.bg-primary {\r\n\tbackground-color: #3FA2DB !important;\r\n}\r\n.bg-light {\r\n    background-color: #ebebff !important;\r\n}\r\na.bg-primary:focus, \r\na.bg-primary:hover, \r\nbutton.bg-primary:focus, \r\nbutton.bg-primary:hover {\r\n    background-color: #3FA2DB !important;\r\n}\r\n.bg-success,\r\n.badge-success {\r\n\tbackground-color:rgba(40, 199, 111, 0.16);\r\n    color: #28C76F;\r\n}\r\n.badge-success-light {\r\n\tbackground-color: rgba(40, 199, 111, 0.08);\r\n    color: rgba(40, 199, 111, 0.48);\r\n}\r\na.bg-success:focus, \r\na.bg-success:hover, \r\nbutton.bg-success:focus, \r\nbutton.bg-success:hover {\r\n    background-color: #699834 !important;\r\n}\r\na.bg-info:focus, \r\na.bg-info:hover, \r\nbutton.bg-info:focus, \r\nbutton.bg-info:hover {\r\n    background-color: #028ee1 !important;\r\n}\r\n.bg-warning,\r\n.badge-warning {\r\n\tbackground-color: rgba(255, 159, 67, 0.48) !important;\r\n\tcolor: #FF9F43;\r\n}\r\na.bg-warning:focus, \r\na.bg-warning:hover, \r\nbutton.bg-warning:focus, \r\nbutton.bg-warning:hover {\r\n    background-color: #e9ab2e !important;\r\n}\r\n.bg-danger,\r\n.badge-danger {\r\n\tbackground-color:rgba(255, 0, 0, 0.16) !important;\r\n\tcolor: #FF0000;\r\n}\r\na.bg-danger:focus, \r\na.bg-danger:hover, \r\nbutton.bg-danger:focus, \r\nbutton.bg-danger:hover {\r\n    background-color: #e63333 !important;\r\n}\r\n.bg-white {\r\n\tbackground-color: #fff;\r\n}\r\n.bg-purple,\r\n.badge-purple {\r\n    background-color: #9368e9 !important;\r\n}\r\n.text-primary,\r\n.dropdown-menu > li > a.text-primary {\r\n\tcolor: #3FA2DB !important;\r\n}\r\n.text-success,\r\n.dropdown-menu > li > a.text-success {\r\n\tcolor: #699834 !important;\r\n}\r\n.text-danger,\r\n.dropdown-menu > li > a.text-danger {\r\n\tcolor: #e84646 !important;\r\n}\r\n.text-light-danger,\r\n.dropdown-menu > li > a.text-danger {\r\n\tcolor: #E87373 !important;\r\n}\r\n.text-info,\r\n.dropdown-menu > li > a.text-info {\r\n\tcolor: #009efb !important;\r\n}\r\n.text-warning,\r\n.dropdown-menu > li > a.text-warning {\r\n\tcolor: #ffbc34 !important;\r\n}\r\n.text-purple,\r\n.dropdown-menu > li > a.text-purple {\r\n\tcolor: #7460ee !important;\r\n}\r\n.text-muted {\r\n    color: #757575 !important;\r\n}\r\n.btn-primary {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tpadding: 10px 20px;\r\n\tborder-radius: 30px;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #3FA2DB;\r\n\tbackground: #3FA2DB;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-primary:hover,\r\n.btn-primary:focus,\r\n.btn-primary.active,\r\n.btn-primary:active,\r\n.open > .dropdown-toggle.btn-primary {\r\n\tcolor: #3FA2DB;\r\n\tborder: 1px solid #3FA2DB;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n    background: transparent;\r\n}\r\n.btn-primary.active.focus,\r\n.btn-primary.active:focus,\r\n.btn-primary.active:hover,\r\n.btn-primary.focus:active,\r\n.btn-primary:active:focus,\r\n.btn-primary:active:hover,\r\n.open > .dropdown-toggle.btn-primary.focus,\r\n.open > .dropdown-toggle.btn-primary:focus,\r\n.open > .dropdown-toggle.btn-primary:hover {\r\n\tbackground-color: #3FA2DB;\r\n\tborder: 1px solid #3FA2DB;\r\n}\r\n.btn-primary.active:not(:disabled):not(.disabled),\r\n.btn-primary:active:not(:disabled):not(.disabled),\r\n.show > .btn-primary.dropdown-toggle {\r\n\tbackground-color: #3FA2DB;\r\n\tborder-color: #3FA2DB;\r\n\tcolor: #fff;\r\n}\r\n.btn-primary.active:focus:not(:disabled):not(.disabled), \r\n.btn-primary:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-primary.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.btn-primary.disabled, .btn-primary:disabled {\r\n    background-color: #FFBC53;\r\n    border-color: #FFBC53;\r\n    color: #fff;\r\n}\r\n.btn-secondary {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tpadding: 10px 20px;\r\n\tborder-radius: 30px;\r\n\tcolor: #000;\r\n\tborder: 1px solid #F7D333;\r\n\tbackground: #F7D333;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-secondary:hover {\r\n\tcolor: #000;\r\n\tborder: 1px solid #F7D333;\r\n\tbackground: transparent;\r\n}\r\n.btn-secondary.active:focus:not(:disabled):not(.disabled), \r\n.btn-secondary:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-secondary.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.btn-primary-line {\r\n\tborder: 2px solid #3FA2DB;\r\n    width: calc(100% - 5px);\r\n    display: block;\r\n\tcolor: #3FA2DB;\r\n    padding: 4px 7px;\r\n    border-radius: 5px;\r\n\toutline: none;\r\n}\r\n.btn-primary-line:hover {\r\n\tbackground: #3FA2DB;\r\n    color: #fff;\r\n}\r\n.btn-success {\r\n\tbackground-color: #28C76F;\r\n\tborder: 1px solid #28C76F\r\n}\r\n.btn-success:hover,\r\n.btn-success:focus,\r\n.btn-success.active,\r\n.btn-success:active,\r\n.open > .dropdown-toggle.btn-success {\r\n\tbackground-color: transparent;\r\n\tborder: 1px solid #699834;\r\n\tcolor: #fff;\r\n}\r\n.btn-success.active.focus,\r\n.btn-success.active:focus,\r\n.btn-success.active:hover,\r\n.btn-success.focus:active,\r\n.btn-success:active:focus,\r\n.btn-success:active:hover,\r\n.open > .dropdown-toggle.btn-success.focus,\r\n.open > .dropdown-toggle.btn-success:focus,\r\n.open > .dropdown-toggle.btn-success:hover {\r\n\tbackground-color: #699834;\r\n\tborder: 1px solid #699834\r\n}\r\n.btn-success.active:not(:disabled):not(.disabled),\r\n.btn-success:active:not(:disabled):not(.disabled),\r\n.show > .btn-success.dropdown-toggle {\r\n\tbackground-color: #699834;\r\n\tborder-color: #699834;\r\n\tcolor: #fff;\r\n}\r\n.btn-success.active:focus:not(:disabled):not(.disabled), \r\n.btn-success:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-success.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.btn-success.disabled, .btn-success:disabled {\r\n    background-color: #7bb13c;\r\n    border-color: #7bb13c;\r\n    color: #fff;\r\n}\r\n.btn-info {\r\n\tbackground-color: #009efb;\r\n\tborder: 1px solid #009efb\r\n}\r\n.btn-info:hover,\r\n.btn-info:focus,\r\n.btn-info.active,\r\n.btn-info:active,\r\n.open > .dropdown-toggle.btn-info {\r\n\tbackground-color: transparent;\r\n\tborder: 1px solid #028ee1\r\n}\r\n.btn-info.active.focus,\r\n.btn-info.active:focus,\r\n.btn-info.active:hover,\r\n.btn-info.focus:active,\r\n.btn-info:active:focus,\r\n.btn-info:active:hover,\r\n.open > .dropdown-toggle.btn-info.focus,\r\n.open > .dropdown-toggle.btn-info:focus,\r\n.open > .dropdown-toggle.btn-info:hover {\r\n\tbackground-color: #028ee1;\r\n\tborder: 1px solid #028ee1\r\n}\r\n.btn-info.active:not(:disabled):not(.disabled),\r\n.btn-info:active:not(:disabled):not(.disabled),\r\n.show > .btn-info.dropdown-toggle {\r\n\tbackground-color: #028ee1;\r\n\tborder-color: #028ee1;\r\n\tcolor: #fff;\r\n}\r\n.btn-info.active:focus:not(:disabled):not(.disabled), \r\n.btn-info:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-info.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.btn-info.disabled, .btn-info:disabled {\r\n    background-color: #009efb;\r\n    border-color: #009efb;\r\n    color: #fff;\r\n}\r\n.btn-warning {\r\n\tbackground-color: #ffbc34;\r\n\tborder: 1px solid #ffbc34\r\n}\r\n.btn-warning:hover,\r\n.btn-warning:focus,\r\n.btn-warning.active,\r\n.btn-warning:active,\r\n.open > .dropdown-toggle.btn-warning {\r\n\tbackground-color: transparent;\r\n\tborder: 1px solid #e9ab2e\r\n}\r\n.btn-warning.active.focus,\r\n.btn-warning.active:focus,\r\n.btn-warning.active:hover,\r\n.btn-warning.focus:active,\r\n.btn-warning:active:focus,\r\n.btn-warning:active:hover,\r\n.open > .dropdown-toggle.btn-warning.focus,\r\n.open > .dropdown-toggle.btn-warning:focus,\r\n.open > .dropdown-toggle.btn-warning:hover {\r\n\tbackground-color: #e9ab2e;\r\n\tborder: 1px solid #e9ab2e\r\n}\r\n.btn-warning.active:not(:disabled):not(.disabled),\r\n.btn-warning:active:not(:disabled):not(.disabled),\r\n.show > .btn-danger.dropdown-toggle {\r\n\tbackground-color: #e9ab2e;\r\n\tborder-color: #e9ab2e;\r\n\tcolor: #fff;\r\n}\r\n.btn-warning.active:focus:not(:disabled):not(.disabled), \r\n.btn-warning:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-warning.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.btn-warning.disabled, .btn-warning:disabled {\r\n    background-color: #ffbc34;\r\n    border-color: #ffbc34;\r\n    color: #fff;\r\n}\r\n.btn-danger {\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tcolor: #FFF;\r\n\tpadding: 8px 20px;\r\n\tbackground-color: #CC0001;\r\n\tborder: 1px solid #CC0001;\r\n\tborder-radius: 30px;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-danger:hover,\r\n.btn-danger:focus,\r\n.btn-danger.active,\r\n.btn-danger:active,\r\n.open > .dropdown-toggle.btn-danger {\r\n\tcolor: #CC0001;\r\n\tbackground-color: transparent;\r\n\tborder: 1px solid #CC0001;\r\n}\r\n.btn-danger.active.focus,\r\n.btn-danger.active:focus,\r\n.btn-danger.active:hover,\r\n.btn-danger.focus:active,\r\n.btn-danger:active:focus,\r\n.btn-danger:active:hover,\r\n.open > .dropdown-toggle.btn-danger.focus,\r\n.open > .dropdown-toggle.btn-danger:focus,\r\n.open > .dropdown-toggle.btn-danger:hover {\r\n\tbackground-color: #CC0001;\r\n\tborder: 1px solid #CC0001;\r\n}\r\n.btn-danger.active:not(:disabled):not(.disabled),\r\n.btn-danger:active:not(:disabled):not(.disabled),\r\n.show > .btn-danger.dropdown-toggle {\r\n\tbackground-color: #CC0001;\r\n\tborder-color: #CC0001;\r\n\tcolor: #fff;\r\n}\r\n.btn-danger.active:focus:not(:disabled):not(.disabled), \r\n.btn-danger:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-danger.dropdown-toggle:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.btn-danger.disabled, .btn-danger:disabled {\r\n    background-color: #f62d51;\r\n    border-color: #f62d51;\r\n    color: #fff;\r\n}\r\n.btn-light {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tpadding: 10px 20px;\r\n\tborder-radius: 30px;\r\n\tcolor: #898989;\r\n\tborder: 1px solid #E6E6E6;\r\n\tbackground: #E6E6E6;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-light:hover {\r\n\tcolor: #000;\r\n\tborder: 1px solid #d3d4d5;\r\n\tbackground: #d3d4d5;\r\n}\r\n.btn-light.active:focus:not(:disabled):not(.disabled), \r\n.btn-light:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-light.dropdown-toggle:focus {\r\n    box-shadow: unset;\r\n}\r\n.btn-dark.active:focus:not(:disabled):not(.disabled), \r\n.btn-dark:active:focus:not(:disabled):not(.disabled), \r\n.show > .btn-dark.dropdown-toggle:focus {\r\n    box-shadow: unset;\r\n}\r\n.btn-black {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tpadding: 10px 20px;\r\n\tborder-radius: 30px;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #000;\r\n\tbackground: #000;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-black:hover {\r\n\tcolor: #000;\r\n\tborder: 1px solid #000;\r\n\tbackground: transparent;\r\n}\r\n.btn-gray {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tpadding: 10px 20px;\r\n\tborder-radius: 30px;\r\n\tcolor: #000;\r\n\tborder: 1px solid #898989;\r\n\tbackground: #898989;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-gray:hover {\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #000;\r\n\tbackground: transparent;\r\n}\r\n.btn-outline-primary {\r\n\tcolor: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n}\r\n.btn-outline-primary:hover {\r\n\tbackground-color: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n}\r\n.btn-outline-primary:focus, \r\n.btn-outline-primary.focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-primary.disabled, \r\n.btn-outline-primary:disabled {\r\n\tcolor: #FFBC53;\r\n\tbackground-color: transparent;\r\n}\r\n.btn-outline-primary:not(:disabled):not(.disabled):active, \r\n.btn-outline-primary:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-primary.dropdown-toggle {\r\n\tbackground-color: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n}\r\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, \r\n.btn-outline-primary:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-primary.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-success {\r\n\tcolor: #7bb13c;\r\n\tborder-color: #7bb13c;\r\n}\r\n.btn-outline-success:hover {\r\n\tbackground-color: #7bb13c;\r\n\tborder-color: #7bb13c;\r\n}\r\n.btn-outline-success:focus, .btn-outline-success.focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-success.disabled, .btn-outline-success:disabled {\r\n\tcolor: #7bb13c;\r\n\tbackground-color: transparent;\r\n}\r\n.btn-outline-success:not(:disabled):not(.disabled):active, \r\n.btn-outline-success:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-success.dropdown-toggle {\r\n\tbackground-color: #7bb13c;\r\n\tborder-color: #7bb13c;\r\n}\r\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, \r\n.btn-outline-success:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-success.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n.box-shadow-none{\r\n\tbox-shadow: none !important;\r\n}\r\n.btn-outline-info {\r\n\tcolor: #009efb;\r\n\tborder-color: #009efb;\r\n}\r\n.btn-outline-info:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #009efb;\r\n\tborder-color: #009efb;\r\n}\r\n.btn-outline-info:focus, .btn-outline-info.focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-info.disabled, .btn-outline-info:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: #009efb;\r\n}\r\n.btn-outline-info:not(:disabled):not(.disabled):active, \r\n.btn-outline-info:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-info.dropdown-toggle {\r\n\tbackground-color: #009efb;\r\n\tborder-color: #009efb;\r\n}\r\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, \r\n.btn-outline-info:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-info.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-warning {\r\n\tcolor: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n}\r\n.btn-outline-warning:hover {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n}\r\n.btn-outline-warning:focus, .btn-outline-warning.focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: #ffbc34;\r\n}\r\n.btn-outline-warning:not(:disabled):not(.disabled):active, \r\n.btn-outline-warning:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-warning.dropdown-toggle {\r\n\tcolor: #212529;\r\n\tbackground-color: #ffbc34;\r\n\tborder-color: #ffbc34;\r\n}\r\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, \r\n.btn-outline-warning:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-warning.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-danger {\r\n\tcolor: #e84646;\r\n\tborder-color: #e84646;\r\n}\r\n.btn-outline-danger:hover {\r\n\tcolor: #fff;\r\n\tbackground-color: #e84646;\r\n\tborder-color: #e84646;\r\n}\r\n.btn-outline-danger:focus, .btn-outline-danger.focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\r\n\tbackground-color: transparent;\r\n\tcolor: #e84646;\r\n}\r\n.btn-outline-danger:not(:disabled):not(.disabled):active, \r\n.btn-outline-danger:not(:disabled):not(.disabled).active,\r\n.show > .btn-outline-danger.dropdown-toggle {\r\n\tbackground-color: #e84646;\r\n\tborder-color: #e84646;\r\n}\r\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, \r\n.btn-outline-danger:not(:disabled):not(.disabled).active:focus,\r\n.show > .btn-outline-danger.dropdown-toggle:focus {\r\n\tbox-shadow: none;\r\n}\r\n.btn-outline-light {\r\n    color: #ababab;\r\n    border-color: #e6e6e6;\r\n}\r\n.btn-outline-light.disabled, .btn-outline-light:disabled {\r\n    color: #ababab;\r\n}\r\n.btn-primary-light {\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tcolor: #3FA2DB;\r\n\tpadding: 8px 15px;\r\n\tbackground: transparent;\r\n\tborder: 1px solid #3FA2DB;\r\n\tborder-radius: 30px;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-primary-light:hover {\r\n\tcolor: #FFF;\r\n\tbackground: #3FA2DB;\r\n\tborder: 1px solid #3FA2DB;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-secondary-light {\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tcolor: #F7D333;\r\n\tpadding: 8px 15px;\r\n\tbackground: transparent;\r\n\tborder: 1px solid #F7D333;\r\n\tborder-radius: 30px;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-secondary-light:hover {\r\n\tcolor: #FFF;\r\n\tbackground: #F7D333;\r\n\tborder: 1px solid #F7D333;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-danger-light {\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tcolor: #CC0001;\r\n\tpadding: 8px 15px;\r\n\tbackground: transparent;\r\n\tborder: 1px solid #CC0001;\r\n\tborder-radius: 30px;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-danger-light:hover {\r\n\tcolor: #FFF;\r\n\tbackground: #CC0001;\r\n\tborder: 1px solid #CC0001;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-dark-light {\r\n\tfont-size: 16px;\r\n\tfont-weight: 400;\r\n\tcolor: #000;\r\n\tpadding: 8px 15px;\r\n\tbackground: transparent;\r\n\tborder: 1px solid #000;\r\n\tborder-radius: 30px;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.btn-dark-light:hover {\r\n\tcolor: #FFF;\r\n\tbackground: #000;\r\n\tborder: 1px solid #000;\r\n\tmoz-transition: all .4s ease-in-out;\r\n    -o-transition: all .4s ease-in-out;\r\n    -webkit-transition: all .4s ease-in-out;\r\n    transition: all .4s ease-in-out;\r\n}\r\n.pagination > .active > a, \r\n.pagination > .active > a:focus,\r\n.pagination > .active > a:hover,\r\n.pagination > .active > span,\r\n.pagination > .active > span:focus,\r\n.pagination > .active > span:hover {\r\n\tbackground-color: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n}\r\n.pagination > li > a, \r\n.pagination > li > span {\r\n\tcolor: #FFBC53;\r\n}\r\ninput:disabled,select:disabled{\r\n\tbackground: #F1F1F2 !important;\r\n}\r\n.page-link:hover {\r\n\tcolor: #FFBC53;\r\n}\r\n.page-link:focus {\r\n\tbox-shadow: unset;\r\n}\r\n.page-item.active .page-link {\r\n\tbackground-color: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n}\r\n.dropdown-menu {\r\n\tborder: 0;\r\n\tborder-radius: 8px;\r\n\ttransform-origin: left top 0;\r\n\tbox-shadow: 0px 0px 10px -1px #00000040;\r\n\tbackground-color: #FFF;\r\n}\r\n.dropdown-menu::-webkit-scrollbar {\r\n\twidth: 5px;\r\n}\r\n.dropdown-menu::-webkit-scrollbar-track {\r\n\tbox-shadow: inset 0 0 10px #D9D9D9; \r\n\tborder-radius: 5px;\r\n}\r\n.dropdown-menu::-webkit-scrollbar-thumb {\r\n\tbackground: #AAA; \r\n\tborder-radius: 5px;\r\n}\r\n.dropdown-menu::-webkit-scrollbar-thumb:hover {\r\n\tbackground: #AAA; \r\n}\r\n.dropdown-item.active, .dropdown-item:active {\r\n    background-color: #FFF;\r\n}\r\n.navbar-nav .open .dropdown-menu {\r\n\tborder: 0;\r\n\tbox-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n\tbackground-color: #fff;\r\n}\r\n.dropdown-menu {\r\n\tfont-size: 14px;\r\n}\r\n.card {\r\n\tbackground: #FFF;\r\n    border: 0;\r\n    border-radius: 15px;\r\n    box-shadow: 0px 0px 10px -1px #00000040;\r\n    margin-bottom: 24px;\r\n}\r\n.card-body {\r\n\tpadding: 24px;\r\n}\r\n.card-header {\r\n\tborder-bottom: 1px solid #e6e6e6;\r\n\tpadding: 1rem 1.5rem;\r\n}\r\n.card-footer {\r\n\tbackground-color: #fff;\r\n\tborder-top: 1px solid #e6e6e6;\r\n\tpadding: 1rem 1.5rem;\r\n}\r\n.card .card-header {\r\n    background-color: #fff;\r\n    border-bottom: 1px solid #eaeaea;\r\n}\r\n.card .card-header .card-title {\r\n    margin-bottom: 0;\r\n    font-size: 18px;\r\n}\r\n.modal-footer.text-left {\r\n\ttext-align: left;\r\n}\r\n.modal-footer.text-center {\r\n\ttext-align: center;\r\n}\r\n.bootstrap-datetimepicker-widget table td.active, .bootstrap-datetimepicker-widget table td.active:hover {\r\n\tbackground-color: #3FA2DB;\r\n\ttext-shadow: unset;\r\n}\r\n.bootstrap-datetimepicker-widget table td.today:before{\r\n\tborder-bottom-color:#FFBC53;\r\n}\r\n.bg-info-light{\r\n\tbackground-color:rgba(2, 182, 179,0.12) !important;\r\n\tcolor:#1db9aa !important;\r\n}\r\n.bg-primary-light{\r\n\tbackground-color:rgba(17, 148, 247,0.12) !important;\r\n\tcolor:#2196f3 !important;\r\n}\r\n.bg-danger-light{\r\n\tbackground-color:#FFBC53 !important;\r\n\tcolor:#fff !important;\r\n}\r\n.bg-warning-light{\r\n\tbackground-color:rgba(255, 152, 0,0.12) !important;\r\n\tcolor:#f39c12 !important;\r\n}\r\n.bg-success-light{\r\n\tbackground-color: #3FA2DB;\r\n    color: #fff;\r\n}\r\n.bg-purple-light{\r\n\tbackground-color:rgba(197, 128, 255,0.12) !important;\r\n\tcolor:#c580ff !important;\r\n}\r\n.badge-highlight {\r\n    background: rgba(0, 207, 232, 0.24) !important;\r\n    color: rgba(0, 207, 232, 0.48);\r\n}\r\n.bg-default-light{\r\n\tbackground-color:rgba(40, 52, 71,0.12) !important;\r\n\tcolor:#283447 !important;\r\n}\r\n.bg-success-light:hover {\r\n\tcolor: #fff;\r\n}\r\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\r\n\tmargin: 15px 0 0;\r\n}\r\ndiv.dataTables_wrapper div.dataTables_info {\r\n    padding-top: 25px;\r\n}\r\ndiv.dataTables_wrapper div.dataTables_length select {\r\n\tappearance: auto;\r\n}\r\n.badge{\r\n\tpadding: 5px 10px;\r\n\tborder-radius: 4px;\r\n\tfont-size: 13px;\r\n    font-weight: 500;\r\n    -webkit-background-clip: initial;\r\n    -webkit-text-fill-color: initial;\r\n}\r\n.dropdown-toggle {\r\n    font-size: 15px;\r\n    color: #000;\r\n    background: transparent;\r\n    border: 0;\r\n}\r\n.dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n.dropdown-menu {\r\n    min-width: 160px;\r\n    border-radius: 8px;\r\n    border: 0;\r\n    padding: 0;\r\n    box-shadow: 0px 0px 10px -1px #00000040;\r\n}\r\n.dropdown-menu .dropdown-item {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tfont-size: 14px;\r\n\tcolor: #000;\r\n\tpadding: 10px 15px;\r\n\tborder-bottom: 1px solid #EFEFEF;\r\n\tborder-radius: 0;\r\n\t-webkit-transition: all 0.4s;\r\n    -ms-transition: all 0.4s;\r\n    transition: all 0.4s;\r\n}\r\n.dropdown-menu .dropdown-item:first-child {\r\n    border-radius: 8px 8px 0 0;\r\n}\r\n.dropdown-menu .dropdown-item:last-child {\r\n    border-radius: 0 0 8px 8px;\r\n    border-bottom: 0;\r\n}\r\n.dropdown-menu .dropdown-item:hover {\r\n    color: #3FA2DB;\r\n    padding-left: 20px;\r\n    -webkit-transition: all 0.4s;\r\n    -ms-transition: all 0.4s;\r\n    transition: all 0.4s;\r\n}\r\n.dropdown-menu .dropdown-item.active {\r\n\tcolor: #3FA2DB;\r\n}\r\n.dropdown-menu .dropdown-item.active:hover {\r\n\tbackground: #f8f9fa;\r\n}\r\n.dropdown-menu .dropdown-item i {\r\n\tfont-size: 18px;\r\n\tmargin-right: 8px;\r\n}\r\n.dropdown-menu .dropdown-item img {\r\n\tmargin-right: 8px;\r\n}\r\n\r\n/*-----------------\r\n\t5. Select2\r\n-----------------------*/\r\nselect {\r\n\toutline: none;\r\n}\r\n.select2-container {\r\n\twidth: 100% !important;\r\n}\r\n.select2-search--dropdown {\r\n\tdisplay: none;\r\n}\r\n.select2-dropdown {\r\n\tborder: 1px solid #EFEFEF;\r\n\tborder-radius: 0;\r\n}\r\n.select2-container .select2-selection--single {\r\n\tborder: 0;\r\n\tborder-bottom: 1px solid #00000038;\r\n\tborder-radius: 0;\r\n\theight: 40px;\r\n}\r\n.select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\theight: 38px;\r\n\tright: 10px;\r\n}\r\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: #000;\r\n    border-style: solid;\r\n    border-width: 0 2px 2px 0;\r\n    padding: 3px;\r\n    height: 0;\r\n    margin-left: -6px;\r\n    margin-top: -3px;\r\n    width: 0;\r\n    transform: rotate(45deg) translateY(-50%);\r\n    -webkit-transform: rotate(45deg) translateY(-50%);\r\n    -ms-transform: rotate(45deg) translateY(-50%);\r\n}\r\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\r\n\tborder-color: #000;\r\n    border-width: 2px 0 0 2px;\r\n    margin-top: 3px;\r\n    padding: 3px;\r\n}\r\n.select2-container .select2-selection--single .select2-selection__rendered {\r\n\tpadding-top: 0;\r\n\tpadding-bottom: 0;\r\n\tpadding-left: 0;\r\n\tpadding-right: 30px;\r\n}\r\n.select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tfont-size: 14px;\r\n\tcolor: #898989;\r\n\tfont-weight: normal;\r\n\tline-height: 38px;\r\n}\r\n.select2-container--default .select2-selection--single .select2-selection__rendered::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\r\n\tbackground-color: #EFEFEF;\r\n\tcolor: #333;\r\n}\r\n.select2-results .select2-highlighted {\r\n    background: #3ea211;\r\n}\r\n.select2-container--default .select2-selection--multiple {\r\n\tborder: 1px solid #00000038;\r\n\tmin-height: 40px;\r\n}\r\n.select2-results__option {\r\n\tfont-size: 14px;\r\n\tcolor: #898989;\r\n\tborder-radius: 0;\r\n\tpadding: 8px 15px;\r\n}\r\n.select2-container--default .select2-results__option[aria-selected=true] {\r\n    background-color: #EFEFEF;\r\n}\r\n.select2-container--default .select2-search--dropdown .select2-search__field {\r\n    border: 1px solid #3333;\r\n}\r\n.select2-search--dropdown .select2-search__field {\r\n\tfont-size: 14px;\r\n    padding: 4px 10px;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n    border-radius: 5px;\r\n}\r\n.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar {\r\n\twidth: 5px;\r\n}\r\n.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar-track {\r\n\tbox-shadow: inset 0 0 10px #D9D9D9; \r\n\tborder-radius: 5px;\r\n}\r\n.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar-thumb {\r\n\tbackground: #AAA; \r\n\tborder-radius: 5px;\r\n}\r\n.select2-container--default .select2-results>.select2-results__options::-webkit-scrollbar-thumb:hover {\r\n\tbackground: #AAA; \r\n}\r\n\r\n/*-----------------\r\n\t6. Nav Tabs\r\n-----------------------*/\r\n\r\n.nav-tabs {\r\n\tborder-bottom: 1px solid #e6e6e6;\r\n}\r\n.card-header-tabs {\r\n    border-bottom: 0;\r\n}\r\n.nav-tabs > li > a {\r\n\tmargin-right: 0;\r\n\tcolor: #888;\r\n\tborder-radius: 0;\r\n}\r\n.nav-tabs > li > a:hover,\r\n.nav-tabs > li > a:focus {\r\n\tborder-color: transparent;\r\n\tcolor: #333;\r\n}\r\n.nav-tabs.nav-tabs-solid > li > a {\r\n\tcolor: #333;\r\n}\r\n.nav-tabs.nav-tabs-solid > .active > a,\r\n.nav-tabs.nav-tabs-solid > .active > a:hover,\r\n.nav-tabs.nav-tabs-solid > .active > a:focus {\r\n\tbackground-color: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n\tcolor: #fff;\r\n}\r\n.tab-content {\r\n\tpadding-top: 0;\r\n}\r\n.nav-tabs .nav-link {\r\n\tborder-radius: 0;\r\n}\r\n.nav-tabs .nav-link:focus, .nav-tabs .nav-link:hover {\r\n    background-color: #eee;\r\n    border-color: transparent;\r\n\tcolor: #333;\r\n}\r\n.nav-tabs.nav-justified > li > a {\r\n\tborder-radius: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n.nav-tabs.nav-justified > li > a:hover,\r\n.nav-tabs.nav-justified > li > a:focus {\r\n\tborder-bottom-color: #ddd;\r\n}\r\n.nav-tabs.nav-justified.nav-tabs-solid > li > a {\r\n\tborder-color: transparent;\r\n}\r\n.nav-tabs.nav-tabs-solid > li > a {\r\n\tcolor: #333;\r\n}\r\n.nav-tabs.nav-tabs-solid > li > a.active,\r\n.nav-tabs.nav-tabs-solid > li > a.active:hover,\r\n.nav-tabs.nav-tabs-solid > li > a.active:focus {\r\n\tbackground-color: #FFBC53;\r\n\tborder-color: #FFBC53;\r\n\tcolor: #fff;\r\n}\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded {\r\n\tborder-radius: 50px;\r\n}\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a {\r\n\tborder-radius: 50px;\r\n}\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active,\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:hover,\r\n.nav-tabs.nav-tabs-solid.nav-tabs-rounded > li > a.active:focus {\r\n\tborder-radius: 50px;\r\n}\r\n.nav-tabs-justified > li > a {\r\n\tborder-radius: 0;\r\n\tmargin-bottom: 0;\r\n}\r\n.nav-tabs-justified > li > a:hover,\r\n.nav-tabs-justified > li > a:focus {\r\n\tborder-bottom-color: #ddd;\r\n}\r\n.nav-tabs-justified.nav-tabs-solid > li > a {\r\n\tborder-color: transparent;\r\n}\r\n.nav-tabs.nav-justified.nav-tabs-top {\r\n\tborder-bottom: 1px solid #ddd;\r\n}\r\n.nav-tabs.nav-justified.nav-tabs-top > li > a,\r\n.nav-tabs.nav-justified.nav-tabs-top > li > a:hover,\r\n.nav-tabs.nav-justified.nav-tabs-top > li > a:focus {\r\n\tborder-width: 2px 0 0 0;\r\n}\r\n.nav-tabs.nav-tabs-top > li {\r\n\tmargin-bottom: 0;\r\n}\r\n.nav-tabs.nav-tabs-top > li > a,\r\n.nav-tabs.nav-tabs-top > li > a:hover,\r\n.nav-tabs.nav-tabs-top > li > a:focus {\r\n\tborder-width: 2px 0 0 0;\r\n}\r\n.nav-tabs.nav-tabs-top > li.open > a,\r\n.nav-tabs.nav-tabs-top > li > a:hover,\r\n.nav-tabs.nav-tabs-top > li > a:focus {\r\n\tborder-top-color: #ddd;\r\n}\r\n.nav-tabs.nav-tabs-top > li+li > a {\r\n\tmargin-left: 1px;\r\n}\r\n.nav-tabs.nav-tabs-top > li > a.active,\r\n.nav-tabs.nav-tabs-top > li > a.active:hover,\r\n.nav-tabs.nav-tabs-top > li > a.active:focus {\r\n\tborder-top-color: #FFBC53;\r\n}\r\n.nav-tabs.nav-tabs-bottom > li {\r\n\tmargin-bottom: -1px;\r\n}\r\n.nav-tabs.nav-tabs-bottom > li > a.active, \r\n.nav-tabs.nav-tabs-bottom > li > a.active:hover, \r\n.nav-tabs.nav-tabs-bottom > li > a.active:focus {\r\n\tborder-bottom-width: 2px;\r\n\tborder-color: transparent;\r\n\tborder-bottom-color: #FFBC53;\r\n\tbackground-color: transparent;\r\n\ttransition: none 0s ease 0s; \r\n\t-moz-transition: none 0s ease 0s; \r\n\t-o-transition: none 0s ease 0s; \r\n\t-ms-transition: none 0s ease 0s; \r\n\t-webkit-transition: none 0s ease 0s;\r\n}\r\n.nav-tabs.nav-tabs-solid {\r\n\tbackground-color: #fafafa;\r\n\tborder: 0;\r\n}\r\n.nav-tabs.nav-tabs-solid > li {\r\n\tmargin-bottom: 0;\r\n}\r\n.nav-tabs.nav-tabs-solid > li > a {\r\n\tborder-color: transparent;\r\n}\r\n.nav-tabs.nav-tabs-solid > li > a:hover,\r\n.nav-tabs.nav-tabs-solid > li > a:focus {\r\n\tbackground-color: #f5f5f5;\r\n}\r\n.nav-tabs.nav-tabs-solid > .open:not(.active) > a {\r\n\tbackground-color: #f5f5f5;\r\n\tborder-color: transparent;\r\n}\r\n.nav-tabs-justified.nav-tabs-top {\r\n\tborder-bottom: 1px solid #ddd;\r\n}\r\n.nav-tabs-justified.nav-tabs-top > li > a,\r\n.nav-tabs-justified.nav-tabs-top > li > a:hover,\r\n.nav-tabs-justified.nav-tabs-top > li > a:focus {\r\n\tborder-width: 2px 0 0 0;\r\n}\r\n\r\n/*-----------------\r\n\t7. Components\r\n-----------------------*/\r\n\r\n.section-header {\r\n\tmargin-bottom: 1.875rem;\r\n}\r\n.section-header .section-title {\r\n\tcolor: #333;\r\n}\r\n.line {\r\n\tbackground-color: #3FA2DB;\r\n\theight: 2px;\r\n\tmargin: 0;\r\n\twidth: 60px;\r\n}\r\n.comp-buttons .btn {\r\n\tmargin-bottom: 5px;\r\n}\r\n.pagination-box .pagination {\r\n\tmargin-top: 0;\r\n}\r\n.comp-dropdowns .btn-group {\r\n\tmargin-bottom: 5px;\r\n}\r\n.progress-example .progress {\r\n\tmargin-bottom: 1.5rem;\r\n}\r\n.progress-xs {\r\n\theight: 4px;\r\n}\r\n.progress-sm {\r\n\theight: 15px;\r\n}\r\n.progress.progress-sm {\r\n\theight: 6px;\r\n}\r\n.progress.progress-md {\r\n\theight: 8px;\r\n}\r\n.progress.progress-lg {\r\n\theight: 18px;\r\n}\r\n.row.row-sm {\r\n\tmargin-left: -3px;\r\n\tmargin-right: -3px;\r\n}\r\n.row.row-sm > div {\r\n\tpadding-left: 3px;\r\n\tpadding-right: 3px;\r\n}\r\n.avatar {\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\twidth: 40px;\r\n\theight: 40px;\r\n}\r\n.avatar > img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\t-o-object-fit: cover;\r\n\tobject-fit: cover;\r\n}\r\n.avatar-title {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tbackground-color: #F7D333;\r\n\tcolor: #fff;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n}\r\n.avatar-away:before,\r\n.avatar-offline:before,\r\n.avatar-online:before {\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\twidth: 25%;\r\n\theight: 25%;\r\n\tborder-radius: 50%;\r\n\tcontent: '';\r\n\tborder: 2px solid #fff;\r\n}\r\n.avatar-online:before {\r\n\tbackground-color: #7bb13c;\r\n}\r\n.avatar-offline:before {\r\n\tbackground-color: #e84646;\r\n}\r\n.avatar-away:before {\r\n\tbackground-color: #ffbc34;\r\n}\r\n.avatar .border {\r\n\tborder-width: 3px !important;\r\n}\r\n.avatar .rounded {\r\n\tborder-radius: 6px !important;\r\n}\r\n.avatar .avatar-title {\r\n\tfont-size: 16px;\r\n}\r\n.avatar-xs {\r\n\twidth: 1.65rem;\r\n\theight: 1.65rem;\r\n}\r\n.avatar-xs .border {\r\n\tborder-width: 2px !important;\r\n}\r\n.avatar-xs .rounded {\r\n\tborder-radius: 4px !important;\r\n}\r\n.avatar-xs .avatar-title {\r\n\tfont-size: 12px;\r\n}\r\n.avatar-xs.avatar-away:before,\r\n.avatar-xs.avatar-offline:before,\r\n.avatar-xs.avatar-online:before {\r\n\tborder-width: 1px;\r\n}\r\n.avatar-sm {\r\n\twidth: 2.5rem;\r\n\theight: 2.5rem;\r\n}\r\n.avatar-sm .border {\r\n\tborder-width: 3px !important;\r\n}\r\n.avatar-sm .rounded {\r\n\tborder-radius: 4px !important;\r\n}\r\n.avatar-sm .avatar-title {\r\n\tfont-size: 15px;\r\n}\r\n.avatar-sm.avatar-away:before,\r\n.avatar-sm.avatar-offline:before,\r\n.avatar-sm.avatar-online:before {\r\n\tborder-width: 2px;\r\n}\r\n.avatar-lg {\r\n\twidth: 3.75rem;\r\n\theight: 3.75rem;\r\n}\r\n.avatar-lg .border {\r\n\tborder-width: 3px !important;\r\n}\r\n.avatar-lg .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n.avatar-lg .avatar-title {\r\n\tfont-size: 24px;\r\n}\r\n.avatar-lg.avatar-away:before,\r\n.avatar-lg.avatar-offline:before,\r\n.avatar-lg.avatar-online:before {\r\n\tborder-width: 3px;\r\n}\r\n.avatar-xl {\r\n\twidth: 5rem;\r\n\theight: 5rem;\r\n}\r\n.avatar-xl .border {\r\n\tborder-width: 4px !important;\r\n}\r\n.avatar-xl .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n.avatar-xl .avatar-title {\r\n\tfont-size: 28px;\r\n}\r\n.avatar-xl.avatar-away:before,\r\n.avatar-xl.avatar-offline:before,\r\n.avatar-xl.avatar-online:before {\r\n\tborder-width: 4px;\r\n}\r\n.avatar-xxl {\r\n\twidth: 5.125rem;\r\n\theight: 5.125rem;\r\n}\r\n.avatar-xxl .border {\r\n\tborder-width: 6px !important;\r\n}\r\n.avatar-xxl .rounded {\r\n\tborder-radius: 8px !important;\r\n}\r\n.avatar-xxl .avatar-title {\r\n\tfont-size: 30px;\r\n}\r\n.avatar-xxl.avatar-away:before,\r\n.avatar-xxl.avatar-offline:before,\r\n.avatar-xxl.avatar-online:before {\r\n\tborder-width: 4px;\r\n}\r\n.avatar-group {\r\n\tdisplay: inline-flex;\r\n}\r\n.avatar-group .avatar + .avatar {\r\n\tmargin-left: -.75rem;\r\n}\r\n.avatar-group .avatar-xs + .avatar-xs {\r\n\tmargin-left: -.40625rem;\r\n}\r\n.avatar-group .avatar-sm+.avatar-sm {\r\n\tmargin-left: -.625rem;\r\n}\r\n.avatar-group .avatar-lg + .avatar-lg {\r\n\tmargin-left: -1rem;\r\n}\r\n.avatar-group .avatar-xl + .avatar-xl {\r\n\tmargin-left: -1.28125rem;\r\n}\r\n.avatar-group .avatar:hover {\r\n\tz-index: 1;\r\n}\r\n.alert {\r\n    position: relative;\r\n    padding: 0.75rem 1.25rem;\r\n    margin-bottom: 1rem;\r\n    border: 1px solid transparent;\r\n    border-radius: 0.25rem;\r\n}\r\n.alert-dismissible .close {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    z-index: 2;\r\n    padding: 0.75rem 1.25rem;\r\n    color: inherit;\r\n    border: none;\r\n    background: transparent;\r\n}\r\n\r\n/*-----------------\r\n\t8. Header\r\n-----------------------*/\r\n\r\n.header {\r\n\tbackground: #000;\r\n\tleft: 0;\r\n\tposition: fixed;\r\n\tright: 0;\r\n\ttop: 0;\r\n\tz-index: 11;\r\n\theight:100px;\r\n}\r\n.header .header-left {\r\n\tfloat: left;\r\n    height: 100px;\r\n    position: relative;\r\n    width: 170px;\r\n    z-index: 1;\r\n    transition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n\tmargin-left: 20px;\r\n\tmargin-right: 60px;\r\n}\r\n.header .header-left .logo {\r\n\tdisplay: inline-block;\r\n}\r\n.header .header-left .logo img {\r\n\tmax-height: 60px;\r\n\twidth: auto;\r\n}\r\n.header-left .logo.logo-small {\r\n\tdisplay: none;\r\n}\r\n.header .dropdown-menu > li > a {\r\n\tposition: relative;\r\n}\r\n.header .has-arrow .dropdown-toggle:after {\r\n\tborder-top: 0;\r\n\tborder-left: 0;\r\n\tborder-bottom: 2px solid #FFF;\r\n\tborder-right: 2px solid #FFF;\r\n\tcontent: '';\r\n\theight: 8px;\r\n\tdisplay: inline-block;\r\n\tpointer-events: none;\r\n\t-webkit-transform-origin: 66% 66%;\r\n\t-transform-origin: 66% 66%;\r\n\ttransform-origin: 66% 66%;\r\n\t-webkit-transform: rotate(45deg);\r\n\t-transform: rotate(45deg);\r\n\ttransform: rotate(45deg);\r\n\t-webkit-transition: all 0.15s ease-in-out;\r\n\ttransition: all 0.15s ease-in-out;\r\n\twidth: 8px;\r\n\tvertical-align: 2px;\r\n}\r\n.header .has-arrow .dropdown-toggle[aria-expanded=\"true\"]:after {\r\n\t-webkit-transform: rotate(-135deg);\r\n\t-transform: rotate(-135deg);\r\n\ttransform: rotate(-135deg);\r\n}\r\n.header .has-arrow .dropdown-toggle:hover {\r\n\tcolor: #FFF;\r\n}\r\n.user-menu {\r\n\tfloat: right;\r\n\tmargin: 0;\r\n\tposition: relative;\r\n\theight: 100px;\r\n\tz-index: 99;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tpadding-right: 20px;\r\n}\r\n.user-menu.nav > li > a:hover i,\r\n.user-menu.nav > li > a:focus i {\r\n\topacity: .8;\r\n}\r\n.user-img {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 3px;\r\n\tposition: relative;\r\n}\r\n.user-img img {\r\n\twidth: 32px;\r\n    border-radius: 50%;\r\n}\r\n.dropdown-item img {\r\n\tmargin-right: 5px;\r\n}\r\n.user-menu.nav > li > a.mobile_btn {\r\n\tborder: 0;\r\n\tposition: relative;\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tcursor: pointer\r\n}\r\n.user-menu .dropdown-menu {\r\n\tmin-width: 200px;\r\n\tpadding: 0;\r\n}\r\n.user-menu .dropdown-menu .dropdown-item {\r\n\tfont-size: 14px;\r\n\tcolor: #000;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tpadding: 10px 15px;\r\n}\r\n.user-menu .dropdown-menu .dropdown-item:hover {\r\n\tpadding-left: 20px;\r\n\tcolor: #3FA2DB;\r\n\tbackground-color: transparent;\r\n}\r\n.user-menu li {\r\n\tmargin-right: 30px;\r\n\tposition: relative;\r\n}\r\n.user-menu li a {\r\n\tfont-size: 16px;\r\n\tcolor: #FFF;\r\n}\r\n.user-menu li a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.user-menu li a.active {\r\n\tborder-radius: 30px;\r\n\tcolor: #FFF;\r\n\tbackground: #3FA2DB;\r\n}\r\n.user-menu li a.active:hover {\r\n\tcolor: #FFF;\r\n}\r\n.user-menu li .btn {\r\n\tpadding: 5px 20px;\r\n\tcolor: #FFF;\r\n}\r\n.user-menu li .btn:hover {\r\n\tcolor: #CC0001;\r\n}\r\n.top-nav-search {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmax-width: 240px;\r\n}\r\n.top-nav-form {\r\n\tposition: relative;\r\n}\r\n.top-nav-search .form-control {\r\n\tpadding-left: 20px;\r\n\tcolor: #FFF;\r\n\tbackground: transparent;\r\n\tborder-bottom: 1px solid #CCCCCC;\r\n}\r\n.top-nav-search .form-control::placeholder {\r\n\tcolor: #CCCCCC;\r\n}\r\n.top-nav-search i {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n    transform: translateY(-50%);\r\n\tcolor: #898989;\r\n}\r\n.top-nav-search .btn {\r\n\tfont-size: 20px;\r\n\tborder: 1px solid #DDD;\r\n\tborder-radius: 30px;\r\n\tbackground: #FFF;\r\n\tcolor: #000;\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    transition: .4s;\r\n    -webkit-transition: .4s;\r\n\t-moz-transition: .4s;\r\n}\r\n.top-nav-search .btn:hover {\r\n\tbackground: #3FA2DB;\r\n\tcolor: #FFF;\r\n\tborder: 1px solid #3FA2DB;\r\n\ttransition: .4s;\r\n    -webkit-transition: .4s;\r\n\t-moz-transition: .4s;\r\n}\r\n.user-menu li a.header-profile {\r\n\tcolor: #FFFFFF;\r\n}\r\n.user-menu li a.header-profile:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.user-menu li a.header-bar {\r\n\tcolor: #FFFFFF;\r\n}\r\n.user-menu li a.header-bar:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.user-menu li a.header-bar span {\r\n    background: #FFF;\r\n    display: block;\r\n    height: 1.5px;\r\n    margin-bottom: 7px;\r\n    width: 34px;\r\n}\r\n.user-menu li a.header-bar span:nth-child(3) {\r\n\tmargin-bottom: 0;\r\n}\r\n.header .dropdown-menu > li > a:focus,\r\n.header .dropdown-menu > li > a:hover {\r\n\tbackground-color: #7638ff;\r\n\tcolor: #fff;\r\n}\r\n.header .dropdown-menu > li > a:focus i,\r\n.header .dropdown-menu > li > a:hover i {\r\n\tcolor: #fff;\r\n}\r\n.header .dropdown-menu > li > a {\r\n\tpadding: 10px 18px;\r\n}\r\n.header .dropdown-menu > li > a i {\r\n\tcolor: #7638ff;\r\n\tmargin-right: 10px;\r\n\ttext-align: center;\r\n\twidth: 18px;\r\n}\r\n.header .user-menu .dropdown-menu > li > a i {\r\n\tcolor: #7638ff;\r\n\tfont-size: 16px;\r\n\tmargin-right: 10px;\r\n\tmin-width: 18px;\r\n\ttext-align: center;\r\n}\r\n.header .user-menu .dropdown-menu > li > a:focus i,\r\n.header .user-menu .dropdown-menu > li > a:hover i {\r\n\tcolor: #fff;\r\n}\r\n.mobile_btn {\r\n\tdisplay: none;\r\n\tfloat: left;\r\n}\r\n.bar-icon {\r\n    display: inline-block;\r\n    width: 24px;\r\n}\r\n.bar-icon span {\r\n    background-color: #FFF;\r\n    display: block;\r\n    float: left;\r\n    height: 2px;\r\n    margin-bottom: 6px;\r\n    width: 31px;\r\n    transition: all 0.5s;\r\n}\r\n.bar-icon span:nth-child(2) {\r\n\twidth: 16px;\r\n}\r\n.bar-icon span:nth-child(3) {\r\n\tmargin-bottom: 0;\r\n}\r\n.menu-opened .slide-nav .bar-icon span:first-child {\r\n    position: relative;\r\n    top: 9px;\r\n    transform: rotate(45deg);\r\n    -webkit-transform: rotate(45deg);\r\n    -ms-transform: rotate(45deg);\r\n}\r\n.menu-opened .slide-nav .bar-icon span:nth-child(2) {\r\n    display: none;\r\n}\r\n.menu-opened .slide-nav .bar-icon span:last-child {\r\n    transform: rotate(135deg);\r\n    -webkit-transform: rotate(135deg);\r\n    -ms-transform: rotate(135deg);\r\n}\r\n.slide-nav .sidebar {\r\n\tmargin-left: 0;\r\n}\r\n.menu-title {\r\n\tcolor: #a3a3a3;\r\n\tdisplay: block;\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 5px;\r\n\tpadding: 0 25px;\r\n}\r\n.sidebar-overlay {\r\n\tbackground-color: rgba(0, 0, 0, 0.6);\r\n\tdisplay: none;\r\n\theight: 100%;\r\n\tleft: 0;\r\n\tposition: fixed;\r\n\ttop: 100px;\r\n\twidth: 100%;\r\n\tz-index: 1;\r\n}\r\n.sidebar-overlay.opened {\r\n\tdisplay: block;\r\n}\r\n.slimScrollBar {\r\n\tbackground: transparent !important;\r\n}\r\nhtml.menu-opened {\r\n\toverflow: hidden;\r\n}\r\nhtml.menu-opened body {\r\n\toverflow: hidden;\r\n}\r\n.mobile-menu {\r\n\tdisplay: inline-block;\r\n\tposition: relative;\r\n\twidth: auto;\r\n\tpadding: 0;\r\n}\r\n.toggler {\r\n\tdisplay: none;\r\n}\r\n.mobile-search {\r\n\tdisplay: none;\r\n}\r\n#menuToggle {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tright: -30px;\r\n\ttransform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n\tdisplay: block;\r\n\tz-index: 1;\r\n\t-webkit-user-select: none;\r\n\t-moz-user-select: none;\r\n\t-ms-user-select: none;\r\n\tuser-select: none;\r\n}\r\n#menuToggle input {\r\n\tdisplay: block;\r\n\twidth: 40px;\r\n\theight: 36px;\r\n\tposition: absolute;\r\n\ttop: -7px;\r\n\tleft: -5px;\r\n\tcursor: pointer;\r\n\topacity: 0;\r\n\tz-index: 2;\r\n\t-webkit-touch-callout: none;\r\n}\r\n#menuToggle span {\r\n  display: block;\r\n  width: 36px;\r\n  height: 1.5px;\r\n  margin-bottom: 6px;\r\n  position: relative;\r\n  background: #FFF;\r\n  border-radius: 0;\r\n  z-index: 1;\r\n  transform-origin: 4px 0px;\r\n  transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0),\r\n  background 0.5s cubic-bezier(0.77,0.2,0.05,1.0),\r\n  opacity 0.55s ease;\r\n}\r\n#menuToggle span:first-child {\r\n\ttransform-origin: 0% 0%;\r\n}\r\n#menuToggle span:nth-last-child(2) {\r\n\ttransform-origin: 0% 100%;\r\n}\r\n#menuToggle input:checked ~ span {\r\n\twidth: 26px;\r\n\topacity: 1;\r\n\ttransform: rotate(45deg) translate(-3px, -3px);\r\n\tbackground: #232323;\r\n}\r\n#menuToggle input:checked ~ span:nth-last-child(3) {\r\n\twidth: 26px;\r\n\topacity: 0;\r\n\tmargin-bottom: 0;\r\n\ttransform: rotate(0deg) scale(0.2, 0.2);\r\n}\r\n#menuToggle input:checked ~ span:nth-last-child(2) {\r\n\twidth: 26px;\r\n\topacity: 1;\r\n\ttransform: rotate(-45deg) translate(-1px, 1px);\r\n}\r\n#menu {\r\n    position: absolute;\r\n    width: 250px;\r\n    margin: -46px 0 0;\r\n    padding: 60px 60px 0 50px;\r\n    right: -10px;\r\n    background: #FFF;\r\n    box-shadow: 0px 4px 10px -1px #00000040;\r\n    border-radius: 10px;\r\n    text-align: center;\r\n    list-style-type: none;\r\n    -webkit-font-smoothing: antialiased;\r\n    transform-origin: 0% 0%;\r\n    transform: translate(110%, 0);\r\n    transition: transform 0.5s cubic-bezier(0.77,0.2,0.05,1.0);\r\n}\r\n#menu li {\r\n\tpadding: 15px 0;\r\n\tmargin-right: 0;\r\n}\r\n#menu .version-nav-item {\r\n\tfont-size: 12px;\r\n\tfont-weight: 500;\r\n\tcolor: #AAAAAA;\r\n\tpadding: 30px 0 20px;\r\n}\r\n.user-menu li #menu a {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tcolor: #000;\r\n}\r\n.user-menu li #menu a:hover {\r\n\tcolor: #00568E;\r\n}\r\n.user-menu li #menu a.active {\r\n\tcolor: #00568E;\r\n}\r\n.user-menu li #menu a i {\r\n\tfont-size: 18px;\r\n\tmargin-right: 10px;\r\n}\r\n#menuToggle input:checked ~ ul {\r\n\ttransform: none;\r\n\topacity: 1;\r\n}\r\n.clinic-nav-item a {\r\n\tfont-size: 14px;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n.clinic-nav-item a p {\r\n\tfont-size: 13px;\r\n\tfont-weight: 300;\r\n\tcolor: #FFF;\r\n\tmargin-bottom: 0;\r\n}\r\n.clinic-nav-item a p:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.clinic-nav-item a span {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tdisplay: block;\r\n}\r\n.clinic-nav-item a img {\r\n\twidth: 60px;\r\n\tmin-width: 60px;\r\n\theight: 60px;\r\n\tborder-radius: 50px;\r\n\tmargin-left: 20px;\r\n\tobject-fit: cover;\r\n}\r\n.clinic-nav-item a .doctor-menu-img {\r\n\tbackground: #eaeaea;\r\n\tborder-radius: 6px;\r\n\tmargin-left: 0;\r\n\tmargin-right: 15px;\r\n}\r\n.user-menu li .notification-link {\r\n\tfont-size: 16px;\r\n\tcolor: #000;\r\n\twidth: 34px;\r\n\theight: 34px;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tbackground: #F2F2F2;\r\n\tborder-radius: 50%;\r\n}\r\n.user-menu li .notification-link .badge {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tfont-size: 10px;\r\n\tfont-weight: 400;\r\n\twidth: 15px;\r\n\tmin-width: 15px;\r\n\theight: 15px;\r\n\tpadding: 0;\r\n\tborder-radius: 50px;\r\n\ttop: -3px;\r\n\tright: 0;\r\n\tposition: absolute;\r\n\tanimation: pulse-animation 2s infinite;\r\n}\r\n.user-menu li .notification-link .badge-primary {\r\n\tbackground: #3FA2DB;\r\n\tcolor: #FFF;\r\n}\r\n@keyframes pulse-animation {\r\n  0% {\r\n    box-shadow: 0 0 0 0px rgba(63, 162, 219, 0.6);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 12px rgba(0, 0, 0, 0);\r\n  }\r\n}\r\n\r\n/*-----------------\r\n\t9. Sidebar\r\n-----------------------*/\r\n\r\n.sidebar {\r\n\tfloat: left;\r\n    bottom: 0;\r\n    left: 0;\r\n    margin-top: 0;\r\n    position: relative;\r\n    top: 0;\r\n    transition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n    width: auto;\r\n    z-index: 1001;\r\n    overflow-y: hidden;\r\n}\r\n.sidebar.opened {\r\n\ttransition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n}\r\n.slimScrollDiv {\r\n\theight: auto !important;\r\n}\r\n.sidebar-inner {\r\n\theight: auto !important;\r\n\ttransition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n} \r\n.sidebar-menu ul {\r\n\tfont-size: 15px;\r\n\tlist-style-type: none;\r\n\tmargin: 0;\r\n\tpadding: 15px 0 0;\r\n\tposition: relative;\r\n}\r\n.sidebar-menu li {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 20px;\r\n}\r\n.sidebar-menu li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.sidebar-menu li a {\r\n\tcolor: #FFF;\r\n    display: block;\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    height: auto;\r\n    padding: 0;\r\n}\r\n.sidebar-menu li.active > a {\r\n\tfont-weight: 600;\r\n\tcolor: #FFF;\r\n}\r\n.sidebar-menu li a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.sidebar-menu li a.active {\r\n\tcolor: #3FA2DB;\r\n}\r\n.menu-title {\r\n\tcolor: #9e9e9e;\r\n\tdisplay: flex;\r\n\tfont-size: 14px;\r\n\topacity: 1;\r\n\tpadding: 5px 15px;\r\n\twhite-space: nowrap;\r\n}\r\n.menu-title > i {\r\n\tfloat: right;\r\n\tline-height: 40px;\r\n}\r\n.sidebar-menu li.menu-title a {\r\n\tcolor: #ff9b44;\r\n\tdisplay: inline-block;\r\n\tmargin-left: auto;\r\n\tpadding: 0;\r\n}\r\n.sidebar-menu li.menu-title a.btn {\r\n\tcolor: #fff;\r\n\tdisplay: block;\r\n\tfloat: none;\r\n\tfont-size: 15px;\r\n\tmargin-bottom: 15px;\r\n\tpadding: 10px 15px;\r\n}\r\n.sidebar-menu ul ul a.active {\r\n    color: #000000;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a span {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    position: relative;\r\n    border-radius: 10px;\r\n\tbackground: rgba(46, 49, 146, 0.10);\r\n\twidth: 40px;\r\n\theight: 40px;\r\n\ttransition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a.active span {\r\n\tbackground: transparent;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a.active span:after {\r\n\tcontent: '';\r\n\tposition: absolute;\r\n\tright: -35px;\r\n\tborder-radius: 30px 0 0 30px;\r\n\tbackground: rgba(46, 49, 146, 0.10);\r\n\twidth: 80px;\r\n\theight: 40px;\r\n}\r\n.right-sidebar .sidebar-menu > ul > li > a.active span:after {\r\n\tright: 0;\r\n\tborder-radius: 0px 30px 30px 0px;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a.active span img {\r\n\tposition: relative;\r\n\tleft: 3px;\r\n}\r\n.right-sidebar .sidebar-menu > ul > li > a.active span img {\r\n\tposition: relative;\r\n\tleft: 0;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a span.chat-user {\r\n\tmargin-left: 0;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a span.badge {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\tfont-size: 12px;\r\n\tfont-weight: 400;\r\n\twidth: 15px;\r\n\tmin-width: 15px;\r\n\theight: 15px;\r\n\tpadding: 0;\r\n\tborder-radius: 50px;\r\n\ttop: 3px;\r\n\tright: 22px;\r\n\tposition: absolute;\r\n\tanimation: pulse-animation 2s infinite;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a.active span.badge:after {\r\n\tdisplay: none;\r\n}\r\n.sidebar .sidebar-menu > ul > li > a span.badge-primary {\r\n\tbackground: #3FA2DB;\r\n\tcolor: #FFF;\r\n}\r\n@keyframes pulse-animation {\r\n  0% {\r\n    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.6);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 0 12px rgba(0, 0, 0, 0);\r\n  }\r\n}\r\n.sidebar-menu ul ul a {\r\n\tdisplay: block;\r\n\tfont-size: 15px;\r\n\tpadding: 7px 10px 7px 45px;\r\n\tposition: relative;\r\n}\r\n.sidebar-menu ul ul a span {\r\n\tfloat: right;\r\n\tcolor: #FF9800;\r\n}\r\n.sidebar-menu ul ul {\r\n\tdisplay: none;\r\n}\r\n.sidebar-menu ul ul ul a {\r\n\tpadding-left: 65px;\r\n}\r\n.sidebar-menu ul ul ul ul a {\r\n\tpadding-left: 85px;\r\n}\r\n.sidebar-menu > ul > li {\r\n\tmargin-top: 40px;\r\n\tposition: relative;\r\n}\r\n.sidebar-menu > ul > li:last-child {\r\n\tmargin-bottom: 25px;\r\n}\r\n.sidebar-menu .menu-arrow {\r\n\t-webkit-transition: -webkit-transform 0.15s;\r\n\t-o-transition: -o-transform 0.15s;\r\n\ttransition: transform .15s;\r\n\tposition: absolute;\r\n\tright: 15px;\r\n\tdisplay: inline-block;\r\n    font-family: \"Font Awesome 5 Free\";\r\n    font-weight: 900;\r\n\ttext-rendering: auto;\r\n\tline-height: 40px;\r\n\tfont-size: 16px;\r\n\t-webkit-font-smoothing: antialiased;\r\n\t-moz-osx-font-smoothing: grayscale;\r\n\t-webkit-transform: translate(0, 0);\r\n\t-transform: translate(0, 0);\r\n\t-o-transform: translate(0, 0);\r\n\ttransform: translate(0, 0);\r\n\tline-height: 18px;\r\n\ttop: 11px;\r\n}\r\n.sidebar-menu .menu-arrow:before {\r\n\tcontent: \"\\f105\";\r\n}\r\n.sidebar-menu li a.subdrop .menu-arrow {\r\n\t-transform: rotate(90deg);\r\n\t-webkit-transform: rotate(90deg);\r\n\t-o-transform: rotate(90deg);\r\n\ttransform: rotate(90deg);\r\n}\r\n.sidebar-menu ul ul a .menu-arrow {\r\n\ttop: 10px;\r\n}\r\n.sidebar-menu > ul > li > a {\r\n\ttransition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n}\r\n.sidebar-menu > ul > li > a svg {\r\n    width: 18px;\r\n}\r\n.sidebar-menu ul li.menu-title a i {\r\n\tfont-size: 16px !important;\r\n\tmargin-right: 0;\r\n\ttext-align: right;\r\n\twidth: auto;\r\n}\r\n.sidebar-menu li a > .badge {\r\n\tcolor: #fff;\r\n}\r\n.sidebar.hide-sidebar,\r\n#toggle_btn.hide-togglebtn {\r\n\tmargin-left: -131px;\r\n}\r\n.page-wrapper.hide-pagewrapper {\r\n\tmargin-left: 0;\r\n}\r\n.toggle-right {\r\n\tdisplay: none;\r\n\tcursor: pointer;\r\n\tmargin-right: 40px;\r\n}\r\n.toggle-right .bar-icon span {\r\n\tbackground-color: #000;\r\n}\r\n.toggle-right .bar-icon {\r\n\tmargin-top: 11px;\r\n}\r\n.header-left.auto-width-logo {\r\n\twidth: auto;\r\n}\r\n.bottom-menu li a span {\r\n\tmargin: 10px auto 0;\r\n\tborder-radius: 50%;\r\n}\r\n.bottom-menu li a span img {\r\n\twidth: 40px;\r\n\tmin-width: 40px;\r\n\theight: 40px;\r\n\tborder-radius: 50%;\r\n}\r\n.sidebar .sidebar-menu ul li a span.bottom-menu-users {\r\n\tcolor: #FFF;\r\n\tbackground: #000;\r\n\tborder-radius: 50%;\r\n}\r\n.right-sidebar {\r\n\ttop: 100px;\r\n    right: 0;\r\n    left: inherit;\r\n    z-index: inherit;\r\n\tbox-shadow: 1px 2px 5px rgba(66, 133, 244, 0.30);\r\n}\r\n.right-sidebar .sidebar-menu ul {\r\n\tpadding: 0 0 30px;\r\n}\r\n.menu-profile {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\ttext-align: center;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\twidth: 80px;\r\n\theight: 100px;\r\n\tbackground: #FFF;\r\n\tbox-shadow: 1px 2px 5px rgba(66, 133, 244, 0.30);\r\n}\r\n.menu-profile img {\r\n\twidth: 55px;\r\n\tmin-width: 55px;\r\n\theight: 55px;\r\n\tborder-radius: 50px;\r\n}\r\n.menu-profile .dropdown-toggle {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n    font-size: 18px;\r\n    color: #000;\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    background: transparent;\r\n    border: 1px solid #000;\r\n}\r\n.menu-profile .dropdown-toggle::after {\r\n\tdisplay: none;\r\n}\r\n.menu-profile .badge {\r\n    background: #00D805;\r\n    display: inline-block;\r\n    width: 14px;\r\n    height: 14px;\r\n    position: absolute;\r\n    padding: 0;\r\n    top: 26px;\r\n    right: 12px;\r\n}\r\n.menu-profile .dropdown-menu {\r\n    min-width: 170px;\r\n    border-radius: 5px;\r\n    border: 1px solid #EFEFEF;\r\n    padding: 0;\r\n    margin-top: 30px !important;\r\n}\r\n.menu-profile .dropdown-menu .dropdown-item {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tfont-size: 15px;\r\n\tcolor: #000;\r\n\tpadding: 10px 15px;\r\n\tborder-bottom: 1px solid #EFEFEF;\r\n\tborder-radius: 0;\r\n\t-webkit-transition: all 0.4s;\r\n    -ms-transition: all 0.4s;\r\n    transition: all 0.4s;\r\n}\r\n.menu-profile .dropdown-menu .dropdown-item:first-child {\r\n    border-radius: 5px 5px 0 0;\r\n}\r\n.menu-profile .dropdown-menu .dropdown-item:last-child {\r\n    border-radius: 0 0 5px 5px;\r\n    border-bottom: 0;\r\n}\r\n.menu-profile .dropdown-menu .dropdown-item:hover {\r\n    color: #3FA2DB;\r\n    padding-left: 20px;\r\n    -webkit-transition: all 0.4s;\r\n    -ms-transition: all 0.4s;\r\n    transition: all 0.4s;\r\n}\r\n.menu-profile .dropdown-menu .dropdown-item i {\r\n\tfont-size: 18px;\r\n\tmargin-right: 10px;\r\n}\r\n.menu-profile .dropdown-menu .accordion-toggle:hover {\r\n\tpadding: 10px 15px;\r\n}\r\n.accordion-toggle .status-item-active {\r\n\twidth: 14px;\r\n\tmin-width: 14px;\r\n\theight: 14px;\r\n\tmargin-right: 10px;\r\n\tborder-radius: 50px;\r\n\tbackground: #00D805;\r\n\tdisplay: inline-block;\r\n}\r\n.menu-profile .dropdown-menu .accordion-toggle i {\r\n\tfont-size: 16px;\r\n\tmargin-right: 0;\r\n\tmargin-left: auto;\r\n}\r\n.menu-profile .dropdown-menu .status-collapse .dropdown-item {\r\n\tborder-bottom: 1px solid #EFEFEF;\r\n}\r\n.menu-profile .dropdown-menu .status-collapse .dropdown-item:hover {\r\n\tpadding: 10px 15px;\r\n}\r\n.status-collapse span {\r\n\twidth: 14px;\r\n\tmin-width: 14px;\r\n\theight: 14px;\r\n\tmargin-right: 10px;\r\n\tborder-radius: 50px;\r\n\tdisplay: inline-block;\r\n}\r\n.status-collapse .status-item-active {\r\n\tbackground: #00D805;\r\n}\r\n.status-collapse .status-item-inactive {\r\n\tbackground: #AAA;\r\n}\r\n.status-collapse .status-item-danger {\r\n\tbackground: #CC0001;\r\n}\r\n.right-sidebar li .menu-profile a {\r\n\tpadding: 0;\r\n\tposition: relative;\r\n}\r\n.right-sidebar .menu-profile .badge {\r\n    background: #00D805;\r\n    display: inline-block;\r\n    width: 14px;\r\n    height: 14px;\r\n    position: absolute;\r\n    padding: 0;\r\n    right: 0;\r\n}\r\n.right-sidebar .sidebar-menu .bottom-menu {\r\n\tpadding: 0 0 20px;\r\n}\r\n.right-sidebar .bottom-menu li {\r\n\tmargin: 0;\r\n}\r\n.bottom-menu-info {\r\n\tposition: relative;\r\n}\r\n.bottom-menu-info li a span img {\r\n\twidth: auto;\r\n\tmin-width: inherit;\r\n\theight: auto;\r\n\tborder-radius: 0;\r\n}\r\n.right-sidebar .sidebar-menu > .bottom-menu-info > li:first-child {\r\n\tmargin: 0;\r\n}\r\n.hideright-sidebar .right-sidebar {\r\n\tright: -200px;\r\n\tz-index: 1001;\r\n}\r\n.hideright-sidebar .page-wrapper {\r\n\tmargin-right: 0;\r\n}\r\n.sidebar-menu > ul > li > .sidebar-right-toggle {\r\n\tposition: fixed;\r\n\tfont-size: 18px;\r\n\tcolor: #000;\r\n\tbackground: #3FA2DB1A;\r\n\tborder-radius: 0 100px 100px 0;\r\n\twidth: 25px;\r\n\theight: 50px;\r\n\tbottom: 200px;\r\n\tright: 55px;\r\n\tpadding: 0;\r\n\ttransition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n}\r\n.sidebar-menu > ul > li > .sidebar-right-toggle:after {\r\n\tcontent: \"\\f054\";\r\n\tposition: absolute;\r\n\tleft: 5px;\r\n  \tfont-family: \"FontAwesome\";\r\n}\r\n.hideright-sidebar #sidebar-right-toggle {\r\n    right: 0;\r\n    border-radius: 100px 0 0 100px;\r\n    transition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n}\r\n.hideright-sidebar #sidebar-right-toggle:after {\r\n\tcontent: \"\\f053\";\r\n\tposition: absolute;\r\n\tright: 5px;\r\n  \tfont-family: \"FontAwesome\";\r\n}\r\n\r\n/*-----------------\r\n\t10. Content\r\n-----------------------*/\r\n\r\n.main-wrapper {\r\n\twidth: 100%;\r\n\theight: 100vh;\r\n\tmin-height: 100vh;\r\n}\r\n.page-wrapper {\r\n\tmargin-left: 0;\r\n\tmargin-right: 0;\r\n    padding-top: 110px;\r\n    position: relative;\r\n    transition: all 0.4s ease;\r\n    -webkit-transition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n}\r\n.account-wrapper {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n}\r\n.page-wrapper-info {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n}\r\n.page-wrapper > .content {\r\n\tpadding: 20px;\r\n}\r\n.page-header {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n    margin-bottom: 20px;\r\n}\r\n.page-header .breadcrumb {\r\n\tbackground-color: transparent;\r\n\tcolor: #6c757d;\r\n\tfont-size: 1rem;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 0;\r\n\tpadding: 0;\r\n}\r\n.page-header .breadcrumb a {\r\n\tcolor: #333;\r\n}\r\n.page-sub-title {\r\n\tfont-size: 16px;\r\n\tfont-weight: 700;\r\n\tcolor: #3FA2DB;\r\n\tmargin-bottom: 8px;\r\n}\r\n.page-title {\r\n\tfont-size: 22px;\r\n\tfont-weight: 700;\r\n\tcolor: #000000;\r\n\tmargin-bottom: 10px;\r\n}\r\n.page-btn {\r\n\tbackground: #ffffff;\r\n    border-radius: 10px;\r\n    font-weight: 900;\r\n    font-size: 30px;\r\n    line-height: 30px;\r\n}\r\n.page-btn::after {\r\n\tdisplay: none;\r\n}\r\n.page-list .nav {\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: flex-end;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: flex-end;\r\n}\r\n.page-list .nav li {\r\n\tmargin-right: 30px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.page-list .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.page-dropdown {\r\n\tposition: relative;\r\n}\r\n.page-dropdown .dropdown-toggle:hover {\r\n\tcolor: #000;\r\n}\r\n.page-dropdown .dropdown-toggle:after {\r\n\tborder-top: 0;\r\n    border-left: 0;\r\n    border-bottom: 2px solid #000;\r\n    border-right: 2px solid #000;\r\n    content: '';\r\n    height: 8px;\r\n    display: inline-block;\r\n    pointer-events: none;\r\n    -webkit-transform-origin: 66% 66%;\r\n    -transform-origin: 66% 66%;\r\n    transform-origin: 66% 66%;\r\n    -webkit-transform: rotate(45deg);\r\n    -transform: rotate(45deg);\r\n    transform: rotate(45deg);\r\n    -webkit-transition: all 0.15s ease-in-out;\r\n    transition: all 0.15s ease-in-out;\r\n    width: 8px;\r\n    vertical-align: 2px;\r\n}\r\n.page-dropdown .dropdown-toggle[aria-expanded=\"true\"]:after {\r\n    -webkit-transform: rotate(-135deg);\r\n    -transform: rotate(-135deg);\r\n    transform: rotate(-135deg);\r\n}\r\n.page-dropdown .dropdown-menu .dropdown-item {\r\n\tpadding: 5px 10px;\r\n\tborder: 0;\r\n}\r\n.page-dropdown .dropdown-menu .dropdown-item:hover {\r\n\tpadding-left: 15px;\r\n}\r\n.page-search {\r\n\tposition: relative;\r\n}\r\n.page-search .form-control {\r\n\tpadding-left: 26px;\r\n    color: #000;\r\n    background: transparent;\r\n    border: 0;\r\n    border-bottom: 1px solid #CCCCCC;\r\n}\r\n.page-search i {\r\n    position: absolute;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: #898989;\r\n}\r\n.page-header-btn .btn {\r\n\tpadding: 9px 20px;\r\n\tmin-width: 150px;\r\n}\r\n\r\n/*-----------------\r\n\t11. Login\r\n-----------------------*/\r\n\r\n.login-wrapper {\r\n\twidth: 100%;\r\n    height: 100vh;\r\n    overflow: hidden;\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -ms-flex-wrap: wrap;\r\n    flex-wrap: wrap;\r\n    background: #FFF;\r\n}\r\n.login-left {\r\n\tposition: relative;\r\n\tpadding: 60px 0 0 60px;\r\n\tbackground: #FFF;\r\n}\r\n.login-logo {\r\n\tpadding-bottom: 20px;\r\n}\r\n.login-content h1 {\r\n\tfont-size: 120px;\r\n\tfont-weight: 700;\r\n\tcolor: #3FA2DB;\r\n\tmargin-bottom: 0;\r\n}\r\n.login-content h5 {\r\n\tfont-size: 30px;\r\n\tfont-weight: 400;\r\n\tcolor: #898989;\r\n\tmargin-bottom: 30px;\r\n}\r\n.login-content-bottom {\r\n\tposition: absolute;\r\n\tbottom: 60px;\r\n}\r\n.login-content-bottom a {\r\n\tcolor: #898989;\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tmargin-bottom: 6px;\r\n}\r\n.login-content-bottom a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.login-content-bottom a:after {\r\n    content: \"\";\r\n    height: 2px;\r\n    width: 100%;\r\n    background: #3FA2DB;\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n    -webkit-transition: all 0.3s ease;\r\n    -ms-transition: all 0.3s ease;\r\n    transition: all 0.3s ease;\r\n    position: absolute;\r\n    bottom: -3px;\r\n    left: 0;\r\n}\r\n.login-content-bottom a:hover:after {\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n}\r\n.login-content-bottom p {\r\n\tcolor: #898989;\r\n\tmargin-bottom: 0;\r\n}\r\n.login-box {   \r\n    width: 630px;\r\n    height: 100vh;\r\n    background: #3FA2DB;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n}\r\n.login-box .login-right {\r\n\tposition: relative;\r\n\tz-index: 1;\r\n\tbackground: #FFF;\r\n\tborder-radius: 15px;\r\n    box-shadow: 0px 0px 10px -1px #00000040;\r\n    padding: 40px;\r\n    max-width: 380px;\r\n    margin-left: -180px;\r\n    margin-bottom: 40px;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n}\r\n.login-box .login-right .login-right-wrap {\r\n    max-width: 100%;\r\n    flex: 0 0 100%;\r\n}\r\n.login-shape-img {\r\n\tposition: absolute;\r\n\tbottom: 60px;\r\n\tmargin-left: -175px;\r\n}\r\n.login-header {\r\n\ttext-align: center;\r\n\tpadding-bottom: 60px;\r\n}\r\n.login-box .login-right h2 {\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #000;\r\n    text-transform: uppercase;\r\n    margin-bottom: 0;\r\n}\r\n.login-form .form-wrap-input {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n.login-form .form-wrap-input img {\r\n\tmargin-right: 15px;\r\n}\r\n.form-wrap-flex {\r\n\tdisplay: flex;\r\n    display: -webkit-flex;\r\n    align-items: center;\r\n    -webkit-align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n}\r\n.login-btn {\r\n\tmargin-top: 40px;\r\n\tmargin-bottom: 15px;\r\n\ttext-align: center;\r\n}\r\n.login-btn .btn {\r\n\tpadding: 10px 50px;\r\n}\r\n.login-otp {\r\n\ttext-align: center;\r\n\tmargin-bottom: 10px;\r\n}\r\n.login-otp.return-to-home {\r\n\tmargin-top: 10px;\r\n}\r\n.login-otp a {\r\n\tfont-weight: 500;\r\n\tcolor: #000;\r\n\tdisplay: inline-block;\r\n\tpadding-bottom: 5px;\r\n\tborder-bottom: 0.5px solid #C3C3C3;\r\n}\r\n.login-otp a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.login-forgot {\r\n\ttext-align: center;\r\n}\r\n.forgot-link {\r\n\tfont-size: 14px;\r\n\tposition: relative;\r\n\tcolor: #B71717;\r\n    display: inline-block;\r\n}\r\n.forgot-link:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.forgot-link:after {\r\n    content: \"\";\r\n    height: 1.5px;\r\n    width: 100%;\r\n    background: #3FA2DB;\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: -3px;\r\n    left: 0;\r\n}\r\n.forgot-link:hover:after {\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n}\r\n.register-body {\r\n\tbackground: url(../img/main-bg.jpg);\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: center;\r\n\tbackground-size: cover;\r\n\tbackground-attachment: fixed;\r\n}\r\n.register-logo {\r\n    position: absolute;\r\n    width: 100%;\r\n    left: 60px;\r\n    top: 60px;\r\n    padding: 0;\r\n    z-index: 1;\r\n}\r\n.register-logo-bg {\r\n\tposition: relative;\r\n\theight: auto;\r\n\tpadding: 30px 0;\r\n\tbackground: url(../img/main-bg.jpg);\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-position: center;\r\n\tbackground-size: cover;\r\n\tbackground-attachment: fixed;\r\n}\r\n.register-box {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: auto;\r\n\ttop: 0;\r\n\tbackground: transparent;\r\n    transform: translateY(0);\r\n    -webkit-transform: translateY(0);\r\n    -ms-transform: translateY(0);\r\n}\r\n.register-box .login-right {\r\n\tmax-width: 600px;\r\n\tmargin: 0 auto 0;\r\n\ttop: 0;\r\n    transform: translateY(0);\r\n    -webkit-transform: translateY(0);\r\n    -ms-transform: translateY(0);\r\n}\r\n.password-body {\r\n\tbackground: #3FA2DB;\r\n}\r\n.white-logo img {\r\n\twidth: 150px;\r\n\tfilter: invert(1) brightness(100);\r\n}\r\n.password-header {\r\n\ttext-align: center;\r\n\tpadding-bottom: 20px;\r\n}\r\n.login-box .login-right .password-header h2 {\r\n\tfont-size: 20px;\r\n\ttext-transform: capitalize;\r\n\tmargin-bottom: 30px;\r\n}\r\n.password-header img {\r\n\tmargin-bottom: 30px;\r\n}\r\n.password-header h5 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #333;\r\n\tmargin-bottom: 5px;\r\n}\r\n.password-header p {\r\n\tcolor: #919191;\r\n\tmax-width: 350px;\r\n\tmargin: 0 auto 0;\r\n}\r\n.otp-box {\r\n\ttext-align: center;\r\n}\r\n.otp-box input {\r\n    width: 35px;\r\n    height: 35px;\r\n    background: #E6E6E6;\r\n    border: 1px solid #E6E6E6;\r\n    border-radius: 0;\r\n    text-align: center;\r\n    margin-right: 20px;\r\n    font-weight: 600;\r\n    font-size: 16px;\r\n    color: #000;\r\n    outline: none;\r\n}\r\n.otp-box input:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.password-btn {\r\n\ttext-align: center;\r\n\tmargin-top: 30px;\r\n}\r\n.password-btn .btn {\r\n\tpadding: 10px 35px;\r\n}\r\n\r\n/*------------------\r\n  12. Modal\r\n--------------------*/\r\n\r\n.custom-modal .modal-content {\r\n\tbackground: #FFF;\r\n\tborder: 1px solid #EFEFEF;\r\n}\r\n.custom-modal .modal-header {\r\n\tpadding: 15px;\r\n\tborder-bottom: 1px solid #EFEFEF;\r\n\tjustify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n}\r\n.custom-modal .modal-header .modal-title {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #3FA2DB;\r\n\tmargin-bottom: 0;\r\n}\r\n.custom-modal .close {\r\n\tcolor: #CC0001;\r\n\tbackground-color: #FFF;\r\n\tborder: 2px solid #CC0001;\r\n\tborder-radius: 50%;\r\n\tfont-size: 22px;\r\n\theight: 24px;\r\n\twidth: 24px;\r\n\tmargin: 0;\r\n\topacity: 1;\r\n\tpadding: 0;\r\n\tright: 10px;\r\n\tz-index: 99;\r\n\tdisplay: flex;\r\n\tdisplay: -webkit-flex;\r\n\talign-items: center;\r\n\t-webkit-align-items: center;\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\ttransition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n\t-o-transition: all 0.4s ease;\r\n\t-ms-transition: all 0.4s ease;\r\n\t-webkit-transition: all 0.4s ease;\r\n}\r\n.custom-modal .close:hover {\r\n\tcolor: #FFF;\r\n\tbackground-color: #CC0001;\r\n\tborder: 2px solid #CC0001;\r\n\ttransition: all 0.4s ease;\r\n\t-moz-transition: all 0.4s ease;\r\n\t-o-transition: all 0.4s ease;\r\n\t-ms-transition: all 0.4s ease;\r\n\t-webkit-transition: all 0.4s ease;\r\n\t-webkit-transform: rotateZ(360deg);\r\n\t-moz-transform: rotateZ(360deg);\r\n\ttransform: rotateZ(360deg);\r\n}\r\n.custom-modal .close span {\r\n \tline-height: 0;\r\n}\r\n.custom-modal .modal-body {\r\n  \tpadding: 15px;\r\n}\r\n.modal-form .form-group {\r\n  \tmargin-bottom: 15px;\r\n}\r\n.modal-form .form-group label {\r\n\tfont-size: 14px;\r\n  \tmargin-bottom: 6px;\r\n}\r\n.modal-form .form-group .form-control {\r\n\tfont-size: 14px;\r\n\tcolor: #000;\r\n\tbackground: #FFFFFF;\r\n\tborder: 1px solid #EFEFEF;\r\n\tpadding: 10px 10px;\r\n\theight: 30px;\r\n}\r\n.modal-form .form-group .form-control::placeholder {\r\n\tfont-size: 14px;\r\n\tcolor: #AAA;\r\n}\r\n.modal-form .form-group textarea.form-control {\r\n\theight: 120px;\r\n\tresize: none;\r\n}\r\n.modal-form-btn .btn {\r\n\tfont-size: 15px;\r\n\tpadding: 7px 26px;\r\n\tmargin-right: 15px;\r\n}\r\n.modal-form-btn .btn:last-child {\r\n  \tmargin-right: 0;\r\n}\r\n.modal-text {\r\n\ttext-align: center;\r\n}\r\n.modal-text span {\r\n\tfont-size: 26px;\r\n\tbackground: #FFEEEC;\r\n\tcolor: #CC0001;\r\n\twidth: 60px;\r\n\theight: 60px;\r\n\tborder-radius: 50%;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tmargin: 0 auto 15px;\r\n\tposition: relative;\r\n}\r\n.modal-text h5 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n\tmargin-bottom: 10px;\r\n}\r\n.modal-text p {\r\n\tfont-size: 15px;\r\n\tmax-width: 260px;\r\n    margin: 0 auto 0;\r\n}\r\n.re-associate-content {\r\n\tpadding: 20px;\r\n\ttext-align: center;\r\n}\r\n.re-associate-text img {\r\n    margin: 0 auto 20px;\r\n    display: block;\r\n}\r\n.re-associate-text p {\r\n    font-size: 16px;\r\n    font-weight: 500;\r\n    margin-bottom: 30px;\r\n}\r\n.re-associate-content .btn {\r\n\tfont-size: 16px;\r\n\tpadding: 10px 20px;\r\n\tmin-width: 140px;\r\n}\r\n.modal.right .modal-dialog {\r\n\tposition: fixed;\r\n\tmargin: auto;\r\n\twidth: 320px;\r\n\theight: 100%;\r\n\t-webkit-transform: translate3d(0%, 0, 0);\r\n\t-ms-transform: translate3d(0%, 0, 0);\r\n\t-o-transform: translate3d(0%, 0, 0);\r\n\ttransform: translate3d(0%, 0, 0);\r\n}\r\n.modal.right.fade .modal-dialog {\r\n\tright: -320px;\r\n\t-webkit-transition: opacity 0.3s linear, right 0.3s ease-out;\r\n\t-moz-transition: opacity 0.3s linear, right 0.3s ease-out;\r\n\t-o-transition: opacity 0.3s linear, right 0.3s ease-out;\r\n\ttransition: opacity 0.3s linear, right 0.3s ease-out;\r\n}\r\n.modal.right.fade.show .modal-dialog {\r\n\tright: 0;\r\n}\r\n.schedule-modal-header {\r\n\tpadding: 40px 0 0;\r\n\ttext-align: center;\r\n}\r\n.schedule-modal-header h4 {\r\n\tfont-size: 20px;\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 0;\r\n}\r\n.schedule-modal-form {\r\n\tpadding: 15px;\r\n}\r\n.schedule-modal-form .form-wrap {\r\n\tmargin-bottom: 10px;\r\n}\r\n.schedule-modal-form .form-control {\r\n\tpadding: 10px 15px;\r\n\tbackground: #F6F6F6;\r\n\tborder: 1px solid #F6F6F6;\r\n}\r\n.schedule-modal-form .form-control::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.schedule-modal-form textarea.form-control {\r\n\tmin-height: 150px;\r\n}\r\n.schedule-modal-form .select2-container .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #898989;\r\n\tpadding-left: 15px;\r\n}\r\n.schedule-modal-form .select2-container .select2-selection--single {\r\n\tborder: 1px solid #F6F6F6;\r\n\tborder-bottom: 1px solid #F6F6F6;\r\n\tbackground: #F6F6F6;\r\n}\r\n.schedule-modal-form .textarea-text {\r\n\tfont-size: 14px;\r\n\tcolor: #898989;\r\n\ttext-align: right;\r\n\tmargin-top: 10px;\r\n\tmargin-bottom: 0;\r\n}\r\n.schedule-modal-form .modal-form-btn {\r\n\ttext-align: center;\r\n\tpadding-top: 10px;\r\n\tpadding-bottom: 10px;\r\n}\r\n.schedule-success {\r\n\tpadding: 40px;\r\n\ttext-align: center;\r\n}\r\n.schedule-success i {\r\n\tfont-size: 60px;\r\n\tcolor: #3FA2DB;\r\n\tmargin: 0 auto 30px;\r\n\tdisplay: block;\r\n}\r\n.schedule-success h4 {\r\n\tfont-size: 30px;\r\n\tmax-width: 500px;\r\n\tmargin: 0 auto 0;\r\n}\r\n.schedule-modal-form .custom-radio {\r\n\tpadding: 20px 0 15px;\r\n}\r\n.schedule-modal-form .custom_radio {\r\n\tfont-weight: 500;\r\n\tpadding-left: 36px;\r\n\tmargin-right: 24px;\r\n\tmargin-bottom: 15px;\r\n}\r\n.schedule-modal-form .custom_radio .checkmark {\r\n\tbackground: #898989;\r\n\tborder: 1px solid #898989;\r\n}\r\n.medical-modal-header {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    padding: 30px;\r\n}\r\n.medical-modal-header h4 {\r\n\tfont-size: 24px;\r\n\tcolor: #00568E;\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-modal-header {\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n}\r\n.prescription-modal-header h5 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n\tmargin-bottom: 0;\r\n\ttext-align: center;\r\n}\r\n.medical-modal-header .close {\r\n\tposition: absolute;\r\n    top: -15px;\r\n    right: -15px;\r\n    width: 34px;\r\n    height: 34px;\r\n    color: #636363;\r\n    background: #FFF;\r\n    border: 1px solid #636363;\r\n}\r\n.medical-modal-header .close:hover {\r\n\tcolor: #FFF;\r\n    background: #00568E;\r\n    border: 1px solid #00568E;\r\n}\r\n.custom-modal .medical-modal-body {\r\n\tpadding: 0 30px 10px;\r\n}\r\n.medical-history-card {\r\n\tborder: 1px solid #00568E;\r\n\tbox-shadow: none;\r\n}\r\n.medical-history-card .card-body {\r\n\tpadding: 0;\r\n\tpadding-bottom: 15px;\r\n}\r\n.medical-history-card.diagram-card .card-body {\r\n\tpadding-bottom: 15px;\r\n}\r\n.past-medical-info {\r\n\tpadding: 20px 30px 0;\r\n\tmargin-bottom: 15px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.medical-history-card .past-surgeries .nav li {\r\n\tmargin-bottom: 15px;\r\n}\r\n.medical-history-card .past-surgeries-left {\r\n\tpadding-left: 40px;\r\n}\r\n.past-surgeries .form-control {\r\n\twidth: 100%;\r\n\tmax-width: 250px;\r\n}\r\n.past-surgeries .form-control::placeholder {\r\n\tcolor: #5B5B5B;\r\n}\r\n.patient-radio-btn .custom_radio {\r\n    padding-left: 30px;\r\n    margin-right: 24px;\r\n    line-height: normal;\r\n}\r\n.patient-radio-btn .custom_radio input:checked ~ .checkmark:after {\r\n\topacity: 1\r\n}\r\n.patient-radio-btn .custom_radio b {\r\n\tfont-weight: 400;\r\n\tcolor: #898989;\r\n}\r\n.patient-radio-btn .custom_radio input:checked ~ b {\r\n\tcolor: #000;\r\n}\r\n.patient-radio-btn .custom_radio .checkmark {\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 20px;\r\n\twidth: 20px;\r\n\tbackground-color: #fff;\r\n\tborder: 1px solid #3FA2DB;\r\n\tborder-radius: 50%;\r\n}\r\n.patient-radio-btn .custom_radio .checkmark:after {\r\n\tdisplay: block;\r\n\tcontent: \"\";\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\ttop: 4px;\r\n\tleft: 4px;\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tborder-radius: 50%;\r\n\tbackground: #3FA2DB;\r\n\tborder: 1px solid #3FA2DB;\r\n\t-moz-transition: all 0.3s ease-in-out;\r\n\t-o-transition: all 0.3s ease-in-out;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-ms-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n}\r\n.past-medical-btn {\r\n\tpadding: 20px 0 10px;\r\n\ttext-align: center;\r\n}\r\n.past-medical-btn .btn {\r\n\tpadding: 7px 30px;\r\n}\r\n.custom-modal .drug-modal-body {\r\n\tpadding: 30px;\r\n}\r\n.drug-form-wrap {\r\n\tposition: relative;\r\n}\r\n.drug-form-wrap .drug-select {\r\n\tmargin-left: auto;\r\n\twidth: 90px;\r\n}\r\n.drug-form-wrap .select2-container .select2-selection--single {\r\n\tborder: 0;\r\n}\r\n.drug-btn {\r\n\tmargin-top: 16px;\r\n\ttext-align: center;\r\n}\r\n.drug-btn .btn {\r\n\tmin-width: 150px;\r\n}\r\n.custom-modal .prescription-modal-body {\r\n\tpadding: 0;\r\n}\r\n.prescription-grid {\r\n\tpadding: 30px;\r\n\tborder-bottom: 1px solid #00000038;\r\n}\r\n.prescription-btn {\r\n\tpadding: 20px 20px 0;\r\n\ttext-align: center;\r\n}\r\n.prescription-btn .btn {\r\n\tpadding: 10px 40px;\r\n}\r\n.create-modal-header {\r\n\tjustify-content: center;\r\n\t-webkit-justify-content: center;\r\n\t-ms-flex-pack: center;\r\n}\r\n.create-modal-header h4 {\r\n\tcolor: #000;\r\n}\r\n.custom-modal .modal-create-form {\r\n\tmax-width: inherit;\r\n}\r\n.custom-modal .profile-modal-content {\r\n\tmax-width: 480px;\r\n\tmargin: auto;\r\n}\r\n.custom-modal .profile-modal-body {\r\n\tpadding: 30px;\r\n}\r\n.profile-modal-title {\r\n\ttext-align: center;\r\n\tmargin-bottom: 24px;\r\n}\r\n.profile-modal-title h4 {\r\n\tfont-size: 20px;\r\n\tmargin-bottom: 0;\r\n}\r\n.profile-modal-img {\r\n\ttext-align: center;\r\n    width: 175px;\r\n    border-radius: 15px;\r\n    margin: 0 auto 24px;\r\n}\r\n.profile-modal-img img {\r\n\twidth: 100%;\r\n\theight: 180px;\r\n    border-radius: 15px;\r\n}\r\n.profile-modal-img .file-upload {\r\n\tfont-size: 14px;\r\n    color: #3FA2DB;\r\n    position: relative;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n    margin-top: 10px;\r\n    margin-bottom: 0;\r\n}\r\n.profile-modal-img .file-upload:hover {\r\n\tcolor: #00568E;\r\n}\r\n.profile-modal-img .file-upload:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #3FA2DB;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 3px;\r\n    left: 0;\r\n}\r\n.profile-modal-img .file-upload:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.profile-modal-img .file-upload input[type=file] {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    min-width: 100%;\r\n    min-height: 100%;\r\n    font-size: 100px;\r\n    text-align: right;\r\n    filter: alpha(opacity = 0);\r\n    opacity: 0;\r\n    outline: none;\r\n    background: #fff;\r\n    cursor: inherit;\r\n    display: block;\r\n}\r\n.profile-modal-form {\r\n\tpadding: 0 30px;\r\n}\r\n.profile-modal-form label {\r\n\tcolor: #707070;\r\n}\r\n.profile-modal-input {\r\n\tmargin-bottom: 5px;\r\n}\r\n.profile-modal-btn {\r\n\tpadding-top: 24px;\r\n\ttext-align: center;\r\n}\r\n.profile-modal-btn .btn {\r\n\tpadding: 5px 24px;\r\n}\r\n.custom-modal .doctor-slot-modal-content {\r\n\tmax-width: 980px;\r\n\tmargin: auto;\r\n}\r\n.custom-modal .doctor-slot-body {\r\n\tpadding: 40px;\r\n}\r\n.doctor-slot-header {\r\n\tpadding-bottom: 40px;\r\n}\r\n.doctor-slot-header h4 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 0;\r\n}\r\n.doctor-slot-input {\r\n\tpadding-left: 30px;\r\n}\r\n.doctor-slot-input .form-wrap {\r\n\tmargin-bottom: 30px;\r\n}\r\n.doctor-slot-input label {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #393939;\r\n\tmargin-bottom: 8px;\r\n}\r\n.doctor-slot-date {\r\n\tposition: relative;\r\n}\r\n.form-wrap-date {\r\n  \tposition: relative;\r\n}\r\n.form-wrap-date .scheduled-slot-datepicker input {\r\n  \tfont-size: 14px;\r\n}\r\n.doctor-slot-date .form-control {\r\n\tfont-size: 14px;\r\n\tpadding: 10px 15px;\r\n\theight: 36px;\r\n\tborder-radius: 7px;\r\n\tborder: 1px solid #3FA2DB;\r\n}\r\n.doctor-slot-date .form-control::placeholder {\r\n\tcolor: #C0C0C0;\r\n}\r\n.doctor-slot-date .doctor-slot-icon {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n\tright: 0;\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\tborder-radius: 7px;\r\n\tbackground: #3FA2DB;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n}\r\n.doctor-slot-date b {\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\ttransform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n\tright: 0;\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\tborder-radius: 7px;\r\n\tbackground: #3FA2DB;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n}\r\n.select-days h6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #393939;\r\n\tmargin-bottom: 10px;\r\n}\r\n.select-days .nav {\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n}\r\n.select-days .nav li {\r\n\tmargin-right: 20px;\r\n}\r\n.select-days .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.select-days label {\r\n\tfont-weight: 300;\r\n}\r\n.custom_check {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tcolor: #000;\r\n\tposition: relative;\r\n\tpadding-left: 30px;\r\n\tmargin-bottom: 10px;\r\n\tcursor: pointer;\r\n}\r\n.custom_check input {\r\n\tposition: absolute;\r\n\topacity: 0;\r\n\tcursor: pointer;\r\n}\r\n.custom_check input:checked ~ .checkmark {\r\n\tbackground-color: #D9D9D9;\r\n}\r\n.custom_check input:checked ~ .checkmark:after {\r\n\tdisplay: block;\r\n}\r\n.custom_check .checkmark {\r\n\theight: 22px;\r\n\twidth: 22px;\r\n\tborder: 1px solid #D9D9D9;\r\n\tbackground-color: #D9D9D9;\r\n\tborder-radius: 30px;\r\n\t-webkit-transition: all 0.3s ease-in-out;\r\n\t-ms-transition: all 0.3s ease-in-out;\r\n\ttransition: all 0.3s ease-in-out;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 0;\r\n}\r\n.custom_check .checkmark::after {\r\n\tcontent: \"\\f00c\";\r\n\tfont-family: \"Font Awesome 5 Free\";\r\n\tfont-weight: 900;\r\n\tdisplay: none;\r\n\tcolor: #0de0fe;\r\n\tfont-size: 12px;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tleft: 4px;\r\n}\r\n.custom_check .checkmark::after {\r\n\tcontent: \"\";\r\n\tbackground: #3FA2DB;\r\n\twidth: 12px;\r\n\theight: 12px;\r\n\ttop: 4px;\r\n\tleft: 4px;\r\n\tborder-radius: 30px;\r\n}\r\n.form-flex-wrap {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n}\r\n.form-flex-wrap .doctor-slot-date {\r\n\tmargin-bottom: 8px;\r\n}\r\n.form-flex-wrap label {\r\n\tmargin-right: 10px;\r\n}\r\n.form-flex-wrap .doctor-slot-date .form-control {\r\n\twidth: 100px;\r\n}\r\n.form-flex-wrap .doctor-slot-date .form-control::placeholder {\r\n\tcolor: #3FA2DB;\r\n}\r\n.form-flex-wrap .doctor-slot-date .p-calendar {\r\n  width: 100px;\r\n}\r\n.form-flex-wrap .doctor-slot-date .p-calendar input {\r\n  font-size: 14px;\r\n  color: #3fa2db;\r\n  height: 36px;\r\n}\r\n.form-flex-wrap .doctor-slot-date .p-calendar input::placeholder {\r\n  color: #3fa2db;\r\n}\r\n.doctor-slot-date small {\r\n  display: block;\r\n}\r\n.doctor-slot-btn .btn {\r\n\tpadding: 10px 40px;\r\n\tmargin-right: 15px;\r\n}\r\n.doctor-slot-btn .btn:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.prescription-head {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: flex-start;\r\n    -ms-flex-align: flex-start;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-bottom: 20px;\r\n\tborder-bottom: 1px solid #00000038;\r\n}\r\n.prescription-head-list {\r\n\tmargin-bottom: 6px;\r\n}\r\n.prescription-head-list p {\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 4px;\r\n}\r\n.prescription-logo {\r\n\tmargin-bottom: 10px;\r\n}\r\n.prescription-logo img {\r\n\tmax-height: 80px;\r\n    width: auto;\r\n}\r\n.prescription-title {\r\n\tmargin-bottom: 15px;\r\n}\r\n.prescription-title h4 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 0;\r\n\tdisplay: inline-block;\r\n\tborder-bottom: 1px solid #000;\r\n}\r\n.prescription-details-info {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: flex-start;\r\n    -ms-flex-align: flex-start;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n}\r\n.prescription-info {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: flex-start;\r\n    -ms-flex-align: flex-start;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n}\r\n.prescription-details-info .prescription-info {\r\n\tdisplay: block;\r\n}\r\n.prescription-info ul {\r\n\tpadding: 0;\r\n\tmargin-left: 20px;\r\n\tmargin-bottom: 20px;\r\n\tlist-style: none;\r\n}\r\n.prescription-info ul li {\r\n\tfont-size: 14px;\r\n\tcolor: #000;\r\n\tmargin-bottom: 4px;\r\n}\r\n.prescription-info ul li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-info ul li span {\r\n\tfont-weight: 500;\r\n}\r\n.prescription-info .sub-prescription-list li {\r\n\tmargin-bottom: 10px;\r\n}\r\n.sub-prescription-list li p {\r\n\tmargin-left: 20px;\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-date {\r\n\tmargin-bottom: 20px;\r\n}\r\n.prescription-date p {\r\n\tfont-size: 14px;\r\n\tcolor: #000;\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-md {\r\n\tpadding-bottom: 20px;\r\n\tmargin-bottom: 20px;\r\n\tborder-bottom: 1px solid #00000038;\r\n}\r\n.prescription-md h6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-md p {\r\n\tfont-size: 14px;\r\n\tmargin-bottom: 0;\r\n}\r\n.prescription-bottom-content {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-bottom: 10px;\r\n}\r\n.prescription-bottom-text {\r\n\tmargin-bottom: 10px;\r\n}\r\n.prescription-bottom-text p {\r\n\tfont-size: 15px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 0;\r\n\tdisplay: inline-block;\r\n\t/* border-bottom: 1px solid #000; */\r\n}\r\n\r\n/*-----------------\r\n\t13. Welcome\r\n-----------------------*/\r\n\r\n.welcome-body {\r\n    background: url(../img/welcome-bg.jpg);\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    background-size: cover;\r\n    background-attachment: fixed;\r\n    overflow: hidden;\r\n}\r\n.welcome-wrapper {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tpadding-top: 0;\r\n\tpadding-bottom: 50px;\r\n}\r\n.welcome-wrapper .content {\r\n\tpadding-left: 80px;\r\n}\r\n.welcome-content {\r\n\tpadding: 40px 0 0 80px;\r\n}\r\n.welcome-logo {\r\n\twidth: 100%;\r\n}\r\n.welcome-text {\r\n\twidth: 100%;\r\n}\r\n.welcome-text h6 {\r\n\tfont-size: 70px;\r\n\tfont-weight: 300;\r\n\tcolor: #FFF;\r\n\tmargin-bottom: 0;\r\n}\r\n.welcome-text h1 {\r\n\tfont-size: 70px;\r\n\tfont-weight: 600;\r\n\tcolor: #FFF;\r\n\tmargin-bottom: 0;\r\n}\r\n.welcome-btn {\r\n\tpadding-top: 20px;\r\n}\r\n.welcome-btn .btn {\r\n\tfont-size: 18px;\r\n\tmin-width: 180px;\r\n\tmargin-right: 15px;\r\n}\r\n.welcome-btn .btn:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.welcome-btn .btn:hover {\r\n\tbackground: #FFF;\r\n}\r\n\r\n/*-----------------\r\n\t14. Dashboard\r\n-----------------------*/\r\n\r\n.dash-header {\r\n\tmargin-bottom: 24px;\r\n}\r\n.dash-header h4 {\r\n    font-size: 24px;\r\n    font-weight: 600;\r\n    color: #3FA2DB;\r\n    margin-bottom: 0;\r\n}\r\n.dash-progress {\r\n\tmargin-bottom: 24px;\r\n}\r\n.progress-info {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tline-height: 0;\r\n}\r\n.progress-info span {\r\n\tcolor: #B9B9B9;\r\n\tmargin-left: 10px;\r\n}\r\n.progress {\r\n\twidth: 100%;\r\n\theight: 5px;\r\n}\r\n.progress .progress-bar {\r\n    animation-name: animateBar;\r\n    animation-iteration-count: 1;\r\n    animation-timing-function: ease-in;\r\n    animation-duration: 1.5s;\r\n}\r\n@keyframes animateBar {\r\n    0% {transform: translateX(-100%);}\r\n    100% {transform: translateX(0);}\r\n}\r\n.dash-progress p {\r\n\tmargin-bottom: 0;\r\n}\r\n.dash-progress h6 {\r\n\tfont-size: 40px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 0;\r\n}\r\n.red-flag-list h6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 15px;\r\n}\r\n.red-flag-list .nav li {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n\tmargin-bottom: 10px;\r\n}\r\n.red-flag-list .nav li p {\r\n\ttext-decoration: underline;\r\n\tmargin-bottom: 0;\r\n}\r\n.red-flag-list .nav li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.red-flag-list .nav li span {\r\n\tdisplay: inline-block;\r\n\twidth: 7px;\r\n\tmin-width: 7px;\r\n\theight: 7px;\r\n\tmargin-right: 15px;\r\n\tbackground: #00568E;\r\n\tborder-radius: 50px;\r\n}\r\n.dashboard-link {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\ttext-align: center;\r\n\tpadding: 24px;\r\n}\r\n.dashboard-link a {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #000;\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n\t-ms-flex-direction: column;\r\n\tflex-direction: column;\r\n\ttext-align: center;\r\n\twidth: 230px;\r\n\tmin-width: 230px;\r\n\tpadding: 24px;\r\n\tborder-radius: 20px;\r\n\tbackground: #EAF5FB80;\r\n}\r\n.dashboard-link a img {\r\n\tmargin-bottom: 14px;\r\n\theight: 120px;\r\n}\r\n.dashboard-link a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n\r\n/*-----------------\r\n\t15. Create\r\n-----------------------*/\r\n\r\n.create-card {\r\n\tpadding: 30px;\r\n}\r\n.create-header {\r\n\ttext-align: center;\r\n}\r\n.create-header h4 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 30px;\r\n}\r\n.create-header img {\r\n\theight: 300px;\r\n}\r\n.create-form {\r\n\tmax-width: 400px;\r\n}\r\n.form-wrap-status {\r\n\tmargin-bottom: 30px;\r\n}\r\n.professional-wrap-status {\r\n\tmargin-top: 40px;\r\n}\r\n.form-wrap-status.professional-wrap-status h4 {\r\n\tmargin-bottom: 10px;\r\n}\r\n.form-wrap-status h4 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 20px;\r\n}\r\n.status-create-radio .custom_radio {\r\n    margin-right: 24px;\r\n    padding-left: 24px;\r\n}\r\n.status-create-radio .custom_radio .checkmark {\r\n\twidth: 14px;\r\n\theight: 14px;\r\n}\r\n.status-create-radio .custom_radio .checkmark:after {\r\n\twidth: 14px;\r\n\theight: 14px;\r\n}\r\n.form-wrap-btn .btn {\r\n\tmin-width: 150px;\r\n\tmargin-right: 20px;\r\n}\r\n.form-wrap-btn .btn:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.edit-inner-body {\r\n\tpadding: 40px;\r\n}\r\n.edit-icon-info {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: flex-end;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: flex-end;\r\n}\r\n.edit-icon-slot {\r\n\tmargin-right: 24px;\r\n}\r\n.edit-icon {\r\n\ttext-align: right;\r\n}\r\n.edit-icon a {\r\n\tfont-size: 26px;\r\n\tcolor: #3FA2DB;\r\n}\r\n.edit-icon a:hover {\r\n\tcolor: #F7D333;\r\n}\r\n.edit-inner-box {\r\n\tposition: relative;\r\n\tborder-right: 1px solid #E6E6E6;\r\n}\r\n.edit-header {\r\n\tpadding-bottom: 100px;\r\n}\r\n.edit-header h4 {\r\n\tfont-size: 30px;\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 10px;\r\n}\r\n.edit-header .nav {\r\n\tmargin-top: 5px;\r\n}\r\n.edit-header .nav li {\r\n\tfont-weight: 300;\r\n\tcolor: #898989;\r\n\tposition: relative;\r\n\tmargin-right: 25px;\r\n}\r\n.edit-header .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.edit-header .nav li::after {\r\n    content: \"|\";\r\n    position: relative;\r\n    left: 15px;\r\n}\r\n.edit-header .nav li:last-child::after {\r\n\tdisplay: none;\r\n}\r\n.edit-header .nav li p {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmargin-bottom: 0;\r\n}\r\n.edit-header .nav li p span {\r\n    width: 10px;\r\n    min-width: 10px;\r\n    height: 10px;\r\n    border-radius: 50px;\r\n    margin-right: 8px;\r\n    display: inline-block;\r\n    background: #3FA2DB;\r\n}\r\n.re-associate-nav {\r\n\tmargin-top: 15px;\r\n}\r\n.re-associate-nav li a {\r\n\tcolor: #3FA2DB;\r\n}\r\n.re-associate-nav li a:hover {\r\n\ttext-decoration: underline;\r\n}\r\n.associate-btn {\r\n\tpadding-top: 20px;\r\n}\r\n.associate-btn .btn {\r\n\tpadding: 6px 30px;\r\n}\r\n.edit-list {\r\n\tmargin-bottom: 20px;\r\n}\r\n.edit-list-info {\r\n\twidth: 100%;\r\n\tmax-width: 400px;\r\n}\r\n.edit-list ul li {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tmargin-bottom: 30px;\r\n}\r\n.edit-list ul li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.edit-list ul li img {\r\n\twidth: 36px;\r\n\theight: 36px;\r\n\tmargin-right: 20px;\r\n}\r\n.edit-list ul li p {\r\n\tword-break: break-word;\r\n\tmargin-bottom: 0;\r\n}\r\n.edit-list ul li .edit-form-control {\r\n\twidth: 100%;\r\n}\r\n.edit-list ul li .form-control {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.edit-details {\r\n\tpadding-left: 50px;\r\n}\r\n.edit-details-disable {\r\n\tcursor: not-allowed;\r\n}\r\n.edit-details-disable .edit-grid h5 {\r\n\tcolor: #B4B4B4;\r\n}\r\n.edit-grid {\r\n\tmargin-bottom: 20px;\r\n}\r\n.edit-grid h5 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 10px;\r\n}\r\n.edit-box {\r\n\tpadding: 0 10px;\r\n\tmargin-bottom: 14px;\r\n\tborder-radius: 12px;\r\n\theight: 170px;\r\n\toverflow: auto;\r\n\tbox-shadow: 0px 0px 10px -1px #00000040;\r\n}\r\n.edit-box::-webkit-scrollbar {\r\n\twidth: 5px;\r\n}\r\n.edit-box::-webkit-scrollbar-track {\r\n\tbox-shadow: inset 0 0 10px #D9D9D9; \r\n\tborder-radius: 5px;\r\n}\r\n.edit-box::-webkit-scrollbar-thumb {\r\n\tbackground: #AAA; \r\n\tborder-radius: 5px;\r\n}\r\n.edit-box::-webkit-scrollbar-thumb:hover {\r\n\tbackground: #AAA; \r\n}\r\n.edit-details-disable .edit-box .table tbody tr td {\r\n\tcolor: #B4B4B4;\r\n}\r\n.edit-associate-btn {\r\n\ttext-align: right;\r\n}\r\n.edit-associate-btn .btn {\r\n\tcolor: #000000;\r\n\tpadding: 5px 20px;\r\n}\r\n.edit-details-disable .edit-associate-btn .btn {\r\n\tcolor: #B4B4B4;\r\n\tbackground: #E6E6E6;\r\n\tborder: 1px solid #E6E6E6;\r\n\tcursor: not-allowed;\r\n}\r\n.edit-info .form-wrap label {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tmargin-bottom: 30px;\r\n}\r\n.edit-info .form-wrap label:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.edit-info .form-wrap label img {\r\n\tmargin-right: 20px;\r\n}\r\n.edit-toggle {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tjustify-content: flex-end;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: flex-end;\r\n}\r\n.edit-toggle .status-toggle {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n}\r\n.edit-toggle .status-toggle p {\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 0;\r\n}\r\n.edit-toggle .status-toggle .front-desk-dropdown p {\r\n\tmargin-bottom: 20px;\r\n}\r\n.edit-toggle .status-toggle .checktoggle {\r\n\twidth: 85px;\r\n\theight: 25px;\r\n\tborder-radius: 50px;\r\n\tbackground-color: #E6E6E6;\r\n\tborder: 1px solid #E6E6E6;\r\n}\r\n.edit-toggle .status-toggle .check-input:checked + .checktoggle {\r\n    background-color: #3FA2DB;\r\n    border: 1px solid #3FA2DB;\r\n}\r\n.edit-toggle .status-toggle .checktoggle:after {\r\n\twidth: 25px;\r\n\theight: 25px;\r\n\tbackground-color: #000;\r\n\ttransform: translate(0, -50%);\r\n}\r\n.edit-toggle .status-toggle .check-input:checked + .checktoggle:after {\r\n\ttransform: translate(calc(-100% - 0px), -50%);\r\n}\r\n.edit-toggle-btn .btn {\r\n\tmin-width: 140px;\r\n\tmargin-left: 24px;\r\n}\r\n.success-card .card-body {\r\n\tpadding: 40px;\r\n}\r\n.success-info {\r\n\ttext-align: center;\r\n}\r\n.success-info i {\r\n\tfont-size: 72px;\r\n\tcolor: #3FA2DB;\r\n\tmargin: 0 auto 20px;\r\n\tdisplay: block;\r\n}\r\n.success-info img {\r\n\tmargin: 0 auto 30px;\r\n}\r\n.success-info p {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 0;\r\n}\r\n.success-info span {\r\n\tfont-weight: 500;\r\n\tcolor: #717171;\r\n\tmargin-top: 4px;\r\n\tdisplay: block;\r\n}\r\n.success-info a {\r\n\tposition: relative;\r\n\tcolor: #00568E;\r\n    display: inline-block;\r\n}\r\n.success-info a:hover {\r\n\tcolor: #00568E;\r\n}\r\n.success-info a:after {\r\n    content: \"\";\r\n    height: 1.5px;\r\n    width: 100%;\r\n    background: #00568E;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 0px;\r\n    left: 0;\r\n}\r\n.success-info a:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.patient-nav-list .nav {\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\tmargin-bottom: 20px;\r\n}\r\n.patient-nav-list .nav li {\r\n\tborder-right: 1px solid #898989;\r\n\tpadding-right: 20px;\r\n\tmargin-right: 20px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.patient-nav-list .nav li:last-child {\r\n\tborder: 0;\r\n\tpadding-right: 0;\r\n\tmargin-right: 0;\r\n}\r\n.patient-nav-list .nav li a {\r\n\tcolor: #898989;\r\n}\r\n.patient-nav-list .nav li a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.patient-nav-list .nav li a.active {\r\n\tfont-weight: 600;\r\n\tcolor: #3FA2DB;\r\n}\r\n\r\n/*-----------------\r\n\t16. Patient Registration\r\n-----------------------*/\r\n\r\n.patient-register-header {\r\n\ttext-align: center;\r\n\tpadding: 20px 0 60px;\r\n}\r\n.patient-register-header h4 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 700;\r\n\tmargin-bottom: 0;\r\n}\r\n.patient-register-card .card-body {\r\n\tpadding: 30px;\r\n}\r\n.patient-register-img {\r\n\twidth: 100px;\r\n\tmin-width: 100px;\r\n\theight: auto;\r\n\tmargin-bottom: 24px;\r\n\tborder-radius: 50%;\r\n}\r\n.patient-register-img img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder-radius: 50%;\r\n}\r\n.patient-register-input .form-control::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.patient-register-input .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #898989;\r\n\tline-height: 24px;\r\n}\r\n.patient-register-input .select2-container .select2-selection--single {\r\n\theight: 26px;\r\n}\r\n.patient-register-input .select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\theight: 26px;\r\n\tright: 0;\r\n}\r\n.patient-register-input .iti__selected-flag {\r\n\tpadding: 0 6px 0 0px;\r\n}\r\n.patient-register-input .iti--allow-dropdown .iti__flag-container:hover .iti__selected-flag {\r\n\tbackground: transparent;\r\n}\r\n.patient-register-input .iti--allow-dropdown input, \r\n.patient-register-input .iti--allow-dropdown input[type=text], \r\n.patient-register-input .iti--allow-dropdown input[type=tel], \r\n.patient-register-input .iti--separate-dial-code input, \r\n.patient-register-input .iti--separate-dial-code input[type=text], \r\n.patient-register-input .iti--separate-dial-code input[type=tel] {\r\n\theight: 30px;\r\n\tpadding-left: 44px;\r\n}\r\n.pass-group {\r\n\tposition: relative;\r\n}\r\n.toggle-password {\r\n\tfont-size: 14px;\r\n    position: absolute;\r\n    right: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: #898989;\r\n    cursor: pointer;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.toggle-password-icon-right {\r\n\ttop: -2px;\r\n\tright: 25px;\r\n\ttransform: translateY(0);\r\n}\r\n.patient-register-proceed {\r\n\tpadding: 40px 0;\r\n\ttext-align: center;\r\n}\r\n.patient-register-proceed .custom_radio {\r\n\tpadding-left: 36px;\r\n}\r\n.patient-register-proceed .text-danger {\r\n\tmargin-top: 10px;\r\n}\r\n.patient-register-btn {\r\n\ttext-align: center;\r\n\tpadding-bottom: 20px;\r\n}\r\n.patient-register-btn .btn {\r\n\tmin-width: 150px;\r\n\tmargin-right: 20px;\r\n}\r\n.patient-register-btn .btn:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.form-wrap-calendar-input input {\r\n\tpadding: 2px 0;\r\n\tborder: 0;\r\n\tborder-radius: 0;\r\n\tborder-bottom: 1px solid #00000038;\r\n}\r\n\r\n/*-----------------\r\n\t17. Doctor Dashboard\r\n-----------------------*/\r\n\r\n.doctor-dash-header h4 {\r\n\tcolor: #00568E;\r\n}\r\n.doctor-dashboard-img {\r\n\twidth: 160px;\r\n\theight: 160px;\r\n\tmargin-bottom: 24px;\r\n\tborder-radius: 15px;\r\n}\r\n.doctor-dashboard-img img {\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\tborder-radius: 15px;\r\n}\r\n.doctor-online {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n}\r\n.doctor-online h6 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 600;\r\n\tmax-width: 200px;\r\n\tmargin-bottom: 0;\r\n\t-webkit-line-clamp: 2;\r\n\t-webkit-box-orient: vertical;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\tdisplay: -webkit-box;\r\n}\r\n.doctor-switch {\r\n\tmargin-left: auto;\r\n}\r\n.doctor-switch .onoffswitch {\r\n\twidth: 90px;\r\n}\r\n.doctor-switch .onoffswitch-inner:before {\r\n\tcontent: \"Online\";\r\n}\r\n.doctor-switch .onoffswitch-inner:after {\r\n\tcontent: \"Offline\";\r\n}\r\n.doctor-switch .onoffswitch-inner:before, \r\n.doctor-switch .onoffswitch-inner:after {\r\n\tfont-size: 12px;\r\n\tcolor: #000;\r\n\tbackground: #E6E6E6;\r\n\theight: 28px;\r\n    line-height: 30px;\r\n}\r\n.doctor-switch .onoffswitch-switch {\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin: 0;\r\n\tright: 64px;\r\n\tbackground: #E87373;\r\n}\r\n.doctor-switch .onoffswitch-switch-online {\r\n\twidth: 26px;\r\n\theight: 26px;\r\n\tmargin: 0;\r\n\tright: 64px;\r\n\tbackground: #37dd07;\r\n}\r\n.dash-card {\r\n\tpadding: 24px;\r\n}\r\n.dash-card-content p {\r\n\tfont-size: 20px;\r\n\tcolor: #FFF;\r\n\tmargin-bottom: 10px;\r\n}\r\n.dash-card-content h4 {\r\n\tfont-size: 40px;\r\n\tcolor: #FFF;\r\n\tmargin-bottom: 0;\r\n}\r\n.bg-pink {\r\n\tbackground: #E87373;\r\n}\r\n.bg-dark-blue {\r\n\tbackground: #00568E;\r\n}\r\n.bg-gray {\r\n\tbackground: #AAA;\r\n}\r\n.doctor-header {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n    flex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tpadding-top: 16px;\r\n\tpadding-bottom: 14px;\r\n}\r\n.doctor-header h4 {\r\n\tfont-size: 24px;\r\n\tfont-weight: 600;\r\n\tcolor: #00568E;\r\n\tmargin-bottom: 10px;\r\n}\r\n.doctor-header .nav li {\r\n\tmargin-bottom: 10px;\r\n\tmargin-right: 15px;\r\n}\r\n.doctor-header .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.doctor-header .nav li .btn {\r\n\tpadding: 5px 24px;\r\n}\r\n.doctor-header .nav li .past-search {\r\n\tfont-size: 24px;\r\n\tcolor: #3FA2DB;\r\n}\r\n.doctor-header .nav li .past-search:hover {\r\n\tcolor: #00568E;\r\n}\r\n.patient-header-list {\r\n\tpadding-top: 30px;\r\n}\r\n.patient-header-info {\r\n\tpadding-bottom: 100px;\r\n}\r\n.patient-header-list h6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tmargin-bottom: 18px;\r\n}\r\n.patient-header-list h6 span {\r\n\tcolor: #3FA2DB;\r\n}\t\r\n.patient-header-list ul li p {\r\n\tfont-weight: 500;\r\n\tcolor: #898989;\r\n\tmargin-bottom: 0;\r\n}\r\n.patient-header-btn {\r\n\twidth: 100%;\r\n\tposition: absolute;\r\n\tbottom: 30px;\r\n\tright: 50%;\r\n\ttransform: translateX(50%);\r\n    -webkit-transform: translateX(50%);\r\n    -ms-transform: translateX(50%);\r\n\tpadding-top: 60px;\r\n\ttext-align: center;\r\n}\r\n.patient-card-header {\r\n\tmargin-bottom: 30px;\r\n}\r\n.patient-card-header h4 {\r\n\tfont-size: 18px;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n/*-----------------\r\n\t18. Appointment \r\n-----------------------*/\r\n\r\n.appointment-details-list ul {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n}\r\n.appointment-details-list ul li {\r\n\tdisplay: block;\r\n\tmargin-bottom: 24px;\r\n}\r\n.appointment-details-list ul li p {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tfont-weight: 300;\r\n\tmargin-bottom: 0;\r\n}\r\n.appointment-details-list ul li p span {\r\n\tfont-weight: 500;\r\n\tmargin-right: 50px;\r\n}\r\n.appointment-tabs {\r\n\toverflow-x: scroll;\r\n\toverflow-y: hidden;\r\n\tpadding-bottom: 4px;\r\n\tmargin-top: 10px;\r\n\tmargin-bottom: 14px;\r\n}\r\n.appointment-tabs::-webkit-scrollbar {\r\n  width: 7px;\r\n}\r\n.appointment-tabs::-webkit-scrollbar:horizontal {\r\n  height: 7px;\r\n}\r\n.appointment-tabs::-webkit-scrollbar-track {\r\n  background-color: rgba(204, 204, 204, 0.3);\r\n}\r\n.appointment-tabs::-webkit-scrollbar-thumb {\r\n  border-radius: 5px;\r\n  background: #3FA2DB;\r\n}\r\n.appointment-details-tabs {\r\n\tpadding-bottom: 10px;\r\n\tmargin-top: 20px;\r\n\tmargin-bottom: 0;\r\n\toverflow: hidden;\r\n}\r\n.appointment-tabs .nav-tabs {\r\n\twidth: 100%;\r\n    padding: 0;\r\n    border: 0;\r\n    display: block;\r\n    white-space: nowrap;\r\n}\r\n.appointment-details-tabs .nav-tabs {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n}\r\n.appointment-tabs .nav-tabs .nav-item {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 20px;\r\n}\r\n.appointment-tabs .nav-tabs .nav-item:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.appointment-tabs .nav-tabs .nav-item .nav-link {\r\n\tfont-size: 15px;\r\n\tcolor: #898989;\r\n\tbackground: transparent;\r\n\tpadding: 0;\r\n\tborder: 0;\r\n\tborder-radius: 0;\r\n}\r\n.appointment-tabs .nav-tabs .nav-item .nav-link:hover {\r\n\tcolor: #00568E;\r\n}\r\n.appointment-tabs .nav-tabs .nav-item .nav-link.active {\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n}\r\n.symptoms-card {\r\n\tpadding: 24px;\r\n\tmargin-bottom: 24px;\r\n\tborder-radius: 12px;\r\n\tbackground: #FFFFFF0A;\r\n\tborder: 1px solid #E6E6E6;\r\n}\r\n.symptoms-card h4 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n\tmargin-bottom: 24px;\r\n}\r\n.symptoms-card p {\r\n\tcolor: #000;\r\n\tbackground: #E6E6E6;\r\n\tdisplay: inline-block;\r\n\tpadding: 5px 24px;\r\n\tborder-radius: 30px;\r\n\tmargin-right: 5px;\r\n\tmargin-bottom: 0;\r\n}\r\n.symptoms-card p:last-child {\r\n  \tmargin-right: 0;\r\n}\r\n.symptoms-search {\r\n\tmargin-bottom: 24px;\r\n}\r\n.symptoms-input {\r\n\tposition: relative;\r\n}\r\n.symptoms-input .form-control {\r\n\tpadding: 10px 20px;\r\n\theight: 46px;\r\n\tborder-radius: 30px;\r\n\tborder: 1px solid #00568E;\r\n}\r\n.symptoms-input .form-control::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.symptoms-input textarea.form-control {\r\n\tborder-radius: 18px;\r\n\theight: 125px;\r\n\tmin-height: 125px;\r\n}\r\n.symptoms-input i {\r\n\tposition: absolute;\r\n    font-size: 20px;\r\n    color: #3FA2DB;\r\n    top: 50%;\r\n    right: 20px;\r\n\ttransform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n}\r\n.symptoms-tags .nav {\r\n\tmargin-top: 14px;\r\n}\r\n.symptoms-tags .nav li {\r\n\tmargin-right: 15px;\r\n\tmargin-bottom: 5px;\r\n}\r\n.symptoms-tags .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.symptoms-tags .nav li h6 {\r\n\tfont-size: 14px;\r\n\tfont-weight: 400;\r\n\tcolor: #FFF;\r\n\tbackground: #3FA2DB;\r\n\tpadding: 4px 15px;\r\n\tborder-radius: 30px;\r\n\tmargin-bottom: 0;\r\n\tline-height: normal;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n.symptoms-tags .nav li h6 a {\r\n\tcolor: #FFF;\r\n\tmargin-left: 10px;\r\n}\r\n.symptoms-tags .nav li h6 a:hover {\r\n\topacity: 0.6;\r\n}\r\n.symptoms-tags .nav li h5 {\r\n\tfont-size: 14px;\r\n\tfont-weight: 400;\r\n\tcolor: #000;\r\n\tbackground: #E6E6E6;\r\n\tpadding: 4px 15px;\r\n\tborder-radius: 30px;\r\n\tmargin-bottom: 0;\r\n\tline-height: normal;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n}\r\n.symptoms-tags .nav li h5 a {\r\n\tmargin-left: 10px;\r\n}\r\n.add-note-link {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tposition: relative;\r\n\tcolor: #00568E;\r\n    display: inline-block;\r\n}\r\n.add-note-link:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.add-note-link:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #00568E;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 3px;\r\n    left: 0;\r\n}\r\n.add-note-link:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.add-symptoms-input {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    margin-top: 10px;\r\n}\r\n.add-self-input {\r\n\ttext-align: right;\r\n\tdisplay: block;\r\n}\r\n.add-self-input a {\r\n\tmargin-left: 0;\r\n}\r\n.add-symptoms-input a {\r\n\tmargin-top: 10px;\r\n\tmargin-left: 10px;\r\n}\r\n.add-symptoms-input .form-control::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.add-symptoms-input textarea.form-control {\r\n\tpadding: 10px 15px;\r\n\tborder: 1px solid #00568E;\r\n\tborder-radius: 20px;\r\n}\r\n.symptoms-save {\r\n\ttext-align: right;\r\n}\r\n.symptoms-save a {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tposition: relative;\r\n\tcolor: #00568E;\r\n    display: inline-block;\r\n}\r\n.symptoms-save a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.symptoms-save a:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #00568E;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 3px;\r\n    left: 0;\r\n}\r\n.symptoms-save a:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.investigation-input .form-control::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.add-investigation a {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tposition: relative;\r\n\tcolor: #00568E;\r\n    display: inline-block;\r\n}\r\n.add-investigation a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.add-investigation a:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #00568E;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 3px;\r\n    left: 0;\r\n}\r\n.add-investigation a:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.symptoms-card .reports-no-data {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #898989;\r\n\tpadding-left: 40px;\r\n\tdisplay: block;\r\n}\r\n.vitals-head {\r\n\tpadding-right: 15px;\r\n\tpadding-left: 40px;\r\n    padding-bottom: 10px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.vitals-head h5 {\r\n\tfont-size: 16px;\r\n    font-weight: 600;\r\n    color: #000;\r\n    margin-bottom: 0;\r\n}\r\n.device-info {\r\n\tpadding-top: 5px;\r\n\tpadding-right: 15px;\r\n\tpadding-left: 25px;\r\n}\r\n.device-list {\r\n\tpadding: 10px 15px 5px;\t\r\n}\r\n.device-list h6 {\r\n\tfont-size: 14px;\r\n    font-weight: 400;\r\n    color: #000;\r\n    margin-bottom: 10px;\r\n}\r\n.device-list p {\r\n\tfont-size: 14px;\r\n    font-weight: 400;\r\n    color: #5E5E5E;\r\n    background: transparent;\r\n    display: block;\r\n    padding: 0;\r\n    margin-bottom: 10px;\r\n}\r\n.vitals-table .table thead tr th {\r\n\tpadding: 0 15px 4px;\r\n}\r\n.vitals-table .table thead tr th:first-child {\r\n\tpadding-left: 40px;\r\n}\r\n.vitals-table .table tbody tr {\r\n\tborder: 0;\r\n}\r\n.vitals-table .table tbody tr td:first-child {\r\n\tpadding-left: 40px;\r\n}\r\n.vitals-table .table tbody tr .value-text {\r\n\tcolor: #5E5E5E;\r\n}\r\n.vitals-table .border-table tbody tr:first-child {\r\n\tborder-top: 1px solid #E6E6E6;\r\n}\r\n.vitals-table .border-table tbody tr {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.vitals-table .border-table tbody tr:last-child {\r\n\tborder-bottom: 0;\r\n}\r\n.value-link a {\r\n\tfont-size: 14px;\r\n\tposition: relative;\r\n\tcolor: #3FA2DB;\r\n    display: inline-block;\r\n}\r\n.value-link a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.value-link a:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #3FA2DB;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 1px;\r\n    left: 0;\r\n}\r\n.value-link a:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.vitals-card {\r\n\tpadding: 0;\r\n\tpadding-bottom: 9px;\r\n}\r\n.vitals-card h4 {\r\n\tpadding: 24px;\r\n\tmargin-bottom: 0;\r\n}\r\n.past-card .card-body {\r\n\tpadding: 0;\r\n\tpadding-bottom: 9px;\r\n}\r\n.past-header {\r\n\tpadding: 24px;\r\n\tmargin-bottom: 20px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.diagram-header {\r\n\tpadding: 0 0 24px;\r\n}\r\n.past-header-border {\r\n\tmargin-bottom: 18px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.past-header h4 {\r\n\tfont-size: 18px;\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n\tmargin-bottom: 0;\r\n}\r\n.past-header .past-title {\r\n\tcolor: #000;\r\n}\r\n.vitals-table .border-table .table-surgeries tbody tr {\r\n\tborder: 0;\r\n}\r\n.vitals-table .border-table .table-surgeries tbody tr td {\r\n\tpadding: 2px;\r\n}\r\n.past-surgeries {\r\n\tpadding-left: 60px;\r\n}\r\n.past-surgeries-head {\r\n\tmargin-bottom: 0;\r\n}\r\n.past-surgeries .nav li {\r\n\twidth: 50%;\r\n\tmargin-bottom: 10px;\r\n}\r\n.past-surgeries-left .nav li:first-child {\r\n\tpadding-left: 40px;\r\n}\r\n.past-surgeries .nav li h6 {\r\n\tfont-size: 15px;\r\n\tfont-weight: 600;\r\n\tcolor: #000;\r\n\tmargin-bottom: 0;\r\n}\r\n.past-surgeries .nav li p {\r\n\tcolor: #000;\r\n\tmargin-bottom: 0;\r\n}\r\n.diagram-card .card-body {\r\n\tpadding: 24px 24px 4px;\r\n}\r\n.body-diagram-img {\r\n\tmargin-bottom: 10px;\r\n}\r\n.body-diagram-img img {\r\n\twidth: 100%;\r\n}\r\n.diagram-list .nav {\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.diagram-list .nav li {\r\n\twidth: 50%;\r\n\tmargin-bottom: 20px;\r\n}\r\n.diagram-checkbox {\r\n\tline-height: normal;\r\n}\r\n.diagram-checkbox .check {\r\n\tmargin-bottom: 0;\r\n}\r\n.diagram-checkbox .check p {\r\n\tmargin-left: 15px;\r\n\tmargin-bottom: 0;\r\n} \r\n.diagram-checkbox .check .box {\r\n    width: 20px;\r\n    min-width: 20px;\r\n    height: 20px;\r\n    background: #FFF;\r\n    border: 1px solid #3FA2DB;\r\n}\r\n.diagram-checkbox .check .box:after {\r\n\tdisplay: none;\r\n}\r\n.attachment-upload-info {\r\n\ttext-align: center;\r\n\tmargin-bottom: 20px;\r\n}\r\n.attachment-upload-info .file-upload {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tcolor: #3FA2DB;\r\n    position: relative;\r\n    overflow: hidden;\r\n    cursor: pointer;\r\n    margin-bottom: 0;\r\n}\r\n.attachment-upload-info .file-upload input[type=file] {\r\n    position: absolute;\r\n    top: 0;\r\n    right: 0;\r\n    min-width: 100%;\r\n    min-height: 100%;\r\n    font-size: 100px;\r\n    text-align: right;\r\n    filter: alpha(opacity = 0);\r\n    opacity: 0;\r\n    outline: none;\r\n    background: #fff;\r\n    cursor: inherit;\r\n    display: block;\r\n}\r\n.attachment-upload-info .file-upload span {\r\n\tdisplay: block;\r\n\tmargin: 20px 0 6px;\r\n}\r\n.attachment-upload-info p {\r\n\tcolor: #898989;\r\n\tmargin-bottom: 0;\r\n}\r\n.attachment-table {\r\n\tborder-left: 0;\r\n\tpadding-left: 0;\r\n\tpadding-bottom: 10px;\r\n    margin-bottom: 20px;\r\n}\r\n.attachment-table .table tbody td h6 {\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    color: #000;\r\n    margin-bottom: 8px;\r\n}\r\n.attachment-table .table tbody td  {\r\n\tfont-weight: 300;\r\n\tcolor: #898989;\r\n}\r\n.attachment-table .table tbody td p {\r\n\tfont-weight: 300;\r\n\tcolor: #898989;\r\n\tmargin-bottom: 0;\r\n\tmax-width: 200px;\r\n\twhite-space: break-spaces;\r\n\t-webkit-line-clamp: 2;\r\n\t-webkit-box-orient: vertical;\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n\tdisplay: -webkit-box;\r\n}\r\n.circle-bar > div {\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: flex-end;\r\n    text-align: center;\r\n    position: relative;\r\n}\r\n.circle-bar > div canvas {\r\n\twidth: 80px !important;\r\n\theight: 80px !important;\r\n}\r\n.circle-bar > div span {\r\n\tposition: absolute;\r\n    font-size: 16px;\r\n    font-weight: 300;\r\n    color: #898989;\r\n    top: 50%;\r\n    left: 50%;\r\n\ttransform: translate(-50%, -50%);\r\n\t-webkit-transform: translate(-50%, -50%);\r\n\t-moz-transform: translate(-50%, -50%);\r\n\t-ms-transform: translate(-50%, -50%); \r\n\t-o-transform: translate(-50%, -50%);\r\n}\r\n.examination-card {\r\n\tmargin-bottom: 24px;\r\n    border-radius: 12px;\r\n    background: #FFF;\r\n    border: 1px solid #E6E6E6;\r\n}\r\n.examination-card h4 {\r\n\tfont-size: 18px;\r\n    font-weight: 500;\r\n    color: #00568E;\r\n    margin-bottom: 24px;\r\n    padding: 24px;\r\n    border-bottom: 1px solid #E6E6E6;\r\n}\r\n.examination-details {\r\n\tpadding: 0 24px 24px;\r\n}\r\n.examination-details p {\r\n\tfont-weight: 300;\r\n\tmargin-bottom: 0;\r\n}\r\n.investigation-details {\r\n\tpadding: 0 24px 24px;\r\n}\r\n.investigation-details ul {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tlist-style: none;\r\n}\r\n.investigation-details ul li {\r\n\tdisplay: block;\r\n\tmargin-bottom: 15px;\r\n}\r\n.investigation-details ul li:last-child {\r\n\tmargin-bottom: 0;\r\n}\r\n.investigation-details p {\r\n\tcolor: #000;\r\n    background: #E6E6E6;\r\n    display: inline-block;\r\n    padding: 5px 24px;\r\n    border-radius: 30px;\r\n    margin-bottom: 0;\r\n}\r\n.screenshot-details {\r\n\tmargin-bottom: 24px;\r\n    padding: 0 24px 20px;\r\n}\r\n.screenshot-details .nav {\r\n\tjustify-content: space-between;\r\n\t-webkit-justify-content: space-between;\r\n\t-ms-flex-pack: space-between;\r\n}\r\n.screenshot-details .nav li {\r\n\tmargin-right: 10px;\r\n}\r\n.screenshot-details .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.screenshot-details a {\r\n\tfont-size: 14px;\r\n\tposition: relative;\r\n\tcolor: #3FA2DB;\r\n    display: inline-block;\r\n}\r\n.screenshot-details a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.screenshot-details a:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #3FA2DB;\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 1px;\r\n    left: 0;\r\n}\r\n.screenshot-details a:hover:after {\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n}\r\n/*-----------------\r\n\t19. Join\r\n-----------------------*/\r\n\r\n.join-bg {\r\n\twidth: 106px;\r\n\theight: 158px;\r\n\tborder-radius: 20px;\r\n\tbackground: #000;\r\n\tdisplay: inline-block;\r\n}\r\n.patient-details {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.patient-details-img {\r\n\twidth: 110px;\r\n\tmin-width: 110px;\r\n\theight: 110px;\r\n\tborder-radius: 10px;\r\n\tmargin-bottom: 24px;\r\n\tmargin-right: 20px;\r\n}\r\n.patient-details-img img {\r\n\twidth: 110px;\r\n\tmin-width: 110px;\r\n\theight: 110px;\r\n\tborder-radius: 10px;\r\n}\r\n.patient-details-content {\r\n\tmargin-bottom: 24px;\r\n}\r\n.patient-details-content h6 {\r\n\tfont-size: 16px;\r\n\tfont-weight: 600;\r\n\tcolor: #000;\r\n\tmargin-bottom: 10px;\r\n}\r\n.patient-details-content p {\r\n\tcolor: #898989;\r\n\tmargin-bottom: 0;\r\n}\r\n.patient-details-content .patient-details-text {\r\n\tmargin-top: 14px;\r\n}\r\n.patient-details-btn .nav {\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    margin-bottom: 14px;\r\n}\r\n.patient-details-btn .nav li {\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.patient-details-btn .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.patient-details-btn .nav li .btn {\r\n\tpadding: 5px 18px;\r\n}\r\n.join-details-list .nav {\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-bottom: 4px;\r\n}\r\n.join-details-list .nav li {\r\n\tdisplay: inline-block;\r\n\tmargin-right: 40px;\r\n\tmargin-bottom: 20px;\r\n}\r\n.join-details-list .nav li p span {\r\n\tmargin-right: 24px;\r\n}\r\n.certificate-list .nav {\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-top: 50px;\r\n\tmargin-bottom: 14px;\r\n}\r\n.certificate-list .nav li {\r\n\tmargin-right: 30px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.certificate-list .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.certificate-list .nav li a {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #3FA2DB;\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n}\r\n.certificate-list .nav li a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.certificate-list .nav li a:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #3FA2DB;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 2px;\r\n    left: 0;\r\n}\r\n.certificate-list .nav li a:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.symptoms-select .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tcolor: #898989;\r\n\tline-height: 34px;\r\n\tpadding-left: 15px;\r\n}\r\n.symptoms-select .select2-container--default .select2-selection--single {\r\n\tbackground: #E6E6E6;\r\n\tborder: 1px solid #E6E6E6;\r\n\tborder-radius: 30px;\r\n\theight: 34px;\r\n}\r\n.symptoms-select .select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\theight: 34px;\r\n}\r\n.symptoms-select .select2-results__option {\r\n\tcolor: #898989;\r\n}\r\n.live-stethoscope {\r\n\tmargin-bottom: 24px;\r\n}\r\n.live-stethoscope .btn {\r\n\tpadding: 5px 20px;\r\n}\r\n.prescription-list {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-bottom: 14px;\r\n}\r\n.prescription-list a {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tmargin-right: 20px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.prescription-list a:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.prescription-list a:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.prescription-list a:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #00568E;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 1px;\r\n    left: 0;\r\n}\r\n.prescription-list a:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.prescription-table {\r\n\tmargin-bottom: 30px;\r\n}\r\n.prescription-table .table thead tr {\r\n\tborder: 0;\r\n}\r\n.prescription-table .table thead tr th {\r\n\tcolor: #737373;\r\n\ttext-align: center;\r\n\tpadding: 10px;\r\n\tbackground: #EFEFEF;\r\n\tborder-radius: 0;\r\n}\r\n.prescription-table .table thead tr th:first-child {\r\n\tborder-radius: 10px 0 0 10px;\r\n}\r\n.prescription-table .table thead tr th:last-child {\r\n\tborder-radius: 0 10px 10px 0;\r\n}\r\n.prescription-table .table tbody tr {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.prescription-table .table tbody tr td {\r\n\tcolor: #3FA2DB;\r\n\ttext-align: center;\r\n}\r\n.prescription-table .table tbody tr .data-link a {\r\n\tfont-size: 18px;\r\n\tcolor: #3FA2DB;\r\n}\r\n.prescription-table .table tbody tr .data-link a:hover {\r\n\tcolor: #00568E;\r\n}\r\n.self-care-add {\r\n\tmargin-bottom: 20px;\r\n}\r\n.self-care-add .self-care-link {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #00568E;\r\n\tposition: relative;\r\n\tdisplay: inline-block;\r\n\tmargin-right: 24px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.self-care-add .self-care-link:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.self-care-add .self-care-link:hover {\r\n\tcolor: #3FA2DB;\r\n}\r\n.self-care-add .self-care-link:after {\r\n    content: \"\";\r\n    height: 1px;\r\n    width: 100%;\r\n    background: #00568E;\r\n    transform: scale(1);\r\n    -webkit-transform: scale(1);\r\n    -ms-transform: scale(1);\r\n    -webkit-transition: all 0.4s ease;\r\n    -ms-transition: all 0.4s ease;\r\n    transition: all 0.4s ease;\r\n    position: absolute;\r\n    bottom: 1px;\r\n    left: 0;\r\n}\r\n.self-care-add .self-care-link:hover:after {\r\n    transform: scale(0);\r\n    -webkit-transform: scale(0);\r\n    -ms-transform: scale(0);\r\n}\r\n.refer-specialist {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: start;\r\n    -ms-flex-align: start;\r\n    align-items: start;\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-bottom: 14px;\r\n}\r\n.refer-specialist p {\r\n\tcolor: #464646;\r\n\tmargin-right: 24px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.refer-specialist .custom-radio {\r\n\tmargin-bottom: 10px;\r\n}\r\n.self-care-calender {\r\n\tposition: relative;\r\n\tmax-width: 270px;\r\n\twidth: 100%;\r\n\tmargin-bottom: 24px;\r\n}\r\n.self-care-calender .form-control::placeholder {\r\n\tcolor: #898989;\r\n}\r\n.self-care-calender i {\r\n\tfont-size: 18px;\r\n\tcolor: #3FA2DB;\r\n\tposition: absolute;\r\n\ttop: 50%;\r\n\tright: 0;\r\n\ttransform: translateY(-50%);\r\n    -webkit-transform: translateY(-50%);\r\n    -ms-transform: translateY(-50%);\r\n}\r\n#refer_select_yes {\r\n\tdisplay: none;\r\n}\r\n.refer-select-info .symptoms-select {\r\n\tmargin-bottom: 10px;\r\n}\r\n.refer-select-info .symptoms-select .select2-container--default .select2-selection--single .select2-selection__rendered {\r\n\tbackground: #FFF;\r\n\tborder: 1px solid #E8E8E8;\r\n\tborder-radius: 5px;\r\n\tpadding-left: 10px;\r\n}\r\n.refer-select-info .symptoms-select .select2-container--default .select2-selection--single {\r\n\tbackground: #FFF;\r\n\tborder: 1px solid #E8E8E8;\r\n\tborder-radius: 5px;\r\n}\r\n.refer-select-info .symptoms-select .select2-container--default .select2-selection--single .select2-selection__arrow {\r\n\twidth: 15px;\r\n}\r\n.past-surgeries-nav {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n\tmargin: 0 40px 15px;\r\n}\r\n.past-surgerie-left .past-surgeries-nav li:first-child {\r\n\twidth: 30%;\r\n}\r\n.past-surgerie-left .past-surgeries-nav li {\r\n\twidth: 70%;\r\n}\r\n.medical-history-card .past-surgeries .past-surgeries-nav li {\r\n\tmargin-bottom: 10px;\r\n}\r\n.surgerie-flex {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.surgerie-flex .since-input {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.surgerie-flex .since-input span {\r\n\tmargin-right: 15px;\r\n}\r\n.surgerie-flex .since-input .form-control {\r\n\tmax-width: 100px;\r\n\tmargin-right: 10px;\r\n\tpadding: 0;\r\n}\r\n.surgerie-flex .per-since-input .form-control {\r\n\tmax-width: 60px;\r\n}\r\n.past-surgerie-left .surgerie-flex .bootstrap-datetimepicker-widget ul {\r\n\tpadding-top: 10px;\r\n\tborder-bottom: 0;\r\n\tmargin: 0;\r\n}\r\n.past-surgerie-left .surgerie-flex .bootstrap-datetimepicker-widget ul li {\r\n\twidth: auto;\r\n\ttext-align: center;\r\n}\r\n.appendectomy-details {\r\n\tpadding: 0 40px 20px 60px;\r\n}\r\n.appendectomy-info {\r\n\tmargin-bottom: 20px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.appendectomy-input {\r\n\tmargin-bottom: 15px;\r\n}\r\n.appendectomy-input .form-control {\r\n\tmax-width: 140px;\r\n}\r\n.appendectomy-input .form-control::placeholder {\r\n\tcolor: #000;\r\n}\r\n.appendectomy-nav {\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.past-surgeries .appendectomy-nav li {\r\n\twidth: 25%;\r\n}\r\n.appendectomy-nav .form-control {\r\n\twidth: 90px;\r\n}\r\n.past-surgeries .appendectomy-nav .bootstrap-datetimepicker-widget ul {\r\n\tpadding-top: 10px;\r\n\tborder-bottom: 0;\r\n\tmargin: 0;\r\n}\r\n.past-surgeries .appendectomy-nav .bootstrap-datetimepicker-widget ul li {\r\n\tpadding-left: 0;\r\n\twidth: auto;\r\n\ttext-align: center;\r\n}\r\n.add-type-surgery .form-control {\r\n\tmax-width: 160px;\r\n}\r\n.add-type-surgery .form-control::placeholder {\r\n\tfont-style: italic;\r\n}\r\n.hospitalization-info {\r\n\tpadding: 0 40px 20px 60px;\r\n}\t\r\n.hospitalization-nav {\r\n\tmargin-bottom: 15px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.past-surgeries-left .hospitalization-nav li:first-child {\r\n\tpadding-left: 0;\r\n}\r\n.hospitalization-grid {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.hospitalization-grid span {\r\n\tcolor: #000;\r\n\tmargin-right: 15px;\r\n}\r\n.hospitalization-date .form-control {\r\n\tmax-width: 110px;\r\n}\r\n.social-history-nav {\r\n\tmargin-bottom: 15px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.past-surgeries-left .social-history-nav li:first-child {\r\n\tpadding-left: 0;\r\n\twidth: 30%;\r\n}\r\n.past-surgeries-left .social-history-nav li {\r\n\twidth: 70%;\r\n}\r\n.medical-history-card .past-surgeries .social-history-nav .sub-history {\r\n\twidth: 100%;\r\n\tmargin: 0;\r\n}\r\n.past-surgeries-left .sub-history .nav {\r\n\tborder: 0;\r\n\tmargin: 0;\r\n}\r\n.past-surgeries-left .sub-history .nav li span {\r\n\tfont-weight: 300;\r\n}\t\r\n.past-surgeries-left .sub-history .nav li:first-child {\r\n\tpadding-left: 30px;\r\n}\r\n.past-surgeries .sub-history .form-control {\r\n\tmax-width: 500px;\r\n}\r\n.patient-sub-radio-btn {\r\n\tpadding: 12px 0 0 30px;\r\n}\r\n.family-history-info {\r\n\tpadding: 0 40px 0 40px;\r\n}\r\n.family-history-nav-top {\r\n\tpadding-bottom: 10px;\r\n\tmargin-bottom: 15px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.family-history-nav-top:last-child {\r\n\tpadding-bottom: 0;\r\n\tmargin-bottom: 0;\r\n\tborder-bottom: 0;\r\n}\r\n.past-surgeries-left .family-history-nav-top li:first-child {\r\n\twidth: 20%;\r\n\tpadding-left: 0;\r\n}\r\n.medical-history-card .past-surgeries .family-history-info .family-history-nav-top li {\r\n\tmargin-bottom: 30px;\r\n}\r\n.past-surgeries .family-history-info .sub-history .form-control {\r\n\tmax-width: 100px;\r\n}\r\n.family-history-nav-top h5 {\r\n\tfont-size: 15px;\r\n\tfont-weight: 400;\r\n\tmargin-bottom: 0;\r\n}\r\n.past-surgeries-left .family-history-nav li:first-child {\r\n\tpadding-left: 0;\r\n\twidth: 30%;\r\n}\r\n.past-surgeries-left .family-history-nav li {\r\n\twidth: 70%;\r\n}\r\n.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history {\r\n\twidth: 100%;\r\n\tmargin: 0;\r\n}\r\n.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li:first-child {\r\n\tpadding-left: 30px;\r\n\twidth: 23%;\r\n}\r\n.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li {\r\n\twidth: 75%;\r\n\tmargin-bottom: 10px;\r\n}\r\n.past-surgeries .family-history-nav li p {\r\n\tfont-size: 14px;\r\n\tfont-weight: 300;\r\n\tmargin-bottom: 0;\r\n}\r\n.vitals-list .nav {\r\n\tpadding-bottom: 5px;\r\n\tmargin-bottom: 15px;\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n}\r\n.vitals-list .nav:last-child {\r\n\tpadding-bottom: 0;\r\n\tmargin-bottom: 5px;\r\n\tborder-bottom: 0;\r\n}\r\n.vitals-list .nav li:first-child {\r\n\tpadding-left: 60px;\r\n}\r\n.vitals-list .nav li {\r\n\twidth: 50%;\r\n\tcolor: #000;\r\n\tmargin-bottom: 10px;\r\n}\r\n.vitals-since p {\r\n\tmargin-bottom: 0;\r\n}\r\n.vitals-text {\r\n\tfont-style: italic;\r\n}\r\n.vitals-since p span {\r\n\tfont-style: normal;\r\n\tmargin-right: 10px;\r\n}\r\n.appendectomy-list .nav li {\r\n\tcolor: #5B5B5B;\r\n}\r\n.appendectomy-list .vitals-since p {\r\n\tcolor: #373737;\r\n}\r\n.appendectomy-list .nav .appendectomy-sub-list {\r\n\twidth: 100%;\r\n}\r\n.appendectomy-list .nav .appendectomy-sub-list .nav {\r\n\tpadding: 0;\r\n\tmargin: 0;\r\n\tborder: 0;\r\n}\r\n.appendectomy-list .nav .appendectomy-sub-list li:first-child {\r\n\tpadding-left: 90px;\r\n}\r\n.appendectomy-list .nav .appendectomy-sub-list li {\r\n\tmargin-bottom: 5px;\r\n}\r\n.appendectomy-list h6 {\r\n\tfont-size: 15px;\r\n\tfont-weight: 500;\r\n\tcolor: #000;\r\n\tmargin-bottom: 0;\r\n}\r\n.hospitalization-date p span {\r\n\tmargin-left: 15px;\r\n\tcolor: #5B5B5B;\r\n}\r\n\r\n/*-----------------\r\n\t20. Notification\r\n-----------------------*/\r\n\r\n.notification-header {\r\n\tborder-bottom: 1px solid #E6E6E6;\r\n\tmargin-bottom: 20px;\r\n}\r\n.notification-header h4 {\r\n\tfont-size: 24px;\r\n\tmargin-bottom: 30px;\r\n}\r\n.notification-header .nav {\r\n\t-webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n    margin-bottom: 20px;\r\n}\r\n.notification-header .nav li {\r\n\tmargin-right: 50px;\r\n}\r\n.notification-header .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.notification-header .nav li a {\r\n\tfont-size: 16px;\r\n\tfont-weight: 500;\r\n\tcolor: #898989;\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n}\r\n.notification-header .nav li a:hover {\r\n\tcolor: #00568E;\r\n}\r\n.notification-header .nav li a.active {\r\n\tcolor: #00568E;\r\n}\r\n.notification-header .nav li a span {\r\n\tbackground: #00568E1A;\r\n\tcolor: #00568E;\r\n\twidth: 25px;\r\n\theight: 25px;\r\n\tpadding: 5px;\r\n\tborder-radius: 5px;\r\n\tmargin-left: 10px;\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n    -webkit-justify-content: center;\r\n    -ms-flex-pack: center;\r\n}\r\n.notification-read {\r\n\tdisplay: -webkit-box;\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tjustify-content: space-between;\r\n    -webkit-justify-content: space-between;\r\n    -ms-flex-pack: space-between;\r\n\tflex-wrap: wrap;\r\n\t-webkit-flex-wrap: wrap;\r\n\tmargin-bottom: 10px;\r\n}\r\n.notification-select-all {\r\n\tmargin-right: 10px;\r\n\tmargin-bottom: 10px;\r\n}\r\n.notification-select-all .custom-checkbox {\r\n\tline-height: normal;\r\n}\r\n.notification-select-all .custom-checkbox .check {\r\n\tfont-size: 14px;\r\n\tfont-weight: 500;\r\n\tmargin-bottom: 0;\r\n}\r\n.notification-select-all .custom-checkbox .check .box {\r\n\tmargin-right: 10px;\r\n}\r\n.notification-read .nav {\r\n\tjustify-content: flex-end;\r\n    -webkit-justify-content: flex-end;\r\n    -ms-flex-pack: flex-end;\r\n\tmargin-bottom: 10px;\r\n}\r\n.notification-read .nav li {\r\n\tmargin-right: 50px;\r\n}\r\n.notification-read .nav li:last-child {\r\n\tmargin-right: 0;\r\n}\r\n.notification-read .nav li a {\r\n\tdisplay: -webkit-inline-box;\r\n\tdisplay: -ms-inline-flexbox;\r\n\tdisplay: inline-flex;\r\n\t-webkit-box-align: center;\r\n\t-ms-flex-align: center;\r\n\talign-items: center;\r\n\tfont-weight: 500;\r\n\tcolor: #3FA2DB;\r\n}\r\n.notification-read .nav li a img {\r\n\tmargin-right: 10px;\r\n}\r\n.notification-read .nav li .clear-all-link {\r\n\tcolor: #FF3B30;\r\n}\r\n.notification-read .nav li a i {\r\n\tfont-size: 17px;\r\n\tmargin-right: 6px;\r\n}\r\n.notification-grid {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n\tborder: 1px solid #E6E6E6;\r\n\tborder-radius: 10px;\r\n\tmargin-bottom: 30px;\r\n}\r\n.notification-grid-unread {\r\n\tborder: 1px solid #000;\r\n}\r\n.notification-left {\r\n\tpadding: 20px;\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n\tflex-grow: 1;\r\n    cursor: pointer;\r\n}\r\n.notification-img {\r\n\tdisplay: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    -webkit-box-align: center;\r\n    -ms-flex-align: center;\r\n    align-items: center;\r\n\tpadding-right: 15px;\r\n\tmargin-right: 15px;\r\n\tborder-right: 1px solid #E6E6E6;\r\n}\r\n.notification-img span {\r\n\twidth: 14px;\r\n\tmin-width: 14px;\r\n\theight: 14px;\r\n\tborder-radius: 50%;\r\n\tmargin-right: 10px;\r\n\tdisplay: inline-block;\r\n}\r\n.notification-active {\r\n\tbackground: #3FA2DB;\r\n}\r\n.notification-pending {\r\n\tbackground: #F7D333;\r\n}\r\n.notification-inactive {\r\n\tbackground: #E87373;\r\n}\r\n.notification-details-checkbox {\r\n\tpadding: 20px 0px 20px 20px;\r\n\tmargin-right: 0;\r\n}\r\n.notification-details-checkbox .check .box {\r\n\twidth: 24px;\r\n    min-width: 24px;\r\n    height: 24px;\r\n}\r\n.notification-img img {\r\n\twidth: 50px;\r\n\tmin-width: 50px;\r\n\theight: 50px;\r\n\tborder-radius: 50%;\r\n}\r\n.notification-content h6 {\r\n\tfont-size: 16px;\r\n\tmargin-bottom: 5px;\r\n}\r\n.notification-content p {\r\n\tcolor: #898989;\r\n\tmargin-right: 15px;\r\n\tmargin-bottom: 0;\r\n}\r\n.notification-right {\r\n\tmargin-left: auto;\r\n}\r\n.notification-right p {\r\n\tcolor: #898989;\r\n\tmargin-bottom: 0;\r\n}\r\n\r\n/*-----------------\r\n\t21. Responsive\r\n-----------------------*/\r\n\r\n@media (min-width:768px) {\r\n\t.avatar-xxl {\r\n\t\twidth: 8rem;\r\n\t\theight: 8rem;\r\n\t}\r\n\t.avatar-xxl .border {\r\n\t\tborder-width: 4px !important;\r\n\t}\r\n\t.avatar-xxl .rounded {\r\n\t\tborder-radius: 12px !important;\r\n\t}\r\n\t.avatar-xxl .avatar-title {\r\n\t\tfont-size: 42px;\r\n\t}\r\n\t.avatar-xxl.avatar-away:before,\r\n\t.avatar-xxl.avatar-offline:before,\r\n\t.avatar-xxl.avatar-online:before {\r\n\t\tborder-width: 4px;\r\n\t}\r\n}\r\n\r\n@media (min-width: 992px) {\r\n\t#toggle_btn {\r\n\t\tcolor: #232020;\r\n\t    float: left;\r\n\t    font-size: 30px;\r\n\t    width: 80px;\r\n\t    height: 100px;\r\n\t    margin-left: 0px;\r\n\t    display: flex;\r\n\t    justify-content: center;\r\n\t    align-items: center;\r\n\t    box-shadow: 1px 2px 5px rgba(66, 133, 244, 0.30);\r\n\t}\r\n\t.mini-sidebar .header-left .logo img {\r\n\t\theight: auto;\r\n\t\twidth: auto;\r\n\t}\r\n\t.mini-sidebar .header .header-left .logo {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.mini-sidebar .header-left .logo.logo-small {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.mini-sidebar .header .header-left {\r\n\t\tpadding: 24px 20px;\r\n    \twidth: 100px;\r\n\t}\r\n\t.mini-sidebar .sidebar {\r\n\t\twidth: 78px;\r\n\t}\r\n\t.mini-sidebar.expand-menu .sidebar {\r\n\t\twidth: 240px;\r\n\t}\r\n\t.mini-sidebar .menu-title {\r\n\t\tvisibility: hidden;\r\n\t\twhite-space: nowrap;\r\n\t}\r\n\t.mini-sidebar.expand-menu .menu-title {\r\n\t\tvisibility: visible;\r\n\t}\r\n\t.mini-sidebar .menu-title a {\r\n\t\tvisibility: hidden;\r\n\t}\r\n\t.mini-sidebar.expand-menu .menu-title a {\r\n\t\tvisibility: visible;\r\n\t}\r\n\t.modal-open.mini-sidebar .sidebar {\r\n\t\tz-index: 1051;\r\n\t}\r\n\t.mini-sidebar .sidebar .sidebar-menu ul > li > a span {\r\n\t\tdisplay: none;\r\n\t\ttransition: all 0.4s ease;\r\n    \t-webkit-transition: all 0.4s ease;\r\n\t\t-moz-transition: all 0.4s ease;\r\n\t\topacity: 0;\r\n\t}\r\n\t.mini-sidebar.expand-menu .sidebar .sidebar-menu ul > li > a span {\r\n\t\tdisplay: inline;\r\n\t\topacity: 1;\r\n\t} \r\n\t.mini-sidebar .page-wrapper {\r\n\t\tmargin-left: 78px;\r\n\t}\r\n\t.user-menu .dropdown-menu {\r\n\t\ttop: 100px;\r\n\t\tright: 0;\r\n\t\tleft: auto;\r\n\t\tmin-width: 200px;\r\n\t\tvisibility: hidden;\r\n\t\topacity: 0;\r\n\t\tborder: 0;\r\n\t\tdisplay: block;\r\n\t\tmargin: 0;\r\n\t\tpadding: 0;\r\n\t\t-webkit-transition: all 0.4s ease;\r\n\t\t-ms-transition: all 0.4s ease;\r\n\t\ttransition: all 0.4s ease;\r\n\t\ttransform: translateY(20px);\r\n\t\t-webkit-transform: translateY(20px);\r\n\t\t-ms-transform: translateY(20px);\r\n\t}\r\n\t.user-menu .dropdown-menu.show {\r\n\t\tvisibility: visible;\r\n\t\topacity: 1;\r\n\t\ttransform: translateY(0);\r\n\t\t-webkit-transform: translateY(0);\r\n\t\t-ms-transform: translateY(0);\r\n\t\t-webkit-transition: all 0.4s ease;\r\n\t\t-ms-transition: all 0.4s ease;\r\n\t\ttransition: all 0.4s ease;\r\n\t}\r\n}\r\n\r\n@media (max-width: 1699.98px) {\r\n\t.account-wrapper-info {\r\n\t\tdisplay: block;\r\n\t\tpadding: 0 0 30px;\r\n\t}\r\n\t.register-main-logo {\r\n\t\tposition: relative;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tpadding: 30px;\r\n\t}\r\n\t.account-wrapper-info .register-box .login-right {\r\n\t\tmargin: 0 auto 30px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 1599.98px) {\r\n\tbody {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\tlabel {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.btn {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.btn-primary {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-secondary {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-danger {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-black {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-primary-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-secondary-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-danger-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-dark-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.page-header-btn .btn {\r\n\t    padding: 8px 20px;\r\n\t    min-width: 130px;\r\n\t}\r\n\t.login-logo img {\r\n\t\twidth: 150px;\r\n \t}\r\n\t.login-content h1 {\r\n\t\tfont-size: 86px;\r\n\t}\r\n\t.login-content h5 {\r\n\t\tfont-size: 26px;\r\n\t}\r\n\t.login-left {\r\n\t\tpadding: 40px 0 0 40px;\r\n\t}\r\n\t.login-box .login-right {\r\n\t\tpadding: 30px;\r\n\t\tmax-width: 340px;\r\n\t\tmargin-left: -160px;\r\n\t\tmargin-bottom: 40px;\r\n\t}\r\n\t.login-box .login-right h2 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.login-box .login-right .password-header h2 {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.login-form .form-wrap-input img {\r\n\t\twidth: 24px;\r\n\t}\r\n\t.login-btn .btn {\r\n\t    padding: 8px 40px;\r\n\t}\r\n\t.login-content img {\r\n\t\twidth: 280px;\r\n\t}\r\n\t.login-content-bottom {\r\n\t\tbottom: 40px;\r\n\t}\r\n\t.login-box {\r\n\t\twidth: 500px;\r\n\t}\r\n\t.login-box.register-box {\r\n    \twidth: 100%;\r\n\t}\r\n\t.register-box .login-right {\r\n\t\tmargin: 0 auto 0;\r\n\t\tmax-width: 500px;\r\n\t}\r\n\t.login-shape-img {\r\n\t\tbottom: 50px;\r\n    \tmargin-left: -140px;\r\n\t}\r\n\t.shape-img img {\r\n\t\twidth: 280px;\r\n\t}\r\n\t.welcome-wrapper .content {\r\n\t\tpadding-left: 60px;\r\n\t}\r\n\t.welcome-content {\r\n\t\tpadding: 40px 0 0 60px;\r\n\t}\r\n\t.welcome-logo img {\r\n\t\twidth: 150px;\r\n\t}\r\n\t.welcome-text h6 {\r\n\t\tfont-size: 60px;\r\n\t}\r\n\t.welcome-text h1 {\r\n\t\tfont-size: 60px;\r\n\t}\r\n\t.welcome-btn .btn {\r\n\t\tfont-size: 16px;\r\n\t\tmin-width: 140px;\r\n\t\tpadding: 9px 20px;\r\n\t}\r\n\t.register-logo {\r\n\t\ttop: 30px;\r\n\t\tleft: 30px;\r\n\t}\r\n\t.register-main-logo {\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t}\r\n\t.white-logo img {\r\n\t\twidth: 130px;\r\n\t}\r\n\t.password-btn .btn {\r\n\t\tpadding: 8px 32px;\r\n\t}\r\n\t.password-header img {\r\n\t\twidth: 50px;\r\n\t}\r\n\t.user-menu li a {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.dash-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.dash-progress h6 {\r\n\t\tfont-size: 36px;\r\n\t}\r\n\t.dashboard-link {\r\n\t\tpadding: 30px;\r\n\t}\r\n\t.dashboard-link a {\r\n\t\tfont-size: 16px;\r\n\t\twidth: 200px;\r\n\t\tmin-width: 200px;\r\n\t}\r\n\t.dashboard-link a img {\r\n\t\twidth: 100px;\r\n\t}\r\n\t.table-btn .btn {\r\n\t\tpadding: 8px 36px;\r\n\t}\r\n\t.table thead tr th {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.dropdown-menu.front-desk-dropdown {\r\n\t\tpadding: 24px;\r\n\t}\r\n\t.front-desk-dropdown-btn .btn {\r\n\t\tmargin-right: 30px;\r\n\t}\r\n\t.create-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.form-wrap-btn .btn {\r\n\t\tmin-width: 120px;\r\n\t\tmargin-right: 15px;\r\n\t}\r\n\t.edit-header h4 {\r\n\t\tfont-size: 26px;\r\n\t}\r\n\t.edit-icon a {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.edit-toggle-btn .btn {\r\n\t\tmin-width: 120px;\r\n\t\tmargin-left: 20px;\r\n\t}\r\n\t.success-info i {\r\n\t\tfont-size: 68px;\r\n\t}\r\n\t.success-info p {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.sidebar-menu li a {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.clinic-nav-item a span {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.re-associate-content .btn {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t\tmin-width: 120px;\r\n\t}\r\n\t.doctor-online h6 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.dash-card-content p {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.dash-card-content h4 {\r\n\t\tfont-size: 34px;\r\n\t}\r\n\t.doctor-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.doctor-header .nav li .past-search {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.symptoms-card h4 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.examination-card h4 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.past-header h4 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.attachment-upload-info .file-upload img {\r\n\t\twidth: 60px;\r\n\t}\r\n\t.certificate-list .nav li a {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.symptoms-input .form-control {\r\n\t\tpadding: 10px 16px;\r\n\t\theight: 40px;\r\n\t}\r\n\t.symptoms-input i {\r\n\t    font-size: 18px;\r\n\t    right: 15px;\r\n\t}\r\n\t.add-note-link {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.add-investigation a {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.symptoms-input textarea.form-control {\r\n\t\theight: 100px;\r\n\t\tmin-height: 100px;\r\n\t}\r\n\t.symptoms-save a {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.medical-modal-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.symptoms-card .reports-no-data {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.prescription-list a {\r\n\t\tfont-size: 15px;\r\n\t\tmargin-right: 20px;\r\n\t}\r\n\t.self-care-add .self-care-link {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.drug-btn .btn {\r\n\t\tmin-width: 120px;\r\n\t}\r\n\t.prescription-btn .btn {\r\n\t\tpadding: 8px 30px;\r\n\t}\r\n\t.modal-form-btn .btn {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.custom-modal .doctor-slot-body {\r\n\t\tpadding: 30px;\r\n\t}\r\n\t.doctor-slot-header {\r\n\t\tpadding-bottom: 30px;\r\n\t}\r\n\t.doctor-slot-input {\r\n\t\tpadding-left: 30px;\r\n\t}\r\n\t.doctor-slot-input label {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.select-days h6 {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.doctor-slot-btn .btn {\r\n\t\tpadding: 8px 40px;\r\n\t}\r\n\t.patient-table-list h6 {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.notification-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.notification-header .nav li {\r\n\t\tmargin-right: 30px;\r\n\t}\r\n\t.notification-read .nav li {\r\n\t\tmargin-right: 30px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 1499.98px) {\r\n\t.login-left {\r\n\t\tpadding: 30px 0 0 30px;\r\n\t}\r\n\t.login-logo img {\r\n\t\twidth: 130px;\r\n\t}\r\n\t.login-shape-img {\r\n\t\tbottom: 30px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 1399.98px) {\r\n\t.login-content h1 {\r\n\t\tfont-size: 74px;\r\n\t}\r\n\t.login-content h5 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.login-content-bottom {\r\n\t\tbottom: 20px;\r\n\t}\r\n\t.login-content img {\r\n\t\twidth: 250px;\r\n\t}\r\n\t.login-box {\r\n\t\twidth: 400px;\r\n\t}\r\n\t.login-shape-img {\r\n\t\tbottom: 20px;\r\n        margin-left: -125px;\r\n    }\r\n\t.shape-img img {\r\n\t\twidth: 250px;\r\n\t}\r\n\t.dash-progress h6 {\r\n\t\tfont-size: 36px;\r\n\t}\r\n\t.dashboard-link a img {\r\n\t\twidth: 120px;\r\n\t\theight: 120px;\r\n\t}\r\n\t.doctor-dash-header h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.doctor-online h6 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.appointment-details-tabs {\r\n\t\tmargin-top: 20px;\r\n\t}\r\n\t.create-header img {\r\n\t\theight: 200px;\r\n\t}\r\n\t.notification-header h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n}\r\n\r\n@media (max-width: 1199.98px) {\r\n\t.header .header-left {\r\n\t\twidth: 100px;\r\n\t\tmargin-right: 20px;\r\n\t}\r\n\t.sidebar-menu li {\r\n\t\tmargin-right: 15px;\r\n\t}\r\n\t.sidebar-menu li a {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.user-menu li {\r\n\t\tmargin-right: 26px;\r\n\t}\r\n\t.clinic-nav-item a img {\r\n\t\tmargin-left: 15px;\r\n\t}\r\n\t.clinic-nav-item a .doctor-menu-img {\r\n\t\tmargin-left: 0;\r\n\t\tmargin-right: 15px;\r\n\t}\r\n\t.user-menu li a {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.user-menu li a span {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.top-nav-search {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.register-logo {\r\n\t\tposition: relative;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\tpadding: 30px 0 0;\r\n\t\ttext-align: center;\r\n\t}\r\n\t.register-box {\r\n\t\tmargin-bottom: 30px;\r\n\t}\r\n\t.login-wrapper {\r\n\t\tmin-height: auto;\r\n\t\theight: auto;\r\n\t\tbackground: #FFF;\r\n\t\ttext-align: center;\r\n\t\tpadding: 0px 0 30px;\r\n\t}\r\n\t.login-left {\r\n\t\twidth: 100%;\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.login-content h5 {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.login-content img {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.shape-img img {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.login-content-bottom {\r\n\t\tposition: relative;\r\n\t\tbottom: 0;\r\n\t}\r\n\t.login-box {\r\n\t\twidth: 100%;\r\n\t\tbackground: transparent;\r\n\t\tposition: relative;\r\n\t\theight: auto;\r\n\t\tpadding: 30px 20px 0;\r\n\t\ttop: 0;\r\n\t    transform: translateY(0);\r\n\t    -webkit-transform: translateY(0);\r\n\t    -ms-transform: translateY(0);\r\n\t}\r\n\t.login-box .login-right {\r\n\t\tmax-width: 400px;\r\n\t\twidth: 100%;\r\n\t\tmargin: 0 auto 0;\r\n\t\ttop: 0;\r\n\t    transform: translateY(0);\r\n\t    -webkit-transform: translateY(0);\r\n\t    -ms-transform: translateY(0);\r\n\t}\r\n\t.account-wrapper {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.edit-inner-body {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.edit-inner-box {\r\n\t\tborder: 0;\r\n\t}\r\n\t.edit-header {\r\n\t\tpadding-bottom: 20px;\r\n\t}\r\n\t.edit-details {\r\n\t\tpadding-left: 0;\r\n\t}\r\n\t.patient-header-btn {\r\n\t\tposition: relative;\r\n\t\tbottom: 0;\r\n\t\tpadding-top: 20px;\r\n\t}\r\n\t.attachment-table {\r\n\t\tborder: 0;\r\n\t\tpadding: 0;\r\n\t}\r\n\t.page-list .nav li {\r\n\t\tmargin-right: 15px;\r\n\t}\r\n\t.past-surgeries .appendectomy-nav li {\r\n\t\twidth: 27%;\r\n\t}\r\n\t.medical-history-card .past-surgeries {\r\n\t\tpadding: 20px 20px 0 20px;\r\n\t}\r\n\t.medical-history-card .past-surgeries.past-surgerie-left {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.medical-history-card .past-surgeries.past-surgeries-left {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.past-surgeries-nav {\r\n\t\tmargin: 0 0 15px;\r\n\t}\r\n\t.past-surgerie-left .past-surgeries-nav li:first-child {\r\n\t\tpadding-left: 20px;\r\n\t\twidth: 20%;\r\n\t}\r\n\t.appendectomy-details {\r\n\t\tpadding: 0 20px;\r\n\t}\r\n\t.hospitalization-info {\r\n\t\tpadding: 0 20px;\r\n\t}\r\n\t.family-history-info {\r\n\t\tpadding: 0 20px;\r\n\t}\r\n\t.surgerie-flex {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.surgerie-flex .since-input {\r\n\t\tmargin-top: 10px;\r\n\t}\r\n\t.past-surgeries-left .social-history-nav li {\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\t.social-history-nav .patient-radio-btn .custom_radio {\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\t.patient-header-info {\r\n\t\tpadding-bottom: 0;\r\n\t}\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n\t.sidebar-overlay {\r\n\t\ttop: 80px;\r\n\t}\r\n\t.header {\r\n\t\theight: 80px;\r\n\t}\r\n\t.header .header-left {\r\n\t\tposition: absolute;\r\n\t    width: 100%;\r\n\t    height: 80px;\r\n\t    margin-right: 0;\r\n\t    justify-content: center;\r\n\t}\r\n\t.header .logout-left {\r\n\t\twidth: auto;\r\n\t    margin-left: 20px;\r\n\t    justify-content: start;\r\n\t}\r\n\t.mobile-menu {\r\n\t\ttop: 80px; \r\n\t}\r\n\t.user-menu {\r\n\t\theight: 80px;\r\n\t}\r\n\t.add-item {\r\n\t\tmargin-top: 10px;\r\n\t}\r\n\t.mobile_btn {\r\n\t\tdisplay: -webkit-box;\r\n\t\tdisplay: -ms-flexbox;\r\n\t\tdisplay: flex;\r\n\t\t-webkit-box-align: center;\r\n\t\t-ms-flex-align: center;\r\n\t\talign-items: center;\r\n\t\tjustify-content: center;\r\n\t\t-webkit-justify-content: center;\r\n\t\t-ms-flex-pack: center;\r\n\t    cursor: pointer;\r\n\t    font-size: 24px;\r\n\t    left: 0;\r\n\t    line-height: 80px;\r\n\t    padding: 0 15px 0 0;\r\n\t    position: absolute;\r\n\t    text-align: center;\r\n\t    width: 80px;\r\n\t    height: 80px;\r\n\t    top: 0;\r\n\t    z-index: 10;\r\n\t}\r\n\t.mobile_btn:hover {\r\n\t\tcolor: #f6f6f7;\r\n\t}\r\n\t#toggle_btn {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.top-nav-search {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.sidebar {\r\n\t\tposition: fixed;\r\n\t\tmargin-left: -260px;\r\n\t    width: 260px;\r\n\t    top: 80px;\r\n\t    background: #FFF;\r\n\t    -webkit-transition: all 0.4s ease;\r\n\t    -moz-transition: all 0.4s ease;\r\n\t    transition: all 0.4s ease;\r\n\t    z-index: 1041;\r\n\t}\r\n\t.right-sidebar {\r\n\t\tmargin-left: 0;\r\n\t}\r\n\t.sidebar-menu > ul > li > .sidebar-right-toggle {\r\n\t\tfont-size: 16px;\r\n\t\twidth: 40px;\r\n\t\theight: 40px;\r\n\t\ttop: 18px;\r\n\t\tright: 25px;\r\n\t\tbottom: inherit;\r\n\t\tborder-radius: 50px;\r\n\t}\r\n\t.sidebar-menu > ul > li > .sidebar-right-toggle:after {\r\n\t\tleft: inherit;\r\n\t}\r\n\t.hideright-sidebar #sidebar-right-toggle {\r\n\t\twidth: 25px;\r\n\t\theight: 50px;\r\n\t}\r\n\t.sidebar-menu > ul {\r\n\t\tpadding: 0px 20px 30px;\r\n\t}\r\n\t.sidebar-menu > ul > li {\r\n\t\tmargin-top: 20px;\r\n\t\tdisplay: block;\r\n\t}\r\n\t.sidebar-menu li a {\r\n\t\tcolor: #000;\r\n\t\ttext-align: left;\r\n\t}\r\n\t#menu {\r\n\t\tmargin: -40px 0 0;\r\n\t}\r\n\t.clinic-nav-item {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.page-wrapper {\r\n\t\tmargin-left: 0;\r\n\t\tpadding-top: 90px;\r\n\t\tpadding-left: 0;\r\n\t\tpadding-right: 0;\r\n\t\t-webkit-transition: all 0.4s ease;\r\n\t\t-moz-transition: all 0.4s ease;\r\n\t\ttransition: all 0.4s ease;\r\n\t}\r\n\t.login-logo img {\r\n\t\twidth: 130px;\r\n\t}\r\n\t.register-logo img {\r\n\t\twidth: 130px;\r\n\t}\r\n\t.login-content h1 {\r\n\t\tfont-size: 60px;\r\n\t}\r\n\t.login-content h5 {\r\n\t\tfont-size: 22px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.welcome-info {\r\n\t\theight: auto;\r\n\t}\r\n\t.welcome-logo {\r\n\t\tpadding-bottom: 30px;\r\n\t}\r\n\t.welcome-wrapper {\r\n\t\tpadding-top: 0;\r\n\t}\r\n\t.welcome-wrapper .content {\r\n\t\tpadding-left: 40px;\r\n\t}\r\n\t.welcome-content {\r\n\t\tpadding: 40px 0 0 40px;\r\n\t}\r\n\t.welcome-text h6 {\r\n\t\tfont-size: 50px;\r\n\t}\r\n\t.welcome-text h1 {\r\n\t\tfont-size: 50px;\r\n\t}\r\n\t.dashboard-link {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.dashboard-link a img {\r\n\t\twidth: 100px;\r\n\t\theight: 100px;\r\n\t}\r\n\t.professional-wrap-status {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.certificate-list .nav {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.symptoms-select {\r\n\t\tmargin-top: 10px;\r\n\t}\r\n\t.refer-select-info .symptoms-select {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.custom-modal .medical-modal-body {\r\n\t\tpadding: 0 20px 10px;\r\n\t}\r\n\t.medical-modal-header {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.medical-history-card .past-surgeries.past-surgeries-left {\r\n        padding: 0 20px;\r\n    }\r\n\t.medical-history-card .past-surgeries {\r\n\t\tpadding: 20px 20px 0px;\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.medical-history-card .past-surgeries .nav li {\r\n\t\twidth: 100%;\r\n\t\tpadding-left: 0;\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.medical-history-card .past-surgeries-left .nav li:first-child {\r\n\t\tpadding-left: 0;\r\n\t}\r\n\t.hospitalization-info {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.past-surgeries-nav {\r\n\t\tpadding: 0 20px;\r\n\t}\r\n\t.appendectomy-details {\r\n        padding: 0;\r\n    }\r\n    .family-history-info {\r\n    \tpadding: 0;\r\n    }\r\n    .hospitalization-nav {\r\n    \tdisplay: block;\r\n    }\r\n\t.past-surgeries-left .sub-history .family-history-nav {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.medical-history-card .past-surgeries .family-history-info .family-history-nav-top li {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li:first-child {\r\n\t\tpadding-left: 0;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.medical-history-card .past-surgeries .family-history-info .family-history-nav-top .sub-history .nav li {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.medical-history-card.diagram-card .card-body {\r\n\t\tpadding: 5px 20px 5px;\r\n\t}\r\n\t.custom-modal .doctor-slot-body {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.doctor-slot-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.doctor-slot-input {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.doctor-slot-input .form-wrap {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.create-header {\r\n\t\tpadding-bottom: 20px;\r\n\t}\r\n\t.create-header img {\r\n\t\theight: 150px;\r\n\t}\r\n\t.create-form {\r\n\t\tmax-width: inherit;\r\n\t}\r\n}\r\n\r\n@media (max-width: 767.98px) {\r\n\tbody {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\th1, .h1 {\r\n\t\tfont-size: 2rem;\r\n\t}\r\n\th2, .h2 {\r\n\t\tfont-size: 1.75rem;\r\n\t}\r\n\th3, .h3 {\r\n\t\tfont-size: 1.5rem;\r\n\t}\r\n\th4, .h4 {\r\n\t\tfont-size: 1.125rem;\r\n\t}\r\n\th5, .h5 {\r\n\t\tfont-size: 1rem;\r\n\t}\r\n\th6, .h6 {\r\n\t\tfont-size: 0.875rem;\r\n\t}\r\n\tlabel {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.form-group {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.form-wrap {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.form-control {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.sidebar-overlay {\r\n\t    top: 80px;\r\n\t}\r\n\t.header .has-arrow .dropdown-toggle:after {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.user-menu.nav > li > a > span:not(.user-img) {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.navbar-nav .open .dropdown-menu {\r\n\t\tfloat: left;\r\n\t\tposition: absolute;\r\n\t}\r\n\t.navbar-nav.user-menu .open .dropdown-menu {\r\n\t\tleft: auto;\r\n\t\tright: 0;\r\n\t}\r\n\t.header .header-left {\r\n\t\tpadding: 0;\r\n\t\tmargin-left: 0;\r\n\t\theight: 80px;\r\n\t\ttext-align: center;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.header .logout-left {\r\n\t\twidth: auto;\r\n\t    margin-left: 20px;\r\n\t    justify-content: start;\r\n\t}\r\n\t.header .header-left .logo {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.header-left .logo.logo-small {\r\n\t\tdisplay: inline-block;\r\n\t}\r\n\t.sidebar-menu > ul > li > .sidebar-right-toggle {\r\n\t\ttop: 7px;\r\n\t}\r\n\t.hideright-sidebar #sidebar-right-toggle {\r\n\t\ttop: 0;\r\n        width: 30px;\r\n        height: 60px;\r\n    }\r\n\t.sidebar-menu > ul > li {\r\n\t\tmargin-top: 20px;\r\n\t}\r\n\t.sidebar-menu > ul > li:last-child {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\t.mobile_btn {\r\n\t\twidth: 65px;\r\n\t    height: 80px;\r\n\t    padding: 0;\r\n\t}\r\n\t.mobile-menu {\r\n\t\ttop: 60px; \r\n\t}\r\n    .user-menu li {\r\n\t    margin-right: 24px;\r\n\t}\r\n\t.user-menu li a.header-profile {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.user-menu li.has-arrow {\r\n\t\tdisplay: none;\r\n\t}\r\n\t.user-menu li a .fa-search {\r\n\t\tdisplay: none;\r\n\t}\r\n\t#menu {\r\n\t\ttext-align: left;\r\n\t\twidth: 180px;\r\n\t\tpadding: 40px 0px 0 20px;\r\n\t}\r\n\t#menu li {\r\n\t\tpadding: 15px 0 0;\r\n\t}\r\n\t.page-wrapper {\r\n\t\tpadding-top: 80px;\r\n\t}\r\n\t.page-wrapper-info {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.page-title {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.breadcrumb .breadcrumb-item {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.breadcrumb-item+.breadcrumb-item {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.card {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.card-body {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.card-header {\r\n\t\tpadding: .75rem 1.25rem;\r\n\t}\r\n\t.card-footer {\r\n\t\tpadding: .75rem 1.25rem;\r\n\t}\r\n\t.table thead tr th {\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.dropdown-menu.front-desk-dropdown {\r\n\t\tmin-width: 220px;\r\n    \tmax-width: 220px;\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.front-desk-dropdown-btn .btn {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.page-header {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.notifications .noti-content {\r\n\t\twidth: 310px;\r\n\t\theight: 355px;\r\n\t}\r\n\t.breadcrumb .breadcrumb-item {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.breadcrumb-item+.breadcrumb-item {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.btn-primary {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-secondary {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-danger {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-black {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-primary-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-secondary-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-danger-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.btn-dark-light {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 8px 20px;\r\n\t}\r\n\t.account-wrapper-info {\r\n\t\tpadding: 0 0 20px;\r\n\t}\r\n\t.login-wrapper {\r\n\t\tpadding: 0 0 30px;\r\n\t}\r\n\t.login-wrapper .login-right {\r\n\t\tfloat: none;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.login-logo img {\r\n\t\twidth: 100px;\r\n\t}\r\n\t.login-content h1 {\r\n\t\tfont-size: 34px;\r\n\t}\r\n\t.login-content h5 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.login-box {\r\n\t\tpadding: 20px 20px 0;\r\n\t}\r\n\t.login-box .login-right {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.login-header {\r\n\t\tpadding-bottom: 40px;\r\n\t}\r\n\t.login-box .login-right h2 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.login-form .form-wrap-input img {\r\n\t\twidth: 20px;\r\n\t}\r\n\t.login-box.register-box {\r\n\t\tpadding: 20px 0 0;\r\n\t}\r\n\t.welcome-body {\r\n\t\tbackground: url(../img/main-bg.jpg);\r\n\t}\r\n\t.welcome-wrapper {\r\n\t\tpadding-top: 0;\r\n\t}\r\n\t.welcome-wrapper .content {\r\n\t\tpadding-left: 20px;\r\n\t}\r\n\t.welcome-content {\r\n\t\tpadding: 20px 0 0 20px;\r\n\t}\r\n\t.welcome-logo img {\r\n\t\twidth: 100px;\r\n\t}\r\n\t.welcome-text h6 {\r\n\t\tfont-size: 30px;\r\n\t}\r\n\t.welcome-text h1 {\r\n\t\tfont-size: 30px;\r\n\t}\r\n\t.welcome-btn .btn {\r\n\t    font-size: 14px;\r\n\t    min-width: auto;\r\n\t    margin-right: 10px;\r\n\t    padding: 7px 20px;\r\n\t}\r\n\t.register-section {\r\n\t\tpadding: 20px 0;\r\n\t}\r\n\t.register-logo {\r\n\t\tpadding: 20px 0;\r\n\t\ttext-align: center;\r\n\t}\r\n\t.register-logo img {\r\n\t\twidth: 100px;\r\n\t}\r\n\t.password-btn {\r\n\t\tmargin-top: 20px;\r\n\t}\r\n\t.otp-box input {\r\n\t\twidth: 32px;\r\n\t\theight: 32px;\r\n\t\tmargin-right: 2px;\r\n\t}\r\n\t.dash-header {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.dash-header h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.dash-progress {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.dashboard-link {\r\n\t\tpadding: 5px;\r\n\t}\r\n\t.dashboard-link a {\r\n\t\twidth: 150px;\r\n\t\tmin-width: 150px;\r\n\t\tfont-size: 15px;\r\n\t}\r\n\t.dashboard-link a img {\r\n\t\twidth: 70px;\r\n\t\theight: 70px;\r\n\t}\r\n\t.page-list .nav {\r\n\t\tjustify-content: start;\r\n\t    -webkit-justify-content: start;\r\n\t    -ms-flex-pack: start;\r\n\t}\r\n\t.page-list .nav li {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.page-header-btn .btn {\r\n\t\tpadding: 8px 20px;\r\n\t\twidth: 100%;\r\n\t}\r\n\t.table-btn {\r\n\t\tpadding: 20px 0;\r\n\t}\r\n\t.table-btn .btn {\r\n\t\tpadding: 8px 40px;\r\n\t}\r\n\t.table-pagination {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.create-card {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.edit-inner-body {\r\n\t\tpadding: 0;\r\n\t\tpadding-top: 20px;\r\n\t}\r\n\t.create-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.create-form {\r\n\t\tmax-width: inherit;\r\n\t}\r\n\t.create-header h4 {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.create-header img {\r\n\t\theight: 100px;\r\n\t}\r\n\t.form-wrap-status {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.form-wrap-btn .btn {\r\n\t\twidth: 100%;\r\n\t\tmin-width: 100%;\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.form-wrap-btn .btn-secondary {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.edit-icon a {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.edit-header h4 {\r\n\t\tfont-size: 22px;\r\n\t}\r\n\t.edit-toggle {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.edit-toggle .status-toggle {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.edit-toggle-btn .btn {\r\n\t\tmargin-left: 0;\r\n\t\tmin-width: 120px;\r\n\t}\r\n\t.success-card .card-body {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.success-info i {\r\n\t\tfont-size: 40px;\r\n\t}\r\n\t.success-info img {\r\n\t    margin: 0 auto 20px;\r\n\t    width: 60px;\r\n\t}\r\n\t.success-info p {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.re-associate-content {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.re-associate-text img {\r\n\t\twidth: 60px;\r\n\t}\r\n\t.re-associate-text p {\r\n\t\tfont-size: 14px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.re-associate-content .btn {\r\n\t\tfont-size: 14px;\r\n\t\tpadding: 7px 20px;\r\n\t\tmin-width: 110px;\r\n\t}\r\n\t.schedule-modal-header {\r\n\t\tpadding: 10px 0 10px;\r\n\t}\r\n\t.schedule-modal-header h4 {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.schedule-modal-form {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.schedule-success {\r\n\t\tpadding: 15px;\r\n\t}\r\n\t.schedule-success i {\r\n\t\tfont-size: 40px;\r\n\t\tmargin: 0 auto 20px;\r\n\t}\r\n\t.schedule-success h4 {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.schedule-modal-form .custom-radio {\r\n\t\tpadding: 10px 0 0;\r\n\t}\r\n\t.patient-nav-list .nav {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.patient-nav-list .nav li {\r\n\t\tpadding-right: 5px;\r\n    \tmargin-right: 4px;\r\n\t}\r\n\t.patient-register-header {\r\n\t\tpadding: 0 0 20px;\r\n\t}\r\n\t.patient-register-header h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.patient-register-form {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.patient-register-img {\r\n\t\tmargin: 0 auto 20px;\r\n\t}\r\n\t.patient-register-proceed {\r\n\t    padding: 20px 0 20px;\r\n\t}\r\n\t.patient-register-btn {\r\n\t\tpadding-bottom: 0;\r\n\t}\r\n\t.patient-register-btn .btn {\r\n\t\tmin-width: 120px;\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.doctor-dashboard-img {\r\n\t\twidth: 100%;\r\n\t\theight: auto;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.dash-card {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.dash-card-content p {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.dash-card-content h4 {\r\n\t\tfont-size: 30px;\r\n\t}\r\n\t.doctor-header {\r\n\t\tpadding-top: 0;\r\n\t}\r\n\t.doctor-header h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.doctor-header .nav li {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.table tbody tr .vitals-data .nav li {\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.patient-card-header {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.appointment-tabs {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.appointment-details-tabs {\r\n\t\toverflow-x: scroll;\r\n    \toverflow-y: hidden;\r\n    \tpadding-bottom: 4px;\r\n    \tmargin-top: 10px;\r\n    \tmargin-bottom: 14px;\r\n\t}\r\n\t.appointment-details-tabs .nav-tabs {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.appointment-tabs .nav-tabs .nav-item .nav-link {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.symptoms-card {\r\n\t\tpadding: 20px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.symptoms-card h4 {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.appointment-details-list ul li {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.vitals-card {\r\n\t\tpadding: 0;\r\n\t\tpadding-bottom: 5px;\r\n\t}\r\n\t.past-card .card-body {\r\n\t\tpadding-bottom: 5px;\r\n\t}\r\n\t.vitals-card h4 {\r\n\t\tpadding: 20px;\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\t.vitals-table .table thead tr th:first-child {\r\n\t\tpadding-left: 20px;\r\n\t}\r\n\t.vitals-table .table tbody tr td:first-child {\r\n\t\tpadding-left: 20px;\r\n\t}\r\n\t.past-header {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.diagram-card .card-body {\r\n\t\tpadding: 20px 20px 0;\r\n\t}\r\n\t.diagram-header {\r\n\t\tpadding: 0 0 20px;\r\n\t}\r\n\t.diagram-list .nav li {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.attachment-upload-info {\r\n\t\tmargin-bottom: 15px;\r\n\t}\r\n\t.attachment-upload-info .file-upload {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.attachment-upload-info .file-upload img {\r\n\t\twidth: 50px;\r\n\t}\r\n\t.attachment-table {\r\n\t\tmargin-bottom: 5px;\r\n\t}\r\n\t.attachment-table .table tbody td h6 {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.patient-details {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.patient-details {\r\n\t\tmargin-right: 0;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.patient-details-content {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.patient-details-btn .nav {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.join-details-list .nav {\r\n\t\tdisplay: block;\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\t.join-details-list .nav li {\r\n\t\tdisplay: block;\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.certificate-list .nav {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.certificate-list .nav li a {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.symptoms-search {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.medical-modal-header {\r\n    \tpadding: 20px 20px 10px;\r\n    }\r\n\t.create-modal-header {\r\n\t\tjustify-content: space-between;\r\n\t\t-webkit-justify-content: space-between;\r\n\t\t-ms-flex-pack: space-between;\r\n\t}\r\n\t.medical-modal-header h4 {\r\n\t\tfont-size: 20px;\r\n\t}\r\n\t.medical-modal-header .close {\r\n\t\twidth: 30px;\r\n\t\theight: 30px;\r\n\t\ttop: 15px;\r\n\t\tright: 15px;\r\n\t}\r\n\t.form-wrap-status h4 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.past-medical-btn {\r\n\t\tpadding: 20px 0 0;\r\n\t}\r\n\t.symptoms-card .reports-no-data {\r\n\t\tpadding-left: 0;\r\n\t}\r\n\t.prescription-list a {\r\n\t\tfont-size: 14px;\r\n\t\tmargin-right: 15px;\r\n\t}\r\n\t.self-care-add .self-care-link {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.self-care-add {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.refer-specialist {\r\n\t\tmargin-bottom: 10px;\r\n\t}\r\n\t.self-care-calender {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.custom-modal .drug-modal-body {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.drug-btn {\r\n\t\tmargin-top: 0;\r\n\t}\r\n\t.prescription-modal-header {\r\n\t\tjustify-content: flex-start;\r\n\t\t-webkit-justify-content: flex-start;\r\n\t\t-ms-flex-pack: flex-start;\r\n\t}\r\n\t.prescription-modal-header h5 {\r\n\t\tfont-size: 16px;\r\n\t}\r\n\t.prescription-grid {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.prescription-btn {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.custom-modal .profile-modal-body {\r\n\t\tpadding: 20px;\r\n\t}\r\n\t.profile-modal-title h4 {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.profile-modal-img {\r\n\t\tmargin: 0 auto 20px;\r\n\t}\r\n\t.profile-modal-form {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.profile-modal-btn {\r\n\t\tpadding: 0;\r\n\t}\r\n\t.doctor-slot-header {\r\n\t\tpadding-bottom: 20px;\r\n\t}\r\n\t.form-flex-wrap {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.form-flex-wrap .doctor-slot-date .form-control {\r\n\t    width: 100%;\r\n\t}\r\n\t.medical-history-card .past-surgeries {\r\n\t\tpadding: 20px 20px 5px;\r\n\t}\r\n\t.hospitalization-grid {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.doctor-slot-btn .btn {\r\n\t\tpadding: 8px 30px;\r\n\t\tmargin-right: 10px;\r\n\t}\r\n\t.notification-header h4 {\r\n\t\tfont-size: 18px;\r\n\t}\r\n\t.notification-grid {\r\n\t\tmargin-bottom: 20px;\r\n\t\tdisplay: block;\r\n\t}\r\n\t.notification-left {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.notification-img {\r\n\t\tborder: 0;\r\n\t\tpadding-right: 0;\r\n\t\tmargin-right: 0;\r\n\t\tpadding-bottom: 15px;\r\n\t\tdisplay: block;\r\n\t}\r\n\t.examination-card {\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.examination-card h4 {\r\n\t\tpadding: 20px;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\t.examination-details {\r\n\t\tpadding: 0 20px 20px;\r\n\t}\r\n\t.investigation-details {\r\n\t\tpadding: 0 20px 20px;\r\n\t}\r\n\t.screenshot-details {\r\n\t\tpadding: 0 20px 20px;\r\n\t}\r\n\t.vitals-list {\r\n\t\tpadding: 0 20px;\r\n\t}\r\n\t.vitals-list .nav {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.vitals-list .nav li {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.vitals-list .nav li:first-child {\r\n\t\tpadding-left: 0;\r\n\t}\r\n\t.appendectomy-list .nav .appendectomy-sub-list li:first-child {\r\n\t\tpadding-left: 0;\r\n\t}\r\n}\r\n\r\n@media (max-width: 575.98px) {\r\n\t.appointment-details-list ul li p {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.appointment-details-list ul li p span {\r\n\t\tmargin-right: 0;\r\n\t\tmargin-bottom: 4px;\r\n\t\tdisplay: block;\r\n\t}\r\n\t.past-surgeries {\r\n\t\tpadding: 0 20px 13px;\r\n\t}\r\n\t.past-surgeries-head {\r\n\t\tmargin-bottom: 0;\r\n\t}\r\n\t.past-surgeries .nav {\r\n\t\tdisplay: block;\r\n\t}\r\n\t.past-surgeries .nav li {\r\n\t\twidth: 100%;\r\n\t\tmargin-bottom: 2px;\r\n\t}\r\n\t.past-surgeries-left .nav li:first-child {\r\n\t\tpadding-left: 0;\r\n\t}\r\n\t.past-surgeries .nav li h6 {\r\n\t\tfont-size: 14px;\r\n\t}\r\n\t.patient-details-btn .nav {\r\n\t\tmargin-bottom: 14px;\r\n\t\tdisplay: block;\r\n\t}\r\n\t.patient-details-btn .nav li {\r\n\t\tmargin-right: 0;\r\n\t}\r\n\t.patient-details-btn .nav li .btn {\r\n\t\twidth: 100%;\r\n\t}\r\n\t.join-details-list .nav li p span {\r\n\t\tmargin-right: 0;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
